
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("JJ6wk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<8b01de59b52ef28edc97e2621fa79862>>
 * @relayHash 3e1b8ad99323925f7f9acd3b0a8da699
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 578f8900b035c8aabb9585b20ffa9eba064b10f20e4fb991d7f807712f2538f9
const $dbf5442f5a3b49c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useObjectHeader"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "contentTypeModified"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "kind": "ScalarField",
            "name": "friendlyWhen"
        }
    ], v4 = {
        "condition": "useObjectHeader",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v3 /*: any*/ 
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": v3 /*: any*/ 
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "useContentBasicInfoFragment"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "useContentSpaceFragment"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3e1b8ad99323925f7f9acd3b0a8da699",
            "id": "578f8900b035c8aabb9585b20ffa9eba064b10f20e4fb991d7f807712f2538f9",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID,$useObjectHeader:Boolean!){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{...useContentBasicInfoFragment,space{...useContentSpaceFragment,id},operations{operation,targetType},version@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen}\n      draftVersion@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen},id}}}fragment useContentBasicInfoFragment on Content{id,title,type,subType,status}fragment useContentSpaceFragment on Space{id,name,key,alias}"
        }
    };
}();
$dbf5442f5a3b49c0$var$node.hash = "b00a2b355a74b39fcbb57135227bc5cf";
var $dbf5442f5a3b49c0$export$2e2bcd8739ae039 = $dbf5442f5a3b49c0$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $j1Ss3 = parcelRequire("j1Ss3");


var $5izcQ = parcelRequire("5izcQ");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $8zMP3 = parcelRequire("8zMP3");


var $8dwdz = parcelRequire("8dwdz");


var $hzkzq = parcelRequire("hzkzq");


var $cgsIj = parcelRequire("cgsIj");


var $b8XTE = parcelRequire("b8XTE");


var $7d2Nc = parcelRequire("7d2Nc");


var $40pD8 = parcelRequire("40pD8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $6S5EB = parcelRequire("6S5EB");


var $bvJwp = parcelRequire("bvJwp");


var $99t4P = parcelRequire("99t4P");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $cVfpT = parcelRequire("cVfpT");


var $3WXN2 = parcelRequire("3WXN2");


var $4aGJ9 = parcelRequire("4aGJ9");


var $7xVCs = parcelRequire("7xVCs");


var $lyx2E = parcelRequire("lyx2E");


var $deZfn = parcelRequire("deZfn");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8z0fF = parcelRequire("8z0fF");


var $9wGTI = parcelRequire("9wGTI");


var $47zp4 = parcelRequire("47zp4");


var $aWwYt = parcelRequire("aWwYt");


var $dPJCf = parcelRequire("dPJCf");


var $bj5fB = parcelRequire("bj5fB");


var $l7iY7 = parcelRequire("l7iY7");


var $1NBp8 = parcelRequire("1NBp8");


var $4VJDS = parcelRequire("4VJDS");


var $hQBR9 = parcelRequire("hQBR9");


var $6LsQQ = parcelRequire("6LsQQ");





var $jMyy4 = parcelRequire("jMyy4");

const $574d761bd3a496fb$export$b84ae570a1bec29f = (query, params, selectors)=>{
    const result = (0, $jMyy4.useQueryInterop)(query, params);
    const { data: data, loading: loading } = result;
    const fragmentRefs = (0, $42omo.useMemo)(()=>{
        // Don't compute fragmentRefs during loading or when data is not available
        if (loading || !data) return {};
        const fragmentRefsResult = {};
        for(const key in selectors){
            const selector = selectors?.[key];
            // Use selector if provided, otherwise fall back to direct key access
            const entity = selector ? selector(data) : data?.[key];
            if (!entity) throw new Error(`useFragmentizedQuery: Expected entity for fragment key "${String(key)}" but it was not found in the query data. Make sure the query includes the necessary fields for this fragment.`);
            if (!entity.__typename || !entity.id) throw new Error(`useFragmentizedQuery: Entity for fragment key "${String(key)}" is missing required fields (__typename or id).`);
            fragmentRefsResult[key] = {
                __typename: entity.__typename,
                id: entity.id
            };
        }
        return fragmentRefsResult;
    }, [
        data,
        loading,
        selectors
    ]);
    return {
        ...result,
        fragmentRefs: fragmentRefs
    };
};



var $5qUgM = parcelRequire("5qUgM");














var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");







var $a3fRD = parcelRequire("a3fRD");


var $lUjjs = parcelRequire("lUjjs");


var $91xA1 = parcelRequire("91xA1");


var $4noo5 = parcelRequire("4noo5");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");














var $lt6Lx = parcelRequire("lt6Lx");


var $7Sm4c = parcelRequire("7Sm4c");


var $bT0se = parcelRequire("bT0se");


var $7QM6o = parcelRequire("7QM6o");


var $kSPGK = parcelRequire("kSPGK");











var $1B6Lx = parcelRequire("1B6Lx");


var $kXsBa = parcelRequire("kXsBa");




const $778018eca844ead1$export$f6d8ac9231e1baff = 60;
const $778018eca844ead1$export$3e7822b6c7b36880 = (error)=>{
    return error.message.includes('exists with the same title in this space');
};
const $778018eca844ead1$var$i18n = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "content-types-header.content-types-title.placeholder",
        defaultMessage: "Untitled whiteboard"
    },
    databaseTitlePlaceholder: {
        id: "content-types-header.content-types-title.database-title-placeholder",
        defaultMessage: "Untitled database"
    },
    embedTitlePlaceholder: {
        id: "content-types-header.content-types-title.embed-title-placeholder",
        defaultMessage: "Untitled Smart Link"
    },
    renameTooltip: {
        id: "content-types-header.content-types-title.rename-tooltip",
        defaultMessage: "Rename"
    },
    permissionsTooltip: {
        id: "content-types-header.content-types-title.permissions-tooltip",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You don't have permission to edit this whiteboard"
    },
    databasePermissionsTooltip: {
        id: "content-types-header.content-types-title.database-permissions-tooltip",
        defaultMessage: "You don\u2019t have permission to edit this database"
    },
    embedPermissionsTooltip: {
        id: "content-types-header.content-types-title.embed-permissions-tooltip",
        defaultMessage: "You don\u2019t have permission to edit this Smart Link"
    },
    duplicateTitleError: {
        id: "content-types-header.content-types-title.duplicate-title-error",
        defaultMessage: "A whiteboard with this title already exists in this space"
    },
    emptyTitleError: {
        id: "content-types-header.content-types-title.empty-title-error",
        defaultMessage: "Title cannot be empty"
    },
    duplicateDatabaseTitleError: {
        id: "content-types-header.content-types-title.duplicate-database-title-error",
        defaultMessage: "A database with this title already exists in this space"
    },
    duplicateEmbedTitleError: {
        id: "content-types-header.content-types-title.duplicate-embed-title-error",
        defaultMessage: "A Smart Link with this title already exists in this space"
    },
    generalError: {
        id: "content-types-header.content-types-title.general-error",
        defaultMessage: "There was an error on our end. Refresh and try again."
    },
    titleLengthError: {
        id: "content-types-header.content-types-title.title-length-error",
        defaultMessage: "{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}"
    },
    onboardingSpotlightBody: {
        id: "content-types-header.content-types-title.onboarding-spotlight-body",
        defaultMessage: "Give your whiteboard a unique name"
    }
});
const $778018eca844ead1$var$i18nByContentType = {
    duplicateTitleError: {
        database: $778018eca844ead1$var$i18n.duplicateDatabaseTitleError,
        whiteboard: $778018eca844ead1$var$i18n.duplicateTitleError,
        embed: $778018eca844ead1$var$i18n.duplicateEmbedTitleError
    },
    permissionsTooltip: {
        database: $778018eca844ead1$var$i18n.databasePermissionsTooltip,
        whiteboard: $778018eca844ead1$var$i18n.permissionsTooltip,
        embed: $778018eca844ead1$var$i18n.embedPermissionsTooltip
    },
    placeholder: {
        database: $778018eca844ead1$var$i18n.databaseTitlePlaceholder,
        embed: $778018eca844ead1$var$i18n.embedTitlePlaceholder,
        whiteboard: $778018eca844ead1$var$i18n.placeholder
    }
};
const $778018eca844ead1$var$height = '20px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$Title = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _k48p1wq8 _1bsb1ns9 _v7e5idpf _hpvwidpf _v9uvidpf _2aw0idpf _zaczidpf _152kidpf _pm1xidpf _1s7bidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _k48p1wq8 _1bsb1ns9 _v7e5idpf _hpvwidpf _v9uvidpf _2aw0idpf _zaczidpf _152kidpf _pm1xidpf _1s7bidpf",
            __cmplp.className
        ])
    });
}); // This needs to be a tagged template expression because @compiled isn't applying the `attr(data-value)`
const $778018eca844ead1$var$EditViewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _szpl2smr _1n6qd9x7 _10ku15vq _bdrc15vq _1kt9zxco _cfu11txw _w09a1osq _1y8lzdsj _1h3dgktf _9tn1qvpr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _szpl2smr _1n6qd9x7 _10ku15vq _bdrc15vq _1kt9zxco _cfu11txw _w09a1osq _1y8lzdsj _1h3dgktf _9tn1qvpr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$TextViewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { errorIcon: errorIcon, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _11tw2smr _1lt8moej _1d6tgktf _15ffs4qr",
            __cmplp.errorIcon && "_clh8idpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorIcon: errorIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _11tw2smr _1lt8moej _1d6tgktf _15ffs4qr",
            __cmplp.errorIcon && "_clh8idpf",
            __cmplp.className
        ])
    });
});
const $778018eca844ead1$var$readOnlyContainerStyles = (0, $ecnYn.xcss)({
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'space.250',
    maxWidth: '100%',
    paddingRight: 'space.075',
    paddingLeft: 'space.075',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'text',
    fontWeight: 'font.weight.bold',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $778018eca844ead1$var$readOnlyMobileAppStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    touchAction: 'none'
});
const $778018eca844ead1$var$popupContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    color: 'color.text'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$ErrorIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _kqaxgktf _1expgktf _autin7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqaxgktf _1expgktf _autin7od",
            __cmplp.className
        ])
    });
});
const $778018eca844ead1$var$readOnlyTitleWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.025' //to match 2px transparent border on InlineEdit readView
});
const $778018eca844ead1$var$tooltipStyles = null; // same styles as a tooltip but with no width restriction to accommodate longer messages
const $778018eca844ead1$export$7574cd0e3a4be128 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? function ToolTipOverride(t0, ref) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c81o8v _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f1pna"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function ToolTipOverride({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c81o8v _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f1pna"
        ])
    }, children);
});
const $778018eca844ead1$var$spotlightWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
function $778018eca844ead1$var$onFocus(evt) {
    evt.target.select();
}
const $778018eca844ead1$export$42d61ec2afde455f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(85);
    const { title: title, contentId: contentId, spaceName: spaceName, readOnly: readOnly, updateContentTree: updateContentTree, contentType: contentType, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler } = t0;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType === "whiteboard";
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== contentType || $[1] !== intl) {
        t1 = intl.formatMessage($778018eca844ead1$var$i18nByContentType.placeholder[contentType] || $778018eca844ead1$var$i18n.placeholder);
        $[0] = contentType;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    const placeholderText = t1;
    const { isEditing: isEditing, setIsEditing: setIsEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateLoading: updateLoading, updateError: updateError, updateTitle: updateTitle, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t2;
    if ($[3] !== isEditing || $[4] !== setUpdatedTitleFromPubsub || $[5] !== updateCache || $[6] !== updateContentTree) {
        t2 = async (_aris, pubsubRequestBody)=>{
            const title_0 = pubsubRequestBody?.contentTitleUpdateRequestBody.contentTitle;
            if (!(0, $9wGTI.fg)("cc_fps_migration_content-title") || ![
                "DUAL",
                "GRAPHQL"
            ].includes((0, $4VJDS.default).getString("confluence-migrate-fps-to-graphql-subscription", ""))) {
                if (!isEditing) {
                    updateCache(title_0);
                    updateContentTree();
                    setUpdatedTitleFromPubsub(undefined);
                } else setUpdatedTitleFromPubsub(title_0);
            }
        };
        $[3] = isEditing;
        $[4] = setUpdatedTitleFromPubsub;
        $[5] = updateCache;
        $[6] = updateContentTree;
        $[7] = t2;
    } else t2 = $[7];
    const onPubSubEvent = t2;
    const t3 = `titleUpdated:${contentType}`;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $9wGTI.fg)("cc_fps_migration_content-title") && (0, $4VJDS.default).getString("confluence-migrate-fps-to-graphql-subscription", "") === "GRAPHQL";
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== contentId || $[10] !== contentType || $[11] !== onPubSubEvent || $[12] !== t3) {
        t5 = {
            contentId: contentId,
            contentType: contentType,
            eventName: t3,
            onEvent: onPubSubEvent,
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES,
            skip: t4
        };
        $[9] = contentId;
        $[10] = contentType;
        $[11] = onPubSubEvent;
        $[12] = t3;
        $[13] = t5;
    } else t5 = $[13];
    (0, $bT0se.usePubSubEvent)(t5);
    const [isTitleSpotlightActive, setIsTitleSpotlightActive] = (0, $42omo.useState)(false);
    let t6;
    let t7;
    if ($[14] !== contentType || $[15] !== createAnalyticsEvent || $[16] !== isTitleSpotlightActive) {
        t6 = ()=>{
            if (isTitleSpotlightActive) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingSpotlightScreen",
                    attributes: {
                        contentType: contentType,
                        spotlight: "spotlight-content-type-title"
                    },
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        t7 = [
            contentType,
            createAnalyticsEvent,
            isTitleSpotlightActive
        ];
        $[14] = contentType;
        $[15] = createAnalyticsEvent;
        $[16] = isTitleSpotlightActive;
        $[17] = t6;
        $[18] = t7;
    } else {
        t6 = $[17];
        t7 = $[18];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[19] !== registerShowTitleSpotlightHandler || $[20] !== setIsEditing) {
        t8 = ()=>{
            registerShowTitleSpotlightHandler?.(()=>{
                setIsEditing(true);
                setIsTitleSpotlightActive(true);
            });
        };
        t9 = [
            registerShowTitleSpotlightHandler,
            setIsEditing,
            setIsTitleSpotlightActive
        ];
        $[19] = registerShowTitleSpotlightHandler;
        $[20] = setIsEditing;
        $[21] = t8;
        $[22] = t9;
    } else {
        t8 = $[21];
        t9 = $[22];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    if ($[23] !== isTitleSpotlightActive || $[24] !== onCloseTitleSpotlight) {
        t10 = ()=>{
            if (isTitleSpotlightActive) {
                setIsTitleSpotlightActive(false);
                onCloseTitleSpotlight?.();
            }
        };
        $[23] = isTitleSpotlightActive;
        $[24] = onCloseTitleSpotlight;
        $[25] = t10;
    } else t10 = $[25];
    const showNextSpotlight = t10;
    let t11;
    let t12;
    if ($[26] !== updateError) {
        t11 = ()=>{
            if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) (0, $7Sm4c.markErrorAsHandled)(updateError);
        };
        t12 = [
            updateError
        ];
        $[26] = updateError;
        $[27] = t11;
        $[28] = t12;
    } else {
        t11 = $[27];
        t12 = $[28];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[29] !== contentType || $[30] !== intl || $[31] !== placeholderText || $[32] !== updateError || $[33] !== updateLoading) {
        t13 = (t14)=>{
            const { errorMessage: errorMessage, ...fieldProps } = t14;
            const error = !!(fieldProps.isInvalid || updateError);
            const renderElemAfterInput = ()=>{
                if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$ErrorIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    label: "error"
                }));
                return null;
            };
            const renderErrorMessage = ()=>{
                if (fieldProps.isInvalid) return errorMessage;
                else {
                    if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) return intl.formatMessage($778018eca844ead1$var$i18nByContentType.duplicateTitleError[contentType] || $778018eca844ead1$var$i18n.duplicateTitleError);
                    else return intl.formatMessage($778018eca844ead1$var$i18n.generalError);
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$EditViewContainer, {
                "data-value": fieldProps.value
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$TextViewContainer, {
                errorIcon: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                autoFocus: false,
                isOpen: error,
                placement: "bottom-start",
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $778018eca844ead1$var$popupContainerStyles
                    }, renderErrorMessage()),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                        ...triggerProps,
                        ...fieldProps,
                        testId: "content-types-title-input",
                        width: "auto",
                        isCompact: true,
                        className: "text-field-input",
                        placeholder: placeholderText,
                        autoComplete: "off",
                        onFocus: $778018eca844ead1$var$onFocus,
                        autoFocus: true,
                        isDisabled: updateLoading,
                        isInvalid: error,
                        maxLength: $778018eca844ead1$export$f6d8ac9231e1baff + 1,
                        elemAfterInput: renderElemAfterInput()
                    }),
                shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-truedisco")
            })));
        };
        $[29] = contentType;
        $[30] = intl;
        $[31] = placeholderText;
        $[32] = updateError;
        $[33] = updateLoading;
        $[34] = t13;
    } else t13 = $[34];
    const renderEditView = t13;
    let t14;
    if ($[35] !== contentType || $[36] !== isMobileAppWhiteboard || $[37] !== readOnly || $[38] !== title) {
        t14 = ()=>{
            const permissionsMessage = $778018eca844ead1$var$i18nByContentType.permissionsTooltip[contentType] || $778018eca844ead1$var$i18n.permissionsTooltip;
            const message = readOnly ? permissionsMessage : $778018eca844ead1$var$i18n.renameTooltip;
            const TooltipComponent = isMobileAppWhiteboard ? (0, $42omo.Fragment) : (0, $3gadb.default);
            const tooltipProps = isMobileAppWhiteboard ? {
                content: undefined
            } : {
                component: $778018eca844ead1$export$7574cd0e3a4be128,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TooltipComponent, tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $778018eca844ead1$var$readOnlyContainerStyles
            }, title));
        };
        $[35] = contentType;
        $[36] = isMobileAppWhiteboard;
        $[37] = readOnly;
        $[38] = title;
        $[39] = t14;
    } else t14 = $[39];
    const renderReadView = t14;
    let t15;
    if ($[40] !== intl) {
        t15 = (value)=>{
            if (!value || value.length === 0) return intl.formatMessage($778018eca844ead1$var$i18n.emptyTitleError);
            if (value.length > $778018eca844ead1$export$f6d8ac9231e1baff) return intl.formatMessage($778018eca844ead1$var$i18n.titleLengthError, {
                maxLength: $778018eca844ead1$export$f6d8ac9231e1baff
            });
        };
        $[40] = intl;
        $[41] = t15;
    } else t15 = $[41];
    const validateName = t15;
    let t16;
    if ($[42] !== contentId || $[43] !== createAnalyticsEvent || $[44] !== setIsEditing || $[45] !== spaceId) {
        t16 = ()=>{
            setIsEditing(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contentTypeHeaderTitle",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        $[42] = contentId;
        $[43] = createAnalyticsEvent;
        $[44] = setIsEditing;
        $[45] = spaceId;
        $[46] = t16;
    } else t16 = $[46];
    const onTitleEdit = t16;
    const { setOptimisticTitle: setOptimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    let t17;
    if ($[47] !== contentId || $[48] !== createAnalyticsEvent || $[49] !== setOptimisticTitle || $[50] !== showNextSpotlight || $[51] !== spaceId || $[52] !== updateContentTree || $[53] !== updateTimestampCache || $[54] !== updateTitle) {
        t17 = async (value_0)=>{
            await updateTitle(value_0);
            setOptimisticTitle(value_0);
            updateContentTree();
            if ((0, $9wGTI.fg)("confluence_frontend_content_wrapper")) updateTimestampCache({
                contentId: contentId
            });
            showNextSpotlight();
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "updated",
                    actionSubject: "contentTypeHeaderTitle",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        $[47] = contentId;
        $[48] = createAnalyticsEvent;
        $[49] = setOptimisticTitle;
        $[50] = showNextSpotlight;
        $[51] = spaceId;
        $[52] = updateContentTree;
        $[53] = updateTimestampCache;
        $[54] = updateTitle;
        $[55] = t17;
    } else t17 = $[55];
    const onTitleUpdate = t17;
    let t18;
    if ($[56] !== isEditing || $[57] !== onTitleEdit || $[58] !== onTitleUpdate || $[59] !== renderEditView || $[60] !== renderReadView || $[61] !== title || $[62] !== validateName) {
        t18 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lUjjs.default), {
                isEditing: isEditing,
                onEdit: onTitleEdit,
                validate: validateName,
                onConfirm: onTitleUpdate,
                defaultValue: title,
                editView: renderEditView,
                readView: renderReadView,
                hideActionButtons: true
            });
        $[56] = isEditing;
        $[57] = onTitleEdit;
        $[58] = onTitleUpdate;
        $[59] = renderEditView;
        $[60] = renderReadView;
        $[61] = title;
        $[62] = validateName;
        $[63] = t18;
    } else t18 = $[63];
    const renderInlineEdit = t18;
    let t19;
    if ($[64] !== isMobileAppWhiteboard || $[65] !== renderReadView) {
        t19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                testId: "content-types-title-read-only-view",
                xcss: [
                    $778018eca844ead1$var$readOnlyTitleWrapperStyles,
                    isMobileAppWhiteboard && $778018eca844ead1$var$readOnlyMobileAppStyles
                ]
            }, renderReadView());
        $[64] = isMobileAppWhiteboard;
        $[65] = renderReadView;
        $[66] = t19;
    } else t19 = $[66];
    const renderReadOnlyTitle = t19;
    let t20;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
        });
        $[67] = t20;
    } else t20 = $[67];
    let t21;
    if ($[68] !== updateError) {
        t21 = updateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: updateError
        });
        $[68] = updateError;
        $[69] = t21;
    } else t21 = $[69];
    let t22;
    if ($[70] !== spaceName || $[71] !== title) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: spaceName
        });
        $[70] = spaceName;
        $[71] = title;
        $[72] = t22;
    } else t22 = $[72];
    let t23;
    if ($[73] !== readOnly || $[74] !== renderInlineEdit || $[75] !== renderReadOnlyTitle) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$Title, null, readOnly ? renderReadOnlyTitle() : renderInlineEdit());
        $[73] = readOnly;
        $[74] = renderInlineEdit;
        $[75] = renderReadOnlyTitle;
        $[76] = t23;
    } else t23 = $[76];
    let t24;
    if ($[77] !== isTitleSpotlightActive) {
        t24 = isTitleSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $778018eca844ead1$var$spotlightWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91xA1.default), {
            key: "whiteboard-onboarding-title-target",
            width: 287
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $778018eca844ead1$var$i18n.onboardingSpotlightBody)));
        $[77] = isTitleSpotlightActive;
        $[78] = t24;
    } else t24 = $[78];
    let t25;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
            metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
        });
        $[79] = t25;
    } else t25 = $[79];
    let t26;
    if ($[80] !== t21 || $[81] !== t22 || $[82] !== t23 || $[83] !== t24) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t20, t21, t22, t23, t24, t25);
        $[80] = t21;
        $[81] = t22;
        $[82] = t23;
        $[83] = t24;
        $[84] = t26;
    } else t26 = $[84];
    return t26;
} : ({ title: title, contentId: contentId, spaceName: spaceName, readOnly: readOnly, updateContentTree: updateContentTree, contentType: contentType, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType === 'whiteboard';
    const intl = (0, $8C5kA.default)();
    const placeholderText = intl.formatMessage($778018eca844ead1$var$i18nByContentType.placeholder[contentType] || $778018eca844ead1$var$i18n.placeholder);
    const { isEditing: isEditing, setIsEditing: setIsEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateLoading: updateLoading, updateError: updateError, updateTitle: updateTitle, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const onPubSubEvent = (0, $42omo.useCallback)(async (_aris, pubsubRequestBody)=>{
        const title_0 = pubsubRequestBody?.contentTitleUpdateRequestBody.contentTitle; // we want to skip this pubsub event when our gate is rolling out
        // but still allow pubsub events to be fired
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if (!(0, $9wGTI.fg)('cc_fps_migration_content-title') || ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))) {
            if (!isEditing) {
                updateCache(title_0);
                updateContentTree();
                setUpdatedTitleFromPubsub(undefined);
            } else setUpdatedTitleFromPubsub(title_0);
        }
    }, [
        isEditing,
        updateCache,
        updateContentTree,
        setUpdatedTitleFromPubsub
    ]);
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType,
        eventName: `titleUpdated:${contentType}`,
        onEvent: onPubSubEvent,
        attribution: (0, $3IBnw.Attribution).CONTENT_TYPES,
        skip: (0, $9wGTI.fg)('cc_fps_migration_content-title') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    const [isTitleSpotlightActive, setIsTitleSpotlightActive] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (isTitleSpotlightActive) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'onboardingSpotlightScreen',
                attributes: {
                    contentType: contentType,
                    spotlight: 'spotlight-content-type-title'
                },
                source: 'contentTypesHeader'
            }
        }).fire();
    }, [
        contentType,
        createAnalyticsEvent,
        isTitleSpotlightActive
    ]);
    (0, $42omo.useEffect)(()=>{
        registerShowTitleSpotlightHandler?.(()=>{
            setIsEditing(true);
            setIsTitleSpotlightActive(true);
        });
    }, [
        registerShowTitleSpotlightHandler,
        setIsEditing,
        setIsTitleSpotlightActive
    ]);
    const showNextSpotlight = (0, $42omo.useCallback)(()=>{
        if (isTitleSpotlightActive) {
            setIsTitleSpotlightActive(false);
            onCloseTitleSpotlight?.();
        }
    }, [
        isTitleSpotlightActive,
        onCloseTitleSpotlight,
        setIsTitleSpotlightActive
    ]);
    (0, $42omo.useEffect)(()=>{
        if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) // This is handled in the UI and doesn't need to be reported
        (0, $7Sm4c.markErrorAsHandled)(updateError);
    }, [
        updateError
    ]);
    const renderEditView = ({ errorMessage: errorMessage, ...fieldProps })=>{
        const error = !!(fieldProps.isInvalid || updateError);
        const renderElemAfterInput = ()=>{
            if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$ErrorIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious",
                label: "error"
            }));
            return null;
        };
        const renderErrorMessage = ()=>{
            if (fieldProps.isInvalid) return errorMessage;
            else if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) return intl.formatMessage($778018eca844ead1$var$i18nByContentType.duplicateTitleError[contentType] || $778018eca844ead1$var$i18n.duplicateTitleError);
            else return intl.formatMessage($778018eca844ead1$var$i18n.generalError);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$EditViewContainer, {
            "data-value": fieldProps.value
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$TextViewContainer, {
            errorIcon: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            autoFocus: false,
            isOpen: error,
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $778018eca844ead1$var$popupContainerStyles
                }, renderErrorMessage()),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                    ...triggerProps,
                    ...fieldProps,
                    testId: "content-types-title-input",
                    width: "auto",
                    isCompact: true // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    ,
                    className: "text-field-input",
                    placeholder: placeholderText,
                    autoComplete: "off",
                    onFocus: $778018eca844ead1$var$onFocus,
                    autoFocus: true,
                    isDisabled: updateLoading,
                    isInvalid: error,
                    maxLength: $778018eca844ead1$export$f6d8ac9231e1baff + 1,
                    elemAfterInput: renderElemAfterInput()
                }),
            shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truedisco')
        })));
    };
    const renderReadView = ()=>{
        const permissionsMessage = $778018eca844ead1$var$i18nByContentType.permissionsTooltip[contentType] || $778018eca844ead1$var$i18n.permissionsTooltip;
        const message = readOnly ? permissionsMessage : $778018eca844ead1$var$i18n.renameTooltip;
        const TooltipComponent = isMobileAppWhiteboard ? (0, $42omo.Fragment) : (0, $3gadb.default);
        const tooltipProps = isMobileAppWhiteboard ? {
            content: undefined
        } : {
            component: $778018eca844ead1$export$7574cd0e3a4be128,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TooltipComponent, tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $778018eca844ead1$var$readOnlyContainerStyles
        }, title));
    };
    const validateName = (value)=>{
        if (!value || value.length === 0) return intl.formatMessage($778018eca844ead1$var$i18n.emptyTitleError);
        if (value.length > $778018eca844ead1$export$f6d8ac9231e1baff) return intl.formatMessage($778018eca844ead1$var$i18n.titleLengthError, {
            maxLength: $778018eca844ead1$export$f6d8ac9231e1baff
        });
    };
    const onTitleEdit = (0, $42omo.useCallback)(()=>{
        setIsEditing(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'contentTypeHeaderTitle',
                containerType: 'space',
                containerId: spaceId,
                objectId: contentId,
                source: 'contentTypesHeader'
            }
        }).fire();
    }, [
        setIsEditing,
        createAnalyticsEvent,
        contentId,
        spaceId
    ]);
    const { setOptimisticTitle: setOptimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const onTitleUpdate = (0, $42omo.useCallback)(async (value_0)=>{
        await updateTitle(value_0);
        setOptimisticTitle(value_0);
        updateContentTree(); // Update timestamp cache so that Last Edited in object header responsively updates
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) updateTimestampCache({
            contentId: contentId
        });
        showNextSpotlight();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'updated',
                actionSubject: 'contentTypeHeaderTitle',
                containerType: 'space',
                containerId: spaceId,
                objectId: contentId,
                source: 'contentTypesHeader'
            }
        }).fire();
    }, [
        updateTitle,
        createAnalyticsEvent,
        contentId,
        showNextSpotlight,
        spaceId,
        updateContentTree,
        setOptimisticTitle,
        updateTimestampCache
    ]);
    const renderInlineEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lUjjs.default), {
            isEditing: isEditing,
            onEdit: onTitleEdit,
            validate: validateName,
            onConfirm: onTitleUpdate,
            defaultValue: title,
            editView: renderEditView,
            readView: renderReadView,
            hideActionButtons: true
        });
    const renderReadOnlyTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "content-types-title-read-only-view",
            xcss: [
                $778018eca844ead1$var$readOnlyTitleWrapperStyles,
                isMobileAppWhiteboard && $778018eca844ead1$var$readOnlyMobileAppStyles
            ]
        }, renderReadView());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
    }), updateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: updateError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        contentTitle: title,
        contentSpace: spaceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778018eca844ead1$var$Title, null, readOnly ? renderReadOnlyTitle() : renderInlineEdit()), isTitleSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $778018eca844ead1$var$spotlightWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91xA1.default), {
        key: "whiteboard-onboarding-title-target",
        width: 287
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $778018eca844ead1$var$i18n.onboardingSpotlightBody))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
    }));
};


const $4cb3eaaf01c9d693$export$dce52735e291d3da = {
    showMove: true,
    showArchive: true,
    showCopy: true,
    showBreadcrumbs: true,
    showFavourite: true,
    showShare: true,
    showMainActions: true,
    showMoreActions: true,
    showClassificationMenuAction: false,
    showContentRestrictions: true,
    showWatchDialog: true,
    showLastEdited: true,
    showPresence: true,
    showWhiteboardTeammate: true
};


const $71c531080fb6afdc$export$753f77420b5437b9 = ({ isSpaceOverviewPage: isSpaceOverviewPage, contentMode: contentMode, editorTitle: editorTitle, contentTitle: contentTitle })=>{
    if (isSpaceOverviewPage) // Pass an undefined string to contentTitle to prevent the breadcrumbs from rendering
    // a title when this is a Space Overview page
    return undefined;
    // intentionally exclude live mode, we want to return published content title since live mode publishes their title on every change
    if (contentMode === 'edit' || contentMode === 'draft') // pass the editorTitle as-is, even if it is an empty string (empty strings will be transformed into "Untitled")
    // pass in contentTitle if editorTitle is not available to prevent any breadcrumbs layout shifting during load (especially for drafts)
    return typeof editorTitle === 'string' ? editorTitle : typeof contentTitle === 'string' ? contentTitle : undefined;
    return contentTitle ?? undefined;
};









var $9vvQJ = parcelRequire("9vvQJ");


var $1qfLF = parcelRequire("1qfLF");


var $gqqjz = parcelRequire("gqqjz");





var $iAOfI = parcelRequire("iAOfI");


var $cxCWb = parcelRequire("cxCWb");





var $4c4ke = parcelRequire("4c4ke");


var $9SsRl = parcelRequire("9SsRl");


var $5EoFB = parcelRequire("5EoFB");


var $jLw6A = parcelRequire("jLw6A");








var $hAnPj = parcelRequire("hAnPj");





var $jFm04 = parcelRequire("jFm04");


var $3dPSK = parcelRequire("3dPSK");


var $2cKGu = parcelRequire("2cKGu");








var $4wEOc = parcelRequire("4wEOc");

const $66bd5ba8343e39f0$var$isContentTypeApplicable = (contentType, isLivePage = false)=>{
    if (contentType === 'page' && isLivePage) return true;
    return [
        'whiteboard',
        'database'
    ].includes(contentType);
};
const $66bd5ba8343e39f0$export$48cea123122bbc52 = (contentType, isLivePage = false, shouldSkipEnablementQuery = false)=>{
    const { isEnabled: isClassificationEnabledForOrg } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)({
        skip: shouldSkipEnablementQuery
    });
    // when object header is enabled, it's enabled for all content types
    return ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || $66bd5ba8343e39f0$var$isContentTypeApplicable(contentType, isLivePage)) && isClassificationEnabledForOrg;
};









var $jeQ9x = parcelRequire("jeQ9x");








var $jypE9 = parcelRequire("jypE9");


var $dj7jL = parcelRequire("dj7jL");

var $1DfVr = parcelRequire("1DfVr");


var $gK1lf = parcelRequire("gK1lf");




const $0f9c0b3d7e5360a3$export$7c95b5e4cc9d3256 = ()=>{
    const previewPanelUrl = (0, $4VJDS.default).getString('confluence_page_preview_panel_testing', '');
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE);
    const isOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    if (!previewPanelUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))),
        label: "Preview Panel Test",
        onClick: ()=>isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel(previewPanelUrl)
    });
};



var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $jmjWc = parcelRequire("jmjWc");


const $fc0e6c31b10b3145$export$ad537527a445740e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GFqC1",
    name: "AgentPresenceLoader",
    loader: async ()=>(await (parcelRequire("eGUYy"))).AgentPresence
});



var $6mKj3 = parcelRequire("6mKj3");


var $cxu5H = parcelRequire("cxu5H");


var $bjZbA = parcelRequire("bjZbA");


var $3o3i5 = parcelRequire("3o3i5");














var $1kaTo = parcelRequire("1kaTo");





var $8jTDW = parcelRequire("8jTDW");


var $imt6g = parcelRequire("imt6g");


var $jY68A = parcelRequire("jY68A");

var $5194c70d50ff0c56$export$cffcd5612128d7f0 = /*#__PURE__*/ function(ContentStatusName) {
    ContentStatusName["OFFLINE"] = "offline";
    ContentStatusName["SAVING"] = "saving";
    ContentStatusName["SAVED"] = "saved";
    ContentStatusName["HIDDEN"] = "hidden";
    return ContentStatusName;
}({});
const $5194c70d50ff0c56$var$Icons = {
    saved: (0, (/*@__PURE__*/$parcel$interopDefault($imt6g))),
    saving: (0, (/*@__PURE__*/$parcel$interopDefault($jY68A))),
    offline: (0, (/*@__PURE__*/$parcel$interopDefault($8jTDW)))
};
const $5194c70d50ff0c56$export$37094bddf66458ca = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { status: status, label: label } = t0;
    const Icon = $5194c70d50ff0c56$var$Icons[status];
    const t1 = `${status}-icon`;
    let t2;
    if ($[0] !== Icon || $[1] !== label || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            color: "var(--ds-icon-subtle, #505258)",
            label: label,
            testId: t1
        });
        $[0] = Icon;
        $[1] = label;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ status: status, label: label })=>{
    const Icon = $5194c70d50ff0c56$var$Icons[status];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        color: "var(--ds-icon-subtle, #505258)",
        label: label,
        testId: `${status}-icon`
    });
};
const $5194c70d50ff0c56$export$437945b454cdf5e5 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { contentStatus: contentStatus } = t0;
    const [inProp, setInProp] = (0, $42omo.useState)(false);
    const [currentStatus, setCurrentStatus] = (0, $42omo.useState)("hidden");
    let t1;
    if ($[0] !== contentStatus.status || $[1] !== currentStatus) {
        t1 = ()=>{
            setInProp(contentStatus.status !== currentStatus);
            setCurrentStatus(contentStatus.status);
        };
        $[0] = contentStatus.status;
        $[1] = currentStatus;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== contentStatus || $[4] !== currentStatus) {
        t2 = [
            contentStatus,
            currentStatus
        ];
        $[3] = contentStatus;
        $[4] = currentStatus;
        $[5] = t2;
    } else t2 = $[5];
    (0, $42omo.useEffect)(t1, t2);
    const t3 = `indicator-icon-${contentStatus.status}`;
    let t4;
    if ($[6] !== contentStatus.status || $[7] !== contentStatus.tooltipText) {
        t4 = contentStatus.status !== "hidden" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$var$IndicatorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$export$37094bddf66458ca, {
            status: contentStatus.status,
            label: contentStatus.tooltipText
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-types-hidden-status"
        });
        $[6] = contentStatus.status;
        $[7] = contentStatus.tooltipText;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== currentStatus || $[10] !== inProp || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kaTo.default), {
            in: inProp,
            key: currentStatus,
            classNames: t3,
            timeout: 300
        }, t4);
        $[9] = currentStatus;
        $[10] = inProp;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== contentStatus.tooltipText || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$export$35212f567cb1e6e9, {
            "data-testid": "content-types-content-status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: contentStatus.tooltipText
        }, t5));
        $[14] = contentStatus.tooltipText;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ contentStatus: contentStatus })=>{
    const [inProp, setInProp] = (0, $42omo.useState)(false);
    const [currentStatus, setCurrentStatus] = (0, $42omo.useState)("hidden");
    (0, $42omo.useEffect)(()=>{
        setInProp(contentStatus.status !== currentStatus);
        setCurrentStatus(contentStatus.status);
    }, [
        contentStatus,
        currentStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$export$35212f567cb1e6e9, {
        "data-testid": "content-types-content-status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: contentStatus.tooltipText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kaTo.default), {
        in: inProp,
        key: currentStatus,
        classNames: `indicator-icon-${contentStatus.status}`,
        timeout: 300
    }, contentStatus.status !== "hidden" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$var$IndicatorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5194c70d50ff0c56$export$37094bddf66458ca, {
        status: contentStatus.status,
        label: contentStatus.tooltipText
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "content-types-hidden-status"
    }))));
};
const $5194c70d50ff0c56$export$35212f567cb1e6e9 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2hwxu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5194c70d50ff0c56$var$IndicatorIconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o _qn0x1fvh _x0eacs5v _1xlgidpf _r30bwdr0 _4u84cs5v _sapykb7n _10g31h7a _1abp1h6o _pc0t1fvh _ng5tkb7n _1x13kb7n _1u8zfnf5 _1omo1fvh _1hwbkb7n _py3nidpf _5r8x1fvh _1fb9t5al _1bytidpf _rdeb1xws _136x1xty _103wkb7n _zxs9kb7n _1kxwkb7n _1w6fidpf _1pci1fvh _1yg6kb7n _1svqfnf5 _eo5j163n _t44qymdr _1d1n12c5 _32o81h6o _4hkwkb7n _t095kb7n _1uc9kb7n _14t3163n _ozapymdr _1d0e12c5 _1xqi1h6o _1naj1fvh _2exnidpf _v68q163n _1m21ymdr _1cf012c5 _pcd11h6o _1cmokb7n _10f0kb7n _sycckb7n _7aw3163n _iz90ymdr _1owd12c5 _1a0w1h6o _11g8cs5v _1wq6idpf _st4e1u4m _1tgy1h6o _qadecs5v _1fk7idpf _1vdd1u4m _13ia1h6o _1sy1cs5v _yxttidpf _mkd3187n _zxim187n _1yh4a7yc _adowkb7n _2h9pzwfg _13pozwfg _138midpf _h9cnkb7n _xinxkb7n _irr3ysee",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o _qn0x1fvh _x0eacs5v _1xlgidpf _r30bwdr0 _4u84cs5v _sapykb7n _10g31h7a _1abp1h6o _pc0t1fvh _ng5tkb7n _1x13kb7n _1u8zfnf5 _1omo1fvh _1hwbkb7n _py3nidpf _5r8x1fvh _1fb9t5al _1bytidpf _rdeb1xws _136x1xty _103wkb7n _zxs9kb7n _1kxwkb7n _1w6fidpf _1pci1fvh _1yg6kb7n _1svqfnf5 _eo5j163n _t44qymdr _1d1n12c5 _32o81h6o _4hkwkb7n _t095kb7n _1uc9kb7n _14t3163n _ozapymdr _1d0e12c5 _1xqi1h6o _1naj1fvh _2exnidpf _v68q163n _1m21ymdr _1cf012c5 _pcd11h6o _1cmokb7n _10f0kb7n _sycckb7n _7aw3163n _iz90ymdr _1owd12c5 _1a0w1h6o _11g8cs5v _1wq6idpf _st4e1u4m _1tgy1h6o _qadecs5v _1fk7idpf _1vdd1u4m _13ia1h6o _1sy1cs5v _yxttidpf _mkd3187n _zxim187n _1yh4a7yc _adowkb7n _2h9pzwfg _13pozwfg _138midpf _h9cnkb7n _xinxkb7n _irr3ysee",
            __cmplp.className
        ])
    });
});















var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48a5da156a2c7b78$var$StyledMainActions = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81nxw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81nxw",
            __cmplp.className
        ])
    });
});
const $48a5da156a2c7b78$var$ConditionalWrapper = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
const $48a5da156a2c7b78$var$TooltipWrapper = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { mainAction: mainAction, children: children } = t0;
    const t1 = `${mainAction.id}-tooltip`;
    let t2;
    if ($[0] !== children || $[1] !== mainAction.tooltip || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: mainAction.tooltip,
            testId: t1
        }, children);
        $[0] = children;
        $[1] = mainAction.tooltip;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ mainAction: mainAction, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: mainAction.tooltip,
        testId: `${mainAction.id}-tooltip`
    }, children);
const $48a5da156a2c7b78$export$a37ba60443eae06e = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { mainActions: mainActions } = t0;
    let t1;
    if ($[0] !== mainActions) {
        t1 = mainActions?.map($48a5da156a2c7b78$var$_temp);
        $[0] = mainActions;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ mainActions: mainActions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, mainActions?.map((mainAction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($48a5da156a2c7b78$var$StyledMainActions, {
            key: mainAction.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($48a5da156a2c7b78$var$ConditionalWrapper, {
            condition: mainAction.tooltip !== undefined,
            wrapper: (children)=>$48a5da156a2c7b78$var$TooltipWrapper({
                    mainAction: mainAction,
                    children: children
                })
        }, mainAction.buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            href: mainAction.buttonLink,
            appearance: mainAction.appearance,
            isSelected: mainAction.isSelected,
            onClick: mainAction.onClick,
            iconBefore: ()=>mainAction.icon,
            testId: mainAction.id,
            target: mainAction.openInNewTab ? '_blank' : '_self'
        }, mainAction.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: mainAction.appearance,
            isSelected: mainAction.isSelected,
            onClick: mainAction.onClick,
            iconBefore: ()=>mainAction.icon,
            testId: mainAction.id
        }, mainAction.text || mainAction.label)))));
};
function $48a5da156a2c7b78$var$_temp(mainAction) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($48a5da156a2c7b78$var$StyledMainActions, {
        key: mainAction.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($48a5da156a2c7b78$var$ConditionalWrapper, {
        condition: mainAction.tooltip !== undefined,
        wrapper: (children)=>$48a5da156a2c7b78$var$TooltipWrapper({
                mainAction: mainAction,
                children: children
            })
    }, mainAction.buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: mainAction.buttonLink,
        appearance: mainAction.appearance,
        isSelected: mainAction.isSelected,
        onClick: mainAction.onClick,
        iconBefore: ()=>mainAction.icon,
        testId: mainAction.id,
        target: mainAction.openInNewTab ? "_blank" : "_self"
    }, mainAction.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: mainAction.appearance,
        isSelected: mainAction.isSelected,
        onClick: mainAction.onClick,
        iconBefore: ()=>mainAction.icon,
        testId: mainAction.id
    }, mainAction.text || mainAction.label)));
}




























var $4rwCt = parcelRequire("4rwCt");


var $6R5uz = parcelRequire("6R5uz");


var $1Zr9M = parcelRequire("1Zr9M");


var $4GKfl = parcelRequire("4GKfl");





var $fIcbd = parcelRequire("fIcbd");


var $6fjxX = parcelRequire("6fjxX");


var $1yB28 = parcelRequire("1yB28");





var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");













var $56M4r = parcelRequire("56M4r");


var $5tOl1 = parcelRequire("5tOl1");


var $eix0u = parcelRequire("eix0u");


var $4BqOc = parcelRequire("4BqOc");


var $isYda = parcelRequire("isYda");


var $fnaPh = parcelRequire("fnaPh");


var $kFjZK = parcelRequire("kFjZK");


var $9Q2dU = parcelRequire("9Q2dU");


var $3KUzn = parcelRequire("3KUzn");


var $ci7Ox = parcelRequire("ci7Ox");


var $kevJM = parcelRequire("kevJM");




var $2Fndw = parcelRequire("2Fndw");


var $avrhI = parcelRequire("avrhI");


var $kpYGL = parcelRequire("kpYGL");


var $9aGns = parcelRequire("9aGns");


var $jluld = parcelRequire("jluld");


var $fwDOR = parcelRequire("fwDOR");


var $bPdpL = parcelRequire("bPdpL");


var $4cOi8 = parcelRequire("4cOi8");





var $euL71 = parcelRequire("euL71");


var $gDbO8 = parcelRequire("gDbO8");





var $gEtAQ = parcelRequire("gEtAQ");





var $78wUU = parcelRequire("78wUU");

parcelRequire("aYZaZ");
var $iQb1R = parcelRequire("iQb1R");


var $d8oE8 = parcelRequire("d8oE8");











var $6ykQV = parcelRequire("6ykQV");


var $eSLr0 = parcelRequire("eSLr0");


var $fjiOd = parcelRequire("fjiOd");


var $kxhju = parcelRequire("kxhju");


var $bHd1w = parcelRequire("bHd1w");


var $5FwhF = parcelRequire("5FwhF");


var $3J7TU = parcelRequire("3J7TU");














var $1Zthr = parcelRequire("1Zthr");


var $k22lL = parcelRequire("k22lL");


var $2WH1B = parcelRequire("2WH1B");


var $kRW4Y = parcelRequire("kRW4Y");


var $bQm3c = parcelRequire("bQm3c");





var $ln0hx = parcelRequire("ln0hx");

var $hjygH = parcelRequire("hjygH");



var $1kHsc = parcelRequire("1kHsc");


var $dcvq8 = parcelRequire("dcvq8");


var $c54hr = parcelRequire("c54hr");


var $aCrkK = parcelRequire("aCrkK");


var $5thep = parcelRequire("5thep");







const $ff966189b275be15$export$78b7a39935e0bb86 = (contentType, contentMode, isSpaceOverviewPage)=>{
    if (contentType === 'page' && !isSpaceOverviewPage) return contentMode === 'view';
    return false;
};
const $ff966189b275be15$export$a130e0ea03d42b0b = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view';
    return contentType === 'whiteboard' || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$32820bf57e654cf8 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'edit';
    return contentType === 'whiteboard' || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$58a134bd2769b459 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'archived';
    else if (contentType === 'blogpost') return contentMode === 'view';
    return contentType === 'whiteboard' || contentType === 'database';
};
const $ff966189b275be15$export$dec488a51a9b97f0 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'edit' || contentMode === 'draft';
    else if (contentType === 'blogpost') return contentMode === 'view' || contentMode === 'edit' || contentMode === 'draft';
    return contentType === 'whiteboard' || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$f7bde71715697ce0 = (contentType, contentMode, readOnly)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'draft';
    if (contentType === 'whiteboard') return (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') && !readOnly;
    return contentType === 'database' && contentMode !== 'archived' && !readOnly;
};
const $ff966189b275be15$export$a2eada40e8c9a2ed = (contentType, contentMode, isSpaceOverviewPage)=>{
    return (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'view' || contentMode === 'live') && !isSpaceOverviewPage;
};
const $ff966189b275be15$export$d790dfbcfcf44b71 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'edit' || contentMode === 'draft';
    return false;
};
const $ff966189b275be15$export$caca47bf68c8998 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' && !(0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false) || contentMode === 'edit';
    else if (contentType === 'blogpost') return contentMode === 'edit';
    return false;
};
const $ff966189b275be15$export$71ad62dbe8638043 = (contentType, contentMode, hasEditPermission, livePageMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (!hasEditPermission) return false;
        if (contentType === 'page' && contentMode === 'live' && livePageMode === 'view') return false;
        return contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft';
    }
    return false;
};
const $ff966189b275be15$export$d0c33a26470e0efe = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'edit';
    return false;
};
const $ff966189b275be15$export$493ddb7a4c710fed = (contentType, contentMode, isDeleteDraftAllowed, isAutoConvertedDraftRevertEnabled)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'edit' && isDeleteDraftAllowed) return true;
        else if (isAutoConvertedDraftRevertEnabled && contentType === 'page' && contentMode === 'draft') return true;
        else if (contentMode === 'view') return true;
    }
    return false;
};
const $ff966189b275be15$export$bb21210c1c36f22a = (contentType, contentMode, isSpaceOverviewPage)=>{
    if (contentType === 'page' && !isSpaceOverviewPage) return contentMode === 'view' || contentMode === 'live' || contentMode === 'archived';
    return false;
};
const $ff966189b275be15$export$49f8860e43af4419 = (contentType, contentMode)=>{
    return (contentType === 'page' || contentType === 'blogpost') && contentMode !== 'draft' && contentMode !== 'edit';
};
const $ff966189b275be15$export$8623af461a2f6a54 = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'live' || contentMode === 'view';
    return false;
};
const $ff966189b275be15$export$46e46e0c15d57a1 = (contentType)=>{
    return contentType === 'whiteboard' || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$1711931c27adfab0 = (contentType)=>{
    return contentType === 'whiteboard' || contentType === 'database';
};
const $ff966189b275be15$export$11233ac17765daec = (contentType)=>{
    return contentType === 'whiteboard' && !(0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') || contentType === 'database' && !(0, $9wGTI.fg)('databases-frontend-content-wrapper') || contentType === 'embed';
};
const $ff966189b275be15$export$5e9136e7e220ab40 = (contentType)=>{
    if (contentType === 'page' || contentType === 'blogpost') // Classify content has moved to the details panel for all page & blogpost types
    return false;
    return contentType === 'whiteboard' && !(0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') || contentType === 'database' && !(0, $9wGTI.fg)('databases-frontend-content-wrapper');
};
const $ff966189b275be15$export$3d371a49efa2fa0a = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode !== 'draft';
    return contentType === 'whiteboard' || contentType === 'database';
};
const $ff966189b275be15$export$4a2abd609e31ae47 = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper');
};
const $ff966189b275be15$export$37d144a1b557c80d = (contentType, contentMode)=>{
    return contentType === 'page' && contentMode === 'live';
};
const $ff966189b275be15$export$74e87e549c7a0f96 = (contentType, contentMode)=>{
    return (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'edit' || contentMode === 'draft');
};
const $ff966189b275be15$export$458bbd6d88041c9d = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'archived';
    else if (contentType === 'blogpost') return contentMode === 'view';
    return false;
};





const $1b70db1d5649f5f3$export$5dc260e4e702b5d0 = (contentType)=>{
    return (contentType === 'whiteboard' || contentType === 'database') && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments');
};









var $6hmtW = parcelRequire("6hmtW");


var $9BVDK = parcelRequire("9BVDK");


var $6eFi0 = parcelRequire("6eFi0");


var $2E1L5 = parcelRequire("2E1L5");


var $ai7NK = parcelRequire("ai7NK");


var $2kB0r = parcelRequire("2kB0r");

/* VersionHistoryOnboardingSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1lhEF = parcelRequire("1lhEF");




// These custom styles are neccessary so the SpotlightPulse doesn't get cut off by the bounds of the menu.
const $330cc2928c11abea$var$spotlightStyles = null;
const $330cc2928c11abea$export$cf692ceb431cd214 = ({ children: children, contentType: contentType, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'versionHistorySpotlightPulse',
                attributes: {
                    source: source,
                    objectType: contentType
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        "data-testId": "version-history-spotlight-pulse",
        radius: 3,
        className: (0, $gMc0m.default)([
            "_18u0v77o _2hwxv77o"
        ])
    }, children);
};



var $5KL6w = parcelRequire("5KL6w");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $4GDP8 = parcelRequire("4GDP8");


var $7J5Uc = parcelRequire("7J5Uc");


var $5yVAS = parcelRequire("5yVAS");


var $4ZXww = parcelRequire("4ZXww");


var $bzwhi = parcelRequire("bzwhi");





var $3eMfQ = parcelRequire("3eMfQ");


var $foQ4a = parcelRequire("foQ4a");





const $c06b6cca0a728bb0$export$154e7cde95b8409b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-pxiH",
    name: "LazyWatchSettingsOverflowMenuShortcut",
    loader: async ()=>(await (parcelRequire("lQ86k"))).WatchSettingsOverflowMenuShortcut
});


/**
 * @graphql cc
 */ 













var $eSUdr = parcelRequire("eSUdr");





var $917iu = parcelRequire("917iu");












var $8cjip = parcelRequire("8cjip");


var $fCjCI = parcelRequire("fCjCI");





var $1o4fX = parcelRequire("1o4fX");


var $1uFM6 = parcelRequire("1uFM6");





var $8Lx5S = parcelRequire("8Lx5S");





var $f9HtC = parcelRequire("f9HtC");








var $7aRa9 = parcelRequire("7aRa9");




/**
 * @graphql cc
 */ 





















var $3pU8m = parcelRequire("3pU8m");

var $fKL7x = parcelRequire("fKL7x");




















var $jle6C = parcelRequire("jle6C");

const $d49593a2f9070b10$var$i18n = (0, $cgtv4.defineMessages)({
    watchThisContent: {
        id: "watch-dialog.overflow-menu.watch-this-content",
        defaultMessage: "Watch this content"
    },
    watchChildItems: {
        id: "watch-dialog.overflow-menu.watch-child-items",
        defaultMessage: "Watch child items"
    },
    watchNewBlogposts: {
        id: "watch-dialog.overflow-menu.watch-new-blog-posts",
        defaultMessage: "Watch new blog posts"
    },
    watchAllContent: {
        id: "watch-dialog.overflow-menu.watch-all-content",
        defaultMessage: "Watch all content in this space"
    },
    watchingContentTitle: {
        id: "watch-dialog.overflow-menu.watching-content-flag-title",
        defaultMessage: "You\u2019re watching this content"
    },
    watchingContentDescription: {
        id: "watch-dialog.overflow-menu.watching-content-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to it."
    },
    watchingWhiteboardTitle: {
        id: "watch-dialog.overflow-menu.watching-whiteboard-flag-title",
        defaultMessage: "You\u2019re watching this whiteboard"
    },
    watchingWhiteboardDescription: {
        id: "watch-dialog.overflow-menu.watching-whiteboard-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    watchingDatabaseTitle: {
        id: "watch-dialog.overflow-menu.watching-database-flag-title",
        defaultMessage: "You\u2019re watching this database"
    },
    watchingDatabaseDescription: {
        id: "watch-dialog.overflow-menu.watching-database-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    stoppedWatchingContentTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-content-flag-title",
        defaultMessage: "You stopped watching this content"
    },
    stoppedWatchingContentDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-content-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to it."
    },
    stoppedWatchingWhiteboardTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-title",
        defaultMessage: "You stopped watching this whiteboard"
    },
    stoppedWatchingWhiteboardDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    stoppedWatchingDatabaseTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-database-flag-title",
        defaultMessage: "You stopped watching this database"
    },
    stoppedWatchingDatabaseDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-database-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    watchingNewBlogpostsTitle: {
        id: "watch-dialog.overflow-menu.watching-blogs-flag-title",
        defaultMessage: "You\u2019re watching for new blog posts"
    },
    watchingNewBlogpostsDescription: {
        id: "watch-dialog.overflow-menu.watching-blogs-flag-description",
        defaultMessage: "You\u2019ll receive email updates about new blog posts in this space."
    },
    stoppedWatchingBlogpostsTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-blogs-flag-title",
        defaultMessage: "You stopped watching for new blog posts"
    },
    stoppedWatchingBlogpostsDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-blogs-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about new blog posts in this space."
    },
    watchSpaceTitle: {
        id: "watch-dialog.overflow-menu.watching-space-flag-title",
        defaultMessage: "You\u2019re watching content in this space"
    },
    watchSpaceDescription: {
        id: "watch-dialog.overflow-menu.watching-space-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to content in this space."
    },
    stoppedWatchingSpaceTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-space-flag-title",
        defaultMessage: "You stopped watching content in this space"
    },
    stoppedWatchingSpaceDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-space-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to content in this space."
    },
    watchChildrenTitle: {
        id: "watch-dialog.overflow-menu.watching-children-flag-title",
        defaultMessage: "You\u2019re watching child items"
    },
    watchChildrenDescription: {
        id: "watch-dialog.overflow-menu.watching-children-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to this content\u2019s child items."
    },
    stoppedWatchingChildrenTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-children-flag-title",
        defaultMessage: "You stopped watching child items"
    },
    stoppedWatchingChildrenDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-children-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to this content\u2019s child items."
    },
    ancestorWatchStatus: {
        id: "watch-dialog.overflow-menu.ancestor-watch-status",
        defaultMessage: "You watch all items under a parent of this content. Adjust its settings anytime."
    }
});
const $d49593a2f9070b10$var$ancestorWatchStatusContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingRight: 'space.200',
    paddingLeft: 'space.200',
    maxWidth: '270px',
    font: 'font.body.small'
});
const $d49593a2f9070b10$var$AncestorWatchStatus = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d49593a2f9070b10$var$ancestorWatchStatusContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.ancestorWatchStatus));
};
const $d49593a2f9070b10$export$aa1e7bb13f611ba0 = ({ isCurrentUserWatching: isCurrentUserWatching, isWatchingSpace: isWatchingSpace, isWatchingBlogs: isWatchingBlogs, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, contentType: contentType, contentId: contentId, spaceId: spaceId, updateQueryHandler: updateQueryHandler, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isCurrentUserWatchingContent, setIsCurrentUserWatchingContent] = (0, $42omo.useState)(isCurrentUserWatching);
    const [isCurrentUserWatchingBlogs, setIsCurrentUserWatchingBlogs] = (0, $42omo.useState)(isWatchingBlogs);
    const [isCurrentUserWatchingSpace, setIsCurrentUserWatchingSpace] = (0, $42omo.useState)(isWatchingSpace);
    const [isCurrentUserWatchingChildren, setIsCurrentUserWatchingChildren] = (0, $42omo.useState)(isWatchingChildren);
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isWatchChildrenRendered = contentType !== 'blogpost' && !isSpaceOverviewPage;
    const watchContentTitleI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.watchingWhiteboardTitle,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.watchingDatabaseTitle,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.watchingContentTitle,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.watchingContentTitle
    };
    const watchContentDescriptionI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.watchingWhiteboardDescription,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.watchingDatabaseDescription,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.watchingContentDescription,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.watchingContentDescription
    };
    const stoppedWatchingContentTitleI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.stoppedWatchingWhiteboardTitle,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.stoppedWatchingDatabaseTitle,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle
    };
    const stoppedWatchingContentDescriptionI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.stoppedWatchingWhiteboardDescription,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.stoppedWatchingDatabaseDescription,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription
    };
    const fireWatchAnalyticsEvent = (action, actionSubject)=>{
        const isActionSubjectSpace = actionSubject === (0, $jle6C.UpdateContentType).SPACE;
        const contentObjectMetadata = {
            objectId: isActionSubjectSpace ? spaceId : contentId,
            objectType: isActionSubjectSpace ? 'space' : contentType
        };
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            source: 'overflowMenu',
            attributes: {
                componentVersion: 'v2'
            },
            ...contentObjectMetadata
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    };
    const [watchContentMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CONTENT, data?.watchContent?.content?.currentUserIsWatching);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            const titleI18n = watchContentTitleI18nMap[contentType];
            const descriptionI18n = watchContentDescriptionI18nMap[contentType];
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-content-success',
                title: formatMessage(titleI18n),
                description: formatMessage(descriptionI18n),
                isAutoDismiss: true
            });
        }
    });
    const [unwatchContentMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation($id:ID!){unwatchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CONTENT, data?.unwatchContent?.content?.currentUserIsWatching);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CONTENT);
            const titleI18n = stoppedWatchingContentTitleI18nMap[contentType];
            const descriptionI18n = stoppedWatchingContentDescriptionI18nMap[contentType];
            flags.showSuccessCircleFlag({
                id: `overflow-menu.watch-settings.stopped-watching-content-success`,
                title: formatMessage(titleI18n),
                description: formatMessage(descriptionI18n),
                isAutoDismiss: true
            });
        }
    });
    const [watchBlogsMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation($spaceId:ID!){watchBlogs(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatchingBlogs}}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, data?.watchBlogs?.space?.currentUser?.isWatchingBlogs);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-blogs-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchingNewBlogpostsTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchingNewBlogpostsDescription),
                isAutoDismiss: true
            });
        }
    });
    const [unwatchBlogsMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation($spaceId:ID!){unwatchBlogs(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatchingBlogs}}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, data?.unwatchBlogs?.space?.currentUser?.isWatchingBlogs);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.unwatch-blogs-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingBlogpostsTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingBlogpostsDescription),
                isAutoDismiss: true
            });
        }
    });
    const [watchSpaceMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation($spaceId:ID!){watchSpace(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatched}}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).SPACE, data?.watchSpace?.space?.currentUser?.isWatched);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-space-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchSpaceTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchSpaceDescription),
                isAutoDismiss: true
            });
        }
    });
    const [unwatchSpaceMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation($spaceId:ID!){unwatchSpace(watchSpaceInput:{spaceId:$spaceId currentUser:true}){space{id currentUser{isWatched}}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).SPACE, data?.unwatchSpace?.space?.currentUser?.isWatched);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.unwatch-space-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingSpaceTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingSpaceDescription),
                isAutoDismiss: true
            });
        }
    });
    const [watchChildrenMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation($id:ID!$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id currentUser:true includeChildren:$includeChildren}){content{id currentUserIsWatchingChildren}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CHILDREN, data?.watchContent?.content.currentUserIsWatchingChildren);
        },
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
                attributes: {
                    startWatchingChildren: true,
                    contentType: contentType
                }
            });
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CHILDREN);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-children-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchChildrenTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchChildrenDescription),
                isAutoDismiss: true
            });
        },
        onError: (mutationError)=>{
            handleWatchChildrenError(mutationError, true);
        }
    });
    const [unwatchChildrenMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation($id:ID!$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id currentUser:true includeChildren:$includeChildren}){content{id currentUserIsWatchingChildren}}}`, {
        update: (cache, { data: data })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CHILDREN, data?.watchContent?.content.currentUserIsWatchingChildren);
        },
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
                attributes: {
                    startWatchingChildren: false,
                    contentType: contentType
                }
            });
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CHILDREN);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.stopped-watching-children-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingChildrenTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingChildrenDescription),
                isAutoDismiss: true
            });
        },
        onError: (mutationError)=>{
            handleWatchChildrenError(mutationError, false);
        }
    });
    const handleWatchChildrenError = (mutationError, startWatchingChildren)=>{
        if ((0, $1uFM6.isUnauthorizedError)(mutationError)) experienceTracker.abort({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            reason: mutationError.message,
            attributes: {
                startWatchingChildren: startWatchingChildren,
                contentType: contentType,
                isUnauthorized: true
            }
        });
        else experienceTracker.fail({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            error: mutationError.message,
            attributes: {
                startWatchingChildren: startWatchingChildren,
                contentType: contentType
            }
        });
    };
    const onWatchContentChange = (0, $42omo.useCallback)(async ()=>{
        if (isCurrentUserWatchingContent) {
            await unwatchContentMutation({
                variables: {
                    id: contentId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatching: false
                        }
                    }
                }
            });
            setIsCurrentUserWatchingContent(false);
        } else {
            await watchContentMutation({
                variables: {
                    id: contentId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatching: true
                        }
                    }
                }
            });
            setIsCurrentUserWatchingContent(true);
        }
    }, [
        isCurrentUserWatchingContent,
        contentId,
        unwatchContentMutation,
        watchContentMutation
    ]);
    const onWatchBlogpostsChange = (0, $42omo.useCallback)(async ()=>{
        if (isCurrentUserWatchingBlogs) {
            await unwatchBlogsMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchBlogs: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatchingBlogs: false
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingBlogs(false);
        } else {
            await watchBlogsMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchBlogs: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatchingBlogs: true
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingBlogs(true);
        }
    }, [
        isCurrentUserWatchingBlogs,
        spaceId,
        unwatchBlogsMutation,
        watchBlogsMutation
    ]);
    const onWatchSpaceChange = (0, $42omo.useCallback)(async ()=>{
        if (isCurrentUserWatchingSpace) {
            await unwatchSpaceMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchSpace: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatched: false
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingSpace(false);
        } else {
            await watchSpaceMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchSpace: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                __typename: 'SpaceUserMetadata',
                                isWatched: true
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingSpace(true);
        }
    }, [
        isCurrentUserWatchingSpace,
        spaceId,
        unwatchSpaceMutation,
        watchSpaceMutation
    ]);
    const onWatchChildrenChange = (0, $42omo.useCallback)(async ()=>{
        experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            attributes: {
                startWatchingChildren: !isCurrentUserWatchingChildren,
                contentType: contentType
            }
        });
        if (isCurrentUserWatchingChildren) {
            await unwatchChildrenMutation({
                variables: {
                    id: contentId,
                    includeChildren: false
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatchingChildren: false
                        }
                    }
                }
            });
            setIsCurrentUserWatchingChildren(false);
        } else {
            await watchChildrenMutation({
                variables: {
                    id: contentId,
                    includeChildren: true
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatchingChildren: true
                        }
                    }
                }
            });
            setIsCurrentUserWatchingChildren(true);
        }
    }, [
        isCurrentUserWatchingChildren,
        contentId,
        unwatchChildrenMutation,
        watchChildrenMutation,
        contentType,
        experienceTracker
    ]);
    const watchContentCheckbox = ()=>{
        const isImplicitlyWatching = isWatchingSpace || hasAncestorWatchingChildren || isWatchingChildren;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-this-content-option",
            testId: "watch-this-content-option",
            isSelected: isCurrentUserWatching || isImplicitlyWatching,
            isDisabled: isImplicitlyWatching,
            onClick: onWatchContentChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchThisContent));
    };
    const watchBlogpostsCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-blogs-option",
            testId: "watch-blogs-option",
            isSelected: isWatchingBlogs || isWatchingSpace,
            isDisabled: isWatchingSpace,
            onClick: onWatchBlogpostsChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchNewBlogposts));
    };
    const watchChildrenCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-children-option",
            testId: "watch-children-option",
            isSelected: hasAncestorWatchingChildren || isWatchingSpace || isWatchingChildren,
            isDisabled: hasAncestorWatchingChildren || isWatchingSpace,
            onClick: onWatchChildrenChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchChildItems));
    };
    const watchSpaceCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pU8m.default), {
            id: "watch-all-content-option",
            testId: "watch-all-content-option",
            isSelected: isWatchingSpace,
            onClick: onWatchSpaceChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d49593a2f9070b10$var$i18n.watchAllContent));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fKL7x.default), {
        id: "overflow-menu-watch-settings"
    }, hasAncestorWatchingChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d49593a2f9070b10$var$AncestorWatchStatus, null), watchContentCheckbox(), isSpaceOverviewPage && watchBlogpostsCheckbox(), isWatchChildrenRendered && watchChildrenCheckbox(), watchSpaceCheckbox());
};






var $gqsYd = parcelRequire("gqsYd");


var $hpr9b = parcelRequire("hpr9b");


var $pskhd = parcelRequire("pskhd");

const $8b864d3fa23503bf$var$i18n = (0, $cgtv4.defineMessages)({
    watchSettings: {
        id: "watch-dialog.overflow-menu.watch-settings",
        defaultMessage: "Watch settings"
    },
    manageWatchers: {
        id: "watch-dialog.overflow-menu.manage-watchers",
        defaultMessage: "Manage watchers"
    },
    watchingIconLabel: {
        id: "watch-dialog.overflow-menu.watching-icon-label",
        defaultMessage: "Watching content"
    },
    notWatchingIconLabel: {
        id: "watch-dialog.overflow-menu.not-watching-icon-label",
        defaultMessage: "Not watching content"
    }
});
var $8b864d3fa23503bf$export$f216106e034bc0b0 = /*#__PURE__*/ function(WatchSettingsRadioOption) {
    WatchSettingsRadioOption["Unwatch"] = "unwatch";
    WatchSettingsRadioOption["ThisItem"] = "this-item";
    WatchSettingsRadioOption["ThisAndNewItems"] = "this-and-new-items";
    WatchSettingsRadioOption["AllContent"] = "all-content";
    return WatchSettingsRadioOption;
}({});
const $8b864d3fa23503bf$export$465e1505ba3dc1c5 = ({ isMenuOpen: isMenuOpen, contentId: contentId, contentType: contentType, spaceId: spaceId = '', spaceKey: spaceKey, setIsMenuOpen: setIsMenuOpen, flags: flags, onMenuClose: onMenuClose, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const updateQueryHandler = (cache, watchTarget, newDataValue)=>{
        const query = (0, $hpr9b.getWatchDialogQuery)();
        const contentData = cache.readQuery({
            query: query,
            variables: {
                contentId: contentId
            }
        });
        switch(watchTarget){
            case (0, $jle6C.UpdateContentType).CONTENT:
                contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        cache.writeQuery({
            query: query,
            data: contentData
        });
    };
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isWatchEnabled = isLicensed || isGuest;
    // eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
    const { data: watchDialogData, error: watchDialogError, loading: watchDialogDataLoading } = (0, $j1Ss3.useQuery)((0, $hpr9b.getWatchDialogQuery)(), {
        variables: {
            contentId: contentId
        },
        skip: !isWatchEnabled,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const { isCurrentUserWatching: isCurrentUserWatching, isWatchingSpace: isWatchingSpace, isWatchingBlogs: isWatchingBlogs, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren } = (0, $pskhd.processWatchData)(watchDialogData);
    const isWatching = isWatchEnabled && (isCurrentUserWatching || isWatchingSpace);
    const { data: watchSettingsTrialDetailsData, error: watchSettingsTrialDetailsError } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query WatchSettingsItemTrialDetailsQuery{license{trialEndDate}}`, {
        skip: !isWatchEnabled || edition === (0, $gqsYd.CONFLUENCE_EDITION).FREE,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const handleWatchSettingsItemClick = (0, $42omo.useCallback)(()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'content-watch-button',
                attributes: {
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                },
                source: 'overflowMenu'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const makeHandleManageWatchersClickHandler = (dialogs)=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'ManageWatcherDialogButton',
                    source: 'overflowMenu',
                    attributes: {
                        source: 'v2',
                        isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                    }
                }
            }).fire();
            dialogs.showDialog((0, $f9HtC.ManageWatcherDialogLoader), {
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                contentType: contentType,
                defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE
            });
            setIsMenuOpen(false);
        };
    };
    const isSpaceAdmin = watchDialogData?.singleContent?.space?.operations?.some((op)=>op.operation === 'administer') ?? false;
    let inTrial = false;
    if (watchSettingsTrialDetailsError) inTrial = true;
    else {
        const trialEndDate = watchSettingsTrialDetailsData?.license?.trialEndDate;
        if (trialEndDate) {
            const trialDaysLeft = (0, $9wGTI.fg)('tako-4040_connie_trial_days_left_standardisation') ? (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialEndDate) ?? null : // +1 day to round up for fractional days
            (0, $917iu.default)(new Date(trialEndDate), new Date()) + 1;
            inTrial = trialDaysLeft !== null && trialDaysLeft > 0;
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "left-start",
        isOpen: isMenuOpen,
        onOpenChange: ({ isOpen: isOpen })=>{
            if (!isOpen) onMenuClose();
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                ...triggerProps,
                ref: triggerRef,
                isDisabled: !isWatchEnabled || watchDialogDataLoading,
                elemBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
                    label: formatMessage($8b864d3fa23503bf$var$i18n.watchingIconLabel)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
                    label: formatMessage($8b864d3fa23503bf$var$i18n.notWatchingIconLabel)
                }),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    size: "small"
                }),
                testId: "nested-watch-menu-trigger",
                onClick: handleWatchSettingsItemClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8b864d3fa23503bf$var$i18n.watchSettings))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d49593a2f9070b10$export$aa1e7bb13f611ba0), {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren,
        contentId: contentId,
        contentType: contentType,
        spaceId: spaceId,
        updateQueryHandler: updateQueryHandler,
        flags: flags
    }), isSpaceAdmin && edition !== (0, $gqsYd.CONFLUENCE_EDITION).FREE && !inTrial && !watchDialogError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: makeHandleManageWatchersClickHandler(dialogs)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8b864d3fa23503bf$var$i18n.manageWatchers)))));
};
const $8b864d3fa23503bf$export$f9409fd8f8b5a92d = (0, $7aRa9.withFlags)($8b864d3fa23503bf$export$465e1505ba3dc1c5);


/**
 * @generated SignedSource<<aa028ee47ad368b7283e2b69db29abfe>>
 * @relayHash b73eeb07332d614a1e170c288004fb18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781
const $1acaf91cfec33c88$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteMenuItemQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteMenuItemQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "b73eeb07332d614a1e170c288004fb18",
            "id": "1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781",
            "metadata": {},
            "name": "FavouriteMenuItemQuery",
            "operationKind": "query",
            "text": "query FavouriteMenuItemQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$1acaf91cfec33c88$var$node.hash = "b2cb562e5c9d7e229a13677a47c445f2";
var $1acaf91cfec33c88$export$2e2bcd8739ae039 = $1acaf91cfec33c88$var$node;



































var $77a1U = parcelRequire("77a1U");

var $cf6nm = parcelRequire("cf6nm");




/**
 * @generated SignedSource<<642c3d33e174f011359216d3b6b2c1c5>>
 * @relayHash 87747e14238de77ee6b608c3fa7ceb25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974
const $acbeb5139d925032$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteContentShortcutListenerQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteContentShortcutListenerQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "87747e14238de77ee6b608c3fa7ceb25",
            "id": "e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974",
            "metadata": {},
            "name": "FavouriteContentShortcutListenerQuery",
            "operationKind": "query",
            "text": "query FavouriteContentShortcutListenerQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$acbeb5139d925032$var$node.hash = "6ff7d72d61283f21b554c99c3279a8f9";
var $acbeb5139d925032$export$2e2bcd8739ae039 = $acbeb5139d925032$var$node;




















const $85cfaddd6945fc1f$var$getStarShortcut = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft') return {
            deprecatedAccelerator: undefined,
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
        };
        else if (contentMode === 'view') return {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
        };
        else return {
            deprecatedAccelerator: undefined,
            accelerator: undefined
        };
    } else // for all other content types, use both keyboard shortcuts
    return {
        deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
    };
};
const $85cfaddd6945fc1f$export$380f18fd66f69c3e = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft' || contentMode === 'view') return 0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT;
        else return null;
    } else return 0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT;
};
const $85cfaddd6945fc1f$export$2846eba8e457bfb = ({ contentId: contentId, contentTitle: contentTitle, contentMode: contentMode, contentType: contentType, source: source = 'FavouriteMoreActionsMenuItem' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator } = $85cfaddd6945fc1f$var$getStarShortcut(contentType, contentMode);
    const FavouriteContentShortcutListenerQuery = (0, $acbeb5139d925032$export$2e2bcd8739ae039);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(FavouriteContentShortcutListenerQuery, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first'
    });
    if (loading || error || !accelerator) return null;
    const isStarred = Boolean(data?.singleContent?.metadata.currentuser?.favourited?.isFavourite);
    const handleShortcut = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: true,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft'
                    },
                    source: source
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $77a1U.PageStar), {
        contentId: contentId,
        isStarred: isStarred,
        contentTitle: contentTitle,
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedAccelerator,
            accelerator: accelerator,
            listener: handleShortcut(toggleStar)
        }));
};


// This component is a dropdown menu item version of the favorite page star button. It is completely standalone and queries for it's own isFavourited data.
// It does not include any shortcut listener and should be used in conjunction with FavouriteContentShortcutListener.tsx if you need to add a listener.
// It is currently used in the page header more actions menu item
const $daed94f8e5673bda$var$FavouriteMenuItemQuery = (0, $1acaf91cfec33c88$export$2e2bcd8739ae039);
const $daed94f8e5673bda$export$ab53347da13f94fa = ({ contentId: contentId, contentTitle: contentTitle, contentMode: contentMode })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($daed94f8e5673bda$var$FavouriteMenuItemQuery, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first'
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const isStarred = Boolean(data?.singleContent?.metadata.currentuser?.favourited?.isFavourite);
    const contentType = data?.singleContent?.type;
    const shortcut = (0, $85cfaddd6945fc1f$export$380f18fd66f69c3e)(contentType || '', contentMode);
    const handleClick = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: false,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft',
                        isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') // for now, this will always be true since FavouriteMenuItem is only used in Content Wrapper as of now
                    },
                    source: 'FavouriteMoreActionsMenuItem'
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $77a1U.PageStar), {
        contentId: contentId,
        isStarred: isStarred,
        contentTitle: contentTitle,
        analytics: {
            source: 'FavouriteMoreActionsMenuItem',
            attributes: {
                componentVersion: 'more-actions-menu-item',
                pageType: contentType
            }
        },
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: handleClick(toggleStar),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: isStarred,
                spacing: "none"
            }),
            elemAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            }),
            isDisabled: !isLoggedIn
        }, isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daed94f8e5673bda$var$i18n.unstar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daed94f8e5673bda$var$i18n.star))));
};
const $daed94f8e5673bda$var$i18n = (0, $cgtv4.defineMessages)({
    star: {
        id: "favourite-button.content.star.label",
        defaultMessage: "Star"
    },
    unstar: {
        id: "favourite-button.content.unstar.label",
        defaultMessage: "Unstar"
    }
});




var $kPqqM = parcelRequire("kPqqM");
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 


















var $f9jv7 = parcelRequire("f9jv7");





var $iCPvv = parcelRequire("iCPvv");

const $e6d97f54b872b96e$var$handleError = (error, createAnalyticsEvent)=>{
    // Temporarily log errors to debug why some are not being marked as handled
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: 'spaceStarShortcutListener',
            source: 'spaceStarShortcutListener',
            attributes: {
                error: JSON.stringify(error),
                isNotFoundError: (0, $f9jv7.isNotFoundError)(error)
            }
        }
    }).fire();
    if ((0, $f9jv7.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
};
const $e6d97f54b872b96e$export$385015a3c6790101 = ({ spaceKey: spaceKey, contentMode: contentMode, source: source = 'FavouriteMoreActionsMenuItem' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: spaceFavouriteStatusData, loading: loading, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query SpaceStarShortcutListenerIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id alias name key currentUser{isFavourited}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        onError: (error)=>{
            $e6d97f54b872b96e$var$handleError(error, createAnalyticsEvent);
        }
    });
    if (loading) return null;
    if (error) {
        $e6d97f54b872b96e$var$handleError(error, createAnalyticsEvent);
        return null;
    }
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    const handleShortcut = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'spaceStar',
                    attributes: {
                        triggeredByKeyboardShortcut: true,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'edit'
                    },
                    source: source
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iCPvv.SpaceStar), {
        spaceId: spaceId,
        spaceKey: spaceKey,
        isStarred: isStarred,
        spaceName: spaceName,
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleShortcut(toggleStar)
        }));
};



var $lOeVN = parcelRequire("lOeVN");


var $efvKr = parcelRequire("efvKr");


var $b66o6 = parcelRequire("b66o6");


var $cMvQV = parcelRequire("cMvQV");


var $kM55L = parcelRequire("kM55L");


var $1PC5x = parcelRequire("1PC5x");


var $4vC63 = parcelRequire("4vC63");





const $b742140c6b014561$export$fcc1c0135b5761c6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F85M0",
    name: "LazyForgeContentTools",
    loader: async ()=>(await (parcelRequire("kxAIf"))).ForgeContentTools
});



var $1jQpq = parcelRequire("1jQpq");














var $xQxzY = parcelRequire("xQxzY");











var $6fil2 = parcelRequire("6fil2");


var $5ZqQS = parcelRequire("5ZqQS");





var $ayQVU = parcelRequire("ayQVU");




const $0633edcc0f21cf62$export$38d9182f14dddb00 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { contentId: contentId, contentType: contentType } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useIsPageOrBlogAutoConvertedQuery($contentId:ID$versionOverride:Int$status:[String]){content(id:$contentId version:$versionOverride status:$status){nodes{id type properties(key:"editor"){nodes{id key value}}operations{operation targetType}body{dynamic{representation}}metadata{frontend{fabricEditorSupported}}}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true) ? [
            "draft",
            "current"
        ] : null;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== contentId) {
        t3 = {
            contentId: contentId,
            status: t2
        };
        $[2] = contentId;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== contentType) {
        t4 = !(contentType === "page" || contentType === "blogpost") && (0, $9wGTI.fg)("confluence_frontend_reintroduce_revert_editor_item");
        $[4] = contentType;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = {
            variables: t3,
            skip: t4
        };
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const { data: contentPropertiesData, error: error } = (0, $xQxzY.useQuery)(t1, t5);
    if (!(0, $9wGTI.fg)("confluence_frontend_reintroduce_revert_editor_item")) return false;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
        return false;
    }
    if (contentPropertiesData) {
        const t6 = contentPropertiesData?.content?.nodes?.[0];
        let t7;
        if ($[9] !== t6) {
            t7 = (0, $ayQVU.getAutoConvertionInfo)(t6);
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        const { isAutoConverted: isAutoConverted } = t7;
        const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
        return !!isAutoConverted && !isNewPage;
    }
    return false;
} : ({ contentId: contentId, contentType: contentType })=>{
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: contentPropertiesData, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsPageOrBlogAutoConvertedQuery($contentId:ID$versionOverride:Int$status:[String]){content(id:$contentId version:$versionOverride status:$status){nodes{id type properties(key:"editor"){nodes{id key value}}operations{operation targetType}body{dynamic{representation}}metadata{frontend{fabricEditorSupported}}}}}`, {
        variables: {
            contentId: contentId,
            status: (0, $6mKj3.expValEquals)('confluence_auto_convert_legacy_draft_fix_fe', 'isEnabled', true) ? [
                'draft',
                'current'
            ] : null
        },
        // skip if is not page or blogpost as the revert to legacy editor menu item can only show for those content types
        skip: !(contentType === 'page' || contentType === 'blogpost') && (0, $9wGTI.fg)('confluence_frontend_reintroduce_revert_editor_item')
    });
    if (!(0, $9wGTI.fg)('confluence_frontend_reintroduce_revert_editor_item')) return false;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
        return false;
    }
    if (contentPropertiesData) {
        const { isAutoConverted: isAutoConverted } = (0, $ayQVU.getAutoConvertionInfo)(contentPropertiesData?.content?.nodes?.[0]);
        const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
        return !!isAutoConverted && !isNewPage;
    }
    return false;
};












var $kyKWe = parcelRequire("kyKWe");





var $e0ycV = parcelRequire("e0ycV");


var $BCkug = parcelRequire("BCkug");








var $bqMNb = parcelRequire("bqMNb");




const $690df6788a087387$export$d91fa1ff1d654586 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { item: item, contentMode: contentMode, spaceId: spaceId, flags: flags, spaceKey: spaceKey, contentId: contentId, closeParentMenu: closeParentMenu } = t0;
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, saveDraft: saveDraft } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== flags || $[3] !== push || $[4] !== retrieveEditorTitleAndContent || $[5] !== saveDraft || $[6] !== spaceId || $[7] !== spaceKey) {
        t1 = contentMode === "view" ? {
            contentId: contentId,
            spaceId: spaceId,
            isUnpublishedDraft: false,
            flags: flags,
            analyticsSource: "viewPageScreen",
            adfOrigin: "RENDERER",
            onSuccessfulConversion: ()=>{
                push((0, $1NBp8.VIEW_PAGE).toUrl({
                    spaceKey: spaceKey,
                    contentId: contentId
                }, {
                    query: {
                        [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }
                }));
            },
            retrieveEditorTitleAndContent: undefined
        } : {
            contentId: contentId,
            spaceId: spaceId,
            isUnpublishedDraft: contentMode === "draft",
            flags: flags,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            saveDraft: saveDraft,
            analyticsSource: "ellipsisDropdownComponent",
            adfOrigin: "EDITOR",
            onSuccessfulConversion: ()=>{
                push((0, $1NBp8.VIEW_PAGE).toUrl({
                    spaceKey: spaceKey,
                    contentId: contentId
                }));
            }
        };
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = flags;
        $[3] = push;
        $[4] = retrieveEditorTitleAndContent;
        $[5] = saveDraft;
        $[6] = spaceId;
        $[7] = spaceKey;
        $[8] = t1;
    } else t1 = $[8];
    const useSwitchToLivePagesProps = t1;
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)(useSwitchToLivePagesProps);
    let t2;
    if ($[9] !== closeParentMenu || $[10] !== switchToLivePage) {
        t2 = ()=>{
            closeParentMenu();
            switchToLivePage();
        };
        $[9] = closeParentMenu;
        $[10] = switchToLivePage;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
            label: ""
        });
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== item.id || $[14] !== item.label || $[15] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: item.id,
            onClick: t2,
            elemBefore: t3
        }, item.label);
        $[13] = item.id;
        $[14] = item.label;
        $[15] = t2;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ item: item, contentMode: contentMode, spaceId: spaceId, flags: flags, spaceKey: spaceKey, contentId: contentId, closeParentMenu: closeParentMenu })=>{
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, saveDraft: saveDraft } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const useSwitchToLivePagesProps = contentMode === 'view' ? {
        contentId: contentId,
        spaceId: spaceId,
        isUnpublishedDraft: false,
        flags: flags,
        analyticsSource: 'viewPageScreen',
        adfOrigin: 'RENDERER',
        onSuccessfulConversion: ()=>{
            push((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }, // do not remove this query param. It is used to force a transition since the route is the same
            // and we need to force a transition to avoid using SSR data.
            {
                query: {
                    [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                }
            }));
        },
        retrieveEditorTitleAndContent: undefined
    } : {
        contentId: contentId,
        spaceId: spaceId,
        isUnpublishedDraft: contentMode === 'draft',
        flags: flags,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        saveDraft: saveDraft,
        analyticsSource: 'ellipsisDropdownComponent',
        adfOrigin: 'EDITOR',
        onSuccessfulConversion: ()=>{
            // Redirect to the route for the new live page.
            push((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }));
        }
    };
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)(useSwitchToLivePagesProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: item.id,
        onClick: ()=>{
            closeParentMenu();
            switchToLivePage();
        },
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
            label: ""
        })
    }, item.label);
};























var $c4sKh = parcelRequire("c4sKh");











// this is to keep consistent with ContentTools PopupMenuGroup
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcd7f3eccb1861ca$var$StyledDropdownItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $ahaN7.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul91wdt _p12f1c3h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $ahaN7.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1ul91wdt _p12f1c3h",
            __cmplp.className
        ])
    });
});
const $bcd7f3eccb1861ca$var$DropdownItemLabelContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $bcd7f3eccb1861ca$var$badgeContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
const $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9 = (styleClass)=>{
    return !styleClass?.includes('aui-button') ? styleClass : '';
};
const $bcd7f3eccb1861ca$export$49b1344a56b06112 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { label: label, items: items, isNestedMenuOpen: isNestedMenuOpen, onClick: onClick, iconBefore: iconBefore, forgeMenuItems: forgeMenuItems, onMenuClose: onMenuClose, id: id } = t0;
    if (!items.length && !forgeMenuItems?.length) return null;
    let t1;
    if ($[0] !== onMenuClose) {
        t1 = (t2)=>{
            const { isOpen: isOpen } = t2;
            if (!isOpen) onMenuClose();
        };
        $[0] = onMenuClose;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== iconBefore || $[3] !== id || $[4] !== label || $[5] !== onClick) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                ...triggerProps,
                ref: triggerRef,
                onClick: onClick,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    size: "small"
                }),
                elemBefore: iconBefore,
                testId: `${id}-button`
            }, label);
        };
        $[2] = iconBefore;
        $[3] = id;
        $[4] = label;
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== items) {
        t3 = items.map($bcd7f3eccb1861ca$var$_temp);
        $[7] = items;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== forgeMenuItems) {
        t4 = forgeMenuItems && forgeMenuItems.length > 0 && forgeMenuItems.map($bcd7f3eccb1861ca$var$_temp2);
        $[9] = forgeMenuItems;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bcd7f3eccb1861ca$var$StyledDropdownItemGroup, null, t3, t4);
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== isNestedMenuOpen || $[15] !== t1 || $[16] !== t2 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            placement: "left-start",
            isOpen: isNestedMenuOpen,
            onOpenChange: t1,
            trigger: t2
        }, t5);
        $[14] = isNestedMenuOpen;
        $[15] = t1;
        $[16] = t2;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ label: label, items: items, isNestedMenuOpen: isNestedMenuOpen, onClick: onClick, iconBefore: iconBefore, forgeMenuItems: forgeMenuItems, onMenuClose: onMenuClose, id: id })=>{
    if (!items.length && !forgeMenuItems?.length) return null;
    return(// TODO: Add `shouldRenderToParent` to component to improve accessibility. See
    // https://a11y.atlassian.net/browse/JCATS-788
    // https://hello.atlassian.net/wiki/spaces/DST/pages/5402216605/shouldRenderToParent+prop+usages+in+cc-disco+packages
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "left-start",
        isOpen: isNestedMenuOpen,
        // need this as onClose/onBlur handler for proper focus management
        onOpenChange: ({ isOpen: isOpen })=>{
            if (!isOpen) onMenuClose();
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                ...triggerProps,
                ref: triggerRef,
                onClick: onClick,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    size: "small"
                }),
                elemBefore: iconBefore,
                testId: `${id}-button`
            }, label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bcd7f3eccb1861ca$var$StyledDropdownItemGroup, null, items.map((item)=>{
        if (item.customComponent) return item.customComponent();
        const { id: id_0, url: url, label: itemLabel, badgeLabel: badgeLabel, tooltip: tooltip, closeParentMenu: closeParentMenu } = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // className is needed here for Connect modals to show properly
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9(item?.styleClass),
            key: id_0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            href: url,
            onClick: closeParentMenu,
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bcd7f3eccb1861ca$var$DropdownItemLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel || tooltip), badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bcd7f3eccb1861ca$var$badgeContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, badgeLabel)))));
    }), forgeMenuItems && forgeMenuItems.length > 0 && forgeMenuItems.map((forgeMenuItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
            key: forgeMenuItem?.props?.extension?.id,
            module: forgeMenuItem?.props?.extension
        }, forgeMenuItem)))));
};
function $bcd7f3eccb1861ca$var$_temp(item) {
    if (item.customComponent) return item.customComponent();
    const { id: id_0, url: url, label: itemLabel, badgeLabel: badgeLabel, tooltip: tooltip, closeParentMenu: closeParentMenu } = item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9(item?.styleClass),
        key: id_0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        href: url,
        onClick: closeParentMenu,
        UNSAFE_shouldDisableRouterLink: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bcd7f3eccb1861ca$var$DropdownItemLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel || tooltip), badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $bcd7f3eccb1861ca$var$badgeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, badgeLabel)))));
}
function $bcd7f3eccb1861ca$var$_temp2(forgeMenuItem) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        key: forgeMenuItem?.props?.extension?.id,
        module: forgeMenuItem?.props?.extension
    }, forgeMenuItem);
}



















var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");










var $4TcLf = parcelRequire("4TcLf");





var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const { IS_MORE_ACTIONS_HINT_VISIBLE: $4af5663ac404949d$var$IS_MORE_ACTIONS_HINT_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $4af5663ac404949d$var$i18n = (0, $cgtv4.defineMessages)({
    tryingToFindSomething: {
        id: "content-types-header.content-types.more-actions.trying-to-find-something",
        defaultMessage: "Trying to find something? Check the <strong>Details</strong> panel in the floating action bar. <link>Show me</link>"
    },
    dontTellMeAgain: {
        id: "content-types-header.content-types.more-actions.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $4af5663ac404949d$var$missingActionsHintMenuItemStyles = (0, $ecnYn.xcss)({
    margin: 'space.150'
});
const $4af5663ac404949d$var$textStyles = (0, $ecnYn.xcss)({
    width: '216px'
});
const $4af5663ac404949d$var$underlinedButtonStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    textDecoration: 'underline',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    ':hover': {
        textDecoration: 'none'
    }
});
const $4af5663ac404949d$var$linkButtonStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    marginLeft: 'space.050'
});
const $4af5663ac404949d$export$b0ffdc20cd96b8d0 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { setIsMenuOpen: setIsMenuOpen } = t0;
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { goToStep: goToStep } = (0, $4TcLf.useMoreActionsObjectSidebarTourActions)();
    const { setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    let t1;
    if ($[0] !== goToStep || $[1] !== setIsMenuOpen || $[2] !== setSidebarControlExpandCollapsedState) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4af5663ac404949d$var$textStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$4af5663ac404949d$var$i18n.tryingToFindSomething,
            values: {
                strong: $4af5663ac404949d$var$_temp,
                link: (text_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                        onClick: ()=>{
                            setSidebarControlExpandCollapsedState("expanded");
                            setIsMenuOpen(false);
                            goToStep((0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST);
                        },
                        padding: "space.0",
                        backgroundColor: "color.background.neutral.subtle",
                        xcss: $4af5663ac404949d$var$linkButtonStyles
                    }, text_0)
            }
        }));
        $[0] = goToStep;
        $[1] = setIsMenuOpen;
        $[2] = setSidebarControlExpandCollapsedState;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== setOnboardingState) {
        t2 = ()=>setOnboardingState({
                key: $4af5663ac404949d$var$IS_MORE_ACTIONS_HINT_VISIBLE,
                value: "false"
            });
        $[4] = setOnboardingState;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4af5663ac404949d$var$i18n.dontTellMeAgain);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            onClick: t2,
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            xcss: $4af5663ac404949d$var$underlinedButtonStyles
        }, t3);
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            alignInline: "start",
            space: "space.300",
            xcss: $4af5663ac404949d$var$missingActionsHintMenuItemStyles
        }, t1, t4));
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ setIsMenuOpen: setIsMenuOpen })=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { goToStep: goToStep } = (0, $4TcLf.useMoreActionsObjectSidebarTourActions)();
    const { setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: "space.300",
        xcss: $4af5663ac404949d$var$missingActionsHintMenuItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4af5663ac404949d$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$4af5663ac404949d$var$i18n.tryingToFindSomething,
        values: {
            strong: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                    color: "color.text.subtlest",
                    as: "strong"
                }, text),
            link: (text_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                    onClick: ()=>{
                        setSidebarControlExpandCollapsedState('expanded');
                        setIsMenuOpen(false);
                        goToStep((0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST);
                    },
                    padding: "space.0",
                    backgroundColor: "color.background.neutral.subtle",
                    xcss: $4af5663ac404949d$var$linkButtonStyles
                }, text_0)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: ()=>setOnboardingState({
                key: $4af5663ac404949d$var$IS_MORE_ACTIONS_HINT_VISIBLE,
                value: 'false'
            }),
        padding: "space.0",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4af5663ac404949d$var$underlinedButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4af5663ac404949d$var$i18n.dontTellMeAgain))));
};
function $4af5663ac404949d$var$_temp(text) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        as: "strong"
    }, text);
}























var $i25hX = parcelRequire("i25hX");


var $h7YX1 = parcelRequire("h7YX1");


var $jyA9t = parcelRequire("jyA9t");

const $eb923bf92acc93d7$var$i18n = (0, $cgtv4.defineMessages)({
    whiteboardToLiveDocWithAi: {
        id: "content-types-header.content-types.more-actions.whiteboard-create-live-doc-with-rovo",
        defaultMessage: "Create live doc with Rovo"
    }
});
const $eb923bf92acc93d7$export$240f536835ebe1cf = 'Create a live doc from this whiteboard.';
const $eb923bf92acc93d7$export$43890b7edce69789 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { spaceKey: spaceKey, contentId: contentId } = t0;
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)("ai-mate");
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($eb923bf92acc93d7$var$i18n.whiteboardToLiveDocWithAi);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const title = t1;
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== openModal || $[5] !== publish || $[6] !== spaceKey || $[7] !== title) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "whiteboardToLiveDocWithAi",
                    source: "overflowMenu"
                }
            }).fire();
            openModal("whiteboardToLiveDocAiConversion", spaceKey, undefined, true, {
                id: contentId,
                type: "whiteboard"
            });
            publish({
                type: "chat-new",
                source: "CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON",
                openChat: false,
                data: {
                    name: title,
                    dialogues: [],
                    prompt: $eb923bf92acc93d7$export$240f536835ebe1cf,
                    contentContext: "staging-area",
                    sourceId: contentId
                }
            });
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = openModal;
        $[5] = publish;
        $[6] = spaceKey;
        $[7] = title;
        $[8] = t2;
    } else t2 = $[8];
    const handleWhiteboardToLiveDocWithAi = t2;
    let t3;
    if ($[9] !== handleWhiteboardToLiveDocWithAi || $[10] !== title) {
        t3 = {
            id: "whiteboard-to-live-doc-with-ai",
            text: title,
            onClick: handleWhiteboardToLiveDocWithAi
        };
        $[9] = handleWhiteboardToLiveDocWithAi;
        $[10] = title;
        $[11] = t3;
    } else t3 = $[11];
    const item = t3;
    const { id: id, onClick: onClick, text: text } = item;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
            label: ""
        });
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== id || $[14] !== onClick || $[15] !== text) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: t4,
            key: id,
            onClick: onClick
        }, text);
        $[13] = id;
        $[14] = onClick;
        $[15] = text;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ spaceKey: spaceKey, contentId: contentId })=>{
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const title = intl.formatMessage($eb923bf92acc93d7$var$i18n.whiteboardToLiveDocWithAi);
    const handleWhiteboardToLiveDocWithAi = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'whiteboardToLiveDocWithAi',
                source: 'overflowMenu'
            }
        }).fire();
        openModal('whiteboardToLiveDocAiConversion' /*entryPoint*/ , spaceKey, undefined /* parentContent */ , true, {
            id: contentId,
            type: 'whiteboard'
        } /* content */ );
        publish({
            type: 'chat-new',
            source: 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON',
            openChat: false,
            data: {
                name: title,
                dialogues: [],
                prompt: $eb923bf92acc93d7$export$240f536835ebe1cf,
                // Hardcoded to en-us for now until we can ensure backend support for other locales
                contentContext: 'staging-area',
                sourceId: contentId
            }
        });
    }, [
        createAnalyticsEvent,
        openModal,
        spaceKey,
        publish,
        title,
        contentId
    ]);
    const item = {
        id: 'whiteboard-to-live-doc-with-ai',
        text: title,
        onClick: handleWhiteboardToLiveDocWithAi
    };
    const { id: id, onClick: onClick, text: text } = item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
            label: ""
        }),
        key: id,
        onClick: onClick
    }, text);
};

























var $fxBfz = parcelRequire("fxBfz");





var $4CxKE = parcelRequire("4CxKE");


var $6767u = parcelRequire("6767u");





var $tvI67 = parcelRequire("tvI67");





var $4WZ5N = parcelRequire("4WZ5N");


var $2MuFw = parcelRequire("2MuFw");





var $82gXq = parcelRequire("82gXq");


var $hw7wB = parcelRequire("hw7wB");


var $eG1e2 = parcelRequire("eG1e2");


var $9RVmI = parcelRequire("9RVmI");


var $gKvd9 = parcelRequire("gKvd9");





var $hFGQl = parcelRequire("hFGQl");


var $jBnsv = parcelRequire("jBnsv");






var $1AbrA = parcelRequire("1AbrA");


var $jcM8h = parcelRequire("jcM8h");


var $l3C2L = parcelRequire("l3C2L");





var $d8J72 = parcelRequire("d8J72");




var $k9WFY = parcelRequire("k9WFY");


var $iVd6X = parcelRequire("iVd6X");


var $g9Ghb = parcelRequire("g9Ghb");


var $jhTeh = parcelRequire("jhTeh");


var $d9tcB = parcelRequire("d9tcB");







const $434c765ed6791bfa$export$68013e639efb767f = 'action-apps';
const $434c765ed6791bfa$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    export: {
        id: "content-types-header.ellipsis.open.ellipsis.export",
        defaultMessage: "Export"
    },
    convert: {
        id: "content-types-header.ellipsis.open.ellipsis.convert",
        defaultMessage: "Convert"
    },
    duplicate: {
        id: "content-types-header.ellipsis.open.ellipsis.duplicate",
        defaultMessage: "Duplicate"
    },
    duplicateDatabase: {
        id: "content-types-header.ellipsis.open.ellipsis.duplicate.database",
        defaultMessage: "Duplicate database"
    },
    archive: {
        id: "content-types-header.ellipsis.open.ellipsis.archive",
        defaultMessage: "Archive"
    },
    deleteDraftLabel: {
        id: "content-types-header.content-types.more-actions.delete-draft",
        defaultMessage: "Delete draft"
    },
    deleteLabel: {
        id: "content-types-header.content-types.more-actions.delete",
        defaultMessage: "Delete"
    },
    archiveAndDeleteLabel: {
        id: "content-types-header.content-types.more-actions.archive-and-delete",
        defaultMessage: "Archive and delete"
    },
    viewChangesTitle: {
        id: "content-types-header.content-types.view.changes.title",
        defaultMessage: "Latest changes"
    },
    viewChangesLabel: {
        id: "content-types-header.content-types.view.changes.label",
        defaultMessage: "View changes"
    },
    automationsModalTitle: {
        id: "content-types-header.automations.title",
        defaultMessage: "Page automations"
    },
    automationsLabel: {
        id: "content-types-header.automations.label",
        defaultMessage: "Automations"
    },
    advancedLabel: {
        id: "content-types-header.advanced.label",
        defaultMessage: "Advanced details"
    },
    pageAppsLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.page.apps",
        defaultMessage: "Apps"
    }
});
var $434c765ed6791bfa$export$8bf1ff90935c8832 = /*#__PURE__*/ function(NestedMenuTypes) {
    NestedMenuTypes["Export"] = "export";
    NestedMenuTypes["Convert"] = "convert";
    NestedMenuTypes["Archive"] = "archive";
    NestedMenuTypes["Advanced"] = "advanced";
    NestedMenuTypes["Attachments"] = "attachments";
    NestedMenuTypes["Apps"] = "apps";
    NestedMenuTypes["ContentOwnership"] = "content-ownership";
    NestedMenuTypes["MoreSupport"] = "more-support";
    NestedMenuTypes["CopyDatabase"] = "copy-database";
    NestedMenuTypes["Help"] = "help";
    NestedMenuTypes["Watch"] = "watch";
    NestedMenuTypes["TemplatesAndImport"] = "templates-and-import";
    return NestedMenuTypes;
}({});
const $434c765ed6791bfa$var$ConvertMenuItemComponent = ({ webItemsMap: webItemsMap, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, spaceKey: spaceKey, contentId: contentId, dialogs: dialogs, handleNestedMenuItemClose: handleNestedMenuItemClose, contentMode: contentMode, flags: flags, spaceId: spaceId, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const convertItems = [
        (0, $511857b10ace36ca$export$10f4bed2ae52719b),
        (0, $511857b10ace36ca$export$7767afe5b675f4b1),
        (0, $511857b10ace36ca$export$5497d83bbd1b1232)
    ].map((id)=>{
        const item = webItemsMap[id];
        if (id === (0, $511857b10ace36ca$export$7767afe5b675f4b1) && item) {
            item.url = '';
            item.urlWithoutContextPath = '';
            return {
                ...item,
                customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8J72.ConvertToFolderItem), {
                        key: item.completeKey,
                        sectionItem: item,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        dialogs: dialogs,
                        shouldHighlight: isConvertToFolderHighlighted,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                            label: ""
                        }),
                        onClick: closeParentMenu
                    })
            };
        } else if (id === (0, $511857b10ace36ca$export$5497d83bbd1b1232) && item) {
            item.url = '';
            item.urlWithoutContextPath = '';
            const makePublishPageAsBlogDialogOpener = ()=>{
                closeParentMenu();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'publishPageAsBlog',
                        source: 'contentTypesHeader'
                    }
                }).fire();
                dialogs.showDialog((0, $k9WFY.PublishPageAsBlogDialog), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: (0, $iVd6X.PublishPageAsBlogSources).ViewPage
                });
            };
            return {
                ...item,
                customComponent: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: item.completeKey,
                        ...item,
                        onClick: makePublishPageAsBlogDialogOpener,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                            label: ""
                        })
                    });
                }
            };
        } else if (id === (0, $511857b10ace36ca$export$10f4bed2ae52719b) && item) return {
            ...item,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                    item: item,
                    contentMode: contentMode,
                    spaceId: spaceId,
                    flags: flags,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    closeParentMenu: closeParentMenu
                })
        };
        else return null;
    }).filter((item_0)=>item_0 && item_0.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.convert),
        items: convertItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
            label: ""
        }),
        key: (0, $511857b10ace36ca$export$3192aea0628d957a),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$1a264aaf74bdd787 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { webItemsMap: webItemsMap, nestedPopup: nestedPopup, handleNestedMenuItemClick: handleNestedMenuItemClick, spaceKey: spaceKey, contentId: contentId, handleNestedMenuItemClose: handleNestedMenuItemClose, flags: flags, spaceId: spaceId, contentMode: contentMode, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowExportAndConvert",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("convert");
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleNestedMenuItemClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleConvertMenuItemClick = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== closeParentMenu || $[5] !== contentId || $[6] !== contentMode || $[7] !== flags || $[8] !== handleConvertMenuItemClick || $[9] !== handleNestedMenuItemClose || $[10] !== isConvertToFolderHighlighted || $[11] !== nestedPopup || $[12] !== spaceId || $[13] !== spaceKey || $[14] !== webItemsMap) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t2
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$var$ConvertMenuItemComponent, {
                webItemsMap: webItemsMap,
                dialogs: dialogs,
                isNestedMenuOpen: nestedPopup === "convert",
                handleClick: handleConvertMenuItemClick,
                contentId: contentId,
                spaceKey: spaceKey,
                flags: flags,
                spaceId: spaceId,
                handleNestedMenuItemClose: handleNestedMenuItemClose,
                contentMode: contentMode,
                closeParentMenu: closeParentMenu,
                isConvertToFolderHighlighted: isConvertToFolderHighlighted
            }));
        $[4] = closeParentMenu;
        $[5] = contentId;
        $[6] = contentMode;
        $[7] = flags;
        $[8] = handleConvertMenuItemClick;
        $[9] = handleNestedMenuItemClose;
        $[10] = isConvertToFolderHighlighted;
        $[11] = nestedPopup;
        $[12] = spaceId;
        $[13] = spaceKey;
        $[14] = webItemsMap;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : ({ webItemsMap: webItemsMap, nestedPopup: nestedPopup, handleNestedMenuItemClick: handleNestedMenuItemClick, spaceKey: spaceKey, contentId: contentId, handleNestedMenuItemClose: handleNestedMenuItemClose, flags: flags, spaceId: spaceId, contentMode: contentMode, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleConvertMenuItemClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowExportAndConvert',
                source: 'overflowMenu'
            }
        }).fire();
        handleNestedMenuItemClick("convert");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$var$ConvertMenuItemComponent, {
            webItemsMap: webItemsMap,
            dialogs: dialogs,
            isNestedMenuOpen: nestedPopup === "convert",
            handleClick: handleConvertMenuItemClick,
            contentId: contentId,
            spaceKey: spaceKey,
            flags: flags,
            spaceId: spaceId,
            handleNestedMenuItemClose: handleNestedMenuItemClose,
            contentMode: contentMode,
            closeParentMenu: closeParentMenu,
            isConvertToFolderHighlighted: isConvertToFolderHighlighted
        }));
};
const $434c765ed6791bfa$export$b945ccaa4d42d330 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $511857b10ace36ca$export$5da5719a925f973),
            (0, $511857b10ace36ca$export$bbe81b5a8b0eaf4)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== closeParentMenu || $[2] !== webItemsMap) {
        t2 = t1.map((id)=>{
            const item = webItemsMap[id];
            return {
                ...item,
                closeParentMenu: closeParentMenu
            };
        }).filter($434c765ed6791bfa$var$_temp);
        $[1] = closeParentMenu;
        $[2] = webItemsMap;
        $[3] = t2;
    } else t2 = $[3];
    const exportItems = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== handleNestedMenuItemClick) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowExport",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("export");
        };
        $[4] = createAnalyticsEvent;
        $[5] = handleNestedMenuItemClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleExportMenuItemClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.export);
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
            label: ""
        });
        $[8] = t5;
    } else t5 = $[8];
    const t6 = nestedPopup === "export";
    let t7;
    if ($[9] !== exportItems || $[10] !== handleExportMenuItemClick || $[11] !== handleNestedMenuItemClose || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t4,
            items: exportItems,
            iconBefore: t5,
            isNestedMenuOpen: t6,
            onClick: handleExportMenuItemClick,
            key: (0, $511857b10ace36ca$export$ab4fe2a2881747b5),
            onMenuClose: handleNestedMenuItemClose
        });
        $[9] = exportItems;
        $[10] = handleExportMenuItemClick;
        $[11] = handleNestedMenuItemClose;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const exportItems = [
        (0, $511857b10ace36ca$export$5da5719a925f973),
        (0, $511857b10ace36ca$export$bbe81b5a8b0eaf4)
    ].map((id)=>{
        const item = webItemsMap[id];
        return {
            ...item,
            closeParentMenu: closeParentMenu
        };
    }).filter((item_0)=>item_0.id);
    const handleExportMenuItemClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowExport',
                source: 'overflowMenu'
            }
        }).fire();
        handleNestedMenuItemClick("export");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.export),
        items: exportItems,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
            label: ""
        }),
        isNestedMenuOpen: nestedPopup === "export",
        onClick: handleExportMenuItemClick,
        key: (0, $511857b10ace36ca$export$ab4fe2a2881747b5),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$5ac124715785374c = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent } = t0;
    const label = contentMode === "draft" ? $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteDraftLabel : $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteLabel;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== label || $[3] !== onDeleteClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1,
            key: `container-${(0, $511857b10ace36ca$export$da4fec526a505196)}`
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "overflowDelete",
                            source: "overflowMenu"
                        }
                    }).fire();
                    onDeleteClick(dialogs);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), label)));
        $[1] = createAnalyticsEvent;
        $[2] = label;
        $[3] = onDeleteClick;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent })=>{
    const label = contentMode === 'draft' ? $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteDraftLabel : $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ],
        key: `container-${(0, $511857b10ace36ca$export$da4fec526a505196)}`
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'overflowDelete',
                        source: 'overflowMenu'
                    }
                }).fire();
                onDeleteClick(dialogs);
            },
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                label: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), label)));
};
const $434c765ed6791bfa$export$f4be76d677f42fda = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onArchiveClick: onArchiveClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onArchiveClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1,
            key: `container-${(0, $511857b10ace36ca$export$d81a93c80838b765)}`
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                onClick: ()=>{
                    onArchiveClick(dialogs);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4WZ5N))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.archive), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jhTeh.ReverseTrialLozengeExperiment), {
                touchpointId: "confluence_archive_list_item",
                edition: (0, $d9tcB.ConfluenceEdition).STANDARD
            })));
        $[1] = onArchiveClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onArchiveClick: onArchiveClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ],
        key: `container-${(0, $511857b10ace36ca$export$d81a93c80838b765)}`
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>{
                onArchiveClick(dialogs);
            },
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4WZ5N))), {
                label: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.archive), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jhTeh.ReverseTrialLozengeExperiment), {
            touchpointId: "confluence_archive_list_item",
            edition: (0, $d9tcB.ConfluenceEdition).STANDARD
        })));
};
const $434c765ed6791bfa$export$a05f0dd30396f811 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { webItems: webItems, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, onArchiveClick: onArchiveClick, onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose } = t0;
    let t1;
    if ($[0] !== contentMode || $[1] !== createAnalyticsEvent || $[2] !== onArchiveClick || $[3] !== onDeleteClick || $[4] !== webItems) {
        let t2;
        if ($[6] !== contentMode || $[7] !== createAnalyticsEvent || $[8] !== onArchiveClick || $[9] !== onDeleteClick) {
            t2 = (item_0)=>{
                if (item_0.id === (0, $511857b10ace36ca$export$d81a93c80838b765)) return {
                    ...item_0,
                    customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$f4be76d677f42fda, {
                            onArchiveClick: onArchiveClick
                        })
                };
                else {
                    if (item_0.id === (0, $511857b10ace36ca$export$da4fec526a505196)) return {
                        ...item_0,
                        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$5ac124715785374c, {
                                onDeleteClick: onDeleteClick,
                                contentMode: contentMode,
                                createAnalyticsEvent: createAnalyticsEvent
                            })
                    };
                }
                return item_0;
            };
            $[6] = contentMode;
            $[7] = createAnalyticsEvent;
            $[8] = onArchiveClick;
            $[9] = onDeleteClick;
            $[10] = t2;
        } else t2 = $[10];
        t1 = webItems.filter($434c765ed6791bfa$var$_temp2).map(t2);
        $[0] = contentMode;
        $[1] = createAnalyticsEvent;
        $[2] = onArchiveClick;
        $[3] = onDeleteClick;
        $[4] = webItems;
        $[5] = t1;
    } else t1 = $[5];
    const archiveItems = t1;
    let t2;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.archiveAndDeleteLabel);
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: ""
        });
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== archiveItems || $[14] !== handleClick || $[15] !== handleNestedMenuItemClose || $[16] !== isNestedMenuOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: archiveItems,
            isNestedMenuOpen: isNestedMenuOpen,
            onClick: handleClick,
            iconBefore: t3,
            onMenuClose: handleNestedMenuItemClose
        });
        $[13] = archiveItems;
        $[14] = handleClick;
        $[15] = handleNestedMenuItemClose;
        $[16] = isNestedMenuOpen;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ webItems: webItems, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, onArchiveClick: onArchiveClick, onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose })=>{
    const archiveItems = webItems.filter((item)=>item.id === (0, $511857b10ace36ca$export$d81a93c80838b765) || item.id === (0, $511857b10ace36ca$export$da4fec526a505196)).map((item_0)=>{
        if (item_0.id === (0, $511857b10ace36ca$export$d81a93c80838b765)) return {
            ...item_0,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$f4be76d677f42fda, {
                    onArchiveClick: onArchiveClick
                })
        };
        else if (item_0.id === (0, $511857b10ace36ca$export$da4fec526a505196)) return {
            ...item_0,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$5ac124715785374c, {
                    onDeleteClick: onDeleteClick,
                    contentMode: contentMode,
                    createAnalyticsEvent: createAnalyticsEvent
                })
        };
        return item_0;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.archiveAndDeleteLabel),
        items: archiveItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: ""
        }),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$d206439c03b979ee = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { shortcutKeys: shortcutKeys, id: id } = t0;
    let t1;
    if ($[0] !== id || $[1] !== shortcutKeys) {
        let t2;
        if ($[3] !== id) {
            t2 = (key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    key: `${id}-shortcut-${key}`,
                    shortcut: key
                });
            $[3] = id;
            $[4] = t2;
        } else t2 = $[4];
        t1 = shortcutKeys.map(t2);
        $[0] = id;
        $[1] = shortcutKeys;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ shortcutKeys: shortcutKeys, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, shortcutKeys.map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            key: `${id}-shortcut-${key}`,
            shortcut: key
        })));
const $434c765ed6791bfa$export$b605bf507f6a39c = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { item: item, icon: icon } = t0;
    const { id: id, url: url, target: target, onClick: onClick, shortcutText: shortcutText, text: text, showToggle: showToggle, isDisabled: isDisabled } = item;
    let t1;
    if ($[0] !== id || $[1] !== shortcutText || $[2] !== showToggle) {
        t1 = ()=>{
            if (shortcutText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$d206439c03b979ee, {
                shortcutKeys: shortcutText.split("+"),
                id: id
            });
            else {
                if (showToggle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
                    isChecked: showToggle.isChecked,
                    isDisabled: showToggle.isDisabled
                });
            }
            return null;
        };
        $[0] = id;
        $[1] = shortcutText;
        $[2] = showToggle;
        $[3] = t1;
    } else t1 = $[3];
    const ElementAfter = t1;
    const t2 = icon ?? null;
    let t3;
    if ($[4] !== ElementAfter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementAfter, null);
        $[4] = ElementAfter;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== id || $[7] !== isDisabled || $[8] !== onClick || $[9] !== t2 || $[10] !== t3 || $[11] !== target || $[12] !== text || $[13] !== url) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: t2,
            key: id,
            href: url,
            target: target,
            onClick: onClick,
            isDisabled: isDisabled,
            elemAfter: t3
        }, text);
        $[6] = id;
        $[7] = isDisabled;
        $[8] = onClick;
        $[9] = t2;
        $[10] = t3;
        $[11] = target;
        $[12] = text;
        $[13] = url;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ item: item, icon: icon })=>{
    const { id: id, url: url, target: target, onClick: onClick, shortcutText: shortcutText, text: text, showToggle: showToggle, isDisabled: isDisabled } = item;
    const ElementAfter = ()=>{
        if (shortcutText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$d206439c03b979ee, {
            shortcutKeys: shortcutText.split('+'),
            id: id
        });
        else if (showToggle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
            isChecked: showToggle.isChecked,
            isDisabled: showToggle.isDisabled
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: icon ?? null,
        key: id,
        href: url,
        target: target,
        onClick: onClick,
        isDisabled: isDisabled,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementAfter, null)
    }, text);
};
const $434c765ed6791bfa$export$36ee254e582a74c2 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { setIsCopyContentModalOpen: setIsCopyContentModalOpen, closeParentMenu: closeParentMenu, item: item, showIcon: t1 } = t0;
    const showIcon = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== closeParentMenu || $[1] !== setIsCopyContentModalOpen) {
        t2 = ()=>{
            closeParentMenu();
            setIsCopyContentModalOpen(true);
        };
        $[0] = closeParentMenu;
        $[1] = setIsCopyContentModalOpen;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== showIcon) {
        t3 = showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        }) : null;
        $[3] = showIcon;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== item.label || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: (0, $511857b10ace36ca$export$94db61d2b880af44),
            onClick: t2,
            elemBefore: t3
        }, item.label);
        $[5] = item.label;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ setIsCopyContentModalOpen: setIsCopyContentModalOpen, closeParentMenu: closeParentMenu, item: item, showIcon: showIcon = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: (0, $511857b10ace36ca$export$94db61d2b880af44),
        onClick: ()=>{
            closeParentMenu();
            setIsCopyContentModalOpen(true);
        },
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        }) : null
    }, item.label);
const $434c765ed6791bfa$export$3131530af790ffe2 = ({ isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, copyDatabaseItem: copyDatabaseItem, copyStructureItem: copyStructureItem, setIsCopyContentModalOpen: setIsCopyContentModalOpen, contentMode: contentMode, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const copyDatabaseLabel = formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.duplicateDatabase);
    const copyOnClick = copyStructureItem.onClick;
    copyStructureItem.onClick = ()=>{
        closeParentMenu();
        copyOnClick?.();
    };
    if (contentMode === 'archived') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$b605bf507f6a39c, {
        item: copyStructureItem,
        key: copyStructureItem.id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        })
    });
    const copyStructureItemWithComponent = {
        ...copyStructureItem,
        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$b605bf507f6a39c, {
                item: copyStructureItem,
                key: copyStructureItem.id
            })
    };
    const copyItems = [
        {
            ...copyDatabaseItem,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($434c765ed6791bfa$export$36ee254e582a74c2, {
                    setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                    closeParentMenu: closeParentMenu,
                    item: {
                        ...copyDatabaseItem,
                        label: copyDatabaseLabel
                    },
                    showIcon: false
                })
        },
        copyStructureItemWithComponent
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.duplicate),
        items: copyItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: ""
        }),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$f28b24dc0422311f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { contentId: contentId, dialogs: dialogs, saveDraft: saveDraft, createAnalyticsEvent: createAnalyticsEvent } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== dialogs || $[3] !== intl || $[4] !== saveDraft) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowViewChanges",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.();
            dialogs.showModal((0, $l3C2L.ViewChangesDialogLoader), {
                contentId: contentId,
                title: intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesTitle)
            });
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = dialogs;
        $[3] = intl;
        $[4] = saveDraft;
        $[5] = t1;
    } else t1 = $[5];
    const onClick = t1;
    let t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CxKE))), {
            label: ""
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesLabel);
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[8] !== onClick) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: "view-changes",
            onClick: onClick,
            elemBefore: t2
        }, t3);
        $[8] = onClick;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ contentId: contentId, dialogs: dialogs, saveDraft: saveDraft, createAnalyticsEvent: createAnalyticsEvent })=>{
    const intl = (0, $8C5kA.default)();
    const onClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowViewChanges',
                source: 'overflowMenu'
            }
        }).fire();
        saveDraft?.();
        dialogs.showModal((0, $l3C2L.ViewChangesDialogLoader), {
            contentId: contentId,
            title: intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesTitle)
        });
    }, [
        contentId,
        dialogs,
        intl,
        saveDraft,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: "view-changes",
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CxKE))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesLabel));
};
const $434c765ed6791bfa$export$2ca3e90bac67fd87 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { item: item, nestedPopup: nestedPopup, setNestedPopup: setNestedPopup, contentId: contentId, setIsMenuOpen: setIsMenuOpen } = t0;
    let t1;
    if ($[0] !== setIsMenuOpen) {
        t1 = ()=>{
            setIsMenuOpen(false);
        };
        $[0] = setIsMenuOpen;
        $[1] = t1;
    } else t1 = $[1];
    const handleMenuClose = t1;
    let t2;
    if ($[2] !== nestedPopup || $[3] !== setNestedPopup) {
        t2 = ()=>{
            if (nestedPopup === "content-ownership") setNestedPopup(undefined);
            else setNestedPopup("content-ownership");
        };
        $[2] = nestedPopup;
        $[3] = setNestedPopup;
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClick = t2;
    let t3;
    if ($[5] !== setNestedPopup) {
        t3 = ()=>{
            setNestedPopup(undefined);
        };
        $[5] = setNestedPopup;
        $[6] = t3;
    } else t3 = $[6];
    const handlePopupClose = t3;
    const t4 = nestedPopup === "content-ownership";
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        }) : null;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== contentId || $[9] !== handleMenuClose || $[10] !== handleOnClick || $[11] !== handlePopupClose || $[12] !== item.id || $[13] !== item.label || $[14] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jcM8h.ContentOwnerPopupComponent), {
            contentId: contentId,
            itemId: item.id,
            itemLabel: item.label,
            isOpen: t4,
            onClick: handleOnClick,
            onCloseParent: handleMenuClose,
            onClosePopup: handlePopupClose,
            elemBefore: t5
        });
        $[8] = contentId;
        $[9] = handleMenuClose;
        $[10] = handleOnClick;
        $[11] = handlePopupClose;
        $[12] = item.id;
        $[13] = item.label;
        $[14] = t4;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ item: item, nestedPopup: nestedPopup, setNestedPopup: setNestedPopup, contentId: contentId, setIsMenuOpen: setIsMenuOpen })=>{
    const handleMenuClose = ()=>{
        setIsMenuOpen(false);
    };
    const handleOnClick = ()=>{
        if (nestedPopup === "content-ownership") setNestedPopup(undefined);
        else setNestedPopup("content-ownership");
    };
    const handlePopupClose = ()=>{
        setNestedPopup(undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jcM8h.ContentOwnerPopupComponent), {
        contentId: contentId,
        itemId: item.id,
        itemLabel: item.label,
        isOpen: nestedPopup === "content-ownership",
        onClick: handleOnClick,
        onCloseParent: handleMenuClose,
        onClosePopup: handlePopupClose,
        elemBefore: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        }) : null
    });
};
const $434c765ed6791bfa$export$f26eff3587fe7632 = ({ isAppsRendered: isAppsRendered, spaceKey: spaceKey, contentId: contentId, isMenuOpen: isMenuOpen, nestedPopup: nestedPopup, items: items, handleNestedMenuItemClick: handleNestedMenuItemClick, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const pageAppItems = items.filter((item)=>item?.completeKey?.includes((0, $jBnsv.CONNECT_APP_PREFIX_KEY)) && item?.id !== (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID)).map((item)=>{
        item.closeParentMenu = closeParentMenu;
        return item;
    });
    const handleAppsMenuItemClick = ()=>{
        handleNestedMenuItemClick("apps");
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowApps',
                source: 'overflowMenu'
            }
        }).fire();
    };
    return {
        name: $434c765ed6791bfa$export$68013e639efb767f,
        shouldRender: isAppsRendered,
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b742140c6b014561$export$fcc1c0135b5761c6), {
                    spaceKey: spaceKey,
                    contentId: contentId,
                    onLoadComplete: ()=>{},
                    isDropdownMenuOpen: isMenuOpen,
                    dialogs: dialogs
                }, (forgeMenuItems)=>pageAppItems.length > 0 || forgeMenuItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.pageAppsLabel),
                        items: pageAppItems,
                        isNestedMenuOpen: nestedPopup === "apps",
                        onClick: handleAppsMenuItemClick,
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                            label: ""
                        }),
                        forgeMenuItems: forgeMenuItems,
                        onMenuClose: handleNestedMenuItemClose,
                        id: "third-party"
                    }) : null))
    };
};
const $434c765ed6791bfa$export$7e059d95fddc01f4 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, pageTitle: pageTitle } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== createAnalyticsEvent || $[3] !== experienceTracker || $[4] !== intl || $[5] !== pageTitle || $[6] !== spaceKey) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Ghb.ReverseTrialLozengeListItemExperiment), {
                    touchpointId: "confluence_page_automations_list_item",
                    edition: (0, $d9tcB.ConfluenceEdition).PREMIUM
                }),
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS)
                    });
                    dialogs.showModal((0, $1AbrA.PageQuickActionAutomationMenu), {
                        pageId: contentId,
                        pageTitle: pageTitle || intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsModalTitle),
                        spaceKey: spaceKey
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "overflowAutomations",
                            source: "overflowMenu"
                        }
                    }).fire();
                }
            }, intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsLabel)));
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = experienceTracker;
        $[4] = intl;
        $[5] = pageTitle;
        $[6] = spaceKey;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, pageTitle: pageTitle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Ghb.ReverseTrialLozengeListItemExperiment), {
                touchpointId: "confluence_page_automations_list_item",
                edition: (0, $d9tcB.ConfluenceEdition).PREMIUM
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                label: ""
            }),
            onClick: ()=>{
                experienceTracker.start({
                    name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS)
                });
                dialogs.showModal((0, $1AbrA.PageQuickActionAutomationMenu), {
                    pageId: contentId,
                    pageTitle: pageTitle || intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsModalTitle),
                    spaceKey: spaceKey
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'overflowAutomations',
                        source: 'overflowMenu'
                    }
                }).fire();
            }
        }, intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsLabel)));
};
const $434c765ed6791bfa$export$f404e2d5b48ab522 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const item = webItemsMap[0, $511857b10ace36ca$export$da9876ab77cf10e8];
    if (!item) return null;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowAdvanced",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("advanced");
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleNestedMenuItemClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClick = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.advancedLabel);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== closeParentMenu || $[5] !== item) {
        t3 = [
            {
                ...item,
                closeParentMenu: closeParentMenu
            }
        ];
        $[4] = closeParentMenu;
        $[5] = item;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "",
            size: "small"
        });
        $[7] = t4;
    } else t4 = $[7];
    const t5 = nestedPopup === "advanced";
    let t6;
    if ($[8] !== handleNestedMenuItemClose || $[9] !== onClick || $[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: t3,
            iconBefore: t4,
            isNestedMenuOpen: t5,
            onClick: onClick,
            key: (0, $511857b10ace36ca$export$ab4fe2a2881747b5),
            onMenuClose: handleNestedMenuItemClose
        });
        $[8] = handleNestedMenuItemClose;
        $[9] = onClick;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const item = webItemsMap[0, $511857b10ace36ca$export$da9876ab77cf10e8];
    if (!item) return null;
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowAdvanced',
                source: 'overflowMenu'
            }
        }).fire();
        handleNestedMenuItemClick("advanced");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $434c765ed6791bfa$export$a7357cdd1f0b0168.advancedLabel),
        items: [
            {
                ...item,
                closeParentMenu: closeParentMenu
            }
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "",
            size: "small"
        }),
        isNestedMenuOpen: nestedPopup === "advanced",
        onClick: onClick,
        key: (0, $511857b10ace36ca$export$ab4fe2a2881747b5),
        onMenuClose: handleNestedMenuItemClose
    });
};
function $434c765ed6791bfa$var$_temp(item_0) {
    return item_0.id;
}
function $434c765ed6791bfa$var$_temp2(item) {
    return item.id === (0, $511857b10ace36ca$export$d81a93c80838b765) || item.id === (0, $511857b10ace36ca$export$da4fec526a505196);
}



























var $4tuiZ = parcelRequire("4tuiZ");

const $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { label: label, isLivePage: isLivePage, contentType: contentType, itemId: t1, itemUrl: t2 } = t0;
    const itemId = t1 === undefined ? "" : t1;
    const itemUrl = t2 === undefined ? "" : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showNewContentHistory: showNewContentHistory } = (0, $4tuiZ.useNewContentHistoryActions)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: ""
        });
        $[0] = t3;
    } else t3 = $[0];
    const t4 = isLivePage && (0, $6mKj3.expVal)("confluence_content_history_updates", "isEnabled", false) ? undefined : itemUrl;
    let t5;
    if ($[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== isLivePage || $[4] !== showNewContentHistory) {
        t5 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "versionHistory",
                    source: "overflowMenu",
                    attributes: {
                        isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper"),
                        isNewContentHistory: (0, $6mKj3.expVal)("confluence_content_history_updates", "isEnabled", false),
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                }
            }).fire();
            if (isLivePage && (0, $6mKj3.expVal)("confluence_content_history_updates", "isEnabled", false)) showNewContentHistory();
        };
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = isLivePage;
        $[4] = showNewContentHistory;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== itemId || $[7] !== label || $[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: itemId,
            elemBefore: t3,
            href: t4,
            onClick: t5
        }, label);
        $[6] = itemId;
        $[7] = label;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ label: label, isLivePage: isLivePage, contentType: contentType, itemId: itemId = '', itemUrl: itemUrl = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showNewContentHistory: showNewContentHistory } = (0, $4tuiZ.useNewContentHistoryActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: itemId,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: ""
        }),
        // When the experiment is enabled, we don't want to redirect live pages since it will be shown as an overlay in the editor
        href: isLivePage && (0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false) ? undefined : itemUrl,
        onClick: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'versionHistory',
                    source: 'overflowMenu',
                    attributes: {
                        isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
                        isNewContentHistory: (0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false),
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                }
            }).fire();
            // Only live pages at the moment will have the "in editor" content history experience
            if (isLivePage && (0, $6mKj3.expVal)('confluence_content_history_updates', 'isEnabled', false)) showNewContentHistory();
        }
    }, label);
};































var $fT2ta = parcelRequire("fT2ta");








var $dmDX7 = parcelRequire("dmDX7");


var $ewVsQ = parcelRequire("ewVsQ");

const $5d3293071a1569ba$var$i18n = (0, $cgtv4.defineMessages)({
    askToEditContentLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit",
        defaultMessage: "Ask to edit"
    },
    askToEditPendingLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.pending.label",
        defaultMessage: "Requested"
    },
    askToEditPendingRequestExistsFlagTitle: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.flag.title",
        defaultMessage: "Request pending"
    },
    askToEditPendingRequestExistsFlagDescription: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.flag.description",
        defaultMessage: "You already sent a request. We'll send you an email when it's been approved."
    }
});
const $5d3293071a1569ba$export$84d0de3613f64b9a = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { contentType: contentType, contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent, askToEditKey: askToEditKey } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== flags || $[2] !== triggerAnalyticsEvent) {
        t1 = {
            contentId: contentId,
            flags: flags,
            triggerAnalyticsEvent: triggerAnalyticsEvent
        };
        $[0] = contentId;
        $[1] = flags;
        $[2] = triggerAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)(t1);
    let t2;
    if ($[4] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t2;
    } else t2 = $[5];
    const { pendingRequestExists: pendingRequestExists, isLoadingForFirstTime: pendingRequestCheckLoading } = (0, $dmDX7.usePendingRequestExists)(t2);
    const readyToSendRequest = !hasRequestedEditPermission && !pendingRequestExists && !pendingRequestCheckLoading;
    let t3;
    if ($[6] !== contentId || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== flags || $[10] !== formatMessage || $[11] !== pendingRequestExists || $[12] !== readyToSendRequest || $[13] !== requestToEditContent) {
        t3 = async ()=>{
            if (readyToSendRequest) {
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "requestAccessButton",
                        source: "moreActionsMenu",
                        attributes: {
                            contentType: contentType,
                            accessType: "edit",
                            contentId: contentId,
                            editDeniedButCanView: true
                        }
                    }
                }).fire();
                await requestToEditContent();
            } else if (pendingRequestExists) flags.showInfoFlag({
                id: "ask-to-edit.ellipsis.pending-edit-request-exists.flag",
                title: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagTitle),
                description: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagDescription),
                isAutoDismiss: true
            });
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = flags;
        $[10] = formatMessage;
        $[11] = pendingRequestExists;
        $[12] = readyToSendRequest;
        $[13] = requestToEditContent;
        $[14] = t3;
    } else t3 = $[14];
    const handleItemClick = t3;
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        });
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== hasRequestedEditPermission || $[17] !== pendingRequestExists) {
        t5 = (hasRequestedEditPermission || pendingRequestExists) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            duration: "medium"
        }, $5d3293071a1569ba$var$_temp);
        $[16] = hasRequestedEditPermission;
        $[17] = pendingRequestExists;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5d3293071a1569ba$var$i18n.askToEditContentLabel);
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== askToEditKey || $[21] !== handleItemClick || $[22] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: askToEditKey,
            onClick: handleItemClick,
            elemBefore: t4,
            elemAfter: t5
        }, t6));
        $[20] = askToEditKey;
        $[21] = handleItemClick;
        $[22] = t5;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
} : ({ contentType: contentType, contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent, askToEditKey: askToEditKey })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)({
        contentId: contentId,
        flags: flags,
        triggerAnalyticsEvent: triggerAnalyticsEvent
    });
    const { pendingRequestExists: pendingRequestExists, isLoadingForFirstTime: pendingRequestCheckLoading } = (0, $dmDX7.usePendingRequestExists)({
        contentId: contentId
    });
    const readyToSendRequest = !hasRequestedEditPermission && !pendingRequestExists && !pendingRequestCheckLoading;
    const handleItemClick = async ()=>{
        if (readyToSendRequest) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'requestAccessButton',
                    source: 'moreActionsMenu',
                    attributes: {
                        contentType: contentType,
                        accessType: 'edit',
                        contentId: contentId,
                        editDeniedButCanView: true
                    }
                }
            }).fire();
            await requestToEditContent();
        } else if (pendingRequestExists) flags.showInfoFlag({
            id: 'ask-to-edit.ellipsis.pending-edit-request-exists.flag',
            title: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagTitle),
            description: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagDescription),
            isAutoDismiss: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: askToEditKey,
        onClick: handleItemClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        }),
        elemAfter: (hasRequestedEditPermission || pendingRequestExists) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5d3293071a1569ba$var$i18n.askToEditPendingLabel))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5d3293071a1569ba$var$i18n.askToEditContentLabel)));
};
function $5d3293071a1569ba$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5d3293071a1569ba$var$i18n.askToEditPendingLabel)));
}


const $511857b10ace36ca$export$bcce08436c9de127 = 'action-move-page-dialog-link';
const $511857b10ace36ca$export$c7733ea6d8e45875 = 'action-move-blogpost-dialog-link';
const $511857b10ace36ca$export$da4fec526a505196 = 'action-remove-content-link';
const $511857b10ace36ca$export$94db61d2b880af44 = 'action-copy-page-link';
const $511857b10ace36ca$export$d81a93c80838b765 = 'action-archive-link';
const $511857b10ace36ca$export$21b8b89e4603550f = 'action-restore-link';
const $511857b10ace36ca$export$84c7eab054d974db = 'action-give-feedback-link';
const $511857b10ace36ca$export$a751f1adb88d1383 = 'view-resolved-comments';
const $511857b10ace36ca$export$e14cf657321c833b = 'action-view-version-history-link';
const $511857b10ace36ca$export$fc2e34cd983af5d6 = 'action-view-history-link';
const $511857b10ace36ca$export$bbe81b5a8b0eaf4 = 'action-export-pdf-link';
const $511857b10ace36ca$export$5da5719a925f973 = 'action-export-word-link';
const $511857b10ace36ca$export$b1a4c392275ea35a = 'action-templates-and-import';
const $511857b10ace36ca$export$5497d83bbd1b1232 = 'action-convert-page-to-blog';
const $511857b10ace36ca$export$7767afe5b675f4b1 = 'action-convert-page-to-folder';
const $511857b10ace36ca$export$8ba85686c8897eca = 'action-convert-live-doc-to-page';
const $511857b10ace36ca$export$f9e89fba7e6b4574 = 'preferences';
const $511857b10ace36ca$export$d588519b9727f1cc = 'export-file';
const $511857b10ace36ca$export$f0ae5a9b5b44d373 = 'open-find-replace';
const $511857b10ace36ca$export$cce5e117e5e43bc = 'whiteboard-import';
const $511857b10ace36ca$export$240b6ef4a1c531f6 = 'presentation-mode';
const $511857b10ace36ca$export$10f4bed2ae52719b = 'action-switch-to-live-edit';
const $511857b10ace36ca$export$c9981a2480d638b0 = 'action-revert-to-previous';
const $511857b10ace36ca$export$fe2b6e9bf8b31ecc = 'action-revert-editor';
const $511857b10ace36ca$export$12b5e6890d8e049c = 'fullscreen';
const $511857b10ace36ca$export$5f2e846fff4ab830 = 'whiteboard-documentation';
const $511857b10ace36ca$export$d4cf3906d3082596 = 'whiteboard-templates';
const $511857b10ace36ca$export$cc1f11fb5e07970e = 'whiteboard-to-live-doc-with-rovo';
const $511857b10ace36ca$export$348fd9bd77c132d9 = 'action-favourite-content';
const $511857b10ace36ca$export$35f02acdf766e275 = 'action-favourite-space';
const $511857b10ace36ca$export$e242b9905c10e726 = 'action-watch-content';
const $511857b10ace36ca$export$6bb183703c5072f1 = 'ask-to-edit-content';
const $511857b10ace36ca$export$74317f458aa33c63 = 'action-preview-content';
const $511857b10ace36ca$export$461acb5c5f9c7b12 = 'action-manage-content';
const $511857b10ace36ca$export$244b90a342b60d9f = 'action-classify-content';
const $511857b10ace36ca$export$fe0a3b90b0b6010b = 'action-automations';
const $511857b10ace36ca$export$52e1dc7e5d9b8b02 = 'action-advanced';
const $511857b10ace36ca$export$da9876ab77cf10e8 = 'action-view-storage-link';
const $511857b10ace36ca$export$2594f905f6c1490e = 'databases-copy-structure';
const $511857b10ace36ca$export$6563b47d35bee4f1 = 'databases-undo';
const $511857b10ace36ca$export$fe723f15ba37849b = 'databases-redo';
const $511857b10ace36ca$export$be7385413e15c3ea = 'databases-templates';
const $511857b10ace36ca$export$e07ca208ff99048e = 'databases-export';
const $511857b10ace36ca$export$d7bae9f2073f40be = 'databases-lock-structure';
const $511857b10ace36ca$export$95f3debc4a615fda = 'databases-get-help';
const $511857b10ace36ca$export$54ed9c94f2cfe2b6 = 'databases-devtools';
const $511857b10ace36ca$export$23eaedbb3a44a3b5 = 'action-edit-embed-link';
const $511857b10ace36ca$export$a6381225def83c4b = 'action-page-permissions-link';
const $511857b10ace36ca$export$ab4fe2a2881747b5 = 'action-export-content';
const $511857b10ace36ca$export$3192aea0628d957a = 'action-convert-content';
const $511857b10ace36ca$export$654801d4f89a934 = 'action-company-hub-feedback';
const $511857b10ace36ca$export$43db96fb923dc5c7 = 'action-editor-undo';
const $511857b10ace36ca$export$4e316098da1efb3e = 'action-editor-redo';
const $511857b10ace36ca$export$8f2c4b97a6e00f7f = 'action-editor-find-replace'; // --- Nested / Combined Actions ---
const $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE = 'combined-action-archive';
const $511857b10ace36ca$var$isWebItem = (item)=>{
    return typeof item === 'object' && 'id' in item;
};
const $511857b10ace36ca$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-types-header.content-types.more-actions.label",
        defaultMessage: "More actions"
    },
    tooltip: {
        id: "content-types-header.content-types.more-actions.disabled-tooltip",
        defaultMessage: "Coming soon"
    },
    templatesImportLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.templates",
        defaultMessage: "Templates and import"
    },
    presentLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.present",
        defaultMessage: "Present"
    },
    revertLabel: {
        id: "content-types-header.revert.label",
        defaultMessage: "Revert to previous version"
    },
    revertEditor: {
        id: "content-types-header.revert.editor.label",
        defaultMessage: "Revert to legacy editor"
    },
    help: {
        id: "content-types-header.ellipsis.open.ellipsis.help",
        defaultMessage: "Help"
    },
    previewLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.preview",
        defaultMessage: "Preview"
    },
    manageLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.manage",
        defaultMessage: "Manage"
    },
    versionHistoryLabel: {
        id: "content-types-header.version.history.label",
        defaultMessage: "Version history"
    },
    convertToPage: {
        id: "content-types-header.ellipsis.open.ellipsis.convert-to-page",
        defaultMessage: "Convert to page"
    },
    companyHubFeedback: {
        id: "content-types-header.ellipsis.open.ellipsis.hub.share-feedback",
        defaultMessage: "Give feedback on Company hub"
    },
    editorUndoLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-undo",
        defaultMessage: "Undo"
    },
    editorRedoLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-redo",
        defaultMessage: "Redo"
    },
    editorFindReplaceLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-find-replace",
        defaultMessage: "Find and replace"
    }
});
const $511857b10ace36ca$var$dropdownMenuContainerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    minWidth: '24px',
    display: 'flex',
    alignItems: 'center'
});
const $511857b10ace36ca$var$dropdownMenuContentStyles = (0, $ecnYn.xcss)({
    minWidth: '260px'
});
const $511857b10ace36ca$var$dropdownTriggerBoxStyles = (0, $ecnYn.xcss)({
    position: 'relative'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $511857b10ace36ca$var$KeyboardShortcutIcon = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ppf _2rkofajl _bfhki8nm _syaz1q3r",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _2rkofajl _bfhki8nm _syaz1q3r",
            __cmplp.className
        ])
    });
}); // NOTE: These styles are directly copied from ContentTools.tsx in @confluence/content-tools
const $511857b10ace36ca$var$ResolvedCommentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $511857b10ace36ca$var$ResolvedCommentsLabelContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlcs5v _1o9zkb7n _i0dlf1ug _2hwx12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlcs5v _1o9zkb7n _i0dlf1ug _2hwx12x7",
            __cmplp.className
        ])
    });
});
const $511857b10ace36ca$var$isItemGroup = (item)=>{
    return !!item.items;
};
const $511857b10ace36ca$var$createActionsMap = (actions)=>{
    const map = {};
    actions?.forEach((action)=>{
        if (action?.id) map[action.id] = action;
    });
    return map;
};
const $511857b10ace36ca$var$useOpenWatchMenuQueryParam = (0, $dPJCf.createSingleQueryParamHook)('openWatchModal');
const $511857b10ace36ca$export$6e6eb6019781c337 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(355);
    const { moreActions: moreActions, contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, allowedFeatures: allowedFeatures, hasArchivePermission: hasArchivePermission, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, flags: flags, contentData: contentData, readOnly: readOnly, isConvertToFolderHighlighted: t1, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted } = t0;
    const isConvertToFolderHighlighted = t1 === undefined ? false : t1;
    const intl = (0, $8C5kA.default)();
    const history = (0, $dPJCf.useHistory)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== contentType || $[3] !== createAnalyticsEvent || $[4] !== spaceKey) {
        t2 = async (eventName)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: eventName,
                    actionSubject: "askToEditContent",
                    source: "moreActionsMenu",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        isContentWrapper: (0, $6mKj3.expValEquals)("confluence_ask_to_edit_across_content_type", "cohort", "test"),
                        spaceKey: spaceKey,
                        contentMode: contentMode || "view"
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = contentType;
        $[3] = createAnalyticsEvent;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const triggerAnalyticsEvent = t2;
    const { saveDraft: saveDraft, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, isContentCreationPanelOpen: isContentCreationPanelOpen, showRevertDialog: showRevertDialog, onPreviewClicked: onPreviewClicked, hasEditPermission: hasEditPermission, validatePageAndOpenModal: validatePageAndOpenModal, canUndo: editorCanUndo, canRedo: editorCanRedo, undo: editorUndo, redo: editorRedo, activateFindReplace: editorActivateFindReplace } = (0, $3o3i5.useEditorObjectHeaderContext)();
    let t3;
    if ($[6] !== contentId || $[7] !== contentType) {
        t3 = {
            contentId: contentId,
            contentType: contentType
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = t3;
    } else t3 = $[8];
    const isPageOrBlogAutoConverted = (0, $0633edcc0f21cf62$export$38d9182f14dddb00)(t3);
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            source: "hubEditorEllipsisDropdown",
            type: (0, $4cOi8.FeedbackType).COMPANY_HUB
        };
        $[9] = t4;
    } else t4 = $[9];
    const openCompanyHubFeedbackCollector = (0, $lOeVN.useFeedbackCollector)(t4);
    let t5;
    if ($[10] !== validatePageAndOpenModal) {
        t5 = validatePageAndOpenModal?.("OverflowMenuConvertToPage");
        $[10] = validatePageAndOpenModal;
        $[11] = t5;
    } else t5 = $[11];
    const publishPage = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== contentId) {
        t7 = {
            variables: {
                contentId: contentId,
                location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
                locations: t6,
                spaceKey: null,
                version: null
            }
        };
        $[13] = contentId;
        $[14] = t7;
    } else t7 = $[14];
    const [preloadWebItemsQuery, t8] = (0, $j1Ss3.useLazyQuery)((0, $fjiOd.WebItemLocationQuery), t7);
    const { data: webItemsData, called: isWebItemsQueryCalled, error: error, loading: loading } = t8;
    const { showMove: shouldShowMove, showArchive: shouldShowArchive, showCopy: shouldShowCopy, showClassificationMenuAction: shouldShowClassification } = allowedFeatures;
    const [isCopyContentModalOpen, setIsCopyContentModalOpen] = (0, $42omo.useState)(false);
    const [isMoveContentModalOpen, setIsMoveContentModalOpen] = (0, $42omo.useState)(false);
    const [isShortcutTriggered, setIsShortcutTriggered] = (0, $42omo.useState)(false);
    const { isMenuOpen: isMenuOpen, isCloseMenuDisabled: isCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuState)();
    const { setIsMenuOpen: setIsMenuOpen } = (0, $c54hr.useMoreActionsMenuActions)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { edition: edition, isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const isFreeUser = edition === (0, $euL71.ConfluenceEdition).FREE;
    const isPremiumUser = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const isCommentsEnabled = (0, $1b70db1d5649f5f3$export$5dc260e4e702b5d0)(contentType);
    const isVersionHistoryEnabled = (0, $5thep.useIsVersionHistoryEnabled)(contentType);
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [nestedPopup, setNestedPopup] = (0, $42omo.useState)(undefined);
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const isExternalCollaborator = (0, $foQ4a.useIsExternalCollaborator)();
    let isSpaceOverviewPage;
    let t9;
    if ($[15] !== contentMode || $[16] !== contentType) {
        isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
        t9 = (0, $ff966189b275be15$export$a2eada40e8c9a2ed)(contentType, contentMode, isSpaceOverviewPage);
        $[15] = contentMode;
        $[16] = contentType;
        $[17] = isSpaceOverviewPage;
        $[18] = t9;
    } else {
        isSpaceOverviewPage = $[17];
        t9 = $[18];
    }
    const isPresentRendered = t9;
    const isLivePage = contentType === "page" && contentMode === "live";
    const [t10] = (0, $efvKr.useLivePageMode)();
    const { mode: livePageMode } = t10;
    const isLivePageViewOnlyPermissions = isLivePage && !hasEditPermission;
    let t11;
    if ($[19] !== contentData?.operations) {
        t11 = (type)=>contentData?.operations?.some((operation)=>operation?.targetType === type && operation?.operation === "update");
        $[19] = contentData?.operations;
        $[20] = t11;
    } else t11 = $[20];
    const hasUpdateOperation = t11;
    let t12;
    if ($[21] !== hasUpdateOperation) {
        t12 = (type_0)=>!hasUpdateOperation(type_0) && (0, $6mKj3.expValEquals)("confluence_ask_to_edit_across_content_type", "cohort", "test");
        $[21] = hasUpdateOperation;
        $[22] = t12;
    } else t12 = $[22];
    const isAskToEditEnabled = t12;
    let t13;
    if ($[23] !== contentType || $[24] !== hasUpdateOperation) {
        t13 = contentType === "page" && !hasUpdateOperation(contentType);
        $[23] = contentType;
        $[24] = hasUpdateOperation;
        $[25] = t13;
    } else t13 = $[25];
    const isPageViewOnlyPermissions = t13;
    let t14;
    if ($[26] !== contentType || $[27] !== isAskToEditEnabled) {
        t14 = contentType === "whiteboard" && isAskToEditEnabled(contentType);
        $[26] = contentType;
        $[27] = isAskToEditEnabled;
        $[28] = t14;
    } else t14 = $[28];
    const isWhiteboardViewOnlyPermissions = t14;
    let t15;
    if ($[29] !== contentType || $[30] !== isAskToEditEnabled) {
        t15 = contentType === "database" && isAskToEditEnabled(contentType);
        $[29] = contentType;
        $[30] = isAskToEditEnabled;
        $[31] = t15;
    } else t15 = $[31];
    const isDatabaseViewOnlyPermissions = t15;
    let t16;
    if ($[32] !== contentType || $[33] !== isAskToEditEnabled) {
        t16 = contentType === "blogpost" && isAskToEditEnabled(contentType);
        $[32] = contentType;
        $[33] = isAskToEditEnabled;
        $[34] = t16;
    } else t16 = $[34];
    const isBlogViewOnlyPermissions = t16;
    const isContentViewOnlyPermissions = isLivePageViewOnlyPermissions || isPageViewOnlyPermissions || isWhiteboardViewOnlyPermissions || isDatabaseViewOnlyPermissions || isBlogViewOnlyPermissions;
    const contentStatus = contentData?.status || undefined;
    const isArchived = contentData?.status === "archived";
    const isStarringEnabledForContentType = (0, $2cKGu.useIsStarringEnabled)(contentType, contentMode);
    const [t17] = (0, $7J5Uc.useThemingState)();
    const { theme: theme } = t17;
    const openWatchModalQueryParam = Boolean($511857b10ace36ca$var$useOpenWatchMenuQueryParam());
    const { setQueryParams: setQueryParams, push: push } = (0, $dPJCf.useRouteActions)();
    let t18;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
            step: (0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST
        };
        $[35] = t18;
    } else t18 = $[35];
    const { activeSpotlight: activeSpotlight, isHintVisible: isHintVisible, resetTour: resetTour } = (0, $bzwhi.useMoreActionsObjectSidebarTour)(t18);
    let t19;
    if ($[36] !== contentData?.operations || $[37] !== contentType) {
        t19 = contentData?.operations?.filter((operation_0)=>operation_0?.targetType === contentType && operation_0?.operation === "read").length;
        $[36] = contentData?.operations;
        $[37] = contentType;
        $[38] = t19;
    } else t19 = $[38];
    const hasReadPermission = Boolean(t19);
    const shouldRenderStarContentMenuItem = isStarringEnabledForContentType && !!allowedFeatures.showFavourite && !isSpaceOverviewPage && hasReadPermission;
    const shouldRenderStarSpaceMenuItem = isSpaceOverviewPage && isLoggedIn;
    let t20;
    if ($[39] !== spaceKey) {
        t20 = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[39] = spaceKey;
        $[40] = t20;
    } else t20 = $[40];
    const isCompanyHub = t20;
    let t21;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = [
            (0, $iQb1R.Buttons).DELETE_DRAFT,
            (0, $iQb1R.Buttons).MANAGE,
            (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
            (0, $iQb1R.Buttons).VIEW_CHANGES
        ];
        $[41] = t21;
    } else t21 = $[41];
    const companyHubEllipsisButtons = t21;
    let t22;
    if ($[42] !== isCompanyHub) {
        const allowedEllipsisButtons = isCompanyHub ? companyHubEllipsisButtons : [
            (0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY,
            (0, $iQb1R.Buttons).DELETE_DRAFT,
            (0, $iQb1R.Buttons).EDIT_LABELS,
            (0, $iQb1R.Buttons).MOVE_PAGE,
            (0, $iQb1R.Buttons).PREVIEW,
            (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
            (0, $iQb1R.Buttons).TEMPLATE_BROWSER,
            (0, $iQb1R.Buttons).VIEW_CHANGES,
            (0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT,
            (0, $iQb1R.Buttons).CLASSIFY_CONTENT
        ];
        t22 = (menuItem)=>allowedEllipsisButtons?.includes(menuItem) ?? true;
        $[42] = isCompanyHub;
        $[43] = t22;
    } else t22 = $[43];
    const isAllowed = t22;
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    let t23;
    let t24;
    if ($[44] !== setIsMenuOpen || $[45] !== showVersionHistorySpotlight) {
        t23 = ()=>{
            if (showVersionHistorySpotlight) setIsMenuOpen(true);
            return ()=>{
                setIsMenuOpen(false);
            };
        };
        t24 = [
            setIsMenuOpen,
            showVersionHistorySpotlight
        ];
        $[44] = setIsMenuOpen;
        $[45] = showVersionHistorySpotlight;
        $[46] = t23;
        $[47] = t24;
    } else {
        t23 = $[46];
        t24 = $[47];
    }
    (0, $42omo.useEffect)(t23, t24);
    let t25;
    let t26;
    if ($[48] !== isConvertToFolderHighlighted || $[49] !== setIsMenuOpen) {
        t25 = ()=>{
            if (isConvertToFolderHighlighted) {
                setIsMenuOpen(isConvertToFolderHighlighted);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Convert);
            }
        };
        t26 = [
            isConvertToFolderHighlighted,
            setIsMenuOpen
        ];
        $[48] = isConvertToFolderHighlighted;
        $[49] = setIsMenuOpen;
        $[50] = t25;
        $[51] = t26;
    } else {
        t25 = $[50];
        t26 = $[51];
    }
    (0, $42omo.useEffect)(t25, t26);
    let t27;
    if ($[52] !== allowedFeatures.showWatchDialog || $[53] !== contentMode || $[54] !== contentType || $[55] !== loading || $[56] !== openWatchModalQueryParam || $[57] !== setIsMenuOpen || $[58] !== setQueryParams) {
        t27 = ()=>{
            if (openWatchModalQueryParam && contentType && contentMode && !loading) {
                if ((0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog) {
                    setIsMenuOpen(true);
                    setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
                }
                setQueryParams({
                    openWatchModal: null
                });
            }
        };
        $[52] = allowedFeatures.showWatchDialog;
        $[53] = contentMode;
        $[54] = contentType;
        $[55] = loading;
        $[56] = openWatchModalQueryParam;
        $[57] = setIsMenuOpen;
        $[58] = setQueryParams;
        $[59] = t27;
    } else t27 = $[59];
    let t28;
    if ($[60] !== allowedFeatures || $[61] !== contentMode || $[62] !== contentType || $[63] !== loading || $[64] !== openWatchModalQueryParam || $[65] !== setIsMenuOpen || $[66] !== setQueryParams) {
        t28 = [
            openWatchModalQueryParam,
            setQueryParams,
            contentType,
            contentMode,
            loading,
            allowedFeatures,
            setIsMenuOpen
        ];
        $[60] = allowedFeatures;
        $[61] = contentMode;
        $[62] = contentType;
        $[63] = loading;
        $[64] = openWatchModalQueryParam;
        $[65] = setIsMenuOpen;
        $[66] = setQueryParams;
        $[67] = t28;
    } else t28 = $[67];
    (0, $42omo.useEffect)(t27, t28);
    let t29;
    if ($[68] !== isShortcutTriggered || $[69] !== loading || $[70] !== webItemsData?.webItemSections) {
        t29 = ()=>{
            if (isShortcutTriggered && !loading) {
                if (webItemsData?.webItemSections?.some($511857b10ace36ca$var$_temp)) {
                    (0, $4GDP8.openMoreActionsMenuClick)();
                    (0, $4GDP8.simulateItemClick)($511857b10ace36ca$export$240b6ef4a1c531f6);
                }
                setIsShortcutTriggered(false);
            }
        };
        $[68] = isShortcutTriggered;
        $[69] = loading;
        $[70] = webItemsData?.webItemSections;
        $[71] = t29;
    } else t29 = $[71];
    let t30;
    if ($[72] !== isShortcutTriggered || $[73] !== loading || $[74] !== webItemsData) {
        t30 = [
            isShortcutTriggered,
            webItemsData,
            loading
        ];
        $[72] = isShortcutTriggered;
        $[73] = loading;
        $[74] = webItemsData;
        $[75] = t30;
    } else t30 = $[75];
    (0, $42omo.useEffect)(t29, t30);
    let t31;
    if ($[76] !== activeSpotlight || $[77] !== contentId || $[78] !== createAnalyticsEvent || $[79] !== isCloseMenuDisabled || $[80] !== resetTour || $[81] !== setIsConvertToFolderHighlighted || $[82] !== setIsMenuOpen || $[83] !== spaceId) {
        t31 = (t32)=>{
            const { isOpen: isOpen } = t32;
            if (!isOpen && isCloseMenuDisabled && (0, $9wGTI.fg)("cc_modernize_ga_changeboarding")) return;
            if (activeSpotlight) return;
            setIsMenuOpen(isOpen);
            if (!isOpen) {
                resetTour();
                setNestedPopup(undefined);
                setIsConvertToFolderHighlighted?.(false);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contentTypeHeaderMoreActions",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader",
                    attributes: {
                        isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                    }
                }
            }).fire();
        };
        $[76] = activeSpotlight;
        $[77] = contentId;
        $[78] = createAnalyticsEvent;
        $[79] = isCloseMenuDisabled;
        $[80] = resetTour;
        $[81] = setIsConvertToFolderHighlighted;
        $[82] = setIsMenuOpen;
        $[83] = spaceId;
        $[84] = t31;
    } else t31 = $[84];
    const handleOpenChange = t31;
    let t32;
    if ($[85] !== preloadWebItemsQuery) {
        t32 = ()=>{
            preloadWebItemsQuery();
        };
        $[85] = preloadWebItemsQuery;
        $[86] = t32;
    } else t32 = $[86];
    const preloadWebItems = t32;
    let t33;
    if ($[87] !== nestedPopup) {
        t33 = (nestedMenuType)=>{
            if (nestedPopup === nestedMenuType) setNestedPopup(undefined);
            else setNestedPopup(nestedMenuType);
        };
        $[87] = nestedPopup;
        $[88] = t33;
    } else t33 = $[88];
    const handleNestedMenuItemClick = t33;
    let t34;
    if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = ()=>{
            setNestedPopup(undefined);
        };
        $[89] = t34;
    } else t34 = $[89];
    const handleNestedMenuItemClose = t34;
    let t35;
    if ($[90] !== moreActions || $[91] !== nestedPopup) {
        t35 = ()=>{
            if (!moreActions?.items?.length) return;
            return moreActions.items.map((itemGroup, idx)=>itemGroup.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                    key: idx,
                    hasSeparator: true
                }, itemGroup.map((item)=>{
                    if ($511857b10ace36ca$var$isItemGroup(item)) {
                        const { id: groupId, items: groupItems, text: groupText } = item;
                        const handleOnOpenChange = (t36)=>{
                            const { isOpen: isOpen_0 } = t36;
                            if (isOpen_0) setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).MoreSupport);
                            else setNestedPopup(undefined);
                        };
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
                            key: groupId,
                            placement: "left-start",
                            trigger: (t37)=>{
                                const { triggerRef: triggerRef, ...triggerProps } = t37;
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                                    ...triggerProps,
                                    ref: triggerRef,
                                    testId: `${groupId}-button`,
                                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                        color: "var(--ds-icon-subtle, #505258)",
                                        label: "",
                                        size: "small"
                                    })
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, groupText));
                            },
                            isOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).MoreSupport,
                            onOpenChange: handleOnOpenChange,
                            shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-truedisco")
                        }, groupItems.map($511857b10ace36ca$var$_temp2));
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item,
                        key: item.id
                    });
                })));
        };
        $[90] = moreActions;
        $[91] = nestedPopup;
        $[92] = t35;
    } else t35 = $[92];
    const renderMoreActions = t35;
    let t36;
    if ($[93] !== contentId || $[94] !== contentType || $[95] !== experienceTracker || $[96] !== setIsMenuOpen) {
        t36 = (dialogs)=>{
            experienceTracker.start({
                name: (0, $irVI7.DELETE_PAGE_EXPERIENCE)
            });
            dialogs.showModal((0, $6ykQV.DeleteNestedPagesActionLoader), {
                contentId: contentId,
                source: "contentTypesHeader",
                shouldRedirectOnSuccess: true,
                contentType: contentType
            });
            setIsMenuOpen(false);
        };
        $[93] = contentId;
        $[94] = contentType;
        $[95] = experienceTracker;
        $[96] = setIsMenuOpen;
        $[97] = t36;
    } else t36 = $[97];
    const onDeleteClick = t36;
    let t37;
    if ($[98] !== contentId || $[99] !== spaceKey) {
        t37 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: ()=>setIsMoveContentModalOpen(false),
                onCloseComplete: ()=>setIsMoveContentModalOpen(false),
                referrer: "content-types-header"
            });
        $[98] = contentId;
        $[99] = spaceKey;
        $[100] = t37;
    } else t37 = $[100];
    const renderMoveContentModal = t37;
    let t38;
    if ($[101] !== contentId || $[102] !== contentMode || $[103] !== experienceTracker || $[104] !== spaceKey) {
        t38 = (dialogs_0)=>{
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs_0.showDialog((0, $bHd1w.MovePageDialog), {
                spaceKey: spaceKey,
                contentId: contentId,
                referrer: "view-page-actions-menu",
                isMovingDraftVersion: contentMode === "edit",
                isUnpublishedDraft: contentMode === "draft"
            });
        };
        $[101] = contentId;
        $[102] = contentMode;
        $[103] = experienceTracker;
        $[104] = spaceKey;
        $[105] = t38;
    } else t38 = $[105];
    const renderMovePageModal = t38;
    let t39;
    if ($[106] !== contentId || $[107] !== contentMode || $[108] !== spaceKey) {
        t39 = (dialogs_1)=>{
            dialogs_1.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: contentMode === "edit",
                isUnpublishedDraft: contentMode === "draft"
            });
        };
        $[106] = contentId;
        $[107] = contentMode;
        $[108] = spaceKey;
        $[109] = t39;
    } else t39 = $[109];
    const renderMoveBlogModal = t39;
    let t40;
    if ($[110] !== contentId || $[111] !== spaceKey) {
        t40 = ()=>(0, $6mKj3.expVal)("confluence_modernized_copy_dialog", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3J7TU.CopyPageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: async ()=>setIsCopyContentModalOpen(false)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FwhF.CopyPageTreeDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: async ()=>setIsCopyContentModalOpen(false)
            });
        $[110] = contentId;
        $[111] = spaceKey;
        $[112] = t40;
    } else t40 = $[112];
    const renderCopyContentModal = t40;
    let t41;
    if ($[113] !== contentId || $[114] !== experienceTracker || $[115] !== isFreeUser || $[116] !== setIsMenuOpen) {
        t41 = (dialogs_2)=>{
            if (isFreeUser) dialogs_2.showDialog((0, $k22lL.ArchiveUpsellDialog));
            else {
                experienceTracker.start({
                    name: (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE)
                });
                dialogs_2.showDialog((0, $2WH1B.ArchivePagesLoader), {
                    contentId: contentId,
                    source: "contentTypesHeader"
                });
            }
            setIsMenuOpen(false);
        };
        $[113] = contentId;
        $[114] = experienceTracker;
        $[115] = isFreeUser;
        $[116] = setIsMenuOpen;
        $[117] = t41;
    } else t41 = $[117];
    const onArchiveClick = t41;
    let t42;
    if ($[118] !== contentId || $[119] !== contentType || $[120] !== createAnalyticsEvent || $[121] !== setShowVersionHistorySpotlight || $[122] !== showSidePanel || $[123] !== showVersionHistorySpotlight || $[124] !== trackExperience) {
        t42 = ()=>{
            setShowVersionHistorySpotlight?.(false);
            trackExperience({
                contentType: contentType,
                experience: "sidePanel",
                task: "start"
            });
            showSidePanel();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "versionHistory",
                    source: "moreActionsMenu",
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        spotlighted: showVersionHistorySpotlight ? 1 : 0,
                        isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                    }
                }
            }).fire();
        };
        $[118] = contentId;
        $[119] = contentType;
        $[120] = createAnalyticsEvent;
        $[121] = setShowVersionHistorySpotlight;
        $[122] = showSidePanel;
        $[123] = showVersionHistorySpotlight;
        $[124] = trackExperience;
        $[125] = t42;
    } else t42 = $[125];
    const handleViewVersionHistory = t42;
    let t43;
    if ($[126] !== createAnalyticsEvent || $[127] !== saveDraft || $[128] !== showRevertDialog) {
        t43 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowRevert",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.({
                isOnClose: false
            });
            showRevertDialog?.();
        };
        $[126] = createAnalyticsEvent;
        $[127] = saveDraft;
        $[128] = showRevertDialog;
        $[129] = t43;
    } else t43 = $[129];
    const onRevertClick = t43;
    let t44;
    if ($[130] !== contentId || $[131] !== contentStatus || $[132] !== contentType || $[133] !== createAnalyticsEvent || $[134] !== push || $[135] !== saveDraft || $[136] !== spaceKey) {
        t44 = (dialogs_3)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowRevertToLegacyEditor",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.({
                isOnClose: false
            });
            dialogs_3.showDialog((0, $b66o6.RevertEditorDialog), {
                contentId: contentId,
                onPageRevert: ()=>(0, $d8oE8.onClickPageRevert)(push, contentType, spaceKey, contentId, (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true) ? contentStatus : undefined)
            });
        };
        $[130] = contentId;
        $[131] = contentStatus;
        $[132] = contentType;
        $[133] = createAnalyticsEvent;
        $[134] = push;
        $[135] = saveDraft;
        $[136] = spaceKey;
        $[137] = t44;
    } else t44 = $[137];
    const onRevertToLegacyEditorClick = t44;
    const onFeedbackClick = $511857b10ace36ca$var$_temp3;
    let t45;
    if ($[138] !== commentService || $[139] !== contentId) {
        t45 = (dialogs_5, context)=>{
            dialogs_5.showDialog((0, $6eFi0.ResolvedInlineCommentsDialogLoader), {
                contentId: contentId,
                context: context,
                onReopenResolvedCommentHandler: (commentIds)=>{
                    commentService.onReopenResolvedComment(commentIds);
                }
            });
        };
        $[138] = commentService;
        $[139] = contentId;
        $[140] = t45;
    } else t45 = $[140];
    const makeInlineCommentsDialogOpener = t45;
    let t46;
    if ($[141] !== contentId || $[142] !== createAnalyticsEvent || $[143] !== experienceTracker || $[144] !== spaceId || $[145] !== theme) {
        t46 = (enterPresenterMode)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "present",
                        source: "moreActions",
                        objectId: contentId,
                        containerId: spaceId,
                        attributes: {
                            currentThemePreference: theme,
                            OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
                        }
                    }
                }).fire();
                experienceTracker.start({
                    name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
                });
                enterPresenterMode();
            };
        $[141] = contentId;
        $[142] = createAnalyticsEvent;
        $[143] = experienceTracker;
        $[144] = spaceId;
        $[145] = theme;
        $[146] = t46;
    } else t46 = $[146];
    const makePresenterModeOpener = t46;
    let t47;
    if ($[147] !== contentId || $[148] !== contentType || $[149] !== createAnalyticsEvent) {
        t47 = (onPreviewClicked_0)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "previewPage",
                        source: "moreActions",
                        objectId: contentId,
                        objectType: contentType
                    }
                }).fire();
                onPreviewClicked_0(false);
            };
        $[147] = contentId;
        $[148] = contentType;
        $[149] = createAnalyticsEvent;
        $[150] = t47;
    } else t47 = $[150];
    const makePreviewContentHandler = t47;
    let t48;
    if ($[151] !== contentId) {
        t48 = (dialogs_6)=>()=>{
                dialogs_6.showModal((0, $1PC5x.LinkToThisPageDialog), {
                    contentId: contentId
                });
            };
        $[151] = contentId;
        $[152] = t48;
    } else t48 = $[152];
    const openLinkToThisPageDialog = t48;
    let t49;
    if ($[153] !== allowedFeatures.showWatchDialog || $[154] !== contentData?.title || $[155] !== contentId || $[156] !== contentMode || $[157] !== contentType || $[158] !== flags || $[159] !== handleNestedMenuItemClick || $[160] !== hasEditPermission || $[161] !== history || $[162] !== isArchived || $[163] !== isCompanyHub || $[164] !== isContentViewOnlyPermissions || $[165] !== isLoggedIn || $[166] !== isPresentRendered || $[167] !== makePresenterModeOpener || $[168] !== makePreviewContentHandler || $[169] !== nestedPopup || $[170] !== onPreviewClicked || $[171] !== setIsMenuOpen || $[172] !== shouldRenderStarContentMenuItem || $[173] !== shouldRenderStarSpaceMenuItem || $[174] !== spaceId || $[175] !== spaceKey || $[176] !== triggerAnalyticsEvent) {
        t49 = (t50)=>{
            const { webItemsMap: webItemsMap, customActionsMap: customActionsMap } = t50;
            const primaryActionsItems = [
                {
                    name: $511857b10ace36ca$export$35f02acdf766e275,
                    shouldRender: shouldRenderStarSpaceMenuItem,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPqqM.SpaceStarMenuItemWithQuery), {
                            spaceKey: spaceKey
                        })
                },
                {
                    name: $511857b10ace36ca$export$348fd9bd77c132d9,
                    shouldRender: shouldRenderStarContentMenuItem && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daed94f8e5673bda$export$ab53347da13f94fa), {
                            contentId: contentId,
                            contentTitle: contentData?.title || "",
                            contentMode: contentMode || ""
                        })
                },
                {
                    name: $511857b10ace36ca$export$e242b9905c10e726,
                    shouldRender: (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b864d3fa23503bf$export$f9409fd8f8b5a92d), {
                            isMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch,
                            contentId: contentId,
                            contentType: contentType,
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            setIsMenuOpen: setIsMenuOpen,
                            onMenuClose: handleNestedMenuItemClose,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch)
                        })
                },
                {
                    name: $511857b10ace36ca$export$6bb183703c5072f1,
                    shouldRender: isLoggedIn && !isArchived && isContentViewOnlyPermissions,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d3293071a1569ba$export$84d0de3613f64b9a), {
                            contentType: contentType,
                            contentId: contentId,
                            flags: flags,
                            triggerAnalyticsEvent: triggerAnalyticsEvent,
                            askToEditKey: $511857b10ace36ca$export$6bb183703c5072f1
                        })
                },
                {
                    name: $511857b10ace36ca$export$74317f458aa33c63,
                    shouldRender: (0, $ff966189b275be15$export$74e87e549c7a0f96)(contentType, contentMode) && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$74317f458aa33c63,
                            onClick: makePreviewContentHandler(onPreviewClicked),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9vvQJ))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$74317f458aa33c63,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW
                                ]
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.previewLabel))
                },
                {
                    name: $511857b10ace36ca$export$461acb5c5f9c7b12,
                    shouldRender: isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$461acb5c5f9c7b12,
                            onClick: ()=>history?.push((0, $1NBp8.COMPANY_HUB_SETTINGS).toUrl(), {
                                    from: (0, $1NBp8.COMPANY_HUB_EDIT).name
                                }),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.manageLabel))
                },
                {
                    name: $511857b10ace36ca$export$12b5e6890d8e049c,
                    shouldRender: !!customActionsMap[$511857b10ace36ca$export$12b5e6890d8e049c],
                    component: ()=>{
                        const item_0 = customActionsMap[$511857b10ace36ca$export$12b5e6890d8e049c];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_0,
                            key: item_0.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($avrhI))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$f9e89fba7e6b4574,
                    shouldRender: (0, $ff966189b275be15$export$4a2abd609e31ae47)(contentType) && !!customActionsMap[$511857b10ace36ca$export$f9e89fba7e6b4574],
                    component: ()=>{
                        const item_1 = customActionsMap[$511857b10ace36ca$export$f9e89fba7e6b4574];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_1,
                            key: item_1.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$240b6ef4a1c531f6,
                    shouldRender: isPresentRendered && !!webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).COMMENTS,
                            key: webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6].completeKey
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
                            key: `presenter-mode-menu-item-${webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6].completeKey}`
                        }, (enterPresenterMode_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                id: $511857b10ace36ca$export$240b6ef4a1c531f6,
                                key: $511857b10ace36ca$export$240b6ef4a1c531f6,
                                onClick: makePresenterModeOpener(enterPresenterMode_0),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3KUzn))), {
                                    label: ""
                                }),
                                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                                    shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT)
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.presentLabel))))
                },
                {
                    name: "viewEditToggle",
                    shouldShowSeparator: false,
                    shouldRender: Boolean(contentMode === "live" && hasEditPermission),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gDbO8.LivePagesModeChanger), {
                            contentId: contentId,
                            flags: flags,
                            analyticsSource: "livePagesEllipsisDropdown",
                            elemAfter: (0, $434c765ed6791bfa$export$d206439c03b979ee)
                        })
                }
            ];
            const actionsToRender = primaryActionsItems.filter($511857b10ace36ca$var$_temp4);
            return {
                key: "primary-actions",
                items: actionsToRender
            };
        };
        $[153] = allowedFeatures.showWatchDialog;
        $[154] = contentData?.title;
        $[155] = contentId;
        $[156] = contentMode;
        $[157] = contentType;
        $[158] = flags;
        $[159] = handleNestedMenuItemClick;
        $[160] = hasEditPermission;
        $[161] = history;
        $[162] = isArchived;
        $[163] = isCompanyHub;
        $[164] = isContentViewOnlyPermissions;
        $[165] = isLoggedIn;
        $[166] = isPresentRendered;
        $[167] = makePresenterModeOpener;
        $[168] = makePreviewContentHandler;
        $[169] = nestedPopup;
        $[170] = onPreviewClicked;
        $[171] = setIsMenuOpen;
        $[172] = shouldRenderStarContentMenuItem;
        $[173] = shouldRenderStarSpaceMenuItem;
        $[174] = spaceId;
        $[175] = spaceKey;
        $[176] = triggerAnalyticsEvent;
        $[177] = t49;
    } else t49 = $[177];
    const primaryActionData = t49;
    let t50;
    if ($[178] !== allowedFeatures.showArchive || $[179] !== allowedFeatures.showCopy || $[180] !== allowedFeatures.showMove || $[181] !== contentId || $[182] !== contentMode || $[183] !== contentType || $[184] !== createAnalyticsEvent || $[185] !== flags || $[186] !== handleNestedMenuItemClick || $[187] !== hasArchivePermission || $[188] !== intl || $[189] !== isCompanyHub || $[190] !== isContentCreationPanelOpen || $[191] !== isConvertToFolderHighlighted || $[192] !== isFreeUser || $[193] !== isLivePageViewOnlyPermissions || $[194] !== isRovoEnabled || $[195] !== isSpaceOverviewPage || $[196] !== nestedPopup || $[197] !== onArchiveClick || $[198] !== onClickOpenContentCreationPanel || $[199] !== onDeleteClick || $[200] !== publishPage || $[201] !== readOnly || $[202] !== renderMoveBlogModal || $[203] !== renderMovePageModal || $[204] !== setIsMenuOpen || $[205] !== spaceId || $[206] !== spaceKey) {
        t50 = (t51)=>{
            const { webItems: webItems, webItemsMap: webItemsMap_0, customActionsMap: customActionsMap_0 } = t51;
            const hasArchive = !isCompanyHub && (0, $ff966189b275be15$export$32820bf57e654cf8)(contentType, contentMode) && (hasArchivePermission || isFreeUser) && allowedFeatures.showArchive && !!webItemsMap_0[$511857b10ace36ca$export$d81a93c80838b765];
            const hasDelete = !!webItemsMap_0[$511857b10ace36ca$export$da4fec526a505196];
            const modifyActionsToRender = [
                {
                    name: $511857b10ace36ca$export$21b8b89e4603550f,
                    shouldRender: !!webItemsMap_0[$511857b10ace36ca$export$21b8b89e4603550f],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${$511857b10ace36ca$export$21b8b89e4603550f}`
                        }, (dialogs_7)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$21b8b89e4603550f,
                                onClick: ()=>{
                                    createAnalyticsEvent({
                                        type: "sendUIEvent",
                                        data: {
                                            action: "clicked",
                                            actionSubject: "button",
                                            actionSubjectId: "overflowRestore",
                                            source: "overflowMenu",
                                            attributes: {
                                                isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                                            }
                                        }
                                    }).fire();
                                    dialogs_7.showModal((0, $1Zthr.UnarchivePagesDialogLoader), {
                                        contentId: contentId,
                                        source: "contentTypesHeader"
                                    });
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eix0u))), {
                                    label: ""
                                })
                            }, webItemsMap_0[$511857b10ace36ca$export$21b8b89e4603550f].label))
                },
                {
                    name: $511857b10ace36ca$export$cc1f11fb5e07970e,
                    shouldRender: contentType === "whiteboard" && isRovoEnabled && (0, $9wGTI.fg)("aifc_create_enabled"),
                    component: ()=>(0, $9wGTI.fg)("whiteboard_to_live_doc_header_action_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eb923bf92acc93d7$export$43890b7edce69789), {
                            spaceKey: spaceKey,
                            contentId: contentId
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
                },
                {
                    name: $511857b10ace36ca$export$94db61d2b880af44,
                    shouldRender: allowedFeatures.showCopy && (0, $ff966189b275be15$export$a130e0ea03d42b0b)(contentType, contentMode) && (!!webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44] || !!customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e]),
                    component: ()=>{
                        if (customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$3131530af790ffe2), {
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase,
                            handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase),
                            copyDatabaseItem: webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44],
                            copyStructureItem: customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e],
                            setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                            contentMode: contentMode,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        });
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$36ee254e582a74c2), {
                            setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            item: webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44]
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$bcce08436c9de127,
                    shouldRender: !isLivePageViewOnlyPermissions && allowedFeatures.showMove && !isCompanyHub && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$bcce08436c9de127],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${$511857b10ace36ca$export$bcce08436c9de127}`
                        }, (dialogs_8)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$bcce08436c9de127,
                                onClick: ()=>renderMovePageModal(dialogs_8),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                    label: ""
                                })
                            }, webItemsMap_0[$511857b10ace36ca$export$bcce08436c9de127].label))
                },
                {
                    name: $511857b10ace36ca$export$c7733ea6d8e45875,
                    shouldRender: allowedFeatures.showMove && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$c7733ea6d8e45875],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${$511857b10ace36ca$export$c7733ea6d8e45875}`
                        }, (dialogs_9)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$c7733ea6d8e45875,
                                onClick: ()=>renderMoveBlogModal(dialogs_9),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                    label: ""
                                })
                            }, webItemsMap_0[$511857b10ace36ca$export$c7733ea6d8e45875].label))
                },
                {
                    name: $511857b10ace36ca$export$b1a4c392275ea35a,
                    shouldRender: (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isContentCreationPanelOpen && !isLivePageViewOnlyPermissions && (contentType !== "whiteboard" || !!customActionsMap_0[$511857b10ace36ca$export$d4cf3906d3082596] || !!customActionsMap_0[$511857b10ace36ca$export$cce5e117e5e43bc]),
                    component: ()=>{
                        if (customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea]) {
                            customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea].text = intl.formatMessage($511857b10ace36ca$var$i18n.templatesImportLabel);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                item: customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea],
                                key: $511857b10ace36ca$export$be7385413e15c3ea,
                                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                    label: ""
                                })
                            });
                        } else {
                            if (customActionsMap_0[$511857b10ace36ca$export$d4cf3906d3082596] || customActionsMap_0[$511857b10ace36ca$export$cce5e117e5e43bc]) {
                                const nestedItems = [];
                                const createNestedItem = (actionKey)=>{
                                    const action = customActionsMap_0[actionKey];
                                    if (action) nestedItems.push({
                                        ...action,
                                        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                                item: action,
                                                key: action.id
                                            })
                                    });
                                };
                                createNestedItem($511857b10ace36ca$export$d4cf3906d3082596);
                                createNestedItem($511857b10ace36ca$export$cce5e117e5e43bc);
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesImportLabel),
                                    isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport,
                                    onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport),
                                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                        label: ""
                                    }),
                                    items: nestedItems,
                                    onMenuClose: handleNestedMenuItemClose
                                });
                            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$b1a4c392275ea35a,
                                onClick: onClickOpenContentCreationPanel,
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesImportLabel));
                        }
                    }
                },
                {
                    name: $511857b10ace36ca$export$10f4bed2ae52719b,
                    shouldRender: (0, $ff966189b275be15$export$d790dfbcfcf44b71)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                            item: webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b],
                            contentMode: contentMode,
                            flags: flags,
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            contentId: contentId,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                {
                    name: $511857b10ace36ca$export$8ba85686c8897eca,
                    shouldRender: (0, $ff966189b275be15$export$37d144a1b557c80d)(contentType, contentMode) && !isLivePageViewOnlyPermissions,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                            name: (0, $47zp4.CONVERT_TO_PAGE_SPOTLIGHT_TARGET)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$8ba85686c8897eca,
                            onClick: publishPage,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.convertToPage)))
                },
                {
                    name: $511857b10ace36ca$export$3192aea0628d957a,
                    shouldRender: (0, $ff966189b275be15$export$78b7a39935e0bb86)(contentType, contentMode, isSpaceOverviewPage) && (!!webItemsMap_0[$511857b10ace36ca$export$5497d83bbd1b1232] || !!webItemsMap_0[$511857b10ace36ca$export$7767afe5b675f4b1] || !!webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b]),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$1a264aaf74bdd787), {
                            webItemsMap: webItemsMap_0,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            spaceKey: spaceKey,
                            contentId: contentId,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            flags: flags,
                            spaceId: spaceId,
                            contentMode: contentMode,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            isConvertToFolderHighlighted: isConvertToFolderHighlighted
                        })
                },
                {
                    name: $511857b10ace36ca$export$ab4fe2a2881747b5,
                    shouldRender: (0, $ff966189b275be15$export$58a134bd2769b459)(contentType, contentMode) && (!!webItemsMap_0[$511857b10ace36ca$export$5da5719a925f973] || !!webItemsMap_0[$511857b10ace36ca$export$bbe81b5a8b0eaf4]),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b945ccaa4d42d330), {
                            webItemsMap: webItemsMap_0,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                {
                    name: $511857b10ace36ca$export$d588519b9727f1cc,
                    shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$d588519b9727f1cc],
                    component: ()=>{
                        const item_3 = customActionsMap_0[$511857b10ace36ca$export$d588519b9727f1cc];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_3,
                            key: item_3.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$f0ae5a9b5b44d373,
                    shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$f0ae5a9b5b44d373],
                    component: ()=>{
                        const item_4 = customActionsMap_0[$511857b10ace36ca$export$f0ae5a9b5b44d373];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_4,
                            key: item_4.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$e07ca208ff99048e,
                    shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$e07ca208ff99048e],
                    component: ()=>{
                        const item_5 = customActionsMap_0[$511857b10ace36ca$export$e07ca208ff99048e];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_5,
                            key: item_5.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$d81a93c80838b765,
                    shouldRender: hasArchive && !hasDelete,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f4be76d677f42fda), {
                            onArchiveClick: onArchiveClick
                        })
                },
                {
                    name: $511857b10ace36ca$export$da4fec526a505196,
                    shouldRender: hasDelete && !hasArchive,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$5ac124715785374c), {
                            contentMode: contentMode,
                            onDeleteClick: onDeleteClick,
                            createAnalyticsEvent: createAnalyticsEvent
                        })
                },
                {
                    name: $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE,
                    shouldRender: hasArchive && hasDelete,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$a05f0dd30396f811), {
                            webItems: webItems,
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive,
                            handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive),
                            onArchiveClick: onArchiveClick,
                            onDeleteClick: onDeleteClick,
                            contentMode: contentMode,
                            createAnalyticsEvent: createAnalyticsEvent,
                            handleNestedMenuItemClose: handleNestedMenuItemClose
                        })
                }
            ];
            const actionsToRender_0 = modifyActionsToRender.filter($511857b10ace36ca$var$_temp5);
            return {
                key: "modify-actions",
                items: actionsToRender_0
            };
        };
        $[178] = allowedFeatures.showArchive;
        $[179] = allowedFeatures.showCopy;
        $[180] = allowedFeatures.showMove;
        $[181] = contentId;
        $[182] = contentMode;
        $[183] = contentType;
        $[184] = createAnalyticsEvent;
        $[185] = flags;
        $[186] = handleNestedMenuItemClick;
        $[187] = hasArchivePermission;
        $[188] = intl;
        $[189] = isCompanyHub;
        $[190] = isContentCreationPanelOpen;
        $[191] = isConvertToFolderHighlighted;
        $[192] = isFreeUser;
        $[193] = isLivePageViewOnlyPermissions;
        $[194] = isRovoEnabled;
        $[195] = isSpaceOverviewPage;
        $[196] = nestedPopup;
        $[197] = onArchiveClick;
        $[198] = onClickOpenContentCreationPanel;
        $[199] = onDeleteClick;
        $[200] = publishPage;
        $[201] = readOnly;
        $[202] = renderMoveBlogModal;
        $[203] = renderMovePageModal;
        $[204] = setIsMenuOpen;
        $[205] = spaceId;
        $[206] = spaceKey;
        $[207] = t50;
    } else t50 = $[207];
    const modifyActionData = t50;
    let t51;
    if ($[208] !== contentMode) {
        t51 = (customActionsMap_1)=>[
                {
                    name: $511857b10ace36ca$export$6563b47d35bee4f1,
                    shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$6563b47d35bee4f1] && contentMode !== "archived",
                    component: ()=>{
                        const item_7 = customActionsMap_1[$511857b10ace36ca$export$6563b47d35bee4f1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_7,
                            key: item_7.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$fe723f15ba37849b,
                    shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$fe723f15ba37849b] && contentMode !== "archived",
                    component: ()=>{
                        const item_8 = customActionsMap_1[$511857b10ace36ca$export$fe723f15ba37849b];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_8,
                            key: item_8.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$d7bae9f2073f40be,
                    shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$d7bae9f2073f40be],
                    component: ()=>{
                        const item_9 = customActionsMap_1[$511857b10ace36ca$export$d7bae9f2073f40be];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_9,
                            key: item_9.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                label: ""
                            })
                        });
                    }
                }
            ];
        $[208] = contentMode;
        $[209] = t51;
    } else t51 = $[209];
    const getDatabaseActionItems = t51;
    let t52;
    if ($[210] !== allowedFeatures.showClassificationMenuAction || $[211] !== contentData?.title || $[212] !== contentId || $[213] !== contentMode || $[214] !== contentType || $[215] !== createAnalyticsEvent || $[216] !== experienceTracker || $[217] !== getDatabaseActionItems || $[218] !== handleNestedMenuItemClick || $[219] !== handleViewVersionHistory || $[220] !== intl || $[221] !== isAllowed || $[222] !== isCommentsEnabled || $[223] !== isCompanyHub || $[224] !== isExternalCollaborator || $[225] !== isLivePage || $[226] !== isLivePageViewOnlyPermissions || $[227] !== isLoggedIn || $[228] !== isMenuOpen || $[229] !== isPageOrBlogAutoConverted || $[230] !== isPremiumUser || $[231] !== isSpaceOverviewPage || $[232] !== isVersionHistoryEnabled || $[233] !== makeInlineCommentsDialogOpener || $[234] !== nestedPopup || $[235] !== onRevertClick || $[236] !== onRevertToLegacyEditorClick || $[237] !== saveDraft || $[238] !== setIsMenuOpen || $[239] !== showVersionHistorySpotlight || $[240] !== spaceKey) {
        t52 = (t53)=>{
            const { webItemsMap: webItemsMap_1, customActionsMap: customActionsMap_2, webItems: webItems_0 } = t53;
            const databaseSecondaryActionItems = getDatabaseActionItems(customActionsMap_2);
            const secondaryActionItems = [
                {
                    name: (0, $iQb1R.Buttons).VIEW_CHANGES,
                    shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$caca47bf68c8998)(contentType, contentMode) && isAllowed((0, $iQb1R.Buttons).VIEW_CHANGES),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: (0, $iQb1R.Buttons).VIEW_CHANGES
                        }, (dialogs_10)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f28b24dc0422311f), {
                                contentId: contentId,
                                dialogs: dialogs_10,
                                saveDraft: saveDraft,
                                createAnalyticsEvent: createAnalyticsEvent
                            }))
                },
                {
                    name: $511857b10ace36ca$export$c9981a2480d638b0,
                    shouldRender: (0, $ff966189b275be15$export$d0c33a26470e0efe)(contentType, contentMode),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$c9981a2480d638b0,
                            onClick: onRevertClick,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.revertLabel))
                },
                {
                    name: $511857b10ace36ca$export$a751f1adb88d1383,
                    shouldRender: isCommentsEnabled && !!webItemsMap_1[$511857b10ace36ca$export$a751f1adb88d1383],
                    component: ()=>{
                        const item_10 = webItemsMap_1[$511857b10ace36ca$export$a751f1adb88d1383];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${item_10.id}`
                        }, (dialogs_11)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: item_10.id,
                                onClick: ()=>{
                                    if (contentType === "whiteboard" || contentType === "database") makeInlineCommentsDialogOpener(dialogs_11, contentType);
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_10.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                                contentId: contentId
                            }))));
                    }
                },
                {
                    name: $511857b10ace36ca$export$a6381225def83c4b,
                    shouldRender: !isExternalCollaborator && !!webItemsMap_1[$511857b10ace36ca$export$a6381225def83c4b],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogMenuPropsProvider), {
                            contentId: contentId
                        }, $511857b10ace36ca$var$_temp6)
                },
                {
                    name: $511857b10ace36ca$export$e14cf657321c833b,
                    shouldRender: isVersionHistoryEnabled && !!webItemsMap_1[$511857b10ace36ca$export$e14cf657321c833b],
                    component: ()=>{
                        const item_11 = webItemsMap_1[$511857b10ace36ca$export$e14cf657321c833b];
                        if (showVersionHistorySpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $330cc2928c11abea$export$cf692ceb431cd214), {
                            key: item_11.id,
                            contentType: contentType,
                            source: "moreActionsMenu"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_11.id,
                            onClick: handleViewVersionHistory,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.versionHistoryLabel)));
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_11.id,
                            onClick: handleViewVersionHistory,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.versionHistoryLabel));
                    }
                },
                {
                    name: $511857b10ace36ca$export$fc2e34cd983af5d6,
                    shouldRender: (0, $ff966189b275be15$export$458bbd6d88041c9d)(contentType, contentMode) && !!webItemsMap_1[$511857b10ace36ca$export$fc2e34cd983af5d6],
                    component: ()=>{
                        const item_12 = webItemsMap_1[$511857b10ace36ca$export$fc2e34cd983af5d6];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc), {
                            itemId: item_12?.id,
                            itemUrl: item_12?.url,
                            label: intl.formatMessage($511857b10ace36ca$var$i18n.versionHistoryLabel),
                            isLivePage: isLivePage,
                            contentType: contentType
                        });
                    }
                },
                ...(0, $9wGTI.fg)("databases-frontend-content-wrapper") ? [] : databaseSecondaryActionItems,
                {
                    name: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                    shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$11233ac17765daec)(contentType) && !!webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                            key: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                            item: webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                            nestedPopup: nestedPopup,
                            setNestedPopup: setNestedPopup,
                            contentId: contentId,
                            setIsMenuOpen: setIsMenuOpen
                        })
                },
                {
                    name: $511857b10ace36ca$export$244b90a342b60d9f,
                    shouldRender: !isLivePageViewOnlyPermissions && !isCompanyHub && (0, $ff966189b275be15$export$5e9136e7e220ab40)(contentType) && allowedFeatures.showClassificationMenuAction,
                    component: $511857b10ace36ca$var$_temp7
                },
                {
                    name: $511857b10ace36ca$export$fe0a3b90b0b6010b,
                    shouldRender: isPremiumUser && isLoggedIn && (0, $ff966189b275be15$export$bb21210c1c36f22a)(contentType, contentMode, isSpaceOverviewPage),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$7e059d95fddc01f4), {
                            experienceTracker: experienceTracker,
                            contentId: contentId,
                            spaceKey: spaceKey,
                            pageTitle: contentData?.title || ""
                        })
                },
                {
                    name: $511857b10ace36ca$export$fe2b6e9bf8b31ecc,
                    shouldRender: (0, $ff966189b275be15$export$493ddb7a4c710fed)(contentType, contentMode, isAllowed((0, $iQb1R.Buttons).DELETE_DRAFT), (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true)) && isPageOrBlogAutoConverted && (0, $9wGTI.fg)("confluence_frontend_reintroduce_revert_editor_item"),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
                            key: "revert-to-legacy-editor-menu-item"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ]
                        }, (dialogs_12)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$c9981a2480d638b0,
                                onClick: ()=>onRevertToLegacyEditorClick(dialogs_12),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.revertEditor))))
                },
                {
                    name: $511857b10ace36ca$export$52e1dc7e5d9b8b02,
                    shouldRender: (0, $ff966189b275be15$export$49f8860e43af4419)(contentType, contentMode),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f404e2d5b48ab522), {
                            webItemsMap: webItemsMap_1,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                (0, $434c765ed6791bfa$export$f26eff3587fe7632)({
                    isAppsRendered: (0, $ff966189b275be15$export$8623af461a2f6a54)(contentType, contentMode),
                    spaceKey: spaceKey,
                    contentId: contentId,
                    isMenuOpen: isMenuOpen,
                    handleNestedMenuItemClick: handleNestedMenuItemClick,
                    nestedPopup: nestedPopup,
                    items: webItems_0,
                    createAnalyticsEvent: createAnalyticsEvent,
                    handleNestedMenuItemClose: handleNestedMenuItemClose,
                    closeParentMenu: ()=>setIsMenuOpen(false)
                }),
                {
                    name: $511857b10ace36ca$export$23eaedbb3a44a3b5,
                    shouldRender: !!customActionsMap_2[$511857b10ace36ca$export$23eaedbb3a44a3b5],
                    component: ()=>{
                        const item_13 = customActionsMap_2[$511857b10ace36ca$export$23eaedbb3a44a3b5];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_13,
                            key: item_13.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                                label: ""
                            })
                        });
                    }
                }
            ];
            const actionsToRender_1 = secondaryActionItems.filter($511857b10ace36ca$var$_temp8);
            return {
                key: "secondary-actions",
                items: actionsToRender_1
            };
        };
        $[210] = allowedFeatures.showClassificationMenuAction;
        $[211] = contentData?.title;
        $[212] = contentId;
        $[213] = contentMode;
        $[214] = contentType;
        $[215] = createAnalyticsEvent;
        $[216] = experienceTracker;
        $[217] = getDatabaseActionItems;
        $[218] = handleNestedMenuItemClick;
        $[219] = handleViewVersionHistory;
        $[220] = intl;
        $[221] = isAllowed;
        $[222] = isCommentsEnabled;
        $[223] = isCompanyHub;
        $[224] = isExternalCollaborator;
        $[225] = isLivePage;
        $[226] = isLivePageViewOnlyPermissions;
        $[227] = isLoggedIn;
        $[228] = isMenuOpen;
        $[229] = isPageOrBlogAutoConverted;
        $[230] = isPremiumUser;
        $[231] = isSpaceOverviewPage;
        $[232] = isVersionHistoryEnabled;
        $[233] = makeInlineCommentsDialogOpener;
        $[234] = nestedPopup;
        $[235] = onRevertClick;
        $[236] = onRevertToLegacyEditorClick;
        $[237] = saveDraft;
        $[238] = setIsMenuOpen;
        $[239] = showVersionHistorySpotlight;
        $[240] = spaceKey;
        $[241] = t52;
    } else t52 = $[241];
    const secondaryActionData = t52;
    let t53;
    if ($[242] !== getDatabaseActionItems) {
        t53 = (t54)=>{
            const { customActionsMap: customActionsMap_3 } = t54;
            const databaseActionItems = getDatabaseActionItems(customActionsMap_3);
            const actionsToRender_2 = databaseActionItems.filter($511857b10ace36ca$var$_temp9);
            return {
                key: "database-actions",
                items: actionsToRender_2
            };
        };
        $[242] = getDatabaseActionItems;
        $[243] = t53;
    } else t53 = $[243];
    const databaseActionData = t53;
    let t54;
    if ($[244] !== contentMode || $[245] !== contentType || $[246] !== editorActivateFindReplace || $[247] !== editorCanRedo || $[248] !== editorCanUndo || $[249] !== editorRedo || $[250] !== editorUndo || $[251] !== hasEditPermission || $[252] !== livePageMode) {
        t54 = ()=>{
            if (!(0, $ff966189b275be15$export$71ad62dbe8638043)(contentType, contentMode, hasEditPermission, livePageMode)) return {
                key: "editor-actions",
                items: []
            };
            const editorActionItems = [
                {
                    name: $511857b10ace36ca$export$43db96fb923dc5c7,
                    shouldRender: !!editorUndo && !(0, $9wGTI.fg)("platform_editor_ai_aifc_streaming"),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$43db96fb923dc5c7,
                            isDisabled: !editorCanUndo,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$43db96fb923dc5c7,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).UNDO
                                ]
                            }),
                            onClick: async ()=>{
                                editorUndo?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorUndoLabel))
                },
                {
                    name: $511857b10ace36ca$export$4e316098da1efb3e,
                    shouldRender: !!editorRedo && !(0, $9wGTI.fg)("platform_editor_ai_aifc_streaming"),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$4e316098da1efb3e,
                            isDisabled: !editorCanRedo,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$4e316098da1efb3e,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).REDO
                                ]
                            }),
                            onClick: async ()=>{
                                editorRedo?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorRedoLabel))
                },
                {
                    name: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                    shouldRender: !!editorActivateFindReplace,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).FIND_REPLACE
                                ]
                            }),
                            onClick: async ()=>{
                                editorActivateFindReplace?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorFindReplaceLabel))
                }
            ];
            const actionsToRender_3 = editorActionItems.filter($511857b10ace36ca$var$_temp0);
            return {
                key: "editor-actions",
                items: actionsToRender_3
            };
        };
        $[244] = contentMode;
        $[245] = contentType;
        $[246] = editorActivateFindReplace;
        $[247] = editorCanRedo;
        $[248] = editorCanUndo;
        $[249] = editorRedo;
        $[250] = editorUndo;
        $[251] = hasEditPermission;
        $[252] = livePageMode;
        $[253] = t54;
    } else t54 = $[253];
    const editorActionData = t54;
    let t55;
    if ($[254] !== contentType || $[255] !== handleNestedMenuItemClick || $[256] !== intl || $[257] !== isCompanyHub || $[258] !== nestedPopup || $[259] !== openCompanyHubFeedbackCollector) {
        t55 = (t56)=>{
            const { webItemsMap: webItemsMap_2, customActionsMap: customActionsMap_4, actions: actions } = t56;
            const additionalActionItems = [
                {
                    name: $511857b10ace36ca$export$84c7eab054d974db,
                    shouldRender: (0, $ff966189b275be15$export$46e46e0c15d57a1)(contentType) && !!webItemsMap_2[$511857b10ace36ca$export$84c7eab054d974db],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ]
                        }, (dialogs_13)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                                key: $511857b10ace36ca$export$84c7eab054d974db,
                                onClick: ()=>{
                                    onFeedbackClick(dialogs_13, contentType);
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                                    label: ""
                                })
                            }, webItemsMap_2[$511857b10ace36ca$export$84c7eab054d974db].label))
                },
                {
                    name: $511857b10ace36ca$export$5f2e846fff4ab830,
                    shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[$511857b10ace36ca$export$5f2e846fff4ab830],
                    component: ()=>{
                        const items = actions.flat().map($511857b10ace36ca$var$_temp1);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.help),
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help),
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                label: ""
                            }),
                            items: items,
                            onMenuClose: handleNestedMenuItemClose
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$95f3debc4a615fda,
                    shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda],
                    component: ()=>{
                        customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda].text = intl.formatMessage($511857b10ace36ca$var$i18n.help);
                        const item_17 = customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_17,
                            key: item_17.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$54ed9c94f2cfe2b6,
                    shouldRender: !!customActionsMap_4[$511857b10ace36ca$export$54ed9c94f2cfe2b6],
                    component: ()=>{
                        const item_18 = customActionsMap_4[$511857b10ace36ca$export$54ed9c94f2cfe2b6];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_18,
                            key: item_18.id
                        });
                    }
                },
                {
                    name: $511857b10ace36ca$export$654801d4f89a934,
                    shouldRender: isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$654801d4f89a934,
                            onClick: openCompanyHubFeedbackCollector,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.companyHubFeedback))
                }
            ];
            const actionsToRender_4 = additionalActionItems.filter($511857b10ace36ca$var$_temp10);
            return {
                key: "additional-items",
                items: actionsToRender_4
            };
        };
        $[254] = contentType;
        $[255] = handleNestedMenuItemClick;
        $[256] = intl;
        $[257] = isCompanyHub;
        $[258] = nestedPopup;
        $[259] = openCompanyHubFeedbackCollector;
        $[260] = t55;
    } else t55 = $[260];
    const feedbackActionData = t55;
    let t56;
    if ($[261] !== contentId || $[262] !== hasArchivePermission || $[263] !== onArchiveClick || $[264] !== onDeleteClick || $[265] !== shouldShowArchive || $[266] !== shouldShowCopy || $[267] !== shouldShowMove) {
        t56 = (webItems_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, webItems_1.map((item_20)=>{
                if ($511857b10ace36ca$var$isWebItem(item_20)) {
                    if (shouldShowCopy && item_20?.id === $511857b10ace36ca$export$94db61d2b880af44) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_20.id,
                        onClick: ()=>setIsCopyContentModalOpen(true)
                    }, item_20.label);
                    if (shouldShowMove && item_20?.id === $511857b10ace36ca$export$bcce08436c9de127) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_20.id,
                        onClick: ()=>setIsMoveContentModalOpen(true)
                    }, item_20.label);
                    if (item_20?.id === $511857b10ace36ca$export$21b8b89e4603550f) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_20.id}`
                    }, (dialogs_14)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>{
                                dialogs_14.showDialog((0, $1Zthr.UnarchivePagesDialogLoader), {
                                    contentId: contentId,
                                    source: "contentTypesHeader"
                                });
                            }
                        }, item_20.label));
                    if (item_20?.id === $511857b10ace36ca$export$da4fec526a505196) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_20.id}`
                    }, (dialogs_15)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>{
                                onDeleteClick(dialogs_15);
                            }
                        }, item_20.label));
                    if (item_20?.id === $511857b10ace36ca$export$d81a93c80838b765 && hasArchivePermission && shouldShowArchive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_20.id}`
                    }, (dialogs_16)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_20.id,
                            onClick: ()=>{
                                onArchiveClick(dialogs_16);
                            }
                        }, item_20.label));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.tooltip),
                    position: "left",
                    key: item_20.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                    isDisabled: true
                }, item_20.label));
                return null;
            }));
        $[261] = contentId;
        $[262] = hasArchivePermission;
        $[263] = onArchiveClick;
        $[264] = onDeleteClick;
        $[265] = shouldShowArchive;
        $[266] = shouldShowCopy;
        $[267] = shouldShowMove;
        $[268] = t56;
    } else t56 = $[268];
    const renderModifyContentActionsWebItems = t56;
    let t57;
    if ($[269] !== contentId || $[270] !== contentType || $[271] !== handleViewVersionHistory || $[272] !== isCommentsEnabled || $[273] !== isVersionHistoryEnabled || $[274] !== makeInlineCommentsDialogOpener || $[275] !== nestedPopup || $[276] !== setIsMenuOpen || $[277] !== shouldShowClassification || $[278] !== showVersionHistorySpotlight) {
        t57 = (webItems_2)=>{
            const webItemsToRender = webItems_2.map((item_21)=>{
                if ($511857b10ace36ca$var$isWebItem(item_21)) {
                    if (item_21?.id === $511857b10ace36ca$export$a751f1adb88d1383 && isCommentsEnabled && (contentType === "whiteboard" || contentType === "database")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_21.id}`
                    }, (dialogs_17)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_21.id,
                            onClick: ()=>makeInlineCommentsDialogOpener(dialogs_17, contentType)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_21.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                            contentId: contentId
                        }))));
                    if (item_21?.id === $511857b10ace36ca$export$e14cf657321c833b && isVersionHistoryEnabled) {
                        if (showVersionHistorySpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $330cc2928c11abea$export$cf692ceb431cd214), {
                            key: item_21.id,
                            contentType: contentType,
                            source: "moreActionsMenu"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_21.id,
                            onClick: handleViewVersionHistory
                        }, item_21.label));
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_21.id,
                            onClick: handleViewVersionHistory
                        }, item_21.label);
                    }
                    if (item_21?.id === (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                        key: `container-${item_21.id}`,
                        item: item_21,
                        nestedPopup: nestedPopup,
                        setNestedPopup: setNestedPopup,
                        contentId: contentId,
                        setIsMenuOpen: setIsMenuOpen
                    });
                }
                return null;
            }).filter(Boolean);
            const itemsToRender = shouldShowClassification ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), {
                    key: "classify-content"
                }),
                ...webItemsToRender
            ] : webItemsToRender;
            return itemsToRender.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                hasSeparator: true
            }, itemsToRender) : null;
        };
        $[269] = contentId;
        $[270] = contentType;
        $[271] = handleViewVersionHistory;
        $[272] = isCommentsEnabled;
        $[273] = isVersionHistoryEnabled;
        $[274] = makeInlineCommentsDialogOpener;
        $[275] = nestedPopup;
        $[276] = setIsMenuOpen;
        $[277] = shouldShowClassification;
        $[278] = showVersionHistorySpotlight;
        $[279] = t57;
    } else t57 = $[279];
    const renderPrimaryContentActionsWebItems = t57;
    let t58;
    if ($[280] !== contentType) {
        t58 = (webItems_3)=>webItems_3.map((item_22)=>{
                if ($511857b10ace36ca$var$isWebItem(item_22)) {
                    if (item_22?.id === $511857b10ace36ca$export$84c7eab054d974db && contentType && (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentType]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                        hasSeparator: true,
                        key: `container-${item_22.id}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ]
                    }, (dialogs_18)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_22.id,
                            onClick: ()=>{
                                onFeedbackClick(dialogs_18, contentType);
                            }
                        }, item_22.label)));
                }
                return null;
            });
        $[280] = contentType;
        $[281] = t58;
    } else t58 = $[281];
    const renderFeedbackWebItems = t58;
    let t59;
    if ($[282] !== contentType || $[283] !== databaseActionData || $[284] !== editorActionData || $[285] !== feedbackActionData || $[286] !== isCompanyHub || $[287] !== isHintVisible || $[288] !== modifyActionData || $[289] !== moreActions?.items || $[290] !== primaryActionData || $[291] !== secondaryActionData || $[292] !== setIsMenuOpen) {
        t59 = (t60)=>{
            const { webItems: webItems_4 } = t60;
            const webItemsMap_3 = $511857b10ace36ca$var$createActionsMap(webItems_4);
            const customActionsToRender = moreActions?.items?.flat() ?? [];
            const customActionsMap_5 = $511857b10ace36ca$var$createActionsMap(customActionsToRender);
            const [, , , feedbackCustomActions] = moreActions?.items ?? [];
            const actionGroupsToRender = [];
            const primaryActionGroup = primaryActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5
            });
            if (primaryActionGroup.items.length > 0) actionGroupsToRender.push(primaryActionGroup);
            const editorActionGroup = editorActionData();
            if (editorActionGroup.items.length > 0) actionGroupsToRender.push(editorActionGroup);
            if ((0, $9wGTI.fg)("databases-frontend-content-wrapper")) {
                const databaseActionGroup = databaseActionData({
                    customActionsMap: customActionsMap_5
                });
                if (databaseActionGroup.items.length > 0) actionGroupsToRender.push(databaseActionGroup);
            }
            const secondaryActionGroup = secondaryActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5,
                webItems: webItems_4
            });
            if (secondaryActionGroup.items.length > 0) actionGroupsToRender.push(secondaryActionGroup);
            const modifyActionGroup = modifyActionData({
                webItems: webItems_4,
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5
            });
            if (modifyActionGroup.items.length > 0) actionGroupsToRender.push(modifyActionGroup);
            const feedbackActionGroup = feedbackActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5,
                actions: feedbackCustomActions ?? []
            });
            if (feedbackActionGroup.items.length > 0) actionGroupsToRender.push(feedbackActionGroup);
            const shouldRenderMissingActionsHint = isHintVisible && !isCompanyHub && contentType !== "whiteboard" && contentType !== "database";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $511857b10ace36ca$var$dropdownMenuContentStyles
            }, actionGroupsToRender.map($511857b10ace36ca$var$_temp12), shouldRenderMissingActionsHint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4af5663ac404949d$export$b0ffdc20cd96b8d0), {
                setIsMenuOpen: setIsMenuOpen
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
            }));
        };
        $[282] = contentType;
        $[283] = databaseActionData;
        $[284] = editorActionData;
        $[285] = feedbackActionData;
        $[286] = isCompanyHub;
        $[287] = isHintVisible;
        $[288] = modifyActionData;
        $[289] = moreActions?.items;
        $[290] = primaryActionData;
        $[291] = secondaryActionData;
        $[292] = setIsMenuOpen;
        $[293] = t59;
    } else t59 = $[293];
    const renderActions = t59;
    let t60;
    if ($[294] === Symbol.for("react.memo_cache_sentinel")) {
        t60 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
        });
        $[294] = t60;
    } else t60 = $[294];
    let t61;
    if ($[295] !== error) {
        t61 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }));
        $[295] = error;
        $[296] = t61;
    } else t61 = $[296];
    let t62;
    if ($[297] !== isLivePage || $[298] !== isPresentRendered || $[299] !== isWebItemsQueryCalled || $[300] !== preloadWebItems) {
        t62 = isPresentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: !isLivePage ? (0, $gnkil.PRESENTATION_MODE_SHORTCUT) : undefined,
            accelerator: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT),
            listener: ()=>{
                if (!isWebItemsQueryCalled) preloadWebItems();
                setIsShortcutTriggered(true);
            }
        });
        $[297] = isLivePage;
        $[298] = isPresentRendered;
        $[299] = isWebItemsQueryCalled;
        $[300] = preloadWebItems;
        $[301] = t62;
    } else t62 = $[301];
    let t63;
    if ($[302] !== contentData?.title || $[303] !== contentId || $[304] !== contentMode || $[305] !== contentType || $[306] !== shouldRenderStarContentMenuItem) {
        t63 = shouldRenderStarContentMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85cfaddd6945fc1f$export$2846eba8e457bfb), {
            contentId: contentId,
            contentTitle: contentData?.title || "",
            contentMode: contentMode,
            contentType: contentType
        });
        $[302] = contentData?.title;
        $[303] = contentId;
        $[304] = contentMode;
        $[305] = contentType;
        $[306] = shouldRenderStarContentMenuItem;
        $[307] = t63;
    } else t63 = $[307];
    let t64;
    if ($[308] !== contentMode || $[309] !== shouldRenderStarSpaceMenuItem || $[310] !== spaceKey) {
        t64 = shouldRenderStarSpaceMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6d97f54b872b96e$export$385015a3c6790101), {
            spaceKey: spaceKey,
            contentMode: contentMode
        });
        $[308] = contentMode;
        $[309] = shouldRenderStarSpaceMenuItem;
        $[310] = spaceKey;
        $[311] = t64;
    } else t64 = $[311];
    let t65;
    if ($[312] !== contentId || $[313] !== contentMode || $[314] !== contentType || $[315] !== isMenuOpen || $[316] !== setIsMenuOpen) {
        t65 = (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c06b6cca0a728bb0$export$154e7cde95b8409b), {
            contentId: contentId,
            contentType: contentType,
            openWatchSettingsMenu: ()=>{
                if (!isMenuOpen) setIsMenuOpen(true);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
            }
        });
        $[312] = contentId;
        $[313] = contentMode;
        $[314] = contentType;
        $[315] = isMenuOpen;
        $[316] = setIsMenuOpen;
        $[317] = t65;
    } else t65 = $[317];
    let t66;
    if ($[318] === Symbol.for("react.memo_cache_sentinel")) {
        t66 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[318] = t66;
    } else t66 = $[318];
    let t67;
    if ($[319] !== contentId || $[320] !== contentMode || $[321] !== isMenuOpen || $[322] !== livePageMode || $[323] !== openLinkToThisPageDialog || $[324] !== spaceKey) {
        t67 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t66
        }, (dialogs_19)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                deprecatedAccelerator: contentMode === "view" || contentMode === "live" && livePageMode === "view" ? (0, $gnkil.LINK_TO_THIS_PAGE_SHORTCUT) : undefined,
                accelerator: (0, $gnkil.UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT),
                listener: openLinkToThisPageDialog(dialogs_19)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b742140c6b014561$export$fcc1c0135b5761c6), {
                spaceKey: spaceKey,
                contentId: contentId,
                onLoadComplete: $511857b10ace36ca$var$_temp13,
                isDropdownMenuOpen: isMenuOpen,
                dialogs: dialogs_19,
                lazyLoaderPlaceholderComponent: ""
            }, $511857b10ace36ca$var$_temp15)));
        $[319] = contentId;
        $[320] = contentMode;
        $[321] = isMenuOpen;
        $[322] = livePageMode;
        $[323] = openLinkToThisPageDialog;
        $[324] = spaceKey;
        $[325] = t67;
    } else t67 = $[325];
    let t68;
    if ($[326] !== activeSpotlight || $[327] !== contentId || $[328] !== handleOpenChange || $[329] !== isMenuOpen || $[330] !== isModernEmbeddedConfluence || $[331] !== loading || $[332] !== preloadWebItems || $[333] !== renderActions || $[334] !== renderFeedbackWebItems || $[335] !== renderModifyContentActionsWebItems || $[336] !== renderMoreActions || $[337] !== renderPrimaryContentActionsWebItems) {
        t68 = !isModernEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $511857b10ace36ca$var$dropdownMenuContainerStyles
            ],
            onMouseEnter: preloadWebItems
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            isOpen: isMenuOpen,
            onOpenChange: handleOpenChange,
            trigger: $511857b10ace36ca$var$_temp16,
            placement: "bottom-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            "data-testid": "web-actions-test",
            contentId: contentId,
            location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
            fetchPolicy: "cache-and-network",
            renderWhenLoading: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        }, (t69)=>{
            const { webItems: webItems_5 } = t69;
            if ((0, $9wGTI.fg)("confluence_frontend_content_wrapper")) {
                if (loading || !webItems_5 || webItems_5.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownMenuContentSkeleton, null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                    name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).MORE_ACTIONS_ITEMS
                }, renderActions({
                    webItems: webItems_5
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, activeSpotlight));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                padding: "space.025"
            }, renderModifyContentActionsWebItems(webItems_5), renderPrimaryContentActionsWebItems(webItems_5), renderFeedbackWebItems(webItems_5), renderMoreActions());
        })));
        $[326] = activeSpotlight;
        $[327] = contentId;
        $[328] = handleOpenChange;
        $[329] = isMenuOpen;
        $[330] = isModernEmbeddedConfluence;
        $[331] = loading;
        $[332] = preloadWebItems;
        $[333] = renderActions;
        $[334] = renderFeedbackWebItems;
        $[335] = renderModifyContentActionsWebItems;
        $[336] = renderMoreActions;
        $[337] = renderPrimaryContentActionsWebItems;
        $[338] = t68;
    } else t68 = $[338];
    let t69;
    if ($[339] !== isCopyContentModalOpen || $[340] !== renderCopyContentModal) {
        t69 = isCopyContentModalOpen && renderCopyContentModal();
        $[339] = isCopyContentModalOpen;
        $[340] = renderCopyContentModal;
        $[341] = t69;
    } else t69 = $[341];
    let t70;
    if ($[342] !== isMoveContentModalOpen || $[343] !== renderMoveContentModal) {
        t70 = isMoveContentModalOpen && renderMoveContentModal();
        $[342] = isMoveContentModalOpen;
        $[343] = renderMoveContentModal;
        $[344] = t70;
    } else t70 = $[344];
    let t71;
    if ($[345] !== t61 || $[346] !== t62 || $[347] !== t63 || $[348] !== t64 || $[349] !== t65 || $[350] !== t67 || $[351] !== t68 || $[352] !== t69 || $[353] !== t70) {
        t71 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t60, t61, t62, t63, t64, t65, t67, t68, t69, t70);
        $[345] = t61;
        $[346] = t62;
        $[347] = t63;
        $[348] = t64;
        $[349] = t65;
        $[350] = t67;
        $[351] = t68;
        $[352] = t69;
        $[353] = t70;
        $[354] = t71;
    } else t71 = $[354];
    return t71;
} : ({ moreActions: moreActions, contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, allowedFeatures: allowedFeatures, hasArchivePermission: hasArchivePermission, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, flags: flags, contentData: contentData, readOnly: readOnly, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted })=>{
    const intl = (0, $8C5kA.default)();
    const history = (0, $dPJCf.useHistory)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const triggerAnalyticsEvent = (0, $42omo.useMemo)(()=>async (eventName)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: eventName,
                    actionSubject: 'askToEditContent',
                    source: 'moreActionsMenu',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        isContentWrapper: (0, $6mKj3.expValEquals)('confluence_ask_to_edit_across_content_type', 'cohort', 'test'),
                        spaceKey: spaceKey,
                        contentMode: contentMode || 'view'
                    }
                }
            }).fire();
        }, [
        contentId,
        contentType,
        spaceKey,
        contentMode,
        createAnalyticsEvent
    ]);
    const { saveDraft: saveDraft, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, isContentCreationPanelOpen: isContentCreationPanelOpen, showRevertDialog: showRevertDialog, onPreviewClicked: onPreviewClicked, hasEditPermission: hasEditPermission, validatePageAndOpenModal: validatePageAndOpenModal, canUndo: editorCanUndo, canRedo: editorCanRedo, undo: editorUndo, redo: editorRedo, activateFindReplace: editorActivateFindReplace } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const isPageOrBlogAutoConverted = (0, $0633edcc0f21cf62$export$38d9182f14dddb00)({
        contentId: contentId,
        contentType: contentType
    });
    const openCompanyHubFeedbackCollector = (0, $lOeVN.useFeedbackCollector)({
        source: 'hubEditorEllipsisDropdown',
        type: (0, $4cOi8.FeedbackType).COMPANY_HUB
    });
    const publishPage = validatePageAndOpenModal?.('OverflowMenuConvertToPage');
    const [preloadWebItemsQuery, { data: webItemsData, called: isWebItemsQueryCalled, error: error, loading: loading }] = (0, $j1Ss3.useLazyQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fjiOd.WebItemLocationQuery), {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
            locations: [],
            spaceKey: null,
            version: null
        }
    });
    const { showMove: shouldShowMove, showArchive: shouldShowArchive, showCopy: shouldShowCopy, showClassificationMenuAction: shouldShowClassification } = allowedFeatures;
    const [isCopyContentModalOpen, setIsCopyContentModalOpen] = (0, $42omo.useState)(false);
    const [isMoveContentModalOpen, setIsMoveContentModalOpen] = (0, $42omo.useState)(false);
    const [isShortcutTriggered, setIsShortcutTriggered] = (0, $42omo.useState)(false);
    const { isMenuOpen: isMenuOpen, isCloseMenuDisabled: isCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuState)();
    const { setIsMenuOpen: setIsMenuOpen } = (0, $c54hr.useMoreActionsMenuActions)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { edition: edition, isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const isFreeUser = edition === (0, $euL71.ConfluenceEdition).FREE;
    const isPremiumUser = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const isCommentsEnabled = (0, $1b70db1d5649f5f3$export$5dc260e4e702b5d0)(contentType);
    const isVersionHistoryEnabled = (0, $5thep.useIsVersionHistoryEnabled)(contentType);
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [nestedPopup, setNestedPopup] = (0, $42omo.useState)(undefined);
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const isExternalCollaborator = (0, $foQ4a.useIsExternalCollaborator)();
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isPresentRendered = (0, $ff966189b275be15$export$a2eada40e8c9a2ed)(contentType, contentMode, isSpaceOverviewPage);
    const isLivePage = contentType === 'page' && contentMode === 'live';
    const [{ mode: livePageMode }] = (0, $efvKr.useLivePageMode)();
    const isLivePageViewOnlyPermissions = isLivePage && !hasEditPermission;
    const hasUpdateOperation = (type)=>contentData?.operations?.some((operation)=>operation?.targetType === type && operation?.operation === 'update');
    const isAskToEditEnabled = (type_0)=>!hasUpdateOperation(type_0) && (0, $6mKj3.expValEquals)('confluence_ask_to_edit_across_content_type', 'cohort', 'test');
    const isPageViewOnlyPermissions = contentType === 'page' && !hasUpdateOperation(contentType);
    const isWhiteboardViewOnlyPermissions = contentType === 'whiteboard' && isAskToEditEnabled(contentType);
    const isDatabaseViewOnlyPermissions = contentType === 'database' && isAskToEditEnabled(contentType);
    const isBlogViewOnlyPermissions = contentType === 'blogpost' && isAskToEditEnabled(contentType);
    const isContentViewOnlyPermissions = isLivePageViewOnlyPermissions || isPageViewOnlyPermissions || isWhiteboardViewOnlyPermissions || isDatabaseViewOnlyPermissions || isBlogViewOnlyPermissions;
    const contentStatus = contentData?.status || undefined;
    const isArchived = contentData?.status === 'archived';
    const isStarringEnabledForContentType = (0, $2cKGu.useIsStarringEnabled)(contentType, contentMode);
    const [{ theme: theme }] = (0, $7J5Uc.useThemingState)();
    const openWatchModalQueryParam = Boolean($511857b10ace36ca$var$useOpenWatchMenuQueryParam());
    const { setQueryParams: setQueryParams, push: push } = (0, $dPJCf.useRouteActions)();
    const { activeSpotlight: activeSpotlight, isHintVisible: isHintVisible, resetTour: resetTour } = (0, $bzwhi.useMoreActionsObjectSidebarTour)({
        step: (0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST
    });
    const hasReadPermission = Boolean(contentData?.operations?.filter((operation_0)=>operation_0?.targetType === contentType && operation_0?.operation === 'read').length); // controls the rendering of the star menu item + the star shortcut listener. There is no starring for draft pages and blogs currently.
    const shouldRenderStarContentMenuItem = isStarringEnabledForContentType && !!allowedFeatures.showFavourite && !isSpaceOverviewPage && hasReadPermission;
    const shouldRenderStarSpaceMenuItem = isSpaceOverviewPage && isLoggedIn;
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const companyHubEllipsisButtons = [
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).MANAGE,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).VIEW_CHANGES
    ];
    const allowedEllipsisButtons = isCompanyHub ? companyHubEllipsisButtons : [
        (0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY,
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).EDIT_LABELS,
        (0, $iQb1R.Buttons).MOVE_PAGE,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).TEMPLATE_BROWSER,
        (0, $iQb1R.Buttons).VIEW_CHANGES,
        (0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT,
        (0, $iQb1R.Buttons).CLASSIFY_CONTENT
    ];
    const isAllowed = (menuItem)=>allowedEllipsisButtons?.includes(menuItem) ?? true;
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    (0, $42omo.useEffect)(()=>{
        if (showVersionHistorySpotlight) setIsMenuOpen(true);
        return ()=>{
            setIsMenuOpen(false);
        };
    }, [
        setIsMenuOpen,
        showVersionHistorySpotlight
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isConvertToFolderHighlighted) {
            setIsMenuOpen(isConvertToFolderHighlighted);
            setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Convert);
        }
    }, [
        isConvertToFolderHighlighted,
        setIsMenuOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (openWatchModalQueryParam && contentType && contentMode && !loading) {
            if ((0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog) {
                setIsMenuOpen(true);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
            }
            setQueryParams({
                openWatchModal: null
            });
        }
    }, [
        openWatchModalQueryParam,
        setQueryParams,
        contentType,
        contentMode,
        loading,
        allowedFeatures,
        setIsMenuOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isShortcutTriggered && !loading) {
            if (webItemsData?.webItemSections?.some((section)=>section?.items?.length && section?.items[0]?.id === $511857b10ace36ca$export$240b6ef4a1c531f6)) {
                (0, $4GDP8.openMoreActionsMenuClick)();
                (0, $4GDP8.simulateItemClick)($511857b10ace36ca$export$240b6ef4a1c531f6);
            }
            setIsShortcutTriggered(false);
        }
    }, [
        isShortcutTriggered,
        webItemsData,
        loading
    ]);
    const handleOpenChange = (0, $42omo.useCallback)(({ isOpen: isOpen })=>{
        // if the "convert to page" spotlight for Modernize GA changeboarding is in progress, prevent the menu from closing when the user clicks outside of it.
        if (!isOpen && isCloseMenuDisabled && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return; // If a tour is currently in progress, prevent the menu from closing when the user clicks outside of it.
        if (activeSpotlight) return;
        setIsMenuOpen(isOpen);
        if (!isOpen) {
            resetTour();
            setNestedPopup(undefined); // Reset the Convert to Folder highlight state when the menu is closed
            setIsConvertToFolderHighlighted?.(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'contentTypeHeaderMoreActions',
                containerType: 'space',
                containerId: spaceId,
                objectId: contentId,
                source: 'contentTypesHeader',
                attributes: {
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
    }, [
        isCloseMenuDisabled,
        activeSpotlight,
        setIsMenuOpen,
        createAnalyticsEvent,
        spaceId,
        contentId,
        resetTour,
        setIsConvertToFolderHighlighted
    ]);
    const preloadWebItems = ()=>{
        preloadWebItemsQuery();
    };
    const handleNestedMenuItemClick = (nestedMenuType)=>{
        if (nestedPopup === nestedMenuType) setNestedPopup(undefined);
        else setNestedPopup(nestedMenuType);
    };
    const handleNestedMenuItemClose = ()=>{
        setNestedPopup(undefined);
    };
    const renderMoreActions = ()=>{
        if (!moreActions?.items?.length) return;
        return moreActions.items.map((itemGroup, idx)=>itemGroup.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                key: idx,
                hasSeparator: true
            }, itemGroup.map((item)=>{
                if ($511857b10ace36ca$var$isItemGroup(item)) {
                    const { id: groupId, items: groupItems, text: groupText } = item;
                    const handleOnOpenChange = ({ isOpen: isOpen_0 })=>{
                        if (isOpen_0) setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).MoreSupport);
                        else setNestedPopup(undefined);
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
                        key: groupId,
                        placement: "left-start",
                        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                                ...triggerProps,
                                ref: triggerRef,
                                testId: `${groupId}-button`,
                                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                    color: "var(--ds-icon-subtle, #505258)",
                                    label: "",
                                    size: "small"
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, groupText)),
                        isOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).MoreSupport,
                        onOpenChange: handleOnOpenChange,
                        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truedisco')
                    }, groupItems.map((subItem)=>{
                        const { id: innerId, url: innerUrl, target: innerTarget, onClick: innerOnClick, shortcutText: innerShortcutText, text: innerText } = subItem;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: innerId,
                            href: innerUrl,
                            target: innerTarget,
                            onClick: innerOnClick,
                            elemAfter: innerShortcutText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$KeyboardShortcutIcon, null, innerShortcutText) : undefined
                        }, innerText);
                    }));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                    item: item,
                    key: item.id
                });
            })));
    };
    const onDeleteClick = (0, $42omo.useCallback)((dialogs)=>{
        experienceTracker.start({
            name: (0, $irVI7.DELETE_PAGE_EXPERIENCE)
        });
        dialogs.showModal((0, $6ykQV.DeleteNestedPagesActionLoader), {
            contentId: contentId,
            source: 'contentTypesHeader',
            shouldRedirectOnSuccess: true,
            contentType: contentType
        });
        setIsMenuOpen(false);
    }, [
        contentId,
        experienceTracker,
        contentType,
        setIsMenuOpen
    ]);
    const renderMoveContentModal = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bHd1w.MovePageDialog), {
            contentId: contentId,
            spaceKey: spaceKey,
            onClose: ()=>setIsMoveContentModalOpen(false),
            onCloseComplete: ()=>setIsMoveContentModalOpen(false),
            referrer: "content-types-header"
        });
    };
    const renderMovePageModal = (dialogs_0)=>{
        experienceTracker.start({
            name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
        });
        dialogs_0.showDialog((0, $bHd1w.MovePageDialog), {
            spaceKey: spaceKey,
            contentId: contentId,
            referrer: 'view-page-actions-menu',
            isMovingDraftVersion: contentMode === 'edit',
            isUnpublishedDraft: contentMode === 'draft'
        });
    };
    const renderMoveBlogModal = (dialogs_1)=>{
        dialogs_1.showModal((0, $78wUU.MoveBlogModalLoader), {
            currentSpaceKey: spaceKey,
            blogPostId: contentId,
            isEditMode: contentMode === 'edit',
            isUnpublishedDraft: contentMode === 'draft'
        });
    };
    const renderCopyContentModal = ()=>{
        return (0, $6mKj3.expVal)('confluence_modernized_copy_dialog', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3J7TU.CopyPageDialog), {
            contentId: contentId,
            spaceKey: spaceKey,
            onClose: async ()=>setIsCopyContentModalOpen(false)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FwhF.CopyPageTreeDialog), {
            contentId: contentId,
            spaceKey: spaceKey,
            onClose: async ()=>setIsCopyContentModalOpen(false)
        });
    };
    const onArchiveClick = (0, $42omo.useCallback)((dialogs_2)=>{
        if (isFreeUser) dialogs_2.showDialog((0, $k22lL.ArchiveUpsellDialog));
        else {
            experienceTracker.start({
                name: (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE)
            });
            dialogs_2.showDialog((0, $2WH1B.ArchivePagesLoader), {
                contentId: contentId,
                source: 'contentTypesHeader'
            });
        }
        setIsMenuOpen(false);
    }, [
        isFreeUser,
        contentId,
        setIsMenuOpen,
        experienceTracker
    ]);
    const handleViewVersionHistory = (0, $42omo.useCallback)(()=>{
        setShowVersionHistorySpotlight?.(false);
        trackExperience({
            contentType: contentType,
            experience: 'sidePanel',
            task: 'start'
        });
        showSidePanel();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'versionHistory',
                source: 'moreActionsMenu',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    spotlighted: showVersionHistorySpotlight ? 1 : 0,
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        showSidePanel,
        setShowVersionHistorySpotlight,
        showVersionHistorySpotlight,
        trackExperience
    ]);
    const onRevertClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowRevert',
                source: 'overflowMenu'
            }
        }).fire();
        saveDraft?.({
            isOnClose: false
        });
        showRevertDialog?.();
    }, [
        createAnalyticsEvent,
        saveDraft,
        showRevertDialog
    ]);
    const onRevertToLegacyEditorClick = (0, $42omo.useCallback)((dialogs_3)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowRevertToLegacyEditor',
                source: 'overflowMenu'
            }
        }).fire();
        saveDraft?.({
            isOnClose: false
        });
        dialogs_3.showDialog((0, $b66o6.RevertEditorDialog), {
            contentId: contentId,
            onPageRevert: ()=>(0, $d8oE8.onClickPageRevert)(push, contentType, spaceKey, contentId, (0, $6mKj3.expValEquals)('confluence_auto_convert_legacy_draft_fix_fe', 'isEnabled', true) ? contentStatus : undefined)
        });
    }, [
        createAnalyticsEvent,
        saveDraft,
        contentId,
        push,
        contentStatus,
        contentType,
        spaceKey
    ]);
    const onFeedbackClick = (dialogs_4, contentTypeForFeedback)=>{
        dialogs_4.showModal((0, $dcvq8.GlobalFeedbackCollector), {
            feedbackSource: (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentTypeForFeedback],
            showTypeField: true,
            contentType: contentTypeForFeedback
        });
    };
    const makeInlineCommentsDialogOpener = (dialogs_5, context)=>{
        dialogs_5.showDialog((0, $6eFi0.ResolvedInlineCommentsDialogLoader), {
            contentId: contentId,
            context: context,
            onReopenResolvedCommentHandler: (commentIds)=>{
                commentService.onReopenResolvedComment(commentIds);
            }
        });
    };
    const makePresenterModeOpener = (enterPresenterMode)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'present',
                    source: 'moreActions',
                    objectId: contentId,
                    containerId: spaceId,
                    attributes: {
                        currentThemePreference: theme,
                        OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
            enterPresenterMode();
        };
    const makePreviewContentHandler = (onPreviewClicked_0)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'previewPage',
                    source: 'moreActions',
                    objectId: contentId,
                    objectType: contentType
                }
            }).fire();
            onPreviewClicked_0(false);
        };
    const openLinkToThisPageDialog = (dialogs_6)=>()=>{
            dialogs_6.showModal((0, $1PC5x.LinkToThisPageDialog), {
                contentId: contentId
            });
        };
    const primaryActionData = ({ webItemsMap: webItemsMap, customActionsMap: customActionsMap })=>{
        const primaryActionsItems = [
            {
                name: $511857b10ace36ca$export$35f02acdf766e275,
                shouldRender: shouldRenderStarSpaceMenuItem,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPqqM.SpaceStarMenuItemWithQuery), {
                        spaceKey: spaceKey
                    })
            },
            {
                name: $511857b10ace36ca$export$348fd9bd77c132d9,
                shouldRender: shouldRenderStarContentMenuItem && !isCompanyHub,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daed94f8e5673bda$export$ab53347da13f94fa), {
                        contentId: contentId,
                        contentTitle: contentData?.title || '',
                        contentMode: contentMode || ''
                    })
            },
            {
                name: $511857b10ace36ca$export$e242b9905c10e726,
                shouldRender: (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog && !isCompanyHub,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b864d3fa23503bf$export$f9409fd8f8b5a92d), {
                        isMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch,
                        contentId: contentId,
                        contentType: contentType,
                        spaceId: spaceId,
                        spaceKey: spaceKey,
                        setIsMenuOpen: setIsMenuOpen,
                        onMenuClose: handleNestedMenuItemClose,
                        onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch)
                    })
            },
            {
                name: $511857b10ace36ca$export$6bb183703c5072f1,
                shouldRender: isLoggedIn && !isArchived && isContentViewOnlyPermissions,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d3293071a1569ba$export$84d0de3613f64b9a), {
                        contentType: contentType,
                        contentId: contentId,
                        flags: flags,
                        triggerAnalyticsEvent: triggerAnalyticsEvent,
                        askToEditKey: $511857b10ace36ca$export$6bb183703c5072f1
                    })
            },
            {
                name: $511857b10ace36ca$export$74317f458aa33c63,
                shouldRender: (0, $ff966189b275be15$export$74e87e549c7a0f96)(contentType, contentMode) && !isCompanyHub,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$74317f458aa33c63,
                        onClick: makePreviewContentHandler(onPreviewClicked),
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9vvQJ))), {
                            label: ""
                        }),
                        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                            id: $511857b10ace36ca$export$74317f458aa33c63,
                            shortcutKeys: [
                                (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW
                            ]
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.previewLabel))
            },
            {
                name: $511857b10ace36ca$export$461acb5c5f9c7b12,
                shouldRender: isCompanyHub,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$461acb5c5f9c7b12,
                        onClick: ()=>history?.push((0, $1NBp8.COMPANY_HUB_SETTINGS).toUrl(), {
                                from: (0, $1NBp8.COMPANY_HUB_EDIT).name
                            }),
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.manageLabel))
            },
            {
                name: $511857b10ace36ca$export$12b5e6890d8e049c,
                shouldRender: !!customActionsMap[$511857b10ace36ca$export$12b5e6890d8e049c],
                component: ()=>{
                    const item_0 = customActionsMap[$511857b10ace36ca$export$12b5e6890d8e049c];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_0,
                        key: item_0.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($avrhI))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$f9e89fba7e6b4574,
                shouldRender: (0, $ff966189b275be15$export$4a2abd609e31ae47)(contentType) && !!customActionsMap[$511857b10ace36ca$export$f9e89fba7e6b4574],
                component: ()=>{
                    const item_1 = customActionsMap[$511857b10ace36ca$export$f9e89fba7e6b4574];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_1,
                        key: item_1.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$240b6ef4a1c531f6,
                shouldRender: isPresentRendered && !!webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6],
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).COMMENTS,
                        key: webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6].completeKey
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
                        key: `presenter-mode-menu-item-${webItemsMap[$511857b10ace36ca$export$240b6ef4a1c531f6].completeKey}`
                    }, (enterPresenterMode_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default // @ts-ignore id prop needed in order for shortcut to work properly
                        ), {
                            id: $511857b10ace36ca$export$240b6ef4a1c531f6,
                            key: $511857b10ace36ca$export$240b6ef4a1c531f6,
                            onClick: makePresenterModeOpener(enterPresenterMode_0),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3KUzn))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                                shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT)
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.presentLabel))))
            },
            {
                name: 'viewEditToggle',
                shouldShowSeparator: false,
                shouldRender: Boolean(contentMode === 'live' && hasEditPermission),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gDbO8.LivePagesModeChanger), {
                        contentId: contentId,
                        flags: flags,
                        analyticsSource: "livePagesEllipsisDropdown",
                        elemAfter: (0, $434c765ed6791bfa$export$d206439c03b979ee)
                    })
            }
        ];
        const actionsToRender = primaryActionsItems.filter((item_2)=>item_2.shouldRender);
        return {
            key: 'primary-actions',
            items: actionsToRender
        };
    };
    const modifyActionData = ({ webItems: webItems, webItemsMap: webItemsMap_0, customActionsMap: customActionsMap_0 })=>{
        const hasArchive = !isCompanyHub && (0, $ff966189b275be15$export$32820bf57e654cf8)(contentType, contentMode) && (hasArchivePermission || isFreeUser) && allowedFeatures.showArchive && !!webItemsMap_0[$511857b10ace36ca$export$d81a93c80838b765];
        const hasDelete = !!webItemsMap_0[$511857b10ace36ca$export$da4fec526a505196];
        const modifyActionsToRender = [
            {
                name: $511857b10ace36ca$export$21b8b89e4603550f,
                shouldRender: !!webItemsMap_0[$511857b10ace36ca$export$21b8b89e4603550f],
                component: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${$511857b10ace36ca$export$21b8b89e4603550f}`
                    }, (dialogs_7)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$21b8b89e4603550f,
                            onClick: ()=>{
                                createAnalyticsEvent({
                                    type: 'sendUIEvent',
                                    data: {
                                        action: 'clicked',
                                        actionSubject: 'button',
                                        actionSubjectId: 'overflowRestore',
                                        source: 'overflowMenu',
                                        attributes: {
                                            isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                                        }
                                    }
                                }).fire();
                                dialogs_7.showModal((0, $1Zthr.UnarchivePagesDialogLoader), {
                                    contentId: contentId,
                                    source: 'contentTypesHeader'
                                });
                            },
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eix0u))), {
                                label: ""
                            })
                        }, webItemsMap_0[$511857b10ace36ca$export$21b8b89e4603550f].label));
                }
            },
            {
                name: $511857b10ace36ca$export$cc1f11fb5e07970e,
                // Render 'Create live doc with Rovo' action if:
                // - Content type is whiteboard
                // - Rovo is enabled
                // - fg for AIFC create (aifc_create_enabled) is enabled
                // - This action(whiteboard_to_live_doc_header_action_enabled) is enabled
                shouldRender: contentType === 'whiteboard' && isRovoEnabled && (0, $9wGTI.fg)('aifc_create_enabled'),
                component: ()=>{
                    return (0, $9wGTI.fg)('whiteboard_to_live_doc_header_action_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eb923bf92acc93d7$export$43890b7edce69789), {
                        spaceKey: spaceKey,
                        contentId: contentId
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
                }
            },
            {
                name: $511857b10ace36ca$export$94db61d2b880af44,
                shouldRender: allowedFeatures.showCopy && (0, $ff966189b275be15$export$a130e0ea03d42b0b)(contentType, contentMode) && (!!webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44] || !!customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e]),
                component: ()=>{
                    if (customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$3131530af790ffe2), {
                        isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase,
                        handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase),
                        copyDatabaseItem: webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44],
                        copyStructureItem: customActionsMap_0[$511857b10ace36ca$export$2594f905f6c1490e],
                        setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                        contentMode: contentMode,
                        handleNestedMenuItemClose: handleNestedMenuItemClose,
                        closeParentMenu: ()=>setIsMenuOpen(false)
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$36ee254e582a74c2), {
                        setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                        closeParentMenu: ()=>setIsMenuOpen(false),
                        item: webItemsMap_0[$511857b10ace36ca$export$94db61d2b880af44]
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$bcce08436c9de127,
                shouldRender: !isLivePageViewOnlyPermissions && allowedFeatures.showMove && !isCompanyHub && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$bcce08436c9de127],
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${$511857b10ace36ca$export$bcce08436c9de127}`
                    }, (dialogs_8)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$bcce08436c9de127,
                            onClick: ()=>renderMovePageModal(dialogs_8),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                label: ""
                            })
                        }, webItemsMap_0[$511857b10ace36ca$export$bcce08436c9de127].label))
            },
            {
                name: $511857b10ace36ca$export$c7733ea6d8e45875,
                shouldRender: allowedFeatures.showMove && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$c7733ea6d8e45875],
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${$511857b10ace36ca$export$c7733ea6d8e45875}`
                    }, (dialogs_9)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$c7733ea6d8e45875,
                            onClick: ()=>renderMoveBlogModal(dialogs_9),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                                label: ""
                            })
                        }, webItemsMap_0[$511857b10ace36ca$export$c7733ea6d8e45875].label))
            },
            {
                name: $511857b10ace36ca$export$b1a4c392275ea35a,
                shouldRender: (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isContentCreationPanelOpen && !isLivePageViewOnlyPermissions && // if whiteboard we allow templates and imports if custom actions are available
                (contentType !== 'whiteboard' || !!customActionsMap_0[$511857b10ace36ca$export$d4cf3906d3082596] || !!customActionsMap_0[$511857b10ace36ca$export$cce5e117e5e43bc]),
                component: ()=>{
                    if (customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea]) {
                        customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea].text = intl.formatMessage($511857b10ace36ca$var$i18n.templatesImportLabel);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: customActionsMap_0[$511857b10ace36ca$export$be7385413e15c3ea],
                            key: $511857b10ace36ca$export$be7385413e15c3ea,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                label: ""
                            })
                        });
                    } else if (customActionsMap_0[$511857b10ace36ca$export$d4cf3906d3082596] || customActionsMap_0[$511857b10ace36ca$export$cce5e117e5e43bc]) {
                        const nestedItems = [];
                        const createNestedItem = (actionKey)=>{
                            const action = customActionsMap_0[actionKey];
                            if (action) nestedItems.push({
                                ...action,
                                customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                        item: action,
                                        key: action.id
                                    })
                            });
                        };
                        createNestedItem($511857b10ace36ca$export$d4cf3906d3082596);
                        createNestedItem($511857b10ace36ca$export$cce5e117e5e43bc);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesImportLabel),
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport),
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                                label: ""
                            }),
                            items: nestedItems,
                            onMenuClose: handleNestedMenuItemClose
                        });
                    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$b1a4c392275ea35a,
                        onClick: onClickOpenContentCreationPanel,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.templatesImportLabel));
                }
            },
            {
                name: $511857b10ace36ca$export$10f4bed2ae52719b,
                shouldRender: (0, $ff966189b275be15$export$d790dfbcfcf44b71)(contentType, contentMode) && !!webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b],
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                        item: webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b],
                        contentMode: contentMode,
                        flags: flags,
                        spaceId: spaceId,
                        spaceKey: spaceKey,
                        contentId: contentId,
                        closeParentMenu: ()=>setIsMenuOpen(false)
                    })
            },
            {
                name: $511857b10ace36ca$export$8ba85686c8897eca,
                shouldRender: (0, $ff966189b275be15$export$37d144a1b557c80d)(contentType, contentMode) && !isLivePageViewOnlyPermissions,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                        name: (0, $47zp4.CONVERT_TO_PAGE_SPOTLIGHT_TARGET)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$8ba85686c8897eca,
                        onClick: publishPage,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.convertToPage)))
            },
            {
                name: $511857b10ace36ca$export$3192aea0628d957a,
                shouldRender: (0, $ff966189b275be15$export$78b7a39935e0bb86)(contentType, contentMode, isSpaceOverviewPage) && (!!webItemsMap_0[$511857b10ace36ca$export$5497d83bbd1b1232] || !!webItemsMap_0[$511857b10ace36ca$export$7767afe5b675f4b1] || !!webItemsMap_0[$511857b10ace36ca$export$10f4bed2ae52719b]),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$1a264aaf74bdd787), {
                        webItemsMap: webItemsMap_0,
                        nestedPopup: nestedPopup,
                        handleNestedMenuItemClick: handleNestedMenuItemClick,
                        spaceKey: spaceKey,
                        contentId: contentId,
                        handleNestedMenuItemClose: handleNestedMenuItemClose,
                        flags: flags,
                        spaceId: spaceId,
                        contentMode: contentMode,
                        closeParentMenu: ()=>setIsMenuOpen(false),
                        isConvertToFolderHighlighted: isConvertToFolderHighlighted
                    })
            },
            {
                name: $511857b10ace36ca$export$ab4fe2a2881747b5,
                shouldRender: (0, $ff966189b275be15$export$58a134bd2769b459)(contentType, contentMode) && (!!webItemsMap_0[$511857b10ace36ca$export$5da5719a925f973] || !!webItemsMap_0[$511857b10ace36ca$export$bbe81b5a8b0eaf4]),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b945ccaa4d42d330), {
                        webItemsMap: webItemsMap_0,
                        handleNestedMenuItemClick: handleNestedMenuItemClick,
                        nestedPopup: nestedPopup,
                        handleNestedMenuItemClose: handleNestedMenuItemClose,
                        closeParentMenu: ()=>setIsMenuOpen(false)
                    })
            },
            {
                name: $511857b10ace36ca$export$d588519b9727f1cc,
                shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$d588519b9727f1cc],
                component: ()=>{
                    const item_3 = customActionsMap_0[$511857b10ace36ca$export$d588519b9727f1cc];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_3,
                        key: item_3.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$f0ae5a9b5b44d373,
                shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$f0ae5a9b5b44d373],
                component: ()=>{
                    const item_4 = customActionsMap_0[$511857b10ace36ca$export$f0ae5a9b5b44d373];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_4,
                        key: item_4.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$e07ca208ff99048e,
                shouldRender: !!customActionsMap_0[$511857b10ace36ca$export$e07ca208ff99048e],
                component: ()=>{
                    const item_5 = customActionsMap_0[$511857b10ace36ca$export$e07ca208ff99048e];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_5,
                        key: item_5.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$d81a93c80838b765,
                shouldRender: hasArchive && !hasDelete,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f4be76d677f42fda), {
                        onArchiveClick: onArchiveClick
                    })
            },
            {
                name: $511857b10ace36ca$export$da4fec526a505196,
                shouldRender: hasDelete && !hasArchive,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$5ac124715785374c), {
                        contentMode: contentMode,
                        onDeleteClick: onDeleteClick,
                        createAnalyticsEvent: createAnalyticsEvent
                    })
            },
            {
                name: $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE,
                shouldRender: hasArchive && hasDelete,
                component: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$a05f0dd30396f811), {
                        webItems: webItems,
                        isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive,
                        handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive),
                        onArchiveClick: onArchiveClick,
                        onDeleteClick: onDeleteClick,
                        contentMode: contentMode,
                        createAnalyticsEvent: createAnalyticsEvent,
                        handleNestedMenuItemClose: handleNestedMenuItemClose
                    });
                }
            }
        ];
        const actionsToRender_0 = modifyActionsToRender.filter((item_6)=>item_6.shouldRender);
        return {
            key: 'modify-actions',
            items: actionsToRender_0
        };
    };
    const getDatabaseActionItems = (customActionsMap_1)=>[
            {
                name: $511857b10ace36ca$export$6563b47d35bee4f1,
                shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$6563b47d35bee4f1] && contentMode !== 'archived',
                component: ()=>{
                    const item_7 = customActionsMap_1[$511857b10ace36ca$export$6563b47d35bee4f1];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_7,
                        key: item_7.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$fe723f15ba37849b,
                shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$fe723f15ba37849b] && contentMode !== 'archived',
                component: ()=>{
                    const item_8 = customActionsMap_1[$511857b10ace36ca$export$fe723f15ba37849b];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_8,
                        key: item_8.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$d7bae9f2073f40be,
                shouldRender: !!customActionsMap_1[$511857b10ace36ca$export$d7bae9f2073f40be],
                component: ()=>{
                    const item_9 = customActionsMap_1[$511857b10ace36ca$export$d7bae9f2073f40be];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_9,
                        key: item_9.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                            label: ""
                        })
                    });
                }
            }
        ];
    const secondaryActionData = ({ webItemsMap: webItemsMap_1, customActionsMap: customActionsMap_2, webItems: webItems_0 })=>{
        const databaseSecondaryActionItems = getDatabaseActionItems(customActionsMap_2);
        const secondaryActionItems = [
            {
                name: (0, $iQb1R.Buttons).VIEW_CHANGES,
                shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$caca47bf68c8998)(contentType, contentMode) && isAllowed((0, $iQb1R.Buttons).VIEW_CHANGES),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: (0, $iQb1R.Buttons).VIEW_CHANGES
                    }, (dialogs_10)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f28b24dc0422311f), {
                            contentId: contentId,
                            dialogs: dialogs_10,
                            saveDraft: saveDraft,
                            createAnalyticsEvent: createAnalyticsEvent
                        }))
            },
            {
                name: $511857b10ace36ca$export$c9981a2480d638b0,
                shouldRender: (0, $ff966189b275be15$export$d0c33a26470e0efe)(contentType, contentMode),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$c9981a2480d638b0,
                        onClick: onRevertClick,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.revertLabel))
            },
            {
                name: $511857b10ace36ca$export$a751f1adb88d1383,
                shouldRender: isCommentsEnabled && !!webItemsMap_1[$511857b10ace36ca$export$a751f1adb88d1383],
                component: ()=>{
                    const item_10 = webItemsMap_1[$511857b10ace36ca$export$a751f1adb88d1383];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ],
                        key: `container-${item_10.id}`
                    }, (dialogs_11)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: item_10.id,
                            onClick: ()=>{
                                if (contentType === 'whiteboard' || contentType === 'database') makeInlineCommentsDialogOpener(dialogs_11, contentType);
                            },
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_10.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                            contentId: contentId
                        }))));
                }
            },
            {
                name: $511857b10ace36ca$export$a6381225def83c4b,
                shouldRender: !isExternalCollaborator && !!webItemsMap_1[$511857b10ace36ca$export$a6381225def83c4b],
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogMenuPropsProvider), {
                        contentId: contentId
                    }, (itemProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                            ...itemProps,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                                label: ""
                            })
                        }))
            },
            {
                name: $511857b10ace36ca$export$e14cf657321c833b,
                shouldRender: isVersionHistoryEnabled && !!webItemsMap_1[$511857b10ace36ca$export$e14cf657321c833b],
                component: ()=>{
                    const item_11 = webItemsMap_1[$511857b10ace36ca$export$e14cf657321c833b];
                    if (showVersionHistorySpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $330cc2928c11abea$export$cf692ceb431cd214), {
                        key: item_11.id,
                        contentType: contentType,
                        source: "moreActionsMenu"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_11.id,
                        onClick: handleViewVersionHistory,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.versionHistoryLabel)));
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_11.id,
                        onClick: handleViewVersionHistory,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.versionHistoryLabel));
                }
            },
            {
                name: $511857b10ace36ca$export$fc2e34cd983af5d6,
                shouldRender: (0, $ff966189b275be15$export$458bbd6d88041c9d)(contentType, contentMode) && !!webItemsMap_1[$511857b10ace36ca$export$fc2e34cd983af5d6],
                component: ()=>{
                    const item_12 = webItemsMap_1[$511857b10ace36ca$export$fc2e34cd983af5d6];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc), {
                        itemId: item_12?.id,
                        itemUrl: item_12?.url,
                        label: intl.formatMessage($511857b10ace36ca$var$i18n.versionHistoryLabel),
                        isLivePage: isLivePage,
                        contentType: contentType
                    });
                }
            },
            ...(0, $9wGTI.fg)('databases-frontend-content-wrapper') ? [] : databaseSecondaryActionItems,
            {
                name: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$11233ac17765daec)(contentType) && !!webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                        key: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                        item: webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                        nestedPopup: nestedPopup,
                        setNestedPopup: setNestedPopup,
                        contentId: contentId,
                        setIsMenuOpen: setIsMenuOpen
                    })
            },
            {
                name: $511857b10ace36ca$export$244b90a342b60d9f,
                shouldRender: !isLivePageViewOnlyPermissions && !isCompanyHub && (0, $ff966189b275be15$export$5e9136e7e220ab40)(contentType) && allowedFeatures.showClassificationMenuAction,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), {
                        key: "classify-content",
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
                            label: ""
                        })
                    })
            },
            {
                name: $511857b10ace36ca$export$fe0a3b90b0b6010b,
                shouldRender: isPremiumUser && isLoggedIn && (0, $ff966189b275be15$export$bb21210c1c36f22a)(contentType, contentMode, isSpaceOverviewPage),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$7e059d95fddc01f4), {
                        experienceTracker: experienceTracker,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        pageTitle: contentData?.title || ''
                    })
            },
            {
                // revert to legacy editor item should show for view/edit page and blogpost dropdown if the content was autoconverted to fabric
                name: $511857b10ace36ca$export$fe2b6e9bf8b31ecc,
                shouldRender: (0, $ff966189b275be15$export$493ddb7a4c710fed)(contentType, contentMode, isAllowed((0, $iQb1R.Buttons).DELETE_DRAFT), (0, $6mKj3.expValEquals)('confluence_auto_convert_legacy_draft_fix_fe', 'isEnabled', true)) && isPageOrBlogAutoConverted && (0, $9wGTI.fg)('confluence_frontend_reintroduce_revert_editor_item'),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
                        key: "revert-to-legacy-editor-menu-item"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ]
                    }, (dialogs_12)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$c9981a2480d638b0,
                            onClick: ()=>onRevertToLegacyEditorClick(dialogs_12),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.revertEditor))))
            },
            {
                name: $511857b10ace36ca$export$52e1dc7e5d9b8b02,
                shouldRender: (0, $ff966189b275be15$export$49f8860e43af4419)(contentType, contentMode),
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$f404e2d5b48ab522), {
                        webItemsMap: webItemsMap_1,
                        handleNestedMenuItemClick: handleNestedMenuItemClick,
                        nestedPopup: nestedPopup,
                        handleNestedMenuItemClose: handleNestedMenuItemClose,
                        closeParentMenu: ()=>setIsMenuOpen(false)
                    })
            },
            (0, $434c765ed6791bfa$export$f26eff3587fe7632)({
                isAppsRendered: (0, $ff966189b275be15$export$8623af461a2f6a54)(contentType, contentMode),
                spaceKey: spaceKey,
                contentId: contentId,
                isMenuOpen: isMenuOpen,
                handleNestedMenuItemClick: handleNestedMenuItemClick,
                nestedPopup: nestedPopup,
                items: webItems_0,
                createAnalyticsEvent: createAnalyticsEvent,
                handleNestedMenuItemClose: handleNestedMenuItemClose,
                closeParentMenu: ()=>setIsMenuOpen(false)
            }),
            {
                name: $511857b10ace36ca$export$23eaedbb3a44a3b5,
                shouldRender: !!customActionsMap_2[$511857b10ace36ca$export$23eaedbb3a44a3b5],
                component: ()=>{
                    const item_13 = customActionsMap_2[$511857b10ace36ca$export$23eaedbb3a44a3b5];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_13,
                        key: item_13.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                            label: ""
                        })
                    });
                }
            }
        ];
        const actionsToRender_1 = secondaryActionItems.filter((item_14)=>item_14.shouldRender);
        return {
            key: 'secondary-actions',
            items: actionsToRender_1
        };
    };
    const databaseActionData = ({ customActionsMap: customActionsMap_3 })=>{
        const databaseActionItems = getDatabaseActionItems(customActionsMap_3);
        const actionsToRender_2 = databaseActionItems.filter((item_15)=>item_15.shouldRender);
        return {
            key: 'database-actions',
            items: actionsToRender_2
        };
    };
    const editorActionData = ()=>{
        if (!(0, $ff966189b275be15$export$71ad62dbe8638043)(contentType, contentMode, hasEditPermission, livePageMode)) return {
            key: 'editor-actions',
            items: []
        };
        const editorActionItems = [
            {
                name: $511857b10ace36ca$export$43db96fb923dc5c7,
                shouldRender: !!editorUndo && !(0, $9wGTI.fg)('platform_editor_ai_aifc_streaming'),
                component: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$43db96fb923dc5c7,
                        isDisabled: !editorCanUndo,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                            label: ""
                        }),
                        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                            id: $511857b10ace36ca$export$43db96fb923dc5c7,
                            shortcutKeys: [
                                (0, $gnkil.EDITOR2_SHORTCUTS).UNDO
                            ]
                        }),
                        onClick: async ()=>{
                            editorUndo?.();
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorUndoLabel));
                }
            },
            {
                name: $511857b10ace36ca$export$4e316098da1efb3e,
                shouldRender: !!editorRedo && !(0, $9wGTI.fg)('platform_editor_ai_aifc_streaming'),
                component: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$4e316098da1efb3e,
                        isDisabled: !editorCanRedo,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                            label: ""
                        }),
                        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                            id: $511857b10ace36ca$export$4e316098da1efb3e,
                            shortcutKeys: [
                                (0, $gnkil.EDITOR2_SHORTCUTS).REDO
                            ]
                        }),
                        onClick: async ()=>{
                            editorRedo?.();
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorRedoLabel));
                }
            },
            {
                name: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                shouldRender: !!editorActivateFindReplace,
                component: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                            label: ""
                        }),
                        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                            id: $511857b10ace36ca$export$8f2c4b97a6e00f7f,
                            shortcutKeys: [
                                (0, $gnkil.EDITOR2_SHORTCUTS).FIND_REPLACE
                            ]
                        }),
                        onClick: async ()=>{
                            editorActivateFindReplace?.();
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.editorFindReplaceLabel));
                }
            }
        ];
        const actionsToRender_3 = editorActionItems.filter((item_16)=>item_16.shouldRender);
        return {
            key: 'editor-actions',
            items: actionsToRender_3
        };
    };
    const feedbackActionData = ({ webItemsMap: webItemsMap_2, customActionsMap: customActionsMap_4, actions: actions })=>{
        const additionalActionItems = [
            {
                name: $511857b10ace36ca$export$84c7eab054d974db,
                shouldRender: (0, $ff966189b275be15$export$46e46e0c15d57a1)(contentType) && !!webItemsMap_2[$511857b10ace36ca$export$84c7eab054d974db],
                component: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                        to: [
                            (0, $kRW4Y.DialogsStateContainer)
                        ]
                    }, (dialogs_13)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                            key: $511857b10ace36ca$export$84c7eab054d974db,
                            onClick: ()=>{
                                onFeedbackClick(dialogs_13, contentType);
                            },
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                                label: ""
                            })
                        }, webItemsMap_2[$511857b10ace36ca$export$84c7eab054d974db].label));
                }
            },
            {
                name: $511857b10ace36ca$export$5f2e846fff4ab830,
                shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[$511857b10ace36ca$export$5f2e846fff4ab830],
                component: ()=>{
                    const items = actions.flat().map((action_0)=>({
                            ...action_0,
                            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                    item: action_0,
                                    key: action_0.id
                                })
                        }));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.help),
                        isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help,
                        onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help),
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                            label: ""
                        }),
                        items: items,
                        onMenuClose: handleNestedMenuItemClose
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$95f3debc4a615fda,
                shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda],
                component: ()=>{
                    customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda].text = intl.formatMessage($511857b10ace36ca$var$i18n.help);
                    const item_17 = customActionsMap_4[$511857b10ace36ca$export$95f3debc4a615fda];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_17,
                        key: item_17.id,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                            label: ""
                        })
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$54ed9c94f2cfe2b6,
                shouldRender: !!customActionsMap_4[$511857b10ace36ca$export$54ed9c94f2cfe2b6],
                component: ()=>{
                    const item_18 = customActionsMap_4[$511857b10ace36ca$export$54ed9c94f2cfe2b6];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                        item: item_18,
                        key: item_18.id
                    });
                }
            },
            {
                name: $511857b10ace36ca$export$654801d4f89a934,
                shouldRender: isCompanyHub,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: $511857b10ace36ca$export$654801d4f89a934,
                        onClick: openCompanyHubFeedbackCollector,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                            label: ""
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.companyHubFeedback))
            }
        ];
        const actionsToRender_4 = additionalActionItems.filter((item_19)=>item_19.shouldRender);
        return {
            key: 'additional-items',
            items: actionsToRender_4
        };
    };
    const renderModifyContentActionsWebItems = (webItems_1)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, webItems_1.map((item_20)=>{
            if ($511857b10ace36ca$var$isWebItem(item_20)) {
                if (shouldShowCopy && item_20?.id === $511857b10ace36ca$export$94db61d2b880af44) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                    key: item_20.id,
                    onClick: ()=>setIsCopyContentModalOpen(true)
                }, item_20.label);
                if (shouldShowMove && item_20?.id === $511857b10ace36ca$export$bcce08436c9de127) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                    key: item_20.id,
                    onClick: ()=>setIsMoveContentModalOpen(true)
                }, item_20.label);
                if (item_20?.id === $511857b10ace36ca$export$21b8b89e4603550f) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                    to: [
                        (0, $kRW4Y.DialogsStateContainer)
                    ],
                    key: `container-${item_20.id}`
                }, (dialogs_14)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_20.id,
                        onClick: ()=>{
                            dialogs_14.showDialog((0, $1Zthr.UnarchivePagesDialogLoader), {
                                contentId: contentId,
                                source: 'contentTypesHeader'
                            });
                        }
                    }, item_20.label));
                if (item_20?.id === $511857b10ace36ca$export$da4fec526a505196) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                    to: [
                        (0, $kRW4Y.DialogsStateContainer)
                    ],
                    key: `container-${item_20.id}`
                }, (dialogs_15)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_20.id,
                        onClick: ()=>{
                            onDeleteClick(dialogs_15);
                        }
                    }, item_20.label));
                if (item_20?.id === $511857b10ace36ca$export$d81a93c80838b765 && hasArchivePermission && shouldShowArchive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                    to: [
                        (0, $kRW4Y.DialogsStateContainer)
                    ],
                    key: `container-${item_20.id}`
                }, (dialogs_16)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_20.id,
                        onClick: ()=>{
                            onArchiveClick(dialogs_16);
                        }
                    }, item_20.label));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.tooltip),
                position: "left",
                key: item_20.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                isDisabled: true
            }, item_20.label));
            return null;
        }));
    };
    const renderPrimaryContentActionsWebItems = (webItems_2)=>{
        const webItemsToRender = webItems_2.map((item_21)=>{
            if ($511857b10ace36ca$var$isWebItem(item_21)) {
                if (item_21?.id === $511857b10ace36ca$export$a751f1adb88d1383 && isCommentsEnabled && (contentType === 'whiteboard' || contentType === 'database')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                    to: [
                        (0, $kRW4Y.DialogsStateContainer)
                    ],
                    key: `container-${item_21.id}`
                }, (dialogs_17)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_21.id,
                        onClick: ()=>makeInlineCommentsDialogOpener(dialogs_17, contentType)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_21.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                        contentId: contentId
                    }))));
                if (item_21?.id === $511857b10ace36ca$export$e14cf657321c833b && isVersionHistoryEnabled) {
                    if (showVersionHistorySpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $330cc2928c11abea$export$cf692ceb431cd214), {
                        key: item_21.id,
                        contentType: contentType,
                        source: "moreActionsMenu"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_21.id,
                        onClick: handleViewVersionHistory
                    }, item_21.label));
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_21.id,
                        onClick: handleViewVersionHistory
                    }, item_21.label);
                }
                if (item_21?.id === (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                    key: `container-${item_21.id}`,
                    item: item_21,
                    nestedPopup: nestedPopup,
                    setNestedPopup: setNestedPopup,
                    contentId: contentId,
                    setIsMenuOpen: setIsMenuOpen
                });
            }
            return null;
        }).filter(Boolean);
        const itemsToRender = shouldShowClassification ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), {
                key: "classify-content"
            }),
            ...webItemsToRender
        ] : webItemsToRender;
        return itemsToRender.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
            hasSeparator: true
        }, itemsToRender) : null;
    };
    const renderFeedbackWebItems = (webItems_3)=>{
        // If additional WebItems are added to the feedback WebSection in the monolith,
        // follow the structure of renderModifyContentActionsWebItems to map items into a collective
        // DropdownItemGroup rather than an individual group
        return webItems_3.map((item_22)=>{
            if ($511857b10ace36ca$var$isWebItem(item_22)) {
                if (item_22?.id === $511857b10ace36ca$export$84c7eab054d974db && contentType && (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentType]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                    hasSeparator: true,
                    key: `container-${item_22.id}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                    to: [
                        (0, $kRW4Y.DialogsStateContainer)
                    ]
                }, (dialogs_18)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        key: item_22.id,
                        onClick: ()=>{
                            onFeedbackClick(dialogs_18, contentType);
                        }
                    }, item_22.label)));
            }
            return null;
        });
    };
    const renderActions = ({ webItems: webItems_4 })=>{
        const webItemsMap_3 = $511857b10ace36ca$var$createActionsMap(webItems_4);
        const customActionsToRender = moreActions?.items?.flat() ?? [];
        const customActionsMap_5 = $511857b10ace36ca$var$createActionsMap(customActionsToRender);
        const [, , , feedbackCustomActions] = moreActions?.items ?? [];
        const actionGroupsToRender = [];
        const primaryActionGroup = primaryActionData({
            webItemsMap: webItemsMap_3,
            customActionsMap: customActionsMap_5
        });
        if (primaryActionGroup.items.length > 0) actionGroupsToRender.push(primaryActionGroup);
        const editorActionGroup = editorActionData();
        if (editorActionGroup.items.length > 0) actionGroupsToRender.push(editorActionGroup);
        if ((0, $9wGTI.fg)('databases-frontend-content-wrapper')) {
            const databaseActionGroup = databaseActionData({
                customActionsMap: customActionsMap_5
            });
            if (databaseActionGroup.items.length > 0) actionGroupsToRender.push(databaseActionGroup);
        }
        const secondaryActionGroup = secondaryActionData({
            webItemsMap: webItemsMap_3,
            customActionsMap: customActionsMap_5,
            webItems: webItems_4
        });
        if (secondaryActionGroup.items.length > 0) actionGroupsToRender.push(secondaryActionGroup);
        const modifyActionGroup = modifyActionData({
            webItems: webItems_4,
            webItemsMap: webItemsMap_3,
            customActionsMap: customActionsMap_5
        });
        if (modifyActionGroup.items.length > 0) actionGroupsToRender.push(modifyActionGroup);
        const feedbackActionGroup = feedbackActionData({
            webItemsMap: webItemsMap_3,
            customActionsMap: customActionsMap_5,
            actions: feedbackCustomActions ?? []
        });
        if (feedbackActionGroup.items.length > 0) actionGroupsToRender.push(feedbackActionGroup);
         // only show for content that has a details panel
        const shouldRenderMissingActionsHint = isHintVisible && !isCompanyHub && contentType !== 'whiteboard' && contentType !== 'database';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $511857b10ace36ca$var$dropdownMenuContentStyles
        }, actionGroupsToRender.map((actionGroup, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
                hasSeparator: index > 0,
                key: actionGroup.key
            }, actionGroup.items.map((item_23)=>item_23.component()))), shouldRenderMissingActionsHint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4af5663ac404949d$export$b0ffdc20cd96b8d0), {
            setIsMenuOpen: setIsMenuOpen
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.CONTENT_OVERFLOW_MENU),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    })), isPresentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !isLivePage ? (0, $gnkil.PRESENTATION_MODE_SHORTCUT) : undefined,
        accelerator: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT),
        listener: ()=>{
            if (!isWebItemsQueryCalled) preloadWebItems();
            setIsShortcutTriggered(true);
        }
    }), shouldRenderStarContentMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85cfaddd6945fc1f$export$2846eba8e457bfb), {
        contentId: contentId,
        contentTitle: contentData?.title || '',
        contentMode: contentMode,
        contentType: contentType
    }), shouldRenderStarSpaceMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6d97f54b872b96e$export$385015a3c6790101), {
        spaceKey: spaceKey,
        contentMode: contentMode
    }), (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c06b6cca0a728bb0$export$154e7cde95b8409b), {
        contentId: contentId,
        contentType: contentType,
        openWatchSettingsMenu: ()=>{
            if (!isMenuOpen) setIsMenuOpen(true);
            setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs_19)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: contentMode === 'view' || contentMode === 'live' && livePageMode === 'view' ? (0, $gnkil.LINK_TO_THIS_PAGE_SHORTCUT) : undefined,
            accelerator: (0, $gnkil.UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT),
            listener: openLinkToThisPageDialog(dialogs_19)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b742140c6b014561$export$fcc1c0135b5761c6), {
            spaceKey: spaceKey,
            contentId: contentId,
            onLoadComplete: ()=>{},
            isDropdownMenuOpen: isMenuOpen,
            dialogs: dialogs_19,
            lazyLoaderPlaceholderComponent: ""
        }, (forgeMenuItems)=>forgeMenuItems.length > 0 && forgeMenuItems.map((forgeMenuItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: forgeMenuItem?.props?.extension?.id,
                    module: forgeMenuItem?.props?.extension,
                    action: ()=>{
                        (0, $4GDP8.openForgeAppFromSubmenu)({
                            parentmenuId: '#more-actions-trigger',
                            submenuId: "[data-testid='third-party-button']",
                            forgeItemId: forgeMenuItem?.props?.extension?.id
                        });
                    }
                }))))), !isModernEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $511857b10ace36ca$var$dropdownMenuContainerStyles
        ],
        onMouseEnter: preloadWebItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        isOpen: isMenuOpen,
        onOpenChange: handleOpenChange,
        trigger: (triggerProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownMenuTrigger, {
                triggerProps: triggerProps_0
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
        "data-testid": "web-actions-test",
        contentId: contentId,
        location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
        fetchPolicy: "cache-and-network",
        renderWhenLoading: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    }, ({ webItems: webItems_5 })=>{
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            if (loading || !webItems_5 || webItems_5.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownMenuContentSkeleton, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).MORE_ACTIONS_ITEMS
            }, renderActions({
                webItems: webItems_5
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, activeSpotlight));
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.025"
        }, renderModifyContentActionsWebItems(webItems_5), renderPrimaryContentActionsWebItems(webItems_5), renderFeedbackWebItems(webItems_5), renderMoreActions());
    }))), isCopyContentModalOpen && renderCopyContentModal(), isMoveContentModalOpen && renderMoveContentModal());
};
const $511857b10ace36ca$var$DropdownMenuTrigger = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { triggerProps: triggerProps } = t0;
    let props;
    let triggerRef;
    if ($[0] !== triggerProps) {
        ({ triggerRef: triggerRef, ...props } = triggerProps);
        $[0] = triggerProps;
        $[1] = props;
        $[2] = triggerRef;
    } else {
        props = $[1];
        triggerRef = $[2];
    }
    const buttonRef = (0, $42omo.useRef)(null);
    const intl = (0, $8C5kA.default)();
    const { isPresenterModeActive: isPresenterModeActive, hasEnteredPresentMode: hasEnteredPresentMode } = (0, $5KL6w.usePresenterModeContext)();
    const [t1] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t1;
    let t2;
    if ($[3] !== isCollabOffline) {
        t2 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[3] = isCollabOffline;
        $[4] = t2;
    } else t2 = $[4];
    const isNetworkDisabled = t2;
    let t3;
    let t4;
    if ($[5] !== hasEnteredPresentMode || $[6] !== isPresenterModeActive) {
        t3 = ()=>{
            if (!isPresenterModeActive && hasEnteredPresentMode && buttonRef?.current) buttonRef.current?.focus();
        };
        t4 = [
            isPresenterModeActive,
            hasEnteredPresentMode
        ];
        $[5] = hasEnteredPresentMode;
        $[6] = isPresenterModeActive;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.triggerLabel);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== intl) {
        t6 = intl.formatMessage($511857b10ace36ca$var$i18n.triggerLabel);
        $[10] = intl;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== triggerRef) {
        t7 = (0, $4rwCt.mergeRefs)([
            triggerRef,
            buttonRef
        ]);
        $[12] = triggerRef;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== isNetworkDisabled || $[15] !== props || $[16] !== t6 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $511857b10ace36ca$var$dropdownTriggerBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "bottom",
            content: t5
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...props,
            label: t6,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
            ref: t7,
            appearance: "subtle",
            id: "more-actions-trigger",
            interactionName: "more-actions-overflow-menu",
            isDisabled: isNetworkDisabled
        })));
        $[14] = isNetworkDisabled;
        $[15] = props;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ triggerProps: triggerProps })=>{
    const { triggerRef: triggerRef, ...props } = triggerProps;
    const buttonRef = (0, $42omo.useRef)(null);
    const intl = (0, $8C5kA.default)();
    const { isPresenterModeActive: isPresenterModeActive, hasEnteredPresentMode: hasEnteredPresentMode } = (0, $5KL6w.usePresenterModeContext)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    (0, $42omo.useEffect)(()=>{
        // Only shift the focus back to "More actions" once the user has entered the present mode
        if (!isPresenterModeActive && hasEnteredPresentMode && buttonRef?.current) buttonRef.current?.focus();
    }, [
        isPresenterModeActive,
        hasEnteredPresentMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $511857b10ace36ca$var$dropdownTriggerBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "bottom",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $511857b10ace36ca$var$i18n.triggerLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        ...props,
        label: intl.formatMessage($511857b10ace36ca$var$i18n.triggerLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
        ref: (0, $4rwCt.mergeRefs)([
            triggerRef,
            buttonRef
        ]),
        appearance: "subtle",
        id: "more-actions-trigger",
        interactionName: "more-actions-overflow-menu",
        isDisabled: isNetworkDisabled
    })));
};
const $511857b10ace36ca$var$DropdownMenuContentSkeleton = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "more-actions-overflow-menu-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "more-actions-overflow-menu-hold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null));
const $511857b10ace36ca$var$DropdownItemSkeleton = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            isShimmering: true,
            borderRadius: 0,
            width: 200,
            height: 20
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        borderRadius: 0,
        width: 200,
        height: 20
    }));
function $511857b10ace36ca$var$_temp(section) {
    return section?.items?.length && section?.items[0]?.id === $511857b10ace36ca$export$240b6ef4a1c531f6;
}
function $511857b10ace36ca$var$_temp2(subItem) {
    const { id: innerId, url: innerUrl, target: innerTarget, onClick: innerOnClick, shortcutText: innerShortcutText, text: innerText } = subItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: innerId,
        href: innerUrl,
        target: innerTarget,
        onClick: innerOnClick,
        elemAfter: innerShortcutText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$KeyboardShortcutIcon, null, innerShortcutText) : undefined
    }, innerText);
}
function $511857b10ace36ca$var$_temp3(dialogs_4, contentTypeForFeedback) {
    dialogs_4.showModal((0, $dcvq8.GlobalFeedbackCollector), {
        feedbackSource: (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentTypeForFeedback],
        showTypeField: true,
        contentType: contentTypeForFeedback
    });
}
function $511857b10ace36ca$var$_temp4(item_2) {
    return item_2.shouldRender;
}
function $511857b10ace36ca$var$_temp5(item_6) {
    return item_6.shouldRender;
}
function $511857b10ace36ca$var$_temp6(itemProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
        ...itemProps,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            label: ""
        })
    });
}
function $511857b10ace36ca$var$_temp7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), {
        key: "classify-content",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
            label: ""
        })
    });
}
function $511857b10ace36ca$var$_temp8(item_14) {
    return item_14.shouldRender;
}
function $511857b10ace36ca$var$_temp9(item_15) {
    return item_15.shouldRender;
}
function $511857b10ace36ca$var$_temp0(item_16) {
    return item_16.shouldRender;
}
function $511857b10ace36ca$var$_temp1(action_0) {
    return {
        ...action_0,
        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                item: action_0,
                key: action_0.id
            })
    };
}
function $511857b10ace36ca$var$_temp10(item_19) {
    return item_19.shouldRender;
}
function $511857b10ace36ca$var$_temp11(item_23) {
    return item_23.component();
}
function $511857b10ace36ca$var$_temp12(actionGroup, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: index > 0,
        key: actionGroup.key
    }, actionGroup.items.map($511857b10ace36ca$var$_temp11));
}
function $511857b10ace36ca$var$_temp13() {}
function $511857b10ace36ca$var$_temp14(forgeMenuItem) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
        key: forgeMenuItem?.props?.extension?.id,
        module: forgeMenuItem?.props?.extension,
        action: ()=>{
            (0, $4GDP8.openForgeAppFromSubmenu)({
                parentmenuId: "#more-actions-trigger",
                submenuId: "[data-testid='third-party-button']",
                forgeItemId: forgeMenuItem?.props?.extension?.id
            });
        }
    });
}
function $511857b10ace36ca$var$_temp15(forgeMenuItems) {
    return forgeMenuItems.length > 0 && forgeMenuItems.map($511857b10ace36ca$var$_temp14);
}
function $511857b10ace36ca$var$_temp16(triggerProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($511857b10ace36ca$var$DropdownMenuTrigger, {
        triggerProps: triggerProps_0
    });
}



var $9xWyx = parcelRequire("9xWyx");











var $5mJom = parcelRequire("5mJom");

const $6967e8de26962a4d$export$99c2b779aa4e8b8b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { collaborators: collaborators, contentId: contentId, contentType: contentType, contentMode: contentMode, isViewMode: isViewMode } = t0;
    const t1 = contentMode === "view" ? "viewPageScreen" : "editPageScreen";
    let t2;
    if ($[0] !== collaborators || $[1] !== contentId || $[2] !== contentType || $[3] !== isViewMode || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5mJom.ContentHeaderPresenceLoader), {
            collaborators: collaborators,
            contentId: contentId,
            contentType: contentType,
            isViewMode: isViewMode,
            analyticSource: t1
        });
        $[0] = collaborators;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = isViewMode;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ collaborators: collaborators, contentId: contentId, contentType: contentType, contentMode: contentMode, isViewMode: isViewMode })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5mJom.ContentHeaderPresenceLoader), {
        collaborators: collaborators,
        contentId: contentId,
        contentType: contentType,
        isViewMode: isViewMode,
        analyticSource: contentMode === 'view' ? 'viewPageScreen' : 'editPageScreen'
    });
};








/**
 * @generated SignedSource<<c753ecb337a1d1138dbceafd7e7f672c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $826269c7e8f31d2c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EditorCloseButtonGetDraftParentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ],
        "type": "Content"
    };
}();
$826269c7e8f31d2c$var$node.hash = "2b05313527c3eb54a3e1e06657506abb";
var $826269c7e8f31d2c$export$2e2bcd8739ae039 = $826269c7e8f31d2c$var$node;




















var $hYoU4 = parcelRequire("hYoU4");


var $5M5fB = parcelRequire("5M5fB");


var $1ch0f = parcelRequire("1ch0f");


var $2unW6 = parcelRequire("2unW6");


var $lu0E4 = parcelRequire("lu0E4");


var $5rEAe = parcelRequire("5rEAe");


var $3mmDo = parcelRequire("3mmDo");


var $atF9V = parcelRequire("atF9V");


var $lHzSp = parcelRequire("lHzSp");





var $5cryL = parcelRequire("5cryL");





var $jacyh = parcelRequire("jacyh");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $ecUYt = parcelRequire("ecUYt");


var $fFmJj = parcelRequire("fFmJj");




const $1d832c644d7a0658$var$i18n = (0, $cgtv4.defineMessages)({
    closeButtonText: {
        id: "content-types-header.close.name",
        defaultMessage: "Close"
    },
    closeButtonPublishTooltip: {
        id: "content-types-header.editor.close.publish.tooltip",
        defaultMessage: "Saves changes without publishing"
    },
    closeButtonUpdateTooltip: {
        id: "content-types-header.editor.close.update.tooltip",
        defaultMessage: "Saves changes without updating"
    },
    discardOnCloseButtonTooltip: {
        id: "content-types-header.editor.discard.close.tooltip",
        defaultMessage: "Discard empty draft"
    }
});
const $1d832c644d7a0658$export$f7109619a5e9e0d6 = 'next-FullPageEditorComponent';
const $1d832c644d7a0658$export$f64ffceb1bd6299f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { contentType: contentType, contentId: contentId, spaceKey: spaceKey, pageTreeStateUpdater: pageTreeStateUpdater, areMainButtonsDisabled: t1, isUnpublishedDraft: t2 } = t0;
    const areMainButtonsDisabled = t1 === undefined ? false : t1;
    const isUnpublishedDraft = t2 === undefined ? false : t2;
    const intl = (0, $8C5kA.default)();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { saveDraft: saveDraft, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, version: version, editorActions: editorActions, title: title } = (0, $3o3i5.useEditorObjectHeaderContext)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fragmentSpec: (0, $826269c7e8f31d2c$export$2e2bcd8739ae039)
        };
        $[0] = t3;
    } else t3 = $[0];
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)(t3);
    const [t4] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t4;
    const { isSingleUserSession: isSingleUserSession } = (0, $5M5fB.usePresence)(collabEditProvider);
    const { hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const hasTitle = Boolean(title);
    let t5;
    if ($[1] !== editorActions) {
        t5 = editorActions.isDocumentEmpty();
        $[1] = editorActions;
        $[2] = t5;
    } else t5 = $[2];
    const hasBody = !t5;
    let t6;
    if ($[3] !== hasBody || $[4] !== hasContentState || $[5] !== hasCoverPicture || $[6] !== hasEmoji || $[7] !== hasLabels || $[8] !== hasRestrictions || $[9] !== hasTitle || $[10] !== isSingleUserSession || $[11] !== isUnpublishedDraft) {
        t6 = {
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        };
        $[3] = hasBody;
        $[4] = hasContentState;
        $[5] = hasCoverPicture;
        $[6] = hasEmoji;
        $[7] = hasLabels;
        $[8] = hasRestrictions;
        $[9] = hasTitle;
        $[10] = isSingleUserSession;
        $[11] = isUnpublishedDraft;
        $[12] = t6;
    } else t6 = $[12];
    const discardDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)(t6);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS));
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== version) {
        t8 = !(0, $9wGTI.fg)("cc_onboarding_experience") || version !== 1;
        $[14] = version;
        $[15] = t8;
    } else t8 = $[15];
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(t7, t8);
    let t9;
    if ($[16] !== onboardingStateData) {
        t9 = (0, $ivb8S.deserializeState)(onboardingStateData);
        $[16] = onboardingStateData;
        $[17] = t9;
    } else t9 = $[17];
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = t9;
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted;
    let t10;
    if ($[18] !== contentId || $[19] !== contentType || $[20] !== createAnalyticsEvent || $[21] !== discardDraftOnClose || $[22] !== forceRefetchBlogTree || $[23] !== navigateOnClose || $[24] !== pageTreeStateUpdater || $[25] !== readFragmentInterop || $[26] !== saveDraft || $[27] !== setOnboardingState || $[28] !== shouldShowRecentSpotlight || $[29] !== triggerAnalyticsEvent) {
        t10 = async ()=>{
            if (contentType === "page") (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
            if (shouldShowRecentSpotlight) setOnboardingState({
                key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
                value: "true"
            });
            if (discardDraftOnClose) {
                triggerAnalyticsEvent("close", {
                    discarded: true
                });
                (0, $1ch0f.deleteDraft)({
                    contentId: contentId,
                    deleteOnlyIfBlank: true
                }).then(async (t11)=>{
                    const { data: data } = t11;
                    if (contentType === "blogpost") forceRefetchBlogTree();
                    triggerAnalyticsEvent("draftDiscarded", {
                        wasDeleted: !!data?.deleteContent?.wasDeleted
                    });
                    const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                    if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                    else createAnalyticsEvent({
                        type: "sendOperationalEvent",
                        data: {
                            action: "notFound",
                            actionSubject: "discardedDraftParent",
                            objectType: contentType,
                            objectId: contentId
                        }
                    }).fire();
                });
                navigateOnClose({
                    isDiscarding: true
                });
            } else {
                triggerAnalyticsEvent("close");
                saveDraft({
                    isOnClose: true
                }).then(()=>navigateOnClose());
            }
        };
        $[18] = contentId;
        $[19] = contentType;
        $[20] = createAnalyticsEvent;
        $[21] = discardDraftOnClose;
        $[22] = forceRefetchBlogTree;
        $[23] = navigateOnClose;
        $[24] = pageTreeStateUpdater;
        $[25] = readFragmentInterop;
        $[26] = saveDraft;
        $[27] = setOnboardingState;
        $[28] = shouldShowRecentSpotlight;
        $[29] = triggerAnalyticsEvent;
        $[30] = t10;
    } else t10 = $[30];
    const onClose = t10;
    let t11;
    if ($[31] !== areMainButtonsDisabled || $[32] !== discardDraftOnClose || $[33] !== intl || $[34] !== isUnpublishedDraft) {
        t11 = ()=>{
            if (areMainButtonsDisabled) return;
            else {
                if (discardDraftOnClose) return intl.formatMessage($1d832c644d7a0658$var$i18n.discardOnCloseButtonTooltip);
                else {
                    if (isUnpublishedDraft) return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonPublishTooltip);
                    else return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonUpdateTooltip);
                }
            }
        };
        $[31] = areMainButtonsDisabled;
        $[32] = discardDraftOnClose;
        $[33] = intl;
        $[34] = isUnpublishedDraft;
        $[35] = t11;
    } else t11 = $[35];
    const getCloseButtonTooltip = t11;
    let t12;
    if ($[36] !== getCloseButtonTooltip) {
        t12 = getCloseButtonTooltip();
        $[36] = getCloseButtonTooltip;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== intl) {
        t13 = intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonText);
        $[38] = intl;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== areMainButtonsDisabled || $[41] !== onClose || $[42] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            id: "close-button",
            appearance: "subtle",
            onClick: onClose,
            isDisabled: areMainButtonsDisabled,
            testId: "close-button"
        }, t13);
        $[40] = areMainButtonsDisabled;
        $[41] = onClose;
        $[42] = t13;
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== t12 || $[45] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t12
        }, t14);
        $[44] = t12;
        $[45] = t14;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== contentId || $[48] !== contentType || $[49] !== isUnpublishedDraft || $[50] !== spaceKey || $[51] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lu0E4.PreloadButtonWrapper), {
            isPublish: false,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }, t15);
        $[47] = contentId;
        $[48] = contentType;
        $[49] = isUnpublishedDraft;
        $[50] = spaceKey;
        $[51] = t15;
        $[52] = t16;
    } else t16 = $[52];
    let t17;
    if ($[53] !== emojiCoverPictureAndContentStateSubscription || $[54] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, emojiCoverPictureAndContentStateSubscription, t16);
        $[53] = emojiCoverPictureAndContentStateSubscription;
        $[54] = t16;
        $[55] = t17;
    } else t17 = $[55];
    return t17;
} : ({ contentType: contentType, contentId: contentId, spaceKey: spaceKey, pageTreeStateUpdater: pageTreeStateUpdater, areMainButtonsDisabled: areMainButtonsDisabled = false, isUnpublishedDraft: isUnpublishedDraft = false })=>{
    const intl = (0, $8C5kA.default)();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { saveDraft: saveDraft, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, version: version, editorActions: editorActions, title: title } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $826269c7e8f31d2c$export$2e2bcd8739ae039)
    });
    // START: discardDraftOnClose logic
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const { isSingleUserSession: isSingleUserSession } = (0, $5M5fB.usePresence)(collabEditProvider);
    const { hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const hasTitle = Boolean(title);
    const hasBody = !editorActions.isDocumentEmpty();
    const discardDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)({
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    });
    // END: discardDraftOnClose logic
    // START: Recent Spotlight logic
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), !(0, $9wGTI.fg)('cc_onboarding_experience') || version !== 1);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted; // Makes sure recentSpotlightCompleted is not undefined
    // END: Recent Spotlight logic
    const onClose = async ()=>{
        if (contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
        if (shouldShowRecentSpotlight) setOnboardingState({
            key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
            value: 'true'
        });
        if (discardDraftOnClose) {
            triggerAnalyticsEvent('close', {
                discarded: true
            });
            (0, $1ch0f.deleteDraft)({
                contentId: contentId,
                deleteOnlyIfBlank: true
            }).then(async ({ data: data })=>{
                if (contentType === 'blogpost') // refreshes blog tree on discard close of blog draft
                forceRefetchBlogTree();
                triggerAnalyticsEvent('draftDiscarded', {
                    wasDeleted: !!data?.deleteContent?.wasDeleted
                });
                const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'notFound',
                        actionSubject: 'discardedDraftParent',
                        objectType: contentType,
                        objectId: contentId
                    }
                }).fire();
            });
            navigateOnClose({
                isDiscarding: true
            });
        } else {
            triggerAnalyticsEvent('close');
            saveDraft({
                isOnClose: true
            }).then(()=>navigateOnClose());
        }
    };
    const getCloseButtonTooltip = ()=>{
        if (areMainButtonsDisabled) return undefined;
        else if (discardDraftOnClose) return intl.formatMessage($1d832c644d7a0658$var$i18n.discardOnCloseButtonTooltip);
        else if (isUnpublishedDraft) return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonPublishTooltip);
        else return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonUpdateTooltip);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, emojiCoverPictureAndContentStateSubscription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lu0E4.PreloadButtonWrapper), {
        isPublish: false,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: getCloseButtonTooltip()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "close-button",
        appearance: "subtle",
        onClick: onClose,
        isDisabled: areMainButtonsDisabled,
        testId: "close-button"
    }, intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonText)))));
};
const $1d832c644d7a0658$export$e392907f0931982f = (0, $ecUYt.withPageTreeStateUpdater)($1d832c644d7a0658$export$f64ffceb1bd6299f);




























var $iXzFq = parcelRequire("iXzFq");


var $3oZ9l = parcelRequire("3oZ9l");



















var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");








var $jSnXV = parcelRequire("jSnXV");












var $6qdjm = parcelRequire("6qdjm");








var $jlIaF = parcelRequire("jlIaF");


var $8lYIw = parcelRequire("8lYIw");





var $kDhla = parcelRequire("kDhla");




















var $e4o8D = parcelRequire("e4o8D");













const $f294e68c8b2b1e6c$var$i18n = (0, $cgtv4.defineMessages)({
    saved: {
        id: "content-types-header.last-edited.saved",
        defaultMessage: "Saved"
    },
    shortJustNow: {
        id: "content-types-header.last-edited.shortJustNow",
        defaultMessage: "just now"
    },
    shortXMinutesAgo: {
        id: "content-types-header.last-edited.shortXMinutesAgo",
        defaultMessage: "{timeAgo}m ago"
    },
    shortXHoursAgo: {
        id: "content-types-header.last-edited.shortXHoursAgo",
        defaultMessage: "{timeAgo}h ago"
    },
    shortXDaysAgo: {
        id: "content-types-header.last-edited.shortXDaysAgo",
        defaultMessage: "{timeAgo}d ago"
    },
    tooltipFullDate: {
        id: "content-types-header.last-edited.tooltipFullDate",
        defaultMessage: "{date} at {time}"
    },
    tooltipDate: {
        id: "content-types-header.last-edited.tooltipDate",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{date}"
    },
    edited: {
        id: "content-types-header.last-edited.edited",
        defaultMessage: "Edited {timestamp}"
    },
    published: {
        id: "content-types-header.last-edited.published",
        defaultMessage: "Published {timestamp}"
    },
    updated: {
        id: "content-types-header.last-edited.updated",
        defaultMessage: "Updated {timestamp}"
    },
    editedOn: {
        id: "content-types-header.last-edited.editedOn",
        defaultMessage: "Edited by {contributor} on {timestamp}"
    },
    publishedOn: {
        id: "content-types-header.last-edited.publishedOn",
        defaultMessage: "Published by {contributor} on {timestamp}"
    },
    updatedOn: {
        id: "content-types-header.last-edited.updatedOn",
        defaultMessage: "Updated by {contributor} on {timestamp}"
    }
});
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_SECONDS = 1000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES = 60000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR = 3600000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_DAY = 86400000;
/**
 * Formats full server date in shortened form ('MMM DD') if in the same calendar year, otherwise uses long form ('MMM DD, YYYY)
 */ const $f294e68c8b2b1e6c$var$formatfriendlyWhen = (friendlyWhen)=>{
    const now = new Date();
    const currentYear = now.getUTCFullYear();
    if (friendlyWhen.includes(currentYear.toString())) {
        // We expect that full server date (version.friendlyWhen) is of the format 'MMM DD, YYYY' (Jan 01, 2025) format for US_en
        // If it is not in this format depending on localization, we take the entire date
        const splitDate = friendlyWhen.split(',');
        return splitDate.length === 2 ? splitDate[0] : friendlyWhen;
    }
    return friendlyWhen;
};
const $f294e68c8b2b1e6c$export$f87e4558f7028ac3 = (lastEditedTime, friendlyWhen, isEditMode, formatMessage, renderServerPlaceholder)=>{
    let headerTimestamp;
    const timeNow = new Date();
    let currentTimestamp;
    if (renderServerPlaceholder && window.__SSR_CURRENT_DATE__) currentTimestamp = window.__SSR_CURRENT_DATE__;
    else currentTimestamp = timeNow.getTime();
    const timeDifference = currentTimestamp - lastEditedTime.getTime();
    let isSavedIndicator = false;
    if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_SECONDS < 60) {
        if (isEditMode) {
            headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.saved);
            isSavedIndicator = true;
        } else headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortJustNow);
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES < 60) {
        const minutes = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXMinutesAgo, {
            timeAgo: minutes
        });
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 24) {
        const hours = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXHoursAgo, {
            timeAgo: hours
        });
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 48) {
        const days = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_DAY);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXDaysAgo, {
            timeAgo: days
        });
    } else // After 48 hours, include date in format MMM DD (shortened month 'Jan', for US_en) from server
    headerTimestamp = $f294e68c8b2b1e6c$var$formatfriendlyWhen(friendlyWhen);
    return {
        headerTimestamp: headerTimestamp,
        isSavedIndicator: isSavedIndicator
    };
};
const $f294e68c8b2b1e6c$export$442a454d04f6993d = (lastEditedTime, friendlyWhen, formatMessage, formatTime, formatDate, timeZone, renderServerPlaceholder)=>{
    let tooltipTimestamp;
    const timeNow = new Date();
    let currentTimestamp;
    if (renderServerPlaceholder && window.__SSR_CURRENT_DATE__) currentTimestamp = window.__SSR_CURRENT_DATE__;
    else currentTimestamp = timeNow.getTime();
    const timeDifference = currentTimestamp - lastEditedTime.getTime();
    // Format client timestamp for use when < 48 hours in the past
    const monthAndDay = formatDate(lastEditedTime, {
        month: 'short',
        day: 'numeric',
        timeZone: timeZone
    });
    const formattedTime = formatTime(lastEditedTime, {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timeZone
    });
    if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 48) tooltipTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.tooltipFullDate, {
        date: monthAndDay,
        time: formattedTime
    });
    else // Use server friendlyWhen here because we want it to match the header timestamp
    tooltipTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.tooltipDate, {
        date: friendlyWhen
    });
    return tooltipTimestamp;
};
const $f294e68c8b2b1e6c$var$focusBorderStyles = (0, $ecnYn.xcss)({
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineWidth: '2px',
        outlineColor: 'color.border.focused',
        outlineOffset: 'space.025'
    }
});
const $f294e68c8b2b1e6c$export$736471da038a469 = ({ localizedHeaderTimestamp: localizedHeaderTimestamp, isSavedIndicator: isSavedIndicator, hasVersionHistory: hasVersionHistory, isPageOrBlog: isPageOrBlog, isEditMode: isEditMode, versionNumber: versionNumber, createChangeLink: createChangeLink, formatMessage: formatMessage })=>{
    if (isSavedIndicator) return hasVersionHistory ? createChangeLink(localizedHeaderTimestamp) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        tabIndex: 0,
        role: "tooltip",
        xcss: $f294e68c8b2b1e6c$var$focusBorderStyles
    }, localizedHeaderTimestamp);
    let headerMessage;
    if (isPageOrBlog) {
        let formattedTimestamp;
        if (isEditMode) formattedTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.edited, {
            timestamp: localizedHeaderTimestamp
        });
        else formattedTimestamp = versionNumber > 1 ? formatMessage($f294e68c8b2b1e6c$var$i18n.updated, {
            timestamp: localizedHeaderTimestamp
        }) : formatMessage($f294e68c8b2b1e6c$var$i18n.published, {
            timestamp: localizedHeaderTimestamp
        });
        headerMessage = hasVersionHistory ? createChangeLink(formattedTimestamp) : formattedTimestamp;
    } else {
        const formattedTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.edited, {
            timestamp: localizedHeaderTimestamp
        });
        headerMessage = hasVersionHistory ? createChangeLink(formattedTimestamp) : formattedTimestamp;
    }
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(headerMessage)) return headerMessage;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        tabIndex: 0,
        role: "tooltip",
        xcss: $f294e68c8b2b1e6c$var$focusBorderStyles
    }, headerMessage);
};
const $f294e68c8b2b1e6c$export$c5802041e21f264 = ({ localizedTooltipTimestamp: localizedTooltipTimestamp, isEditMode: isEditMode, isPageOrBlog: isPageOrBlog, versionNumber: versionNumber, fullName: fullName, formatMessage: formatMessage })=>{
    let tooltipMessage;
    if (isPageOrBlog) {
        if (isEditMode) tooltipMessage = formatMessage($f294e68c8b2b1e6c$var$i18n.editedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        });
        else tooltipMessage = versionNumber > 1 ? formatMessage($f294e68c8b2b1e6c$var$i18n.updatedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        }) : formatMessage($f294e68c8b2b1e6c$var$i18n.publishedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        });
    } else tooltipMessage = formatMessage($f294e68c8b2b1e6c$var$i18n.editedOn, {
        timestamp: localizedTooltipTimestamp,
        contributor: fullName
    });
    return tooltipMessage;
};


const $f00826a51c2021a6$var$lastEditedStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 'space.050',
    textWrap: 'nowrap'
});
const $f00826a51c2021a6$var$linkStyles = {
    color: "var(--ds-text-subtle, #505258)"
};
const $f00826a51c2021a6$var$disabledLinkStyles = {
    ...$f00826a51c2021a6$var$linkStyles,
    pointerEvents: 'none',
    cursor: 'default'
};
const $f00826a51c2021a6$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    ':hover': {
        textDecoration: 'underline'
    }
});
const $f00826a51c2021a6$export$2fd1e1faefc578c4 = ({ contentId: contentId, version: version, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey })=>{
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { formatMessage: formatMessage, formatTime: formatTime, formatDate: formatDate } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const contentIdRef = (0, $42omo.useRef)(contentId);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Debounce to avoid rapid calls and prevent performance lag
    const debouncedSetRecentVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            updateTimestampCache({
                contentId: contentIdRef.current // we need to use a ref for contentId so that the debounced timer doesn't reset every rerender
            });
        }, 3000), // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // intentionally do not add dependencies so that the debounce timer is not reset on every rerender
    );
    // Update time stamp to "Just now" on page edit and live page edit
    (0, $6qdjm.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    (0, $42omo.useEffect)(()=>{
        contentIdRef.current = contentId;
    }, [
        contentId
    ]);
    // Cancel any pending timers on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedSetRecentVersion
    ]);
    const fireOnClickAnalyticsEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'objectHeader',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lastEditedTimestamp',
                attributes: {
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        contentMode
    ]);
    const createEditorChangeLink = (formattedMessage)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isNetworkDisabled ? $f00826a51c2021a6$var$disabledLinkStyles : $f00826a51c2021a6$var$linkStyles,
            href: `${(0, $jlIaF.CONTEXT_PATH)}/spaces/${spaceKey}/history/${contentId}`,
            onClick: isNetworkDisabled ? undefined : fireOnClickAnalyticsEvent
        }, formattedMessage);
    };
    const handleContentTypesLinkClick = ()=>{
        showSidePanel();
        fireOnClickAnalyticsEvent();
    };
    const createContentTypesChangeLink = (formattedMessage)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $f00826a51c2021a6$var$pressableStyles,
            backgroundColor: "color.background.neutral.subtle",
            onClick: handleContentTypesLinkClick
        }, formattedMessage);
    };
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const lastEditedHeaderResult = (0, $42omo.useMemo)(()=>{
        const lastEditedTime = new Date(version.when);
        const isEditMode = !(contentMode === 'view' || contentMode === 'archived');
        const { headerTimestamp: headerTimestamp, isSavedIndicator: isSavedIndicator } = (0, $f294e68c8b2b1e6c$export$f87e4558f7028ac3)(lastEditedTime, version.friendlyWhen, isEditMode, formatMessage, renderServerPlaceholder);
        return {
            headerTimestamp: headerTimestamp,
            isSavedIndicator: isSavedIndicator
        };
    }, [
        version.when,
        version.friendlyWhen,
        contentMode,
        formatMessage,
        renderServerPlaceholder
    ]);
    const lastEditedTooltipResult = (0, $42omo.useMemo)(()=>{
        const lastEditedTime = new Date(version.when);
        return (0, $f294e68c8b2b1e6c$export$442a454d04f6993d)(lastEditedTime, version.friendlyWhen, formatMessage, formatTime, formatDate, timeZone, renderServerPlaceholder);
    }, [
        version.when,
        version.friendlyWhen,
        formatMessage,
        formatTime,
        formatDate,
        timeZone,
        renderServerPlaceholder
    ]);
    /**
   * Formats header timestamp as well as tooltip timestamp
   */ const formatTimestamps = ()=>{
        let headerMessage;
        let tooltipMessage;
        const isEditMode = !(contentMode === 'view' || contentMode === 'archived');
        const { headerTimestamp: headerTimestamp, isSavedIndicator: isSavedIndicator } = lastEditedHeaderResult;
        const tooltipTimestamp = lastEditedTooltipResult;
        const isPageOrBlog = contentType === 'page' || contentType === 'blogpost';
        if (isPageOrBlog) {
            const hasEditorVersionHistory = !!spaceKey && contentMode !== 'draft';
            headerMessage = (0, $f294e68c8b2b1e6c$export$736471da038a469)({
                localizedHeaderTimestamp: headerTimestamp,
                isSavedIndicator: isSavedIndicator,
                hasVersionHistory: hasEditorVersionHistory,
                isPageOrBlog: isPageOrBlog,
                isEditMode: isEditMode,
                versionNumber: version.number,
                createChangeLink: createEditorChangeLink,
                formatMessage: formatMessage
            });
            tooltipMessage = (0, $f294e68c8b2b1e6c$export$c5802041e21f264)({
                localizedTooltipTimestamp: tooltipTimestamp,
                isEditMode: isEditMode,
                isPageOrBlog: isPageOrBlog,
                versionNumber: version.number,
                fullName: version.by.fullName,
                formatMessage: formatMessage
            });
        } else if (contentType === 'whiteboard' || contentType === 'database') {
            const hasContentTypesVersionHistory = !version.contentTypeModified;
            headerMessage = (0, $f294e68c8b2b1e6c$export$736471da038a469)({
                localizedHeaderTimestamp: headerTimestamp,
                isSavedIndicator: isSavedIndicator,
                hasVersionHistory: hasContentTypesVersionHistory,
                isPageOrBlog: isPageOrBlog,
                isEditMode: isEditMode,
                versionNumber: version.number,
                createChangeLink: createContentTypesChangeLink,
                formatMessage: formatMessage
            });
            tooltipMessage = (0, $f294e68c8b2b1e6c$export$c5802041e21f264)({
                localizedTooltipTimestamp: tooltipTimestamp,
                isEditMode: isEditMode,
                isPageOrBlog: isPageOrBlog,
                versionNumber: version.number,
                fullName: version.by.fullName,
                formatMessage: formatMessage
            });
        } else {
            headerMessage = null;
            tooltipMessage = null;
        }
        return {
            headerMessage: headerMessage,
            tooltipMessage: tooltipMessage
        };
    };
    // Ensures that timestamp will only display when most accurate timestamp is available
    if (contentMode === 'edit' && !version.when) return null;
    const { headerMessage: formattedHeaderMessage, tooltipMessage: formattedTooltipMessage } = formatTimestamps();
    // Only show tooltip if header timestamp is not full format > 2 days
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $3oZ9l.LAST_UPDATED_SPOTLIGHT_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $f00826a51c2021a6$var$lastEditedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        component: (0, $778018eca844ead1$export$7574cd0e3a4be128),
        content: formattedTooltipMessage,
        delay: 0
    }, formattedHeaderMessage)));
};


const $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $71eaeeab7c35a8b6$var$unpublishedChangesLinkStyles = null; // this component is copied from content-header PageMetadataBanner.jsx to avoid circular dependency
const $71eaeeab7c35a8b6$export$87049fd2bc239211 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, version: version, hasEditPermission: hasEditPermission } = t0;
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] !== getQueryParams) {
        const queryParams = getQueryParams();
        t1 = (0, $c3Qwv.getSingleParamInt)(queryParams, "versionOverride", null);
        $[0] = getQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const versionOverride = t1;
    let t2;
    if ($[2] !== contentId || $[3] !== contentMode || $[4] !== contentType || $[5] !== hasEditPermission || $[6] !== spaceKey || $[7] !== version) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f00826a51c2021a6$export$2fd1e1faefc578c4), {
                contentId: contentId,
                version: version,
                contentType: contentType,
                contentMode: contentMode,
                spaceKey: spaceKey,
                hasEditPermission: hasEditPermission
            });
        $[2] = contentId;
        $[3] = contentMode;
        $[4] = contentType;
        $[5] = hasEditPermission;
        $[6] = spaceKey;
        $[7] = version;
        $[8] = t2;
    } else t2 = $[8];
    const renderLastEdited = t2;
    if (!(contentMode === "view" && (contentType === "page" || contentType === "blogpost"))) {
        let t3;
        if ($[9] !== renderLastEdited) {
            t3 = renderLastEdited();
            $[9] = renderLastEdited;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        });
        $[11] = t3;
    } else t3 = $[11];
    const t4 = versionOverride || undefined;
    let t5;
    if ($[12] !== contentId || $[13] !== contentType || $[14] !== hasEditPermission || $[15] !== renderLastEdited || $[16] !== spaceKey) {
        t5 = (t6)=>{
            const { webItems: webItems } = t6;
            let unpublishedChangesItem = null;
            const editUrl = (0, $iXzFq.getUrlForContentType)({
                contentType: contentType,
                contentId: contentId,
                spaceKey: spaceKey,
                redirectToEditor: true
            });
            if (webItems.some($71eaeeab7c35a8b6$var$_temp)) unpublishedChangesItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                name: (0, $3oZ9l.LAST_UPDATED_SPOTLIGHT_TARGET)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles
            }, hasEditPermission && editUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: editUrl,
                "data-testid": "unpublished-changes-edit-link",
                className: (0, $gMc0m.default)([
                    "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1rpy _10531rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
            }), unpublishedChangesItem || renderLastEdited());
        };
        $[12] = contentId;
        $[13] = contentType;
        $[14] = hasEditPermission;
        $[15] = renderLastEdited;
        $[16] = spaceKey;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== contentId || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            location: (0, $eSLr0.PAGE_METADATA_BANNER),
            contentId: contentId,
            version: t4
        }, t5));
        $[18] = contentId;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, version: version, hasEditPermission: hasEditPermission })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const versionOverride = (0, $c3Qwv.getSingleParamInt)(queryParams, 'versionOverride', null); // webitemlocation must use versionOverride, and not just version
    const renderLastEdited = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f00826a51c2021a6$export$2fd1e1faefc578c4), {
            contentId: contentId,
            version: version,
            contentType: contentType,
            contentMode: contentMode,
            spaceKey: spaceKey,
            hasEditPermission: hasEditPermission
        });
    }; // if not viewing page or blogpost, automatically return lastedited instead of unpublished changes.
    if (!(contentMode === 'view' && (contentType === 'page' || contentType === 'blogpost'))) return renderLastEdited();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
        tagName: "span",
        location: (0, $eSLr0.PAGE_METADATA_BANNER),
        contentId: contentId,
        version: versionOverride || undefined
    }, ({ webItems: webItems })=>{
        let unpublishedChangesItem = null;
        const editUrl = (0, $iXzFq.getUrlForContentType)({
            contentType: contentType,
            contentId: contentId,
            spaceKey: spaceKey,
            redirectToEditor: true
        });
        if (webItems.some((item)=>item.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID))) unpublishedChangesItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $3oZ9l.LAST_UPDATED_SPOTLIGHT_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles
        }, hasEditPermission && editUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: editUrl,
            "data-testid": "unpublished-changes-edit-link",
            className: (0, $gMc0m.default)([
                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1rpy _10531rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        }), unpublishedChangesItem || renderLastEdited());
    }));
};
const $71eaeeab7c35a8b6$var$i18n = (0, $cgtv4.defineMessages)({
    unpublishedChanges: {
        id: "content-types-header.object-header-items.unpublished-changes.link.text",
        defaultMessage: "Unpublished changes"
    }
});
function $71eaeeab7c35a8b6$var$_temp(item) {
    return item.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID);
}












var $gabmL = parcelRequire("gabmL");







const $85c7900526df4a2e$export$b0a1564bba9108e3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentId, contentMode)=>{
    const $ = (0, $frIzR.c)(16);
    const isEditorMode = contentMode === "draft" || contentMode === "edit" || contentMode === "live";
    const t0 = !isEditorMode;
    let t1;
    if ($[0] !== contentId || $[1] !== t0) {
        t1 = {
            pageId: contentId,
            fetchPolicy: "cache-and-network",
            skip: t0
        };
        $[0] = contentId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)(t1);
    let t2;
    let t3;
    if ($[3] !== isEditorMode || $[4] !== publicLinkData.errors) {
        t2 = ()=>{
            if (!isEditorMode) return;
            for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            isEditorMode,
            publicLinkData.errors
        ];
        $[3] = isEditorMode;
        $[4] = publicLinkData.errors;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $42omo.useEffect)(t2, t3);
    const { isPublishingContent: isPublishingContent, userOffline: userOffline, forceDisabled: forceDisabled, editorTitle: editorTitle, collabLimitReached: collabLimitReached } = (0, $3o3i5.useEditorObjectHeaderContext)();
    if (!isEditorMode) {
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                shouldDisableEditorButtons: false,
                isPublishDisabledForPublishModal: false,
                isPublishDisabled: false,
                pageIsExternallyShared: false
            };
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    const publicLinkDataIsLoading = publicLinkData.isLoading;
    const pageIsExternallyShared = !publicLinkData.isLoading && publicLinkData.isPublicLinkFullyEnabled;
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    const shouldDisableEditorButtons = shouldDisableActions || publicLinkDataIsLoading;
    let t4;
    if ($[8] !== editorTitle) {
        t4 = !editorTitle || !editorTitle.trim();
        $[8] = editorTitle;
        $[9] = t4;
    } else t4 = $[9];
    const isEditorTitleEmpty = t4;
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const isPublishDisabled = isEditorTitleEmpty || isPublishDisabledForPublishModal;
    let t5;
    if ($[10] !== isPublishDisabled || $[11] !== isPublishDisabledForPublishModal || $[12] !== pageIsExternallyShared || $[13] !== shouldDisableActions || $[14] !== shouldDisableEditorButtons) {
        t5 = {
            shouldDisableEditorButtons: shouldDisableEditorButtons,
            isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
            isPublishDisabled: isPublishDisabled,
            isCloseButtonDisabled: shouldDisableActions,
            pageIsExternallyShared: pageIsExternallyShared
        };
        $[10] = isPublishDisabled;
        $[11] = isPublishDisabledForPublishModal;
        $[12] = pageIsExternallyShared;
        $[13] = shouldDisableActions;
        $[14] = shouldDisableEditorButtons;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : (contentId, contentMode)=>{
    const isEditorMode = contentMode === 'draft' || contentMode === 'edit' || contentMode === 'live';
    // This is only used to disable the buttons in the editor
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)({
        pageId: contentId,
        fetchPolicy: 'cache-and-network',
        skip: !isEditorMode
    });
    // Data is not used so we don't worry about errors here
    (0, $42omo.useEffect)(()=>{
        if (!isEditorMode) return;
        for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        isEditorMode,
        publicLinkData.errors
    ]);
    const { isPublishingContent: isPublishingContent, userOffline: userOffline, forceDisabled: forceDisabled, editorTitle: editorTitle, collabLimitReached: collabLimitReached } = (0, $3o3i5.useEditorObjectHeaderContext)();
    if (!isEditorMode) return {
        shouldDisableEditorButtons: false,
        isPublishDisabledForPublishModal: false,
        isPublishDisabled: false,
        pageIsExternallyShared: false
    };
    const publicLinkDataIsLoading = publicLinkData.isLoading;
    const pageIsExternallyShared = !publicLinkData.isLoading && publicLinkData.isPublicLinkFullyEnabled;
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    // this check should be equivalent to areMainButtonsDisabled
    const shouldDisableEditorButtons = shouldDisableActions || publicLinkDataIsLoading;
    const isEditorTitleEmpty = !editorTitle || !editorTitle.trim();
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const isPublishDisabled = isEditorTitleEmpty || isPublishDisabledForPublishModal;
    return {
        shouldDisableEditorButtons: shouldDisableEditorButtons,
        isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
        isPublishDisabled: isPublishDisabled,
        isCloseButtonDisabled: shouldDisableActions,
        pageIsExternallyShared: pageIsExternallyShared
    };
};











const $0ecb1ba642d20f26$export$b5190710ae2f673b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentData: contentData, useDraftVersion: useDraftVersion } = t0;
    let t1;
    bb0: {
        if (useDraftVersion) {
            const t2 = contentData?.draftVersion?.contentTypeModified ?? false;
            const t3 = contentData?.draftVersion?.number ?? 1;
            const t4 = contentData?.draftVersion?.when ?? "";
            const t5 = contentData?.draftVersion?.friendlyWhen ?? "";
            const t6 = contentData?.draftVersion?.by?.displayName ?? "";
            let t7;
            if ($[0] !== t6) {
                t7 = {
                    fullName: t6
                };
                $[0] = t6;
                $[1] = t7;
            } else t7 = $[1];
            let t8;
            if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t7) {
                t8 = {
                    contentTypeModified: t2,
                    number: t3,
                    when: t4,
                    friendlyWhen: t5,
                    by: t7
                };
                $[2] = t2;
                $[3] = t3;
                $[4] = t4;
                $[5] = t5;
                $[6] = t7;
                $[7] = t8;
            } else t8 = $[7];
            t1 = t8;
            break bb0;
        }
        const t2 = contentData?.version?.contentTypeModified ?? false;
        const t3 = contentData?.version?.number ?? 1;
        const t4 = contentData?.version?.when ?? "";
        const t5 = contentData?.version?.friendlyWhen ?? "";
        const t6 = contentData?.version?.by?.displayName ?? "";
        let t7;
        if ($[8] !== t6) {
            t7 = {
                fullName: t6
            };
            $[8] = t6;
            $[9] = t7;
        } else t7 = $[9];
        let t8;
        if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
            t8 = {
                contentTypeModified: t2,
                number: t3,
                when: t4,
                friendlyWhen: t5,
                by: t7
            };
            $[10] = t2;
            $[11] = t3;
            $[12] = t4;
            $[13] = t5;
            $[14] = t7;
            $[15] = t8;
        } else t8 = $[15];
        t1 = t8;
    }
    const version = t1;
    return version;
} : ({ contentData: contentData, useDraftVersion: useDraftVersion })=>{
    const version = (0, $42omo.useMemo)(()=>{
        if (useDraftVersion) return {
            contentTypeModified: contentData?.draftVersion?.contentTypeModified ?? false,
            number: contentData?.draftVersion?.number ?? 1,
            when: contentData?.draftVersion?.when ?? '',
            friendlyWhen: contentData?.draftVersion?.friendlyWhen ?? '',
            by: {
                fullName: contentData?.draftVersion?.by?.displayName ?? ''
            }
        };
        return {
            contentTypeModified: contentData?.version?.contentTypeModified ?? false,
            number: contentData?.version?.number ?? 1,
            when: contentData?.version?.when ?? '',
            friendlyWhen: contentData?.version?.friendlyWhen ?? '',
            by: {
                fullName: contentData?.version?.by?.displayName ?? ''
            }
        };
    }, [
        contentData,
        useDraftVersion
    ]);
    return version;
};


























const $bd64585724dda192$export$4aac5356fb0022cd = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $eSUdr.default)`query useIsPrivacyModeEnabledQuery($cloudId:ID!){confluence_isPrivacyModeEnabled(cloudId:$cloudId){isPrivacyModeEnabled}}`;
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== edition) {
        t2 = !(0, $9wGTI.fg)("ccir_privacy_mode") || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || Boolean(undefined);
        $[3] = edition;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const { data: data, error: error } = (0, $xQxzY.useQuery)(t0, t3);
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
} : ()=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsPrivacyModeEnabledQuery($cloudId:ID!){confluence_isPrivacyModeEnabled(cloudId:$cloudId){isPrivacyModeEnabled}}`, {
        variables: {
            cloudId: cloudId
        },
        skip: !(0, $9wGTI.fg)('ccir_privacy_mode') || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined)
    });
    if (error) {
        // We dont care about the error, thus we handle it silently
        (0, $7Sm4c.markErrorAsHandled)(error);
        // Return true to avoid any privacy leakage.
        return true;
    }
    return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
};


'use no memo';
const $2c279a34b2a89086$export$2ed55bc7ce9c518 = ({ contentId: contentId, contentType: contentType, contentMode: contentMode, contentActions: contentActions, handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight, allowedFeatures: allowedFeatures, contentData: contentData, renderCopyLink: renderCopyLink, renderShare: renderShare, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, isSpaceOverviewPage: isSpaceOverviewPage, readOnly: readOnly, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage })=>{
    const isWatchDialogEnabledForContentType = (0, $3dPSK.useIsWatchDialogEnabled)(contentType);
    const isStarringEnabledForContentType = (0, $2cKGu.useIsStarringEnabled)(contentType, contentMode);
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { loomExternalOpenRoute: loomExternalOpenRoute } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { isPublishingContent: isPublishingContent, onClickPublish: onClickPublish, editorTitle: editorTitle, saveDraft: saveDraft, isUnpublishedDraft: isUnpublishedDraft, shouldRenderPreview: shouldRenderPreview, onPreviewClicked: onPreviewClicked, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, viewMode: viewMode, onHoverPublish: onHoverPublish } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { isPublishDisabledForPublishModal: isPublishDisabledForPublishModal, isPublishDisabled: isPublishDisabled, isCloseButtonDisabled: isCloseButtonDisabled } = (0, $85c7900526df4a2e$export$b0a1564bba9108e3)(contentId, contentMode);
    const isClassicEdit = (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'draft' || contentMode === 'edit');
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(contentData?.space?.key);
    const isClassificationEnabled = (0, $66bd5ba8343e39f0$export$48cea123122bbc52)(contentData?.type ?? '');
    const isArchived = contentData?.status === 'archived';
    const version = (0, $0ecb1ba642d20f26$export$b5190710ae2f673b)({
        contentData: contentData,
        useDraftVersion: isClassicEdit
    });
    const isPrivacyModeEnabled = (0, $bd64585724dda192$export$4aac5356fb0022cd)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const computedReadOnly = readOnly || isExternal || !contentData?.operations?.some((operation)=>operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === 'update');
    const isClassificationAllowedInMoreActions = !computedReadOnly && isClassificationEnabled;
    const moreActionsAllowedFeatures = isClassificationAllowedInMoreActions ? {
        ...allowedFeatures,
        showClassificationMenuAction: true
    } : allowedFeatures;
    const hasArchivePermission = contentData?.operations?.some((operation_0)=>{
        return operation_0?.targetType === contentType && operation_0?.operation === 'archive';
    });
    const renderLastEditedForDatabase = contentType === 'database' && (0, $9wGTI.fg)('databases-frontend-content-wrapper');
    const isPreviewPanelTestEnabled = (0, $4VJDS.default).getString('confluence_page_preview_panel_testing', '') !== '';
    const isCanvasPresenceEnabled = !isMobileApp && contentMode !== 'archived' && [
        'whiteboard',
        'database'
    ].includes(contentType);
    const isPagePresenceEnabled = [
        'page',
        'blogpost'
    ].includes(contentType) && contentMode !== 'archived';
    if (isVersionHistoryPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // don't show any header items or overflow items for version history page as they are irrelevant
    return [];
    if (isAttachmentsPage && (0, $6mKj3.expValEquals)('cc_attachments_page', 'isEnabled', true)) // don't show any header items or overflow items for attachments page as they are irrelevant
    return [];
    const currentUserHasEditPermission = contentData?.operations?.some((operation_1)=>{
        return operation_1?.targetType === contentType && operation_1?.operation === 'update';
    });
    return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
        {
            name: 'lastEdited',
            shouldShowSeparator: false,
            shouldRender: allowedFeatures.showLastEdited !== false && (renderLastEditedForDatabase || contentType !== 'embed' && contentType !== 'database' && !isSpaceOverviewPage),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71eaeeab7c35a8b6$export$87049fd2bc239211), {
                contentId: contentId,
                version: version,
                contentType: contentType,
                contentMode: contentMode,
                spaceKey: contentData?.space?.key ?? '',
                hasEditPermission: currentUserHasEditPermission ?? false
            }))
        },
        {
            name: 'aiAgentPresence',
            shouldShowSeparator: false,
            shouldRender: [
                'page',
                'blogpost'
            ].includes(contentType) && (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft'),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fc0e6c31b10b3145$export$ad537527a445740e), null)
        },
        {
            name: 'presence',
            shouldShowSeparator: isCompanyHub,
            shouldRender: allowedFeatures.showPresence !== false && (isPagePresenceEnabled || isCanvasPresenceEnabled) && !isPrivacyModeEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6967e8de26962a4d$export$99c2b779aa4e8b8b), {
                collaborators: contentActions?.collaborators,
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                isViewMode: viewMode
            })
        },
        {
            name: 'preview',
            shouldShowSeparator: false,
            shouldRender: isCompanyHub,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).COMPANY_HUB
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9vvQJ))),
                appearance: "subtle",
                label: "",
                onClick: onPreviewClicked
            }))
        },
        {
            name: 'mainActions',
            // this only handles showing external link for embed object header
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions && (0, $9wGTI.fg)('open_in_new_tab_button_update'),
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            })) : null
        },
        {
            name: 'editIcon',
            shouldShowSeparator: false,
            shouldRender: (contentType === 'page' || contentType === 'blogpost') && contentMode === 'view',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iAOfI.EditContentButton), {
                contentId: contentId
            }))
        },
        {
            name: 'previewPanelTest',
            shouldShowSeparator: false,
            shouldRender: isPreviewPanelTestEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0f9c0b3d7e5360a3$export$7c95b5e4cc9d3256), null)
        },
        {
            name: 'update',
            shouldShowSeparator: false,
            shouldRender: isClassicEdit,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jeQ9x.PublishButtonWithMoreOptions), {
                    onClickPublish: onClickPublish,
                    onHoverPublish: onHoverPublish,
                    publishButtonDisabled: isPublishDisabledForPublishModal ?? isPublishDisabled,
                    title: editorTitle,
                    onClickPreview: onPreviewClicked,
                    userViewingPreview: shouldRenderPreview,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    isUnpublishedDraft: isUnpublishedDraft,
                    flags: flags,
                    saveDraft: saveDraft,
                    contentType: contentType,
                    savingInProgress: isPublishingContent,
                    shouldShowWorldIcon: false,
                    shouldShowFooterButtons: true
                })))
        },
        {
            name: 'close',
            shouldShowSeparator: false,
            shouldRender: contentMode === 'draft' || contentMode === 'edit',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1d832c644d7a0658$export$e392907f0931982f), {
                contentType: contentType,
                contentId: contentId,
                spaceKey: contentData?.space?.key ?? '',
                areMainButtonsDisabled: !!isCloseButtonDisabled,
                isUnpublishedDraft: contentMode === 'draft'
            }))
        },
        {
            name: 'share',
            shouldShowSeparator: false,
            shouldRender: !isAnonymous && !isArchived && !!allowedFeatures.showShare && !isCompanyHub,
            children: renderShare()
        },
        {
            name: 'loomExternalOpen',
            shouldShowSeparator: false,
            shouldRender: (0, $9wGTI.fg)('mr2-meeting-recording-notes-confluence') && !!loomExternalOpenRoute,
            children: loomExternalOpenRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bjZbA.LoomExternalOpenButton), null) : null
        },
        {
            name: 'contentRestrictions',
            shouldShowSeparator: false,
            shouldRender: !isAnonymous && !!allowedFeatures.showContentRestrictions && isArchived,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextProvider), {
                contentId: contentId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogTriggerWrapper), {
                contentId: contentId,
                key: "restrictions-dialog-trigger",
                triggeredFrom: "fromContentType"
            })))
        },
        {
            name: 'copy',
            shouldShowSeparator: false,
            shouldRender: isArchived,
            children: renderCopyLink()
        },
        {
            name: 'moreActions',
            shouldShowSeparator: false,
            shouldRenderInContainer: false,
            shouldRender: !!allowedFeatures.showMoreActions,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $511857b10ace36ca$export$6e6eb6019781c337), {
                    moreActions: contentActions?.moreActions,
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    spaceKey: contentData?.space?.key ?? '',
                    allowedFeatures: moreActionsAllowedFeatures,
                    hasArchivePermission: hasArchivePermission,
                    handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
                    setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
                    showVersionHistorySpotlight: showVersionHistorySpotlight,
                    flags: flags_0,
                    contentData: contentData,
                    readOnly: computedReadOnly,
                    isConvertToFolderHighlighted: isConvertToFolderHighlighted,
                    setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted
                }))))
        }
    ] : [
        {
            name: 'status',
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.contentStatus,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5194c70d50ff0c56$export$437945b454cdf5e5), {
                contentStatus: contentActions?.contentStatus
            })
        },
        {
            name: 'presence',
            shouldShowSeparator: isCompanyHub,
            shouldRender: allowedFeatures.showPresence !== false && isCanvasPresenceEnabled && !isPrivacyModeEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6967e8de26962a4d$export$99c2b779aa4e8b8b), {
                collaborators: contentActions?.collaborators,
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                isViewMode: viewMode
            })
        },
        {
            name: 'mainActions',
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions && (0, $9wGTI.fg)('open_in_new_tab_button_update'),
            // For FG cleanup, remove this line and remove the second 'mainActions' item.
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            }) : null
        },
        {
            name: 'favourite',
            shouldShowSeparator: !isWatchDialogEnabledForContentType,
            shouldRender: isStarringEnabledForContentType && !!allowedFeatures.showFavourite,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxCWb.FavouriteButton), {
                contentId: contentId
            })
        },
        {
            name: 'watchDialog',
            shouldShowSeparator: true,
            shouldRender: isWatchDialogEnabledForContentType && !!allowedFeatures.showWatchDialog,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
                key: contentId,
                metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4c4ke.WatchDialog), {
                contentId: contentId,
                defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
                customTrigger: (0, $9xWyx.ContentTypesWatchDialogButtonLoader),
                useShortcut: true
            }))
        },
        {
            name: 'mainActions',
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions && !(0, $9wGTI.fg)('open_in_new_tab_button_update'),
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            }) : null
        },
        {
            name: 'contentRestrictions',
            shouldShowSeparator: isArchived,
            shouldRender: false,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextProvider), {
                contentId: contentId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.RestrictionsDialogTriggerWrapper), {
                contentId: contentId,
                key: "restrictions-dialog-trigger",
                triggeredFrom: "fromContentType"
            })))
        },
        {
            name: 'copy',
            shouldShowSeparator: false,
            shouldRender: isArchived,
            children: renderCopyLink()
        },
        {
            name: 'share',
            shouldShowSeparator: true,
            shouldRender: !isArchived && !!allowedFeatures.showShare,
            children: renderShare()
        },
        {
            name: 'loomExternalOpen',
            shouldShowSeparator: false,
            shouldRender: (0, $9wGTI.fg)('mr2-meeting-recording-notes-confluence') && !!loomExternalOpenRoute,
            children: loomExternalOpenRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bjZbA.LoomExternalOpenButton), null) : null
        },
        {
            name: 'moreActions',
            shouldShowSeparator: false,
            shouldRenderInContainer: false,
            shouldRender: !!allowedFeatures.showMoreActions,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $511857b10ace36ca$export$6e6eb6019781c337), {
                    moreActions: contentActions?.moreActions,
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: contentData?.space?.key ?? '',
                    allowedFeatures: moreActionsAllowedFeatures,
                    hasArchivePermission: hasArchivePermission,
                    handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
                    setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
                    showVersionHistorySpotlight: showVersionHistorySpotlight,
                    contentData: contentData,
                    flags: flags_1
                })))
        }
    ];
};

























var $5Vf1r = parcelRequire("5Vf1r");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $d8c6dd08bfe3a65f$var$getIsSideNavCollapsed = ()=>{
    const sideNavCollapsedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? 'expanded';
    return sideNavCollapsedValue === 'collapsed';
};
const $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentType: contentType, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isEditorToolbarShown: isEditorToolbarShown, isTitleFullyVisible: isTitleFullyVisible, isObjectSidebarShown: isObjectSidebarShown, contentId: contentId, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading } = t0;
    const hasMounted = (0, $42omo.useRef)(false);
    const shouldListenForTitleVisibilityChanges = (contentType === "blogpost" || contentType === "page") && !isSpaceOverviewPage && !isArchived && !isEditorToolbarShown && !isVersionHistoryPage && !isAttachmentsPage;
    let t1;
    if ($[0] !== contentTypesHeaderDataLoading || $[1] !== isAttachmentsPage || $[2] !== isEditorToolbarShown || $[3] !== isObjectSidebarShown || $[4] !== isSpaceOverviewPage || $[5] !== isTitleFullyVisible || $[6] !== isVersionHistoryPage || $[7] !== shouldListenForTitleVisibilityChanges) {
        t1 = ()=>{
            const toggleSpaceNameBreadcrumbListener = ()=>{
                const separator = document.getElementById("breadcrumbs-separator");
                const spaceName = document.getElementById("breadcrumbs-space-name");
                const chevron = document.getElementById("breadcrumbs-dropdown-chevron-button");
                const contentTitle = document.getElementById("breadcrumbs-content-title");
                const showOnlyContentTitle = ()=>{
                    separator?.setAttribute("style", "display: none;");
                    spaceName?.setAttribute("style", "display: none;");
                    chevron?.setAttribute("style", "display: block;");
                    if (contentTitle) {
                        contentTitle.style.opacity = "1";
                        contentTitle.style.maxWidth = "800px";
                    }
                };
                const showOnlySpaceName = ()=>{
                    separator?.setAttribute("style", "display: none;");
                    spaceName?.setAttribute("style", "display: inline;");
                    chevron?.setAttribute("style", "display: block;");
                    if (contentTitle) {
                        contentTitle.style.opacity = "0";
                        contentTitle.style.maxWidth = "0px";
                    }
                };
                const showFullBreadcrumbs = ()=>{
                    separator?.setAttribute("style", "display: inline;");
                    spaceName?.setAttribute("style", "display: inline;");
                    chevron?.setAttribute("style", "display: block;");
                    if (contentTitle) {
                        contentTitle.style.opacity = "1";
                        contentTitle.style.maxWidth = "800px";
                    }
                };
                const hideEntireBreadcrumbs = ()=>{
                    separator?.setAttribute("style", "display: none;");
                    spaceName?.setAttribute("style", "display: none;");
                    chevron?.setAttribute("style", "display: none;");
                    if (contentTitle) {
                        contentTitle.style.opacity = "0";
                        contentTitle.style.maxWidth = "0px";
                    }
                };
                if (!isEditorToolbarShown) {
                    if (contentTitle) contentTitle.style.transition = "opacity 100ms linear";
                }
                if (!isSpaceOverviewPage && !isVersionHistoryPage && !isAttachmentsPage) {
                    if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                        if (shouldListenForTitleVisibilityChanges) {
                            if (isTitleFullyVisible) showOnlySpaceName();
                            else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                            else showFullBreadcrumbs();
                        } else {
                            if (isEditorToolbarShown) showFullBreadcrumbs();
                            separator?.setAttribute("style", "display: inline;");
                            spaceName?.setAttribute("style", "display: inline;");
                        }
                    } else if (shouldListenForTitleVisibilityChanges) {
                        if (isTitleFullyVisible) {
                            if (isObjectSidebarShown) showOnlyContentTitle();
                            else hideEntireBreadcrumbs();
                        } else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                        else showOnlyContentTitle();
                    } else {
                        if (isEditorToolbarShown) showOnlyContentTitle();
                        separator?.setAttribute("style", "display: none;");
                        spaceName?.setAttribute("style", "display: none;");
                    }
                }
            };
            window.addEventListener("resize", toggleSpaceNameBreadcrumbListener);
            if (!hasMounted.current) hasMounted.current = true;
            else toggleSpaceNameBreadcrumbListener();
            return ()=>{
                window.removeEventListener("resize", toggleSpaceNameBreadcrumbListener);
            };
        };
        $[0] = contentTypesHeaderDataLoading;
        $[1] = isAttachmentsPage;
        $[2] = isEditorToolbarShown;
        $[3] = isObjectSidebarShown;
        $[4] = isSpaceOverviewPage;
        $[5] = isTitleFullyVisible;
        $[6] = isVersionHistoryPage;
        $[7] = shouldListenForTitleVisibilityChanges;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== contentId || $[10] !== contentTypesHeaderDataLoading || $[11] !== isAttachmentsPage || $[12] !== isEditorToolbarShown || $[13] !== isObjectSidebarShown || $[14] !== isSpaceOverviewPage || $[15] !== isTitleFullyVisible || $[16] !== isVersionHistoryPage || $[17] !== shouldListenForTitleVisibilityChanges) {
        t2 = [
            isObjectSidebarShown,
            shouldListenForTitleVisibilityChanges,
            isSpaceOverviewPage,
            isVersionHistoryPage,
            isAttachmentsPage,
            contentId,
            isTitleFullyVisible,
            isEditorToolbarShown,
            contentTypesHeaderDataLoading
        ];
        $[9] = contentId;
        $[10] = contentTypesHeaderDataLoading;
        $[11] = isAttachmentsPage;
        $[12] = isEditorToolbarShown;
        $[13] = isObjectSidebarShown;
        $[14] = isSpaceOverviewPage;
        $[15] = isTitleFullyVisible;
        $[16] = isVersionHistoryPage;
        $[17] = shouldListenForTitleVisibilityChanges;
        $[18] = t2;
    } else t2 = $[18];
    (0, $42omo.useEffect)(t1, t2);
    if (!isVersionHistoryPage && !isAttachmentsPage) {
        if ((contentType === "blogpost" || contentType === "page") && !isSpaceOverviewPage && !isArchived) {
            if (contentTypesHeaderDataLoading && !isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
            if (isEditorToolbarShown) {
                if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            } else if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                if (isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_SPACE_NAME;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            } else {
                if (isTitleFullyVisible) {
                    if (isObjectSidebarShown) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
                    return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
                } else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            }
        } else if (contentType === "database" || contentType === "whiteboard" || contentType === "embed") {
            if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
        }
    }
    return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
} : ({ contentType: contentType, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isEditorToolbarShown: isEditorToolbarShown, isTitleFullyVisible: isTitleFullyVisible, isObjectSidebarShown: isObjectSidebarShown, contentId: contentId, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading })=>{
    const hasMounted = (0, $42omo.useRef)(false);
    // only live pages, page, blogs, and editor (when toolbar is not shown) care about title visibility (when user scrolls past page title)
    // except for space overview and archived pages and version history
    const shouldListenForTitleVisibilityChanges = (contentType === 'blogpost' || contentType === 'page') && !isSpaceOverviewPage && !isArchived && !isEditorToolbarShown && !isVersionHistoryPage && !isAttachmentsPage;
    // this useEffect duplicates logic for FULL, ONLY_CONTENT_TITLE, ONLY_SPACE_NAME, and HIDDEN breadcrumbs
    // this is required because using react state to conditionally render parts of breadcrumbs is simply not fast enough and causes jumpiness in the breadcrumbs on side nav collapse/expand
    // AND we need to fine-tuned control over fade in of content title breadcrumbs
    (0, $42omo.useEffect)(()=>{
        const toggleSpaceNameBreadcrumbListener = ()=>{
            const separator = document.getElementById('breadcrumbs-separator');
            const spaceName = document.getElementById('breadcrumbs-space-name');
            const chevron = document.getElementById('breadcrumbs-dropdown-chevron-button');
            const contentTitle = document.getElementById('breadcrumbs-content-title');
            const showOnlyContentTitle = ()=>{
                separator?.setAttribute('style', 'display: none;');
                spaceName?.setAttribute('style', 'display: none;');
                chevron?.setAttribute('style', 'display: block;');
                if (contentTitle) {
                    contentTitle.style.opacity = '1';
                    contentTitle.style.maxWidth = '800px';
                }
            };
            const showOnlySpaceName = ()=>{
                separator?.setAttribute('style', 'display: none;');
                spaceName?.setAttribute('style', 'display: inline;');
                chevron?.setAttribute('style', 'display: block;');
                if (contentTitle) {
                    contentTitle.style.opacity = '0';
                    contentTitle.style.maxWidth = '0px';
                }
            };
            const showFullBreadcrumbs = ()=>{
                separator?.setAttribute('style', 'display: inline;');
                spaceName?.setAttribute('style', 'display: inline;');
                chevron?.setAttribute('style', 'display: block;');
                if (contentTitle) {
                    contentTitle.style.opacity = '1';
                    contentTitle.style.maxWidth = '800px';
                }
            };
            const hideEntireBreadcrumbs = ()=>{
                separator?.setAttribute('style', 'display: none;');
                spaceName?.setAttribute('style', 'display: none;');
                chevron?.setAttribute('style', 'display: none;');
                if (contentTitle) {
                    contentTitle.style.opacity = '0';
                    contentTitle.style.maxWidth = '0px';
                }
            };
            if (!isEditorToolbarShown) {
                if (contentTitle) contentTitle.style.transition = 'opacity 100ms linear';
            }
            // these are the only three places where we do not want to hide space name on collapse of side nav
            if (!isSpaceOverviewPage && !isVersionHistoryPage && !isAttachmentsPage) {
                if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                    if (shouldListenForTitleVisibilityChanges) {
                        if (isTitleFullyVisible) // SIDE NAV COLLAPSED + TITLE IS SHOWING = ONLY SPACE NAME
                        showOnlySpaceName();
                        else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                        else // SIDE NAV COLLAPSED + TITLE IS NOT SHOWING = FULL
                        showFullBreadcrumbs();
                    } else {
                        if (isEditorToolbarShown) // for when user swaps between contextual toolbar and docked toolbar
                        showFullBreadcrumbs();
                        // for all other cases that don't care about title visibility, simply show space name and separator
                        separator?.setAttribute('style', 'display: inline;');
                        spaceName?.setAttribute('style', 'display: inline;');
                    }
                } else if (shouldListenForTitleVisibilityChanges) {
                    if (isTitleFullyVisible) {
                        if (isObjectSidebarShown) // in the case where you are at the top of the page and the object sidebar is open, we should force show breadcrumbs and border so the sidebar isn't floating there by itself
                        showOnlyContentTitle();
                        else // SIDE NAV EXPANDED + TITLE IS SHOWING = NO BREADCRUMBS
                        hideEntireBreadcrumbs();
                    } else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                    else // SIDE NAV EXPANDED + TITLE IS COVERED = CONTENT TITLE ONLY
                    showOnlyContentTitle();
                } else {
                    if (isEditorToolbarShown) // for when user swaps between contextual toolbar and docked toolbar
                    showOnlyContentTitle();
                    // for all other cases that don't care about title visibility, simply hide space name and separator
                    separator?.setAttribute('style', 'display: none;');
                    spaceName?.setAttribute('style', 'display: none;');
                }
            }
        };
        window.addEventListener('resize', toggleSpaceNameBreadcrumbListener); // listen for side nav collapse and expand and other resize events
        if (!hasMounted.current) hasMounted.current = true;
        else // don't run this on initial render of SSRed page since it will become a ttvc offender
        toggleSpaceNameBreadcrumbListener();
        return ()=>{
            window.removeEventListener('resize', toggleSpaceNameBreadcrumbListener);
        };
    }, [
        isObjectSidebarShown,
        shouldListenForTitleVisibilityChanges,
        isSpaceOverviewPage,
        isVersionHistoryPage,
        isAttachmentsPage,
        contentId,
        isTitleFullyVisible,
        isEditorToolbarShown,
        contentTypesHeaderDataLoading
    ]);
    // NOTE: If you are changing any of the logic below for display modes, you will likely need to update the useEffect above to match accordingly.
    if (!isVersionHistoryPage && !isAttachmentsPage) {
        // all live pages, page, blogs, and editor except for space overview and archived pages
        if ((contentType === 'blogpost' || contentType === 'page') && !isSpaceOverviewPage && !isArchived) {
            if (contentTypesHeaderDataLoading && !isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
            if (isEditorToolbarShown) {
                // don't care about title visibility
                if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            } else // care about title visibility (aka view page or blogpost, live page view mode)
            if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                // SIDE NAV COLLAPSED + TITLE IS SHOWING = ONLY SPACE NAME
                if (isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_SPACE_NAME;
                else // SIDE NAV COLLAPSED + TITLE IS NOT SHOWING = FULL
                return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            } else {
                // SIDE NAV EXPANDED + TITLE IS SHOWING = NO BREADCRUMBS
                if (isTitleFullyVisible) {
                    if (isObjectSidebarShown) // in the case where you are at the top of the page and the object sidebar is open, we should force show breadcrumbs and border so the sidebar isn't floating there by itself
                    return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
                    return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
                } else // SIDE NAV EXPANDED + TITLE IS COVERED = CONTENT TITLE ONLY
                return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            }
        // all other content types
        } else if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'embed') {
            if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
        }
    }
    return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
};



var $lEVfb = parcelRequire("lEVfb");













const $9234e6aea1a8bf8e$export$3a542eb6901fb0e2 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { contentId: contentId, objectHeaderRef: objectHeaderRef, shouldUseProgressiveHeader: shouldUseProgressiveHeader } = t0;
    const [isIntersecting, setIsIntersecting] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== objectHeaderRef) {
        t1 = ()=>{
            if (objectHeaderRef?.current) {
                const title = document.getElementById("content-title-id") || document.getElementById("editor-title-id");
                if (title) {
                    const titleRect = title.getBoundingClientRect();
                    const headerRect = objectHeaderRef.current.getBoundingClientRect();
                    setIsIntersecting(titleRect.top < headerRect.bottom);
                }
            }
        };
        $[0] = objectHeaderRef;
        $[1] = t1;
    } else t1 = $[1];
    const checkIntersection = t1;
    let t2;
    if ($[2] !== checkIntersection || $[3] !== shouldUseProgressiveHeader) {
        t2 = ()=>{
            if (shouldUseProgressiveHeader) {
                if (!Boolean(window.__SSR_RENDERED__) || !(0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) checkIntersection();
                window.addEventListener("scroll", checkIntersection, true);
                window.addEventListener("resize", checkIntersection);
            }
            return ()=>{
                window.removeEventListener("scroll", checkIntersection, true);
                window.removeEventListener("resize", checkIntersection);
            };
        };
        $[2] = checkIntersection;
        $[3] = shouldUseProgressiveHeader;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== checkIntersection || $[6] !== contentId || $[7] !== objectHeaderRef || $[8] !== shouldUseProgressiveHeader) {
        t3 = [
            contentId,
            objectHeaderRef,
            checkIntersection,
            shouldUseProgressiveHeader
        ];
        $[5] = checkIntersection;
        $[6] = contentId;
        $[7] = objectHeaderRef;
        $[8] = shouldUseProgressiveHeader;
        $[9] = t3;
    } else t3 = $[9];
    (0, $42omo.useEffect)(t2, t3);
    return isIntersecting;
} : ({ contentId: contentId, objectHeaderRef: objectHeaderRef, shouldUseProgressiveHeader: shouldUseProgressiveHeader })=>{
    const [isIntersecting, setIsIntersecting] = (0, $42omo.useState)(false);
    const checkIntersection = (0, $42omo.useCallback)(()=>{
        if (objectHeaderRef?.current) {
            const title = document.getElementById('content-title-id') || document.getElementById('editor-title-id');
            if (title) {
                const titleRect = title.getBoundingClientRect();
                const headerRect = objectHeaderRef.current.getBoundingClientRect();
                setIsIntersecting(titleRect.top < headerRect.bottom);
            }
        }
    }, [
        objectHeaderRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // only add progressive header listeners when for view page/blogpost and live pages view mode
        if (shouldUseProgressiveHeader) {
            // If SSR_RENDERED is true and the experiment is enabled (true),
            // we'll skip checking the intersection on load.
            if (!Boolean(window.__SSR_RENDERED__) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) // need to run this on initialization once in case the page was initially loaded with a non visible title (scrolled down)
            checkIntersection();
            window.addEventListener('scroll', checkIntersection, true);
            window.addEventListener('resize', checkIntersection);
        }
        return ()=>{
            window.removeEventListener('scroll', checkIntersection, true);
            window.removeEventListener('resize', checkIntersection);
        };
    }, [
        contentId,
        objectHeaderRef,
        checkIntersection,
        shouldUseProgressiveHeader
    ]);
    return isIntersecting;
};


const $4e15ea858159a232$export$b109b4315ce03d6c = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentType: contentType, contentMode: contentMode, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isObjectSidebarShown: isObjectSidebarShown, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading, objectHeaderRef: objectHeaderRef, contentId: contentId } = t0;
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t1;
    const t2 = !isLiveEditMode;
    let t3;
    if ($[0] !== t2) {
        t3 = {
            defaultDockedAtTop: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)(t3);
    const isPageOrBlog = contentType === "page" || contentType === "blogpost";
    const isViewOrViewLiveMode = contentMode === "view" || isLiveViewMode;
    const isInEditor = contentMode === "draft" || contentMode === "edit" || isLiveEditMode;
    const isEditorToolbarShown = isInEditor && isEditorToolbarDockedAtTop;
    const shouldUseProgressiveHeader = isPageOrBlog && isViewOrViewLiveMode || isInEditor && !isEditorToolbarShown || isVersionHistoryPage || isAttachmentsPage;
    let t4;
    if ($[2] !== contentId || $[3] !== objectHeaderRef || $[4] !== shouldUseProgressiveHeader) {
        t4 = {
            contentId: contentId,
            objectHeaderRef: objectHeaderRef,
            shouldUseProgressiveHeader: shouldUseProgressiveHeader
        };
        $[2] = contentId;
        $[3] = objectHeaderRef;
        $[4] = shouldUseProgressiveHeader;
        $[5] = t4;
    } else t4 = $[5];
    const isTitleIntersectingWithHeader = (0, $9234e6aea1a8bf8e$export$3a542eb6901fb0e2)(t4);
    const t5 = !isTitleIntersectingWithHeader;
    let t6;
    if ($[6] !== contentId || $[7] !== contentType || $[8] !== contentTypesHeaderDataLoading || $[9] !== isArchived || $[10] !== isAttachmentsPage || $[11] !== isEditorToolbarShown || $[12] !== isObjectSidebarShown || $[13] !== isSpaceOverviewPage || $[14] !== isVersionHistoryPage || $[15] !== t5) {
        t6 = {
            isVersionHistoryPage: isVersionHistoryPage,
            isAttachmentsPage: isAttachmentsPage,
            contentType: contentType,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isArchived: isArchived,
            isEditorToolbarShown: isEditorToolbarShown,
            isTitleFullyVisible: t5,
            isObjectSidebarShown: isObjectSidebarShown,
            contentId: contentId,
            contentTypesHeaderDataLoading: contentTypesHeaderDataLoading
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = contentTypesHeaderDataLoading;
        $[9] = isArchived;
        $[10] = isAttachmentsPage;
        $[11] = isEditorToolbarShown;
        $[12] = isObjectSidebarShown;
        $[13] = isSpaceOverviewPage;
        $[14] = isVersionHistoryPage;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    const breadcrumbsDisplayMode = (0, $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd)(t6);
    let isBorderlessHeader = !isSpaceOverviewPage && !isTitleIntersectingWithHeader && !isObjectSidebarShown && !isEditorToolbarShown || contentTypesHeaderDataLoading && isTitleIntersectingWithHeader;
    let t7;
    if ($[17] !== breadcrumbsDisplayMode || $[18] !== isBorderlessHeader || $[19] !== isEditorToolbarShown) {
        t7 = {
            breadcrumbsDisplayMode: breadcrumbsDisplayMode,
            isBorderlessHeader: isBorderlessHeader,
            isEditorToolbarShown: isEditorToolbarShown
        };
        $[17] = breadcrumbsDisplayMode;
        $[18] = isBorderlessHeader;
        $[19] = isEditorToolbarShown;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ contentType: contentType, contentMode: contentMode, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isObjectSidebarShown: isObjectSidebarShown, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading, objectHeaderRef: objectHeaderRef, contentId: contentId })=>{
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLiveEditMode
    });
    const isPageOrBlog = contentType === 'page' || contentType === 'blogpost';
    const isViewOrViewLiveMode = contentMode === 'view' || isLiveViewMode;
    const isInEditor = contentMode === 'draft' || contentMode === 'edit' || isLiveEditMode;
    const isEditorToolbarShown = isInEditor && isEditorToolbarDockedAtTop;
    const shouldUseProgressiveHeader = isPageOrBlog && isViewOrViewLiveMode || isInEditor && !isEditorToolbarShown || isVersionHistoryPage || isAttachmentsPage;
    const isTitleIntersectingWithHeader = (0, $9234e6aea1a8bf8e$export$3a542eb6901fb0e2)({
        contentId: contentId,
        objectHeaderRef: objectHeaderRef,
        shouldUseProgressiveHeader: shouldUseProgressiveHeader
    });
    const breadcrumbsDisplayMode = (0, $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd)({
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage,
        contentType: contentType,
        isSpaceOverviewPage: isSpaceOverviewPage,
        isArchived: isArchived,
        isEditorToolbarShown: isEditorToolbarShown,
        isTitleFullyVisible: !isTitleIntersectingWithHeader,
        isObjectSidebarShown: isObjectSidebarShown,
        contentId: contentId,
        contentTypesHeaderDataLoading: contentTypesHeaderDataLoading
    });
    let isBorderlessHeader = !isSpaceOverviewPage && !isTitleIntersectingWithHeader && !isObjectSidebarShown && !isEditorToolbarShown || contentTypesHeaderDataLoading && isTitleIntersectingWithHeader; // if user is scrolled down on the page such that the header is showing and transitions to another page, the header shows for a second on the new page before hiding. This prevents that.
    return {
        breadcrumbsDisplayMode: breadcrumbsDisplayMode,
        isBorderlessHeader: isBorderlessHeader,
        isEditorToolbarShown: isEditorToolbarShown
    };
};















var $7hXu9 = parcelRequire("7hXu9");


var $3vc4U = parcelRequire("3vc4U");


var $gKr8t = parcelRequire("gKr8t");





var $fJlJm = parcelRequire("fJlJm");








var $aMcHK = parcelRequire("aMcHK");







const $dfe2d565e9152de8$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined'
];
const $dfe2d565e9152de8$export$76c04e45533062c9 = (response, onDataReceived)=>{
    const payload = response?.subscriptionData?.data?.confluence_onContentModified;
    const _deltas = payload?._deltas;
    if (!payload || !Array.isArray(_deltas)) return;
    if (_deltas?.length === 0 || _deltas.indexOf('contentTitleUpdated') === -1) return;
    const { contentTitleUpdated: contentTitleUpdated } = payload;
    const title = contentTitleUpdated?.contentTitle;
    onDataReceived(title);
};
const $dfe2d565e9152de8$export$33a5663c83a12152 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentType: contentType, contentId: contentId, onDataReceived: onDataReceived, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== contentId || $[1] !== contentType) {
        t2 = {
            contentType: contentType,
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = t2;
    } else t2 = $[2];
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onSubscriptionData } = (0, $3vc4U.useSubscriptionValues)(t2);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $eSUdr.default)`subscription ContentTypesTitleSubscription($id:ID!){confluence_onContentModified(id:$id){type id __typename _deltas contentTitleUpdated{contentTitle __typename}}}`;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== extensions || $[5] !== id) {
        t4 = {
            id: id,
            __extensions: extensions
        };
        $[4] = extensions;
        $[5] = id;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== id || $[8] !== onDataReceived || $[9] !== onSubscriptionComplete || $[10] !== onSubscriptionData || $[11] !== skip || $[12] !== skipSubscriptionForAnonUsers || $[13] !== t4) {
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $gKr8t.getAGGClient)();
            $[15] = t6;
        } else t6 = $[15];
        t5 = {
            variables: t4,
            onSubscriptionComplete: onSubscriptionComplete,
            onSubscriptionData (response) {
                $dfe2d565e9152de8$export$76c04e45533062c9(response, onDataReceived);
                onSubscriptionData(response);
            },
            skip: skip || !id || skipSubscriptionForAnonUsers,
            client: t6
        };
        $[7] = id;
        $[8] = onDataReceived;
        $[9] = onSubscriptionComplete;
        $[10] = onSubscriptionData;
        $[11] = skip;
        $[12] = skipSubscriptionForAnonUsers;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    const { error: error } = (0, $7hXu9.useSubscription)(t3, t5);
    let t6;
    let t7;
    if ($[16] !== contentId || $[17] !== contentType || $[18] !== error) {
        t6 = ()=>{
            if (error) {
                const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
                const isIgnoredError = $dfe2d565e9152de8$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
                const statusCode = (0, $aMcHK.getStatusCode)(error) || error?.errors?.[0]?.extensions?.statusCode;
                if (statusCode !== 403 && !isIgnoredError) {
                    const e = new Error(`Subscription Error - ContentTypesTitleSubscription:${errorMessage}`);
                    (0, $fJlJm.setContentErrorAttributes)(e, {
                        objectId: contentId,
                        objectType: contentType
                    });
                    (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    });
                }
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        t7 = [
            error,
            contentId,
            contentType
        ];
        $[16] = contentId;
        $[17] = contentType;
        $[18] = error;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $42omo.useEffect)(t6, t7);
    return null;
} : ({ contentType: contentType, contentId: contentId, onDataReceived: onDataReceived, skip: skip = false })=>{
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onSubscriptionData } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription ContentTypesTitleSubscription($id:ID!){confluence_onContentModified(id:$id){type id __typename _deltas contentTitleUpdated{contentTitle __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            $dfe2d565e9152de8$export$76c04e45533062c9(response, onDataReceived);
            onSubscriptionData(response);
        },
        skip: skip || !id || skipSubscriptionForAnonUsers,
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const isIgnoredError = $dfe2d565e9152de8$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            const statusCode = (0, $aMcHK.getStatusCode)(error) || error?.errors?.[0]?.extensions?.statusCode;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - ContentTypesTitleSubscription:${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    return null;
};









var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

parcelRequire("iiPY2");
var $2JKSZ = parcelRequire("2JKSZ");


var $Q2uE4 = parcelRequire("Q2uE4");


var $bFMG7 = parcelRequire("bFMG7");


var $hl0fg = parcelRequire("hl0fg");








var $1u6lx = parcelRequire("1u6lx");

const $5b06a9a89418566a$export$4ad2c8d6c7cae594 = 1000;
const $5b06a9a89418566a$var$CONTENT_TITLE_MAX_LENGTH = 25;
const $5b06a9a89418566a$var$CLASSIFICATION_NAME_MAX_LENGTH = 25;
const $5b06a9a89418566a$var$TOTAL_MAX_LENGTH = $5b06a9a89418566a$var$CONTENT_TITLE_MAX_LENGTH + $5b06a9a89418566a$var$CLASSIFICATION_NAME_MAX_LENGTH;
// ~ "Add classification", in English
const $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH = 18;
const $5b06a9a89418566a$export$9dbd9e1965ba2157 = ({ contentTitle: contentTitle = '', classificationName: classificationName = '' })=>{
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const contentTitleLength = contentTitle.length;
    const tagLabelLength = classificationName === '' ? $5b06a9a89418566a$var$APPROX_ADD_BUTTON_CHAR_LENGTH : classificationName.length;
    const combinedLength = contentTitleLength + tagLabelLength;
    const isIconOnly = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 : windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594 && combinedLength > $5b06a9a89418566a$var$TOTAL_MAX_LENGTH;
    // window is not availble in SSR so we need to need to render
    // the icon only while hydrating
    return isIconOnly || renderServerPlaceholder ? (0, $1u6lx.TagButtonUIVariant).iconOnly : (0, $1u6lx.TagButtonUIVariant).default;
};





/**
 * @generated SignedSource<<5a869015cfcf17ad719cec281143972f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dfd3aefd5b50ce2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentBasicInfoFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$4dfd3aefd5b50ce2$var$node.hash = "c75429b09fee9e0b10f7ca8e827e75a3";
var $4dfd3aefd5b50ce2$export$2e2bcd8739ae039 = $4dfd3aefd5b50ce2$var$node;





const $b19fb0df3b9373e6$export$26aebb14cb61773d = (fragmentNode, fragmentRef)=>{
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: fragmentNode
    });
    return readFragmentInterop({
        id: `${fragmentRef?.__typename}:${fragmentRef?.id}`
    });
};


const $da1026f8e09cf81c$export$d21a46dab87be04 = (contentBasicInfoRef, externalShareContent)=>{
    if (externalShareContent) return {
        id: externalShareContent.id,
        title: externalShareContent.title,
        type: externalShareContent.type,
        subType: externalShareContent.subType,
        status: externalShareContent.status
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b19fb0df3b9373e6$export$26aebb14cb61773d)((0, $4dfd3aefd5b50ce2$export$2e2bcd8739ae039), contentBasicInfoRef);
};


/**
 * @generated SignedSource<<03895c0ed41af97ac87b6a1ead4897ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $428aade5a3e8b849$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "alias"
        }
    ],
    "type": "Space"
};
$428aade5a3e8b849$var$node.hash = "5e7d3791ffec068935e152aaea16d3a4";
var $428aade5a3e8b849$export$2e2bcd8739ae039 = $428aade5a3e8b849$var$node;



const $437d3186ffdaf7cd$export$64efb28d9ab6d8a8 = (contentSpaceRef, externalShareContent)=>{
    if (externalShareContent?.space) return {
        id: externalShareContent.space.id,
        name: externalShareContent.space.name,
        key: externalShareContent.space.key,
        alias: externalShareContent.space.alias
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b19fb0df3b9373e6$export$26aebb14cb61773d)((0, $428aade5a3e8b849$export$2e2bcd8739ae039), contentSpaceRef);
};


const $580936b329b9c958$export$68383d0b588bf7b6 = ({ contentId: contentId, contentData: contentData, contentBasicInfoRef: contentBasicInfoRef, contentSpaceRef: contentSpaceRef, contentStatusContext: contentStatusContext, contentType: contentType, readOnly: readOnly, isSpaceOverviewPage: isSpaceOverviewPage, isObjectHeader: isObjectHeader })=>{
    let spaceKey, contentBasicInfo;
    if (contentBasicInfoRef && contentSpaceRef) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        contentBasicInfo = (0, $da1026f8e09cf81c$export$d21a46dab87be04)(contentBasicInfoRef);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        spaceKey = (0, $437d3186ffdaf7cd$export$64efb28d9ab6d8a8)(contentSpaceRef)?.key ?? '';
    } else {
        contentBasicInfo = contentData;
        spaceKey = contentData?.space?.key ?? '';
    }
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: true
    });
    const isClassificationEnabled = contentClassificationMetadata?.featureEnabled ?? false;
    const classificationTagUiVariant = (0, $5b06a9a89418566a$export$9dbd9e1965ba2157)({
        contentTitle: contentBasicInfo?.title ?? '',
        classificationName: contentClassificationMetadata.classification?.name
    });
    if ((contentType.type === 'whiteboard' || contentType.type === 'database' || contentType.type === 'embed' || !isObjectHeader) && // from renderOriginalHeader in ContentTypesHeader
    isClassificationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        testId: "content-types-header-classification"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2JKSZ.ContentTypeClassification), {
        variant: classificationTagUiVariant,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType.type,
        contentClassificationMetadata: contentClassificationMetadata,
        readOnly: readOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Q2uE4.ClassificationEditModal), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentClassificationMetadata: contentClassificationMetadata
    }));
    else if (contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit') return null;
    else if (isSpaceOverviewPage) // we want to render the classification tag in the header for space overview pages
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "content-classification-tag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($580936b329b9c958$var$ContentClassificationTagLoader, {
        contentId: contentId,
        contentType: contentType.type || null,
        contentClassificationMetadata: contentClassificationMetadata,
        isEditMode: false
    }));
    return null;
};

// duplicated from ContentHeader
const $580936b329b9c958$var$ContentClassificationTagLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ifxj2",
    name: 'ContentClassificationTag',
    loader: async ()=>(await (parcelRequire("iRMiv"))).ContentClassificationTag
});




const $985b9df8a4afde11$export$e5688214a1861822 = {
    database: (0, $5qUgM.DATABASE_HEADER_SEGMENT_METRIC),
    embed: (0, $5qUgM.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC),
    whiteboard: (0, $5qUgM.WHITEBOARD_HEADER_SEGMENT_METRIC)
};
const $985b9df8a4afde11$var$contentTypesBreadcrumbsContainerStyles = (0, $ecnYn.xcss)({
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: '20px',
    paddingLeft: 'space.100' /* To align better with the ContentTypesTitle component */ ,
    paddingRight: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ContentActionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _1yt4u2gc _bfhkvuon _lcxv1wug _1e0c1txw _1tke1ylp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1yt4u2gc _bfhkvuon _lcxv1wug _1e0c1txw _1tke1ylp",
            __cmplp.className
        ])
    });
});
$985b9df8a4afde11$var$ContentActionsWrapper.displayName = 'ContentActionsWrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ContentActionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showSeparator: showSeparator, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.showSeparator && "_eq43ia51 _j9jr1nu5 _aetrb3bt _1qdg7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showSeparator: showSeparator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.showSeparator && "_eq43ia51 _j9jr1nu5 _aetrb3bt _1qdg7vkz",
            __cmplp.className
        ])
    });
});
$985b9df8a4afde11$var$ContentActionContainer.displayName = 'ContentActionContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ArchiveBannerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _lcxv1wug",
            __cmplp.isFullWidth ? "_18s8tmrp" : "_18s81hs1 _p12f1fdn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _lcxv1wug",
            __cmplp.isFullWidth ? "_18s8tmrp" : "_18s81hs1 _p12f1fdn",
            __cmplp.className
        ])
    });
});
$985b9df8a4afde11$var$ArchiveBannerContainer.displayName = 'ArchiveBannerContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$StyledShare = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8h8dc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8h8dc",
            __cmplp.className
        ])
    });
});
$985b9df8a4afde11$var$StyledShare.displayName = 'StyledShare';
const $985b9df8a4afde11$var$flexNavigationContainerStyles = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    justifyContent: 'space-between'
});
const $985b9df8a4afde11$var$objectHeaderFlexNavigationContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.0',
    paddingRight: 'space.0',
    overflow: 'hidden'
});
const $985b9df8a4afde11$var$floatingHeaderContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    height: '58px'
});
const $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles = (0, $ecnYn.xcss)({
    gap: 'space.075',
    alignItems: 'center',
    minWidth: '176px'
});
const $985b9df8a4afde11$var$objectHeaderStyles = (0, $ecnYn.xcss)({
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'elevation.surface',
    height: '56px',
    zIndex: 'layer'
});
const $985b9df8a4afde11$var$objectHeaderSpotlightZIndexOverride = (0, $ecnYn.xcss)({
    zIndex: 'spotlight'
}); // If the object header's size changes, make sure to update the height constant
// FIXED_OBJECT_HEADER_SSR_HEIGHT in contentTypesHeaderConstants.ts
const $985b9df8a4afde11$var$fixedBorderHeaderContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $985b9df8a4afde11$var$borderHeaderFadeInStyles = (0, $ecnYn.xcss)({
    transition: 'border-bottom 100ms linear'
});
const $985b9df8a4afde11$var$fixedBorderlessHeaderContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-inverse, #FFFFFF)"}`
});
const $985b9df8a4afde11$var$floatingBlockHeaderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.100',
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.raised',
    height: '56px',
    pointerEvents: 'auto',
    [(0, $bWLcG.media).above.xs]: {
        // overrides min width 0 set in contentBreadcrumbsAndMetadataStyles used for header responsiveness
        // floatingBlockHeaderStyles is only used for whiteboard headers (which do not support responsiveness)
        minWidth: 'fit-content'
    }
});
const $985b9df8a4afde11$var$newFloatingBlockHeaderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.100',
    backgroundColor: 'elevation.surface',
    height: '56px',
    pointerEvents: 'auto',
    minWidth: '176px'
});
const $985b9df8a4afde11$var$objectHeaderActionsContainerStyles = (0, $ecnYn.xcss)({
    flexShrink: 0,
    paddingRight: 'space.075'
});
const $985b9df8a4afde11$var$inlineRenameMarginStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.075'
});
const $985b9df8a4afde11$var$inlineRenameOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden'
});
const $985b9df8a4afde11$var$mobileAppWhiteboardStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    touchAction: 'none'
});
const $985b9df8a4afde11$var$skeletonBreadcrumbsStyles = (0, $ecnYn.xcss)({
    height: '20px',
    width: '200px'
});
const $985b9df8a4afde11$var$skeletonTitleStyles = (0, $ecnYn.xcss)({
    height: '24px',
    width: '300px'
});
const $985b9df8a4afde11$var$skeletonActionSmallStyles = (0, $ecnYn.xcss)({
    height: '32px',
    width: '80px'
});
const $985b9df8a4afde11$var$skeletonActionLargeStyles = (0, $ecnYn.xcss)({
    height: '32px',
    width: '100px'
});
const $985b9df8a4afde11$var$getShareAction = (mode)=>mode === (0, $cD1qu.PageMode).EDIT ? (0, $cD1qu.PageMode).EDIT : (0, $cD1qu.PageMode).VIEW;
const $985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { shouldShowEmojiTitle: shouldShowEmojiTitle, contentId: contentId, readOnly: readOnly, contentType: contentType, title: title, spaceName: spaceName, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler } = t0;
    const { isEditing: isEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const onDataReceivedRef = (0, $42omo.useRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (newTitle)=>onDataReceivedRef?.current?.(newTitle);
        $[0] = t1;
    } else t1 = $[0];
    const stableOnDataReceived = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && [
            $985b9df8a4afde11$var$inlineRenameMarginStyles,
            $985b9df8a4afde11$var$inlineRenameOverflowStyles
        ];
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $7xVCs.PageTreeStateUpdater)
        ];
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== contentId || $[4] !== contentType || $[5] !== isEditing || $[6] !== onCloseTitleSpotlight || $[7] !== readOnly || $[8] !== registerShowTitleSpotlightHandler || $[9] !== setUpdatedTitleFromPubsub || $[10] !== shouldShowEmojiTitle || $[11] !== spaceName || $[12] !== title || $[13] !== updateCache) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            testId: "inline-rename-breadcrumb-title",
            xcss: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t3
        }, (pageStateUpdater)=>{
            const updateContentTree = ()=>{
                pageStateUpdater.setForceFetchPageId(contentId);
            };
            const onDataReceived = (newTitle_0)=>{
                if (!isEditing) {
                    updateCache(newTitle_0);
                    updateContentTree();
                    setUpdatedTitleFromPubsub(undefined);
                } else setUpdatedTitleFromPubsub(newTitle_0);
            };
            onDataReceivedRef.current = onDataReceived;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.0",
                alignBlock: "center",
                xcss: (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $985b9df8a4afde11$var$inlineRenameOverflowStyles
            }, shouldShowEmojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8z0fF.EmojiTitleSelection), {
                "data-testid": "emoji-title-selection",
                contentId: contentId,
                isTitleDisabled: false,
                isTitleCenterAligned: true,
                hasCoverPicture: false,
                isReadOnly: readOnly,
                contentType: contentType,
                updateContentTree: updateContentTree
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778018eca844ead1$export$42d61ec2afde455f), {
                title: title ?? "",
                contentId: contentId,
                spaceName: spaceName ?? "",
                readOnly: readOnly,
                key: title,
                updateContentTree: updateContentTree,
                contentType: contentType ?? "",
                onCloseTitleSpotlight: onCloseTitleSpotlight,
                registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dfe2d565e9152de8$export$33a5663c83a12152), {
                contentId: contentId,
                contentType: contentType,
                onDataReceived: stableOnDataReceived,
                skip: !(0, $9wGTI.fg)("cc_fps_migration_content-title") || ![
                    "DUAL",
                    "GRAPHQL"
                ].includes((0, $4VJDS.default).getString("confluence-migrate-fps-to-graphql-subscription", ""))
            }));
        }));
        $[3] = contentId;
        $[4] = contentType;
        $[5] = isEditing;
        $[6] = onCloseTitleSpotlight;
        $[7] = readOnly;
        $[8] = registerShowTitleSpotlightHandler;
        $[9] = setUpdatedTitleFromPubsub;
        $[10] = shouldShowEmojiTitle;
        $[11] = spaceName;
        $[12] = title;
        $[13] = updateCache;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ shouldShowEmojiTitle: shouldShowEmojiTitle, contentId: contentId, readOnly: readOnly, contentType: contentType, title: title, spaceName: spaceName, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler })=>{
    const { isEditing: isEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const onDataReceivedRef = (0, $42omo.useRef)();
    const stableOnDataReceived = (0, $42omo.useMemo)(()=>(newTitle)=>onDataReceivedRef?.current?.(newTitle), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        gap: "space.075",
        alignItems: "center",
        testId: "inline-rename-breadcrumb-title",
        xcss: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && [
            $985b9df8a4afde11$var$inlineRenameMarginStyles,
            $985b9df8a4afde11$var$inlineRenameOverflowStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>{
        const updateContentTree = ()=>{
            pageStateUpdater.setForceFetchPageId(contentId);
        };
        const onDataReceived = (newTitle_0)=>{
            if (!isEditing) {
                updateCache(newTitle_0);
                updateContentTree();
                setUpdatedTitleFromPubsub(undefined);
            } else setUpdatedTitleFromPubsub(newTitle_0);
        };
        onDataReceivedRef.current = onDataReceived;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.0",
            alignBlock: "center",
            xcss: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $985b9df8a4afde11$var$inlineRenameOverflowStyles
        }, shouldShowEmojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8z0fF.EmojiTitleSelection), {
            "data-testid": "emoji-title-selection",
            contentId: contentId,
            isTitleDisabled: false,
            isTitleCenterAligned: true,
            hasCoverPicture: false,
            isReadOnly: readOnly,
            contentType: contentType,
            updateContentTree: updateContentTree
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778018eca844ead1$export$42d61ec2afde455f), {
            title: title ?? '',
            contentId: contentId,
            spaceName: spaceName ?? '',
            readOnly: readOnly,
            key: title,
            updateContentTree: updateContentTree,
            contentType: contentType ?? '',
            onCloseTitleSpotlight: onCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dfe2d565e9152de8$export$33a5663c83a12152), {
            contentId: contentId,
            contentType: contentType,
            onDataReceived: stableOnDataReceived,
            skip: !(0, $9wGTI.fg)('cc_fps_migration_content-title') || ![
                'DUAL',
                'GRAPHQL'
            ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))
        }));
    }));
};
$985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb.displayName = 'ContentTypesInlineRenameBreadcrumb';
const $985b9df8a4afde11$var$ContentTypesHeaderInner = ({ externalShareContent: externalShareContent, contentId: contentId, contentActions: contentActions, isFloating: isFloating = false, allowedFeatures: allowedFeatures = (0, $4cb3eaaf01c9d693$export$dce52735e291d3da), onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler, onHeightChange: onHeightChange, handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight, isHeaderPinned: isHeaderPinned = false, showVersionHistorySpotlight: showVersionHistorySpotlight, setShowVersionHistorySpotlight: setShowVersionHistorySpotlight, isSpaceOverviewPage: isSpaceOverviewPage = false, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted, whiteboardAIAgentService: whiteboardAIAgentService, viewOnlyBadge: viewOnlyBadge })=>{
    const isExternal = (0, $6S5EB.isExternalShareRequest)(); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { bannerHeight: headerHeight, setBannerElement: setHeaderHeightElement } = (0, $bvJwp.useResizeBanner)(isSSR);
    const objectHeaderRef = (0, $42omo.useRef)(null); // If accessing these values outside of editor sessions, they will be default values
    const { editorTitle: editorTitle, shouldRenderPreview: shouldRenderPreview, shouldShowNewContentHistory: shouldShowNewContentHistory } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const isVersionHistoryPage = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.CONTENT_HISTORY).name
    });
    const isAttachmentsPage = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.ATTACHMENTS_PAGE).name
    }); // Automation manual trigger modal listening for query param
    (0, $hQBR9.useAutomationUrlParamTrigger)((0, $9wGTI.fg)('a4c-enable-automation-url-trigger'));
    (0, $42omo.useEffect)(()=>{
        onHeightChange?.(headerHeight);
    }, [
        headerHeight,
        onHeightChange
    ]);
    const fragmentSelectors = (0, $42omo.useMemo)(()=>{
        return {
            contentBasicInfo: (data)=>data?.content?.nodes?.[0],
            contentSpace: (data)=>data?.content?.nodes?.[0]?.space
        };
    }, []);
    let contentData, contentSpace, contentBasicInfo, contentTypesHeaderDataLoading, ContentTypesHeaderQueryError, fragmentRefs;
    if ((0, $9wGTI.fg)('confluence_use_fragmentized_queries')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $574d761bd3a496fb$export$b84ae570a1bec29f)((0, $dbf5442f5a3b49c0$export$2e2bcd8739ae039), {
            skip: !!externalShareContent,
            variables: {
                contentId: contentId,
                useObjectHeader: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
            },
            fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 'cache-and-network' : 'cache-first'
        }, fragmentSelectors);
        contentData = externalShareContent || result?.data?.content?.nodes?.[0];
        contentTypesHeaderDataLoading = result?.loading;
        ContentTypesHeaderQueryError = result?.error;
        fragmentRefs = result?.fragmentRefs; // eslint-disable-next-line react-hooks/rules-of-hooks
        contentBasicInfo = (0, $da1026f8e09cf81c$export$d21a46dab87be04)(fragmentRefs?.contentBasicInfo, externalShareContent); // eslint-disable-next-line react-hooks/rules-of-hooks
        contentSpace = (0, $437d3186ffdaf7cd$export$64efb28d9ab6d8a8)(fragmentRefs?.contentSpace, externalShareContent);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks, graphql-relay-compat/no-import-graphql-operations
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
        (0, $6LsQQ.ContentTypesHeaderQuery), {
            skip: !!externalShareContent,
            variables: {
                contentId: contentId,
                useObjectHeader: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
            },
            fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 'cache-and-network' : 'cache-first'
        });
        contentData = externalShareContent || result?.data?.content?.nodes?.[0];
        contentTypesHeaderDataLoading = result?.loading;
        ContentTypesHeaderQueryError = result?.error;
        contentSpace = contentData?.space;
        contentBasicInfo = contentData;
    }
    const spaceKey = contentSpace?.key || ''; // Different pieces of content can have different modes, which need to be reflected in this header.
    // Eg, pages & blogposts can be 'draft', 'archived', 'view', 'edit', or 'live' (or 'embedded', or 'legacy'!)
    const rawContentType = contentBasicInfo?.type ?? undefined; // ShareButton's shareContentType prop doesn't like null values
    const isArchived = contentBasicInfo?.status === 'archived';
    const isDraft = contentBasicInfo?.status === 'draft';
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)(); // we use subType value directly for live pages bc when a user is not on the live page route,
    // the live docs sweet state store is not populated and useIsCurrentPageLive in useGetPageMode returns false
    const subType = contentBasicInfo?.subType;
    const contentType = (0, $42omo.useMemo)(()=>({
            type: rawContentType,
            mode: (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, subType === 'live' ? subType : isViewEditOrLive)
        }), [
        rawContentType,
        isArchived,
        isDraft,
        subType,
        isViewEditOrLive
    ]);
    const isEditPage = (0, $42omo.useMemo)(()=>contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit', [
        contentType.mode
    ]);
    const { shouldDisableEditorButtons: shouldDisableEditorButtons } = (0, $85c7900526df4a2e$export$b0a1564bba9108e3)(contentId, contentType.mode);
    const isUnpublishedDraft = contentType.mode === 'draft';
    const isRecapSpotlightEligible = (0, $l7iY7.useRecapSpotlightEligibility)(isUnpublishedDraft);
    let contentStatusContext;
    if (contentType.mode === 'live') contentStatusContext = 'current-and-draft';
    else if (contentType.mode === 'edit' || contentType.mode === 'draft') contentStatusContext = 'draft-only';
    else contentStatusContext = 'current-only';
    const { breadcrumbsDisplayMode: breadcrumbsDisplayMode, isBorderlessHeader: isBorderlessHeader, isEditorToolbarShown: isEditorToolbarShown } = (0, $4e15ea858159a232$export$b109b4315ce03d6c)({
        contentType: contentType.type,
        contentMode: contentType.mode || '',
        isSpaceOverviewPage: isSpaceOverviewPage,
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage,
        isArchived: isArchived,
        isObjectSidebarShown: isObjectSidebarShown,
        contentTypesHeaderDataLoading: contentTypesHeaderDataLoading,
        objectHeaderRef: objectHeaderRef,
        contentId: contentId
    });
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType.type === 'whiteboard';
    const operations = externalShareContent?.operations || contentData?.operations;
    const readOnly = isMobileAppWhiteboard || isExternal || !operations?.some((operation)=>operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === 'update');
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const shouldShowEmojiTitle = (0, $99t4P.isEmojiTitleEnabled)(contentType.type); // Whiteboard and Database's archive banner renders in its own shell to account for a pinned solid header and a side panel
    // Similarly, pages and blogposts manage their own archive banner
    const showArchiveBanner = contentType.type === 'embed';
    const hasFullWidthBanner = contentType.type === 'embed';
    const showInlineRename = contentType.type !== 'page' && contentType.type !== 'blogpost';
    const { showBreadcrumbs: breadcrumbsIsAllowedFeature } = allowedFeatures;
    const renderCopyLink = ()=>{
        if (Object.values((0, $3WXN2.SUPPORTED_CONTENT_TYPES)).includes(contentType.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cVfpT.CopyLinkButtonLoader), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType.type,
            source: "contentHeader" /**
                                                                                                                                    * All currently-supported content types currently treats both viewing and
                                                                                                                                    * editing the same. To avoid issues, we'll refer to viewing to maintain
                                                                                                                                    * consistency, as using 'edit' would generate a different URL.
                                                                                                                                    */ ,
            pageMode: "view"
        });
    };
    const renderShare = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
            contentId: contentId,
            contentType: contentType.type,
            shareeAction: $985b9df8a4afde11$var$getShareAction(isViewEditOrLive),
            source: "contentHeader",
            isUnpublishedDraft: contentType.mode === 'draft',
            contentSubType: contentType.mode === 'live' ? 'live' : undefined
        });
    };
    const wrappedRenderShare = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $47zp4.LIVE_DOC_SHARE_BUTTON_TARGET)
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, renderShare()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$StyledShare, null, renderShare()));
    }; // The primary reason for this structure is to support programmatic control of when a separator should render
    const headerItems = (0, $2c279a34b2a89086$export$2ed55bc7ce9c518)({
        contentId: contentId,
        contentType: contentType.type,
        contentMode: contentType.mode,
        contentActions: contentActions,
        handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
        allowedFeatures: allowedFeatures,
        contentData: contentData,
        renderCopyLink: renderCopyLink,
        renderShare: wrappedRenderShare,
        showVersionHistorySpotlight: showVersionHistorySpotlight,
        setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
        isSpaceOverviewPage: isSpaceOverviewPage,
        readOnly: readOnly,
        isConvertToFolderHighlighted: isConvertToFolderHighlighted,
        setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted,
        whiteboardAIAgentService: whiteboardAIAgentService,
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage
    });
    const renderActionContainers = ()=>{
        const contentToRender = headerItems.filter((contentActions)=>contentActions.shouldRender);
        return contentToRender.map((contentAction, index)=>{
            const { name: name, shouldShowSeparator: shouldShowSeparator, children: children, shouldRenderInContainer: shouldRenderInContainer = true } = contentAction;
            const isLastEntry = index + 1 === contentToRender.length;
            const showSeparator = isLastEntry ? false : shouldShowSeparator;
            const testIdName = `${name}-action-container-${showSeparator ? 'with-separator' : 'without-separator'}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                key: name
            }, shouldRenderInContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentActionContainer, {
                "data-testid": testIdName,
                showSeparator: showSeparator,
                "data-vc": testIdName
            }, children) : children);
        });
    };
    const hasActionsToRender = ()=>{
        return headerItems.some((contentAction)=>contentAction.shouldRender);
    };
    const renderOriginalHeader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.TitleAndBreadcrumbsWrapper), {
            isContentHeaderPinned: isHeaderPinned
        }, breadcrumbsIsAllowedFeature && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$contentTypesBreadcrumbsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.BreadcrumbsNonLoadable), {
            contentId: contentId,
            spaceKey: spaceKey,
            showInlineRename: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb, {
            contentId: contentId,
            readOnly: readOnly,
            contentType: contentType.type,
            spaceName: contentSpace?.name,
            title: contentBasicInfo?.title,
            shouldShowEmojiTitle: shouldShowEmojiTitle,
            onCloseTitleSpotlight: onCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580936b329b9c958$export$68383d0b588bf7b6), {
            contentStatusContext: contentStatusContext,
            ...(0, $9wGTI.fg)('confluence_use_fragmentized_queries') ? {
                contentBasicInfoRef: fragmentRefs?.contentBasicInfo,
                contentSpaceRef: fragmentRefs?.contentSpace
            } : {
                contentData: contentData
            },
            contentId: contentId,
            contentType: contentType,
            readOnly: readOnly,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isObjectHeader: false
        })), isMobile || isMobileApp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE)
        })) : hasActionsToRender() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentActionsWrapper, null, renderActionContainers()));
    };
    const renderObjectHeader = ()=>{
        if (shouldRenderPreview || shouldShowNewContentHistory) return null;
        const isFloatingBlockHeader = contentType.type === 'whiteboard'; // Return link for Version History or Attachments breadcrumbs
        const contentLink = contentId && (isVersionHistoryPage || isAttachmentsPage) ? (0, $hzkzq.buildContentPath)({
            contentId: contentId,
            contentType: contentType.type === 'space' ? 'page' : contentType.type,
            isSpaceOverview: isSpaceOverviewPage,
            spaceKey: spaceKey
        }) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: [
                $985b9df8a4afde11$var$objectHeaderStyles,
                isRecapSpotlightEligible && $985b9df8a4afde11$var$objectHeaderSpotlightZIndexOverride,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingHeaderContainerStyles,
                !isFloatingBlockHeader && isBorderlessHeader && $985b9df8a4afde11$var$fixedBorderlessHeaderContainerStyles,
                !isFloatingBlockHeader && !isBorderlessHeader && $985b9df8a4afde11$var$fixedBorderHeaderContainerStyles,
                !isEditorToolbarShown && $985b9df8a4afde11$var$borderHeaderFadeInStyles,
                isMobileAppWhiteboard && $985b9df8a4afde11$var$mobileAppWhiteboardStyles
            ],
            ref: objectHeaderRef,
            id: "object-header-container-id",
            testId: "object-header-container",
            "data-vc": "object-header-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: [
                $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles,
                isFloatingBlockHeader && (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') && $985b9df8a4afde11$var$newFloatingBlockHeaderStyles,
                isFloatingBlockHeader && !(0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') && $985b9df8a4afde11$var$floatingBlockHeaderStyles
            ]
        }, breadcrumbsIsAllowedFeature && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.BreadcrumbsNonLoadable), {
            contentId: contentId,
            // the alias because that is used in the route URL so SSR will pick that up as the
            // space key and use it in the preloading cache for the space detail query.  If we
            // use the true (UUID) space key here in the request, the SSR cache will not find it
            // in the cache and we won't see the breadcrumbs in the SSR'ed version of the header
            spaceKey: contentSpace?.alias ?? contentSpace?.key ?? '',
            contentTitle: (0, $71c531080fb6afdc$export$753f77420b5437b9)({
                isSpaceOverviewPage: isSpaceOverviewPage,
                contentMode: contentType.mode,
                editorTitle: editorTitle,
                contentTitle: contentBasicInfo?.title
            }),
            showInlineRename: showInlineRename,
            shouldDisableMoveButton: shouldDisableEditorButtons,
            displayMode: breadcrumbsDisplayMode,
            contentLink: contentLink,
            contentType: contentType.type,
            subType: contentType.mode === 'live' ? 'live' : undefined
        }), showInlineRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb, {
            contentId: contentId,
            readOnly: readOnly,
            contentType: contentType.type,
            spaceName: contentSpace?.name,
            title: contentBasicInfo?.title,
            shouldShowEmojiTitle: shouldShowEmojiTitle,
            onCloseTitleSpotlight: onCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
        }), viewOnlyBadge, !isEditPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580936b329b9c958$export$68383d0b588bf7b6), {
            contentStatusContext: contentStatusContext,
            ...(0, $9wGTI.fg)('confluence_use_fragmentized_queries') ? {
                contentBasicInfoRef: fragmentRefs?.contentBasicInfo,
                contentSpaceRef: fragmentRefs?.contentSpace
            } : {
                contentData: contentData
            },
            contentId: contentId,
            contentType: contentType,
            readOnly: readOnly,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isObjectHeader: true
        })), !isMobile && !isMobileApp && hasActionsToRender() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            xcss: [
                $985b9df8a4afde11$var$objectHeaderActionsContainerStyles,
                isFloatingBlockHeader && (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') && $985b9df8a4afde11$var$newFloatingBlockHeaderStyles,
                isFloatingBlockHeader && !(0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') && $985b9df8a4afde11$var$floatingBlockHeaderStyles
            ],
            testId: "object-header-actions-container"
        }, renderActionContainers())));
    };
    const segmentMetric = $985b9df8a4afde11$export$e5688214a1861822[contentType.type];
    const headerComponents = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? renderObjectHeader() : renderOriginalHeader(); // We moved the classification modal context provider to the fullpageeditor component level for page editor to be able to use it
    // in the page editor byline. We need to conditionally render it here for the other content types.
    const ConditionalClassificationProvider = (contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit') && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $42omo.Fragment) : (0, $40pD8.ClassificationModalContextProvider);
    const hasPointerEvents = contentType.type === 'whiteboard' ? false : (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
    }, segmentMetric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: segmentMetric
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
        isFloating: isFloating,
        ref: setHeaderHeightElement,
        hasPointerEvents: hasPointerEvents,
        key: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $985b9df8a4afde11$var$flexNavigationContainerStyles,
            (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $985b9df8a4afde11$var$objectHeaderFlexNavigationContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConditionalClassificationProvider, null, headerComponents)), showArchiveBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ArchiveBannerContainer, {
        isFullWidth: hasFullWidthBanner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deZfn.ArchivedPageBanner), {
        contentId: contentId,
        marginStyle: "none"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType.type
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType.type,
            contentMode: contentType.mode
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC),
        customData: {
            contentType: contentType.type,
            contentMode: contentType.mode
        }
    }), ContentTypesHeaderQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: ContentTypesHeaderQueryError
    }));
};
$985b9df8a4afde11$var$ContentTypesHeaderInner.displayName = 'ContentTypesHeaderInner';
const $985b9df8a4afde11$export$f6490cc19c07c23d = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonBreadcrumbsStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonTitleStyles
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
            isFloating: false,
            hasPointerEvents: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$flexNavigationContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $985b9df8a4afde11$var$objectHeaderStyles
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            xcss: $985b9df8a4afde11$var$objectHeaderActionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonActionSmallStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $985b9df8a4afde11$var$skeletonActionLargeStyles
        })))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
        isFloating: false,
        hasPointerEvents: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $985b9df8a4afde11$var$flexNavigationContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $985b9df8a4afde11$var$objectHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $985b9df8a4afde11$var$skeletonBreadcrumbsStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $985b9df8a4afde11$var$skeletonTitleStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.075",
        alignBlock: "center",
        alignInline: "end",
        xcss: $985b9df8a4afde11$var$objectHeaderActionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $985b9df8a4afde11$var$skeletonActionSmallStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $985b9df8a4afde11$var$skeletonActionLargeStyles
    })))));
};
const $985b9df8a4afde11$export$e3980b758fe4ea84 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$export$f6490cc19c07c23d, null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-types-header",
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInner, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "content-types-header",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$export$f6490cc19c07c23d, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInner, props));
};
$985b9df8a4afde11$export$e3980b758fe4ea84.displayName = 'ContentTypesHeader';
module.exports["segmentMetricsMap"] = $985b9df8a4afde11$export$e5688214a1861822;
module.exports["ContentTypesHeaderSkeleton"] = $985b9df8a4afde11$export$f6490cc19c07c23d;
module.exports["ContentTypesHeader"] = $985b9df8a4afde11$export$e3980b758fe4ea84;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("8zMP3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $eS4vC = parcelRequire("eS4vC");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $42omo.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $42omo.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("40pD8", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $42omo.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $42omo.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>!!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("bvJwp", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $357714bfdc877a0f$export$75b569184a0dd765 = (isSSR)=>{
    const [bannerHeight, setBannerHeight] = (0, $42omo.useState)(0);
    const [bannerElement, setBannerElement] = (0, $42omo.useState)(null);
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!isSSR) return new ResizeObserver((entries)=>{
            for (const entry of entries)setBannerHeight(entry.borderBoxSize[0].blockSize);
        });
    }, [
        isSSR
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bannerElement && resizeObserver) {
            resizeObserver.observe(bannerElement);
            return ()=>resizeObserver.unobserve(bannerElement);
        } else setBannerHeight(0);
    }, [
        bannerElement,
        resizeObserver
    ]);
    return {
        setBannerElement: setBannerElement,
        bannerHeight: bannerHeight,
        setBannerHeight: setBannerHeight
    };
};
module.exports["useResizeBanner"] = $357714bfdc877a0f$export$75b569184a0dd765;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("cuWTe", function(module, exports) {
const $52d439f2e3e46670$export$5d6b4e71896e8f23 = (contentType, isArchived, isDraft, isViewEditOrLive)=>{
    // archived takes priority, since other modes like 'view' can be in this state
    if (isArchived) return 'archived';
    // useGetPageMode *always* returns one of 'live', 'view', or 'edit', but these modes don't apply across all
    // content types - so the content type doesn't have a 'mode' and we should return undefined
    if (contentType === 'page' || contentType === 'blogpost') {
        // then draft takes next priority, since other modes like 'edit' can be in this state
        if (isDraft) return 'draft';
        // technically only pages can be live at the moment, and blogposts wouldn't ever return live, but they *could*
        return isViewEditOrLive;
    } else return undefined;
};
module.exports["getContentMode"] = $52d439f2e3e46670$export$5d6b4e71896e8f23;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("cVfpT", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("9WYR7")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $h5hpR = parcelRequire("h5hpR");


var $9WYR7 = parcelRequire("9WYR7");


const $77a17cdb2708e975$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qHKXp",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await Promise.resolve((parcelRequire("9WYR7")))).CopyLink;
    },
    loading: (0, $h5hpR.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $77a17cdb2708e975$export$9d30156e45c09e81;

});

parcelRegister("h5hpR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $585272eb5e339a55$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $585272eb5e339a55$export$1f3200a5b8d4d8e1 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button-placeholder",
        "data-test-id": "copy-link-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: intl.formatMessage($585272eb5e339a55$var$i18n.copyLinkLabel),
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["CopyLinkButtonPlaceholder"] = $585272eb5e339a55$export$1f3200a5b8d4d8e1;

});

parcelRegister("9WYR7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $56QzY = parcelRequire("56QzY");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $3WXN2 = parcelRequire("3WXN2");

const $5e79baa87b282684$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "share.copylink.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "share.copylink.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e79baa87b282684$var$RESET_COPYTEXT_TIMEOUT = 5000;
const $5e79baa87b282684$export$9957974f8b4d8f74 = 'copyShareLink';
var $5e79baa87b282684$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
const $5e79baa87b282684$var$CopyLinkComponent = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom' })=>{
    const intl = (0, $8C5kA.default)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const updateTooltipPosition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e79baa87b282684$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'copyShareLink',
                action: 'shown',
                source: source,
                attributes: {
                    contentType: contentType,
                    pageMode: pageMode,
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        source,
        pageMode
    ]);
    const { queryError: queryError, unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $3WXN2.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source
    });
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltipPosition.current?.();
    }, [
        isCopied
    ]);
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e79baa87b282684$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
        try {
            await copyContentLink();
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    const handleHover = ()=>{
        experienceTracker.start({
            name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE)
        });
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text and fail experience if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e79baa87b282684$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e79baa87b282684$var$i18n.errorCopyingTextLabel : $5e79baa87b282684$var$i18n.copiedTextLabel);
    const isAnyError = Boolean(queryError || copyError);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnyError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError || copyError
    }), Boolean(copyError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE),
        error: copyError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltipPosition.current = update;
            return isCopied ? confirmationText : copyLinkText;
        },
        position: tooltipPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button",
        "aria-label": isCopied ? confirmationText : copyLinkText,
        appearance: buttonAppearance,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: "",
            color: isCopied ? "var(--ds-icon-selected, #1868DB)" : undefined,
            spacing: "spacious"
        }),
        onClick: handleCopyLink,
        onMouseEnter: handleHover,
        // Some consumers of CopyLink only reveal the button on hover, and
        // for those ones we need to reset the button to default post hover.
        // state after mouse leaves the component (because the button gets
        // hidden when no longer hovering)
        onMouseLeave: ()=>{
            if (shouldResetOnHover) setIsCopied(false);
            experienceTracker.abort({
                name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE),
                reason: 'user navigated away'
            });
        },
        shouldFitContainer: true
    })), isCopied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE)
    }));
};
const $5e79baa87b282684$export$1711531201a0c4b7 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($5e79baa87b282684$var$CopyLinkComponent);
module.exports["ACTION_SUBJECT_ID"] = $5e79baa87b282684$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $5e79baa87b282684$export$e82cf716cce37b4e;
module.exports["CopyLink"] = $5e79baa87b282684$export$1711531201a0c4b7;

});

parcelRegister("hjygH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $1aeb691895c5954d$export$85823f26dca064c3 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceStop(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceStop({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (error) experienceTracker.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
        else experienceTracker.succeed({
            name: name,
            attributes: attributes
        });
    }, [
        experienceTracker,
        name,
        attributes,
        error
    ]);
    return null;
};
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("3WXN2", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $3JQXa = parcelRequire("3JQXa");


var $9WYR7 = parcelRequire("9WYR7");

const $1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery = (0, $eSUdr.default)`query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id links{editui webui tinyui base}}}`;
var $1e41cfcb0548d2ef$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $1e41cfcb0548d2ef$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $3JQXa.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $j1Ss3.useQuery)($1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        }
    });
    const getCopyContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $9WYR7.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $9WYR7.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
            // omit unsupported content types
            default:
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $9WYR7.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $9WYR7.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $42omo.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $1e41cfcb0548d2ef$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $1e41cfcb0548d2ef$export$a049904f049cf16d;

});

parcelRegister("3JQXa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e2866f1e30f0246d$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = (0, $42omo.useCallback)(async (value)=>{
        // check if the browser supports the clipboard API
        if (value && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') await navigator.clipboard.writeText(value);
    }, []);
    return (0, $42omo.useMemo)(()=>({
            copyToClipboard: copyToClipboard
        }), [
        copyToClipboard
    ]);
};
module.exports["useCopyToClipboard"] = $e2866f1e30f0246d$export$b2199c37e85de4a7;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $7sObp.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $7sObp.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhk1j28 _kqswlr7h _lcxv12je _1bsb1osq _1e0c11p5",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$titleAndBreadcrumbsBaseStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'auto',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.small',
    paddingInline: 'space.100',
    paddingBlockEnd: 'space.050',
    display: 'flex',
    flexWrap: 'nowrap',
    paddingBlockStart: 'space.050',
    height: '100%'
});
// Utilized only when the content header is pinned and during the viewing of public whiteboards
const $3d1681a377877e6e$var$alignCenterStyle = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $3d1681a377877e6e$var$titleAndBreadcrumbsBaseStyles,
            isContentHeaderPinned && $3d1681a377877e6e$var$alignCenterStyle
        ]
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("deZfn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3af5d746447ab7ac$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "u0VI7",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("gS8hC"))).ArchivedPageBanner
});

const $3af5d746447ab7ac$export$59d39ce9027a0e01 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cwXQQ",
    name: "ArchivedPageBannerAfterPaint",
    loader: async ()=>(await (parcelRequire("gS8hC"))).ArchivedPageBanner
});
module.exports["ArchivedPageBanner"] = $3af5d746447ab7ac$export$a32ab742d345a2c9;
module.exports["ArchivedPageBannerAfterPaint"] = $3af5d746447ab7ac$export$59d39ce9027a0e01;

});

parcelRegister("gS8hC", function(module, exports) {

let $c4881d540ace89f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4881d540ace89f8$var$load("g5te7"),
    $c4881d540ace89f8$var$load("6rpul")
]).then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("aSsfA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
} : ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("8z0fF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $kC9tB = parcelRequire("kC9tB");


const $fcf77a474368dc3c$export$2626335f65c6c2ab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GPirm",
    name: "EmojiTitleSelection",
    loader: async ()=>(await (parcelRequire("ctRuH"))).EmojiTitleSelection,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC9tB.EmojiTitleSelectionPlaceholder), props)
});
module.exports["EmojiTitleSelection"] = $fcf77a474368dc3c$export$2626335f65c6c2ab;

});

parcelRegister("kC9tB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $crLHf = parcelRequire("crLHf");

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const $12207dce16c7aead$var$paddingStyle = (0, $ecnYn.xcss)({
    paddingRight: 'space.150',
    // this is the spacing between the emoji button and the title
    paddingLeft: 'space.050' // necessary for left aligning placeholder with emoji button (value comes from from button base)
});
const $12207dce16c7aead$export$f477b16652398d6f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned } = t0;
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    let t1;
    if ($[0] !== hasCoverPicture || $[1] !== hasInitialEmoji || $[2] !== needsPadding) {
        t1 = hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
            testId: "emoji-selection-placeholder-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: hasCoverPicture ? 80 : 40
        })) : null;
        $[0] = hasCoverPicture;
        $[1] = hasInitialEmoji;
        $[2] = needsPadding;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned })=>{
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    return hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
        testId: "emoji-selection-placeholder-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
        height: hasCoverPicture ? 80 : 40
    })) : null;
};
module.exports["EmojiTitleSelectionPlaceholder"] = $12207dce16c7aead$export$f477b16652398d6f;

});

parcelRegister("crLHf", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const PLACEHOLDER_SIZE = props.height || 26;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...animationProps,
            "data-testid": "emoji-placeholder",
            "data-css-target": "emoji-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                width: `${PLACEHOLDER_SIZE}px`,
                height: `${PLACEHOLDER_SIZE}px`,
                margin: props.loadingMargin
            },
            className: (0, $gMc0m.default)([
                "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
            ])
        })));
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("ctRuH", function(module, exports) {

let $9161b0472dec4481$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9161b0472dec4481$var$load("dlm6q"),
    $9161b0472dec4481$var$load("ioQAS"),
    $9161b0472dec4481$var$load("6wr18"),
    $9161b0472dec4481$var$load("kjZZD"),
    $9161b0472dec4481$var$load("ffEVr"),
    $9161b0472dec4481$var$load("2bmVk"),
    $9161b0472dec4481$var$load("6KGrg"),
    $9161b0472dec4481$var$load("4hZJd")
]).then(()=>parcelRequire('leLdu'));

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $9ee4137247832c84$var$getExperimentValue = (0, $c6GJD.default).getExperimentValue;
const $9ee4137247832c84$var$EXPERIMENT = 'platform_global_preview_panels_default_width';
const $9ee4137247832c84$export$c82b124a4ae0f274 = 'isEnabled';
const $9ee4137247832c84$export$56368731b0f4a091 = 'minimumWidth';
const $9ee4137247832c84$export$97a0618f336c05be = 'ratio';
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$FALLBACK_RATIO = 0.25;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    if (!$9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$c82b124a4ae0f274, false)) return $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    const windowWidth = window.innerWidth;
    const minWidthForWiderPanel = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$56368731b0f4a091, Number.MAX_VALUE);
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth > minWidthForWiderPanel) {
        const panelWidthToWindowWidthRatio = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$97a0618f336c05be, $9ee4137247832c84$var$FALLBACK_RATIO);
        const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("l7iY7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");

const $508580e8423e2725$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $508580e8423e2725$export$26f6630e61e959f9 = (isUnpublishedDraft)=>{
    const hasSeenPublishSpotlightRef = (0, $42omo.useRef)(null);
    const showRecap2025QueryParam = $508580e8423e2725$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isUnpublishedDraft;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT, !isEligible || !(0, $9wGTI.fg)('cc_recap_2025_nudge_enabled'));
    const { hasSeenPublishSpotlight: hasSeenPublishSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Mark GraphQL errors as handled since we gracefully treat them as "hasn't seen spotlight"
    (0, $42omo.useEffect)(()=>{
        if (onboardingStateError) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    }, [
        onboardingStateError
    ]);
    // Capture the value once when it first becomes available
    // This ensures state changes during the current render cycle don't affect eligibility
    if (hasSeenPublishSpotlightRef.current === null && !onboardingStateLoading) hasSeenPublishSpotlightRef.current = hasSeenPublishSpotlight;
    if (!(0, $9wGTI.fg)('cc_recap_2025_nudge_enabled')) return false;
    if (onboardingStateLoading || onboardingStateError) return false;
    // If user has already seen the spotlight, don't show it again
    if (Boolean(hasSeenPublishSpotlightRef.current)) return false;
    return isEligible;
};
module.exports["useRecapSpotlightEligibility"] = $508580e8423e2725$export$26f6630e61e959f9;

});

parcelRegister("6LsQQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $g2gGv = parcelRequire("g2gGv");

const $f8780459a3f4abf6$export$7da3cd10eb68919e = (0, $eSUdr.default)`query ContentTypesHeaderQuery($contentId:ID$useObjectHeader:Boolean!){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type subType status version@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedVersionFragment}draftVersion@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedDraftVersionFragment}}}}${(0, $g2gGv.LastEditedVersionFragment)}${(0, $g2gGv.LastEditedDraftVersionFragment)}`;
module.exports["ContentTypesHeaderQuery"] = $f8780459a3f4abf6$export$7da3cd10eb68919e;

});

parcelRegister("g2gGv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $82f60ea6bd1b627b$export$deecf62d8ca1b922 = (0, $eSUdr.default)`fragment LastEditedVersionFragment on Version{by{displayName}when}`;
const $82f60ea6bd1b627b$export$36bc043d85f07c8 = (0, $eSUdr.default)`fragment LastEditedDraftVersionFragment on Version{by{displayName}when}`;
module.exports["LastEditedVersionFragment"] = $82f60ea6bd1b627b$export$deecf62d8ca1b922;
module.exports["LastEditedDraftVersionFragment"] = $82f60ea6bd1b627b$export$36bc043d85f07c8;

});

parcelRegister("5qUgM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $15M40 = parcelRequire("15M40");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("7d41Y", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("15M40", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8336b070b3684358$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $8336b070b3684358$export$8fdec53caa79133c;

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $cgtv4.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $8C5kA.default)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence")
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    if (typeof document !== 'undefined' && document.title && !contentTitle) {
        // If contentTitle is empty, we're likely setting a generic title (just siteTitle or siteTitle with space)
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title && !isHomePage) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement('script', {
                dangerouslySetInnerHTML: {
                    __html: `document.title=${(0, $8vxJi.stringifyForSSR)(title)};`
                }
            });
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("kSPGK", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $frIzR.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : (contentId, initialTitle, onOptimisticUpdate)=>{
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    const publishOptimisticTitle = (0, $42omo.useCallback)((value)=>{
        if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
    }, [
        contentId,
        optimisticTitle
    ]);
    const handleTitleChanged = (0, $42omo.useCallback)((title)=>{
        setOptimisticTitle(title);
        onOptimisticUpdate && onOptimisticUpdate(contentId, title);
    }, [
        contentId,
        setOptimisticTitle,
        onOptimisticUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
        return ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
        };
    }, [
        contentId,
        handleTitleChanged
    ]);
    // If initialTitle changes, update optimistic title to match new initialTitle.
    // Why? This fixes scenarios where the BE title of the page changes without the title changing on the FE, e.g. when a draft with no title is converted to a live page with a title generated by the BE.
    //      Without this useEffect, the title will undesirably stay as the original initialTitle of "Untitled" instead of using the new title from the BE.
    (0, $42omo.useEffect)(()=>{
        setOptimisticTitle(initialTitle);
    }, [
        initialTitle
    ]);
    return {
        optimisticTitle: optimisticTitle,
        setOptimisticTitle: publishOptimisticTitle
    };
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $eSUdr = parcelRequire("eSUdr");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");


var $6mKj3 = parcelRequire("6mKj3");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const apolloClient = (0, $7hXu9.useApolloClient)();
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default)
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default)
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default)
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default)
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const fragment = (0, $eSUdr.default)`fragment useUpdateLastEditedTimestampVersionCacheOldFragment on Version{by{displayName}when}`;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) {
            try {
                const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
                const prevCache = readFragmentInterop({
                    id: id
                });
                if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
            } catch  {
            // silently fallback to default typename "KnownUser"
            }
            try {
                const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
                writeFragmentInterop({
                    fragmentId: id,
                    data: {
                        by: {
                            displayName: displayName,
                            __typename: prevTypename
                        },
                        when: newWhen,
                        __typename: 'Version'
                    }
                });
            } catch  {
            // silently fail write to cache
            }
        } else {
            try {
                const prevCache = apolloClient.readFragment({
                    id: id,
                    fragment: fragment
                });
                if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
            } catch  {
            // silently fallback to default typename "KnownUser"
            }
            try {
                apolloClient.writeFragment({
                    id: id,
                    fragment: fragment,
                    data: {
                        by: {
                            displayName: displayName,
                            __typename: prevTypename
                        },
                        when: newWhen,
                        __typename: 'Version'
                    }
                });
            } catch  {
            // silently fail write to cache
            }
        }
    };
    const updateTimestampCacheWithCallback = (0, $42omo.useCallback)(updateTimestampCache, [
        apolloClient,
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true)) return updateTimestampCacheWithCallback;
    return updateTimestampCache;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<2ac329da81149c1c3666eddb688657bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<0a1c88ca4a42ad82ed80e88345c91c0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<375bcded8b18381e41f1464677a39a40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<faed0d1cb93aff3affdab8bcefc50ba6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("kXsBa", function(module, exports) {

var $cXQmG = parcelRequire("cXQmG");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $cgpF0 = parcelRequire("cgpF0");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");

const $563fbe27571904a7$export$57b25de3525e313f = (contentId, currentTitle)=>{
    const [isEditing, setIsEditing] = (0, $42omo.useState)(false);
    const [updatedTitleFromPubsub, setUpdatedTitleFromPubsub] = (0, $42omo.useState)(undefined);
    const isProcessingTitleUpdate = (0, $42omo.useRef)(false);
    const onMutationComplete = ()=>{
        setUpdateError(undefined);
        setIsEditing(false);
    };
    const [updateError, setUpdateError] = (0, $42omo.useState)(undefined);
    const [updateContentTitle, { loading: updateLoading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!$title:String){updateTitle(contentId:$contentId title:$title){id title links{editui webui}}}`, {
        onCompleted: onMutationComplete,
        onError: setUpdateError
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $cXQmG.default)
    });
    const updateCache = (0, $42omo.useCallback)((value)=>{
        writeFragmentInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                id: contentId,
                title: value,
                __typename: 'Content'
            }
        });
    }, [
        contentId,
        writeFragmentInterop
    ]);
    const updateTitle = (0, $42omo.useCallback)(async (value_0)=>{
        if (value_0 === currentTitle) {
            setIsEditing(false);
            // We have to manually clear the error here because it is no longer relevant to this most recent call to `updateTitle`,
            // since we're now attempting to set the title back to the current title, which should be valid.
            setUpdateError(undefined);
            if (updatedTitleFromPubsub && updatedTitleFromPubsub !== currentTitle) {
                updateCache(updatedTitleFromPubsub);
                setUpdatedTitleFromPubsub(undefined);
            }
            if (!isProcessingTitleUpdate.current) return;
        }
        try {
            await updateContentTitle({
                variables: {
                    contentId: contentId,
                    title: value_0
                }
            });
        } catch  {
        // error handled by useMutation result updateError
        }
    }, [
        contentId,
        currentTitle,
        updateCache,
        updateContentTitle,
        updatedTitleFromPubsub
    ]);
    /**
   * The following section is a mutation queue to ensure that title updates are processed sequentially and that the
   * latest title is always the one that gets applied.
   * This is important because multiple title updates can be triggered in quick succession when AI inline streaming
   * occurs and we want to avoid stale state errors from the GQL store, but also ensure the latest title is the one that
   * gets applied.
   */ const latestCachedTitle = (0, $42omo.useRef)();
    const processQueue = (0, $42omo.useCallback)(async ()=>{
        if (isProcessingTitleUpdate.current) return;
        isProcessingTitleUpdate.current = true;
        let nextTitle = latestCachedTitle.current;
        latestCachedTitle.current = undefined;
        // We keep updating the title until there are no more titles in the cache
        while(!!nextTitle){
            await updateTitle(nextTitle);
            nextTitle = latestCachedTitle.current;
            latestCachedTitle.current = undefined;
        }
        isProcessingTitleUpdate.current = false;
    }, [
        updateTitle
    ]);
    const enqueueTitle = (0, $42omo.useCallback)(async (title)=>{
        latestCachedTitle.current = title;
        if (!isProcessingTitleUpdate.current) await processQueue();
    }, [
        processQueue
    ]);
    // Set the title change handler when the component mounts
    // Content types use this method to update the title from within the iframe
    (0, $42omo.useEffect)(()=>{
        (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(updateTitle);
        return ()=>{
            (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(()=>{});
        };
    }, [
        updateTitle
    ]);
    return {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub,
        updateLoading: updateLoading,
        updateError: updateError,
        updateTitle: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitle : updateTitle,
        updateCache: updateCache
    };
};
module.exports["useContentTypesTitleUpdate"] = $563fbe27571904a7$export$57b25de3525e313f;

});

parcelRegister("cXQmG", function(module, exports) {
/**
 * @generated SignedSource<<3a0cc20ba43170d4195e7743f00dc422>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6b675ba61ab7de1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$d6b675ba61ab7de1$var$node.hash = "3d624df929b7f5b6bedfdab8b98fb427";
var $d6b675ba61ab7de1$export$2e2bcd8739ae039 = $d6b675ba61ab7de1$var$node;
module.exports["default"] = $d6b675ba61ab7de1$export$2e2bcd8739ae039;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("9vvQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c3928c64a97db38eb981c4055c674e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ebfb6f6e33ed6b8$var$_react = $6ebfb6f6e33ed6b8$var$_interopRequireDefault((parcelRequire("42omo")));

var $6ebfb6f6e33ed6b8$var$_baseNew = $6ebfb6f6e33ed6b8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6ebfb6f6e33ed6b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ebfb6f6e33ed6b8$var$ScreenIcon = (props)=>/*#__PURE__*/ $6ebfb6f6e33ed6b8$var$_react.default.createElement($6ebfb6f6e33ed6b8$var$_baseNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$6ebfb6f6e33ed6b8$var$ScreenIcon.displayName = 'ScreenIcon';
var $6ebfb6f6e33ed6b8$var$_default = module.exports.default = $6ebfb6f6e33ed6b8$var$ScreenIcon;

});

parcelRegister("cxCWb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $gaGKC = parcelRequire("gaGKC");


const $56c3dbef55a81b41$export$a1f5ff36b0810fd8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0sh4s",
    name: "FavouriteButton",
    loader: async ()=>(await (parcelRequire("dRU1E"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});

const $56c3dbef55a81b41$export$4151d732511e5aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m_S4n",
    name: "LazyFavouriteButton",
    loader: async ()=>(await (parcelRequire("dRU1E"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});
module.exports["FavouriteButton"] = $56c3dbef55a81b41$export$a1f5ff36b0810fd8;
module.exports["LazyFavouriteButton"] = $56c3dbef55a81b41$export$4151d732511e5aa6;

});

parcelRegister("gaGKC", function(module, exports) {
/* FavouriteButtonPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $kfYj7 = parcelRequire("kfYj7");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ecf1ddef823285$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $97ecf1ddef823285$export$d599e45cb4e3913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97ecf1ddef823285$var$StyledButton, {
        "data-test-id": "page-favourite-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        isDisabled: true
    });
module.exports["FavouriteButtonPlaceholder"] = $97ecf1ddef823285$export$d599e45cb4e3913;

});

parcelRegister("dRU1E", function(module, exports) {

let $a18baf22d869c86f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a18baf22d869c86f$var$load("lUlCu"),
    $a18baf22d869c86f$var$load("fZt2F"),
    $a18baf22d869c86f$var$load("1sXQt")
]).then(()=>parcelRequire('lDaLP'));

});

parcelRegister("9SsRl", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $730f8b16a3d58539$export$8ce793b178574678 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["WATCH_BUTTON_METRIC"] = $730f8b16a3d58539$export$8ce793b178574678;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("2cKGu", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
        if (contentMode === 'draft') return false;
        return contentType === 'page' || contentType === 'blogpost' || contentType === 'whiteboard' || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
    } else return contentType === 'whiteboard' || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("4wEOc", function(module, exports) {

var $hGuUS = parcelRequire("hGuUS");


var $jMyy4 = parcelRequire("jMyy4");

const $17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery = (0, $hGuUS.default);
const $17b0e005176b05e7$export$2e6840e38da4c328 = ({ skip: skip = false } = {})=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery, {
        context: {
            single: true
        },
        skip: skip
    });
    const isEnabled = Boolean(data?.isDataClassificationEnabled);
    return {
        isEnabled: isEnabled,
        error: error,
        loading: loading
    };
};
module.exports["useIsDataClassificationEnabledForOrg"] = $17b0e005176b05e7$export$2e6840e38da4c328;

});

parcelRegister("hGuUS", function(module, exports) {
/**
 * @generated SignedSource<<b0abdf0d5cd8bf05705f2652464b7df5>>
 * @relayHash 7a459e5b02d70f6bd0fcfe9c6f09aaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe
const $d06bb9e5b53f54be$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isDataClassificationEnabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7a459e5b02d70f6bd0fcfe9c6f09aaed",
            "id": "f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe",
            "metadata": {},
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "operationKind": "query",
            "text": "query useIsDataClassificationEnabledForOrgQuery{isDataClassificationEnabled}"
        }
    };
}();
$d06bb9e5b53f54be$var$node.hash = "5fefa316f3ebea3d1e92d59f94b250db";
var $d06bb9e5b53f54be$export$2e2bcd8739ae039 = $d06bb9e5b53f54be$var$node;
module.exports["default"] = $d06bb9e5b53f54be$export$2e2bcd8739ae039;

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("16ET8"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $buthI = parcelRequire("buthI");


var $9wGTI = parcelRequire("9wGTI");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $8C5kA.default)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader : (0, $lACKt.i18nShared).chevronButtonTooltip)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $cgtv4.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltip: {
        id: "publish-modal.split-button-tooltip",
        defaultMessage: "Adjust update settings"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("16ET8", function(module, exports) {

let $0ce6118b6ccf4086$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ce6118b6ccf4086$var$load("6FuHS"),
    $0ce6118b6ccf4086$var$load("eyaRC"),
    $0ce6118b6ccf4086$var$load("6wr18"),
    $0ce6118b6ccf4086$var$load("kahM9"),
    $0ce6118b6ccf4086$var$load("cYWWR"),
    $0ce6118b6ccf4086$var$load("2F69B"),
    $0ce6118b6ccf4086$var$load("5zDuS"),
    $0ce6118b6ccf4086$var$load("hhss7"),
    $0ce6118b6ccf4086$var$load("7EorR"),
    $0ce6118b6ccf4086$var$load("awqCy"),
    $0ce6118b6ccf4086$var$load("7u4WP"),
    $0ce6118b6ccf4086$var$load("let0D"),
    $0ce6118b6ccf4086$var$load("ffEVr"),
    $0ce6118b6ccf4086$var$load("g7g2y"),
    $0ce6118b6ccf4086$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("eGUYy", function(module, exports) {

let $ab212f216942c1d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab212f216942c1d6$var$load("8yTXr"),
    $ab212f216942c1d6$var$load("g9CVe"),
    $ab212f216942c1d6$var$load("5EQhG"),
    $ab212f216942c1d6$var$load("h2QhJ"),
    $ab212f216942c1d6$var$load("4eboO"),
    $ab212f216942c1d6$var$load("7EorR"),
    $ab212f216942c1d6$var$load("St9Nk"),
    $ab212f216942c1d6$var$load("drv5I"),
    $ab212f216942c1d6$var$load("dTsOE"),
    $ab212f216942c1d6$var$load("34R0T")
]).then(()=>parcelRequire('f2tcq'));

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("bjZbA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8tdj3 = parcelRequire("8tdj3");


var $1qfLF = parcelRequire("1qfLF");


var $ep3mz = parcelRequire("ep3mz");


var $iXzFq = parcelRequire("iXzFq");

const $b9c78150b710374f$export$692138f5b3745b91 = ()=>{
    const [{ contentId: contentId, contentType: contentType, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const handleClick = ()=>{
        if (!contentId || !contentType || !spaceKey) return;
        const url = (0, $iXzFq.getUrlForContentType)({
            contentType: contentType,
            contentId: contentId,
            spaceKey: spaceKey,
            redirectToEditor: false
        });
        if (!url) return;
        window.open(url, '_blank');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        label: "Open in new window",
        onClick: handleClick,
        testId: "loom-external-open-button"
    });
};
module.exports["LoomExternalOpenButton"] = $b9c78150b710374f$export$692138f5b3745b91;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("3o3i5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");

const $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $d83b6646de023a51$var$defaultEditorObjectHeaderContext = {
    saveDraft: ()=>Promise.resolve(),
    navigateOnClose: ()=>{},
    triggerAnalyticsEvent: ()=>{},
    version: 0,
    editorActions: {
        isDocumentEmpty: ()=>{}
    },
    title: '',
    retrieveEditorTitleAndContent: $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent,
    onPreviewClicked: ()=>{},
    isPublishingContent: false,
    userOffline: false,
    editorTitle: null,
    collabLimitReached: false,
    collabEditConnected: false,
    onClickPublish: ()=>{},
    shouldRenderPreview: false,
    shouldShowNewContentHistory: false,
    isUnpublishedDraft: false,
    onHoverPublish: ()=>{}
};
const $d83b6646de023a51$var$EditorObjectHeaderContext = /*#__PURE__*/ (0, $42omo.createContext)($d83b6646de023a51$var$defaultEditorObjectHeaderContext);
const $d83b6646de023a51$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d83b6646de023a51$export$7cf4636ad0f38e12 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, value: value } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $d83b6646de023a51$var$memoizeDeepEq(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    const memoizedValue = t1;
    const t2 = memoizedValue;
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d83b6646de023a51$var$EditorObjectHeaderContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, value: value })=>{
    const memoizedValue = $d83b6646de023a51$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d83b6646de023a51$var$EditorObjectHeaderContext.Provider, {
        value: memoizedValue
    }, children);
};
const $d83b6646de023a51$export$54525653dcbc614a = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d83b6646de023a51$var$EditorObjectHeaderContext);
    if (!context) throw new Error("useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider, and a `value` must be provided to EditorObjectHeaderContextProvider");
    return context;
} : ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d83b6646de023a51$var$EditorObjectHeaderContext);
    if (!context) throw new Error('useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider, and a `value` must be provided to EditorObjectHeaderContextProvider');
    return context;
};
module.exports["EditorObjectHeaderContextProvider"] = $d83b6646de023a51$export$7cf4636ad0f38e12;
module.exports["useEditorObjectHeaderContext"] = $d83b6646de023a51$export$54525653dcbc614a;

});

parcelRegister("8jTDW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e542faf6fbe5ebc711b672478100d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60eb42a7b08ac844$var$_react = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("42omo")));

var $60eb42a7b08ac844$var$_baseNew = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60eb42a7b08ac844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudOffline".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for showing when a connection can't be established to the cloud.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60eb42a7b08ac844$var$CloudOfflineIcon = (props)=>/*#__PURE__*/ $60eb42a7b08ac844$var$_react.default.createElement($60eb42a7b08ac844$var$_baseNew.default, Object.assign({
        name: "CloudOfflineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.5 1.5H3.75a3.75 3.75 0 0 1-1.42-7.22q.06-.32.14-.62l1.29 1.28a.75.75 0 0 1-.56.63A2.25 2.25 0 0 0 3.75 12zM8 1.5c-.96 0-1.87.24-2.66.65l1.13 1.13a4.25 4.25 0 0 1 5.72 3.23.75.75 0 0 0 .53.59 2.5 2.5 0 0 1 1.36 3.79l1.07 1.07a4 4 0 0 0-1.58-6.15A5.75 5.75 0 0 0 8 1.5"/>`
    }, props));
$60eb42a7b08ac844$var$CloudOfflineIcon.displayName = 'CloudOfflineIcon';
var $60eb42a7b08ac844$var$_default = module.exports.default = $60eb42a7b08ac844$var$CloudOfflineIcon;

});

parcelRegister("jY68A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c064ac252dc790$var$_react = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("42omo")));

var $03c064ac252dc790$var$_baseNew = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $03c064ac252dc790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03c064ac252dc790$var$SyncIcon = (props)=>/*#__PURE__*/ $03c064ac252dc790$var$_react.default.createElement($03c064ac252dc790$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$03c064ac252dc790$var$SyncIcon.displayName = 'SyncIcon';
var $03c064ac252dc790$var$_default = module.exports.default = $03c064ac252dc790$var$SyncIcon;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("6fjxX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a07179b7f5702563b15bc18315c2436>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48c34e576a5d6e3c$var$_react = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("42omo")));

var $48c34e576a5d6e3c$var$_baseNew = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $48c34e576a5d6e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48c34e576a5d6e3c$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $48c34e576a5d6e3c$var$_react.default.createElement($48c34e576a5d6e3c$var$_baseNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$48c34e576a5d6e3c$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $48c34e576a5d6e3c$var$_default = module.exports.default = $48c34e576a5d6e3c$var$MegaphoneIcon;

});

parcelRegister("avrhI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc3145262927e8aafd6e7a23c5905db2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a61f6ca9f1fa7cb$var$_react = $7a61f6ca9f1fa7cb$var$_interopRequireDefault((parcelRequire("42omo")));

var $7a61f6ca9f1fa7cb$var$_baseNew = $7a61f6ca9f1fa7cb$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7a61f6ca9f1fa7cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a61f6ca9f1fa7cb$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $7a61f6ca9f1fa7cb$var$_react.default.createElement($7a61f6ca9f1fa7cb$var$_baseNew.default, Object.assign({
        name: "FullscreenEnterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$7a61f6ca9f1fa7cb$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $7a61f6ca9f1fa7cb$var$_default = module.exports.default = $7a61f6ca9f1fa7cb$var$FullscreenEnterIcon;

});

parcelRegister("gDbO8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $efvKr = parcelRequire("efvKr");


var $82Ooj = parcelRequire("82Ooj");


var $khqIr = parcelRequire("khqIr");

const $074be0d28909724e$export$9674de41b3e1d3c1 = ({ contentId: contentId, isDisabled: isDisabled, flags: flags, analyticsSource: analyticsSource, elemAfter: elemAfter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ mode: livePageMode }, { setMode: setLivePageMode }] = (0, $efvKr.useLivePageMode)();
    const { showLivePageModeFlag: showLivePageModeFlag } = (0, $82Ooj.useLivePageModeFlag)(flags);
    const handleModeChange = (newMode)=>{
        showLivePageModeFlag(newMode);
        setLivePageMode(newMode);
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                source: analyticsSource,
                action: 'changed',
                actionSubject: 'mode',
                actionSubjectId: 'livePagesModeSwitcher',
                attributes: {
                    previousMode: livePageMode,
                    newMode: newMode
                },
                objectType: 'page',
                objectId: contentId
            }
        })?.fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khqIr.LivePagesModeChangerDropdown), {
        selectedMode: livePageMode ?? 'view',
        onChange: handleModeChange,
        isDisabled: isDisabled,
        elemAfter: elemAfter
    });
};
module.exports["LivePagesModeChanger"] = $074be0d28909724e$export$9674de41b3e1d3c1;

});

parcelRegister("82Ooj", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $8C5kA.default)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("khqIr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $5dK2X = parcelRequire("5dK2X");


var $dAYOx = parcelRequire("dAYOx");


var $x4n5k = parcelRequire("x4n5k");


var $1Zr9M = parcelRequire("1Zr9M");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $d0922dfcb7434c92$var$i18n = (0, $cgtv4.defineMessages)({
    modeToggleToEdit: {
        id: "live-pages-features.live-pages-mode-switcher.editing.edit-dropdown",
        defaultMessage: "Resume editing"
    },
    modeToggleToView: {
        id: "live-pages-features.live-pages-mode-switcher.editing.view-dropdown",
        defaultMessage: "Switch to viewing"
    }
});
const $d0922dfcb7434c92$export$7266636f729f5bc9 = ({ selectedMode: selectedMode, onChange: onChange, isDisabled: isDisabled, elemAfter: elemAfter })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const dropdownMenuContent = selectedMode === 'edit' ? $d0922dfcb7434c92$var$i18n.modeToggleToView : $d0922dfcb7434c92$var$i18n.modeToggleToEdit;
    const shortcut = selectedMode === 'edit' ? (0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW) : (0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT);
    const getShortcutComponent = ()=>{
        if (elemAfter) return elemAfter({
            shortcutKeys: [
                shortcut
            ],
            id: 'viewEditToggle'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: shortcut
        });
    };
    const Icon = selectedMode === 'edit' ? (0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: ""
        }),
        elemAfter: getShortcutComponent(),
        testId: "live-page-mode-toggle-label",
        onClick: ()=>onChange?.(selectedMode === 'view' ? 'edit' : 'view'),
        "aria-label": formatMessage(dropdownMenuContent),
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), dropdownMenuContent)));
};
module.exports["LivePagesModeChangerDropdown"] = $d0922dfcb7434c92$export$7266636f729f5bc9;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("gEtAQ", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("78wUU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("1XBTi"))).MoveBlogModal
});
module.exports["MoveBlogModalLoader"] = $745e4e253bb54f50$export$fbea3c6f057d30b6;

});

parcelRegister("1XBTi", function(module, exports) {

let $16d8b177b3877728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16d8b177b3877728$var$load("6wr18"),
    $16d8b177b3877728$var$load("lnnYm"),
    $16d8b177b3877728$var$load("ffEVr"),
    $16d8b177b3877728$var$load("Wowvf"),
    $16d8b177b3877728$var$load("hhss7"),
    $16d8b177b3877728$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("96kIh"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");

const $565f8db62106cdff$var$i18n = (0, $cgtv4.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $8C5kA.default)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("96kIh", function(module, exports) {

let $6a04bdcc8f282e9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a04bdcc8f282e9a$var$load("3VLKz"),
    $6a04bdcc8f282e9a$var$load("2Mq3f"),
    $6a04bdcc8f282e9a$var$load("4t77a"),
    $6a04bdcc8f282e9a$var$load("7EorR"),
    $6a04bdcc8f282e9a$var$load("e9JE4"),
    $6a04bdcc8f282e9a$var$load("e4GNb"),
    $6a04bdcc8f282e9a$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("d8oE8", function(module, exports) {
const $305fd3cd961d4815$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId, contentStatus)=>{
    if (!contentType || !contentId) return;
    const isBlogPost = contentType === 'blogpost';
    const isCreate = contentStatus === 'draft';
    if (isBlogPost && !isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
    else if (!isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
    else push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
};
module.exports["onClickPageRevert"] = $305fd3cd961d4815$export$bd41ea3025fc88df;

});

parcelRegister("6ykQV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf5e0ab73c00afb3$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fmQ7C",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("9BhWS"))).DeleteNestedPagesAction
});
module.exports["DeleteNestedPagesActionLoader"] = $cf5e0ab73c00afb3$export$25f686fb78162d50;

});

parcelRegister("9BhWS", function(module, exports) {

let $6fd57dfd69928c7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fd57dfd69928c7b$var$load("kHOMt"),
    $6fd57dfd69928c7b$var$load("6wr18"),
    $6fd57dfd69928c7b$var$load("73HOd"),
    $6fd57dfd69928c7b$var$load("iQ0Jm"),
    $6fd57dfd69928c7b$var$load("a4yJG"),
    $6fd57dfd69928c7b$var$load("Wowvf"),
    $6fd57dfd69928c7b$var$load("jXx9i"),
    $6fd57dfd69928c7b$var$load("iZU4p"),
    $6fd57dfd69928c7b$var$load("ffEVr"),
    $6fd57dfd69928c7b$var$load("9ftJe"),
    $6fd57dfd69928c7b$var$load("hhss7"),
    $6fd57dfd69928c7b$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("fjiOd", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $78914c14925ace72$export$abf96c374bfacb58 = (0, $eSUdr.default)`query WebItemLocationQuery($location:String$locations:[String]$contentId:ID$spaceKey:String$version:Int){webItemSections(location:$location locations:$locations contentId:$contentId key:$spaceKey version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}`;
const $78914c14925ace72$export$c4b66d2db87918fa = (0, $eSUdr.default)`query WebItemLocationWithSpaceKeyQuery($location:String$locations:[String]$spaceKey:String$version:Int){space(key:$spaceKey){id homepageId homepageWebSections(location:$location locations:$locations version:$version){id label cacheKey styleClass items{accessKey completeKey hasCondition id icon{height width path}params{key value}label moduleKey section styleClass tooltip url urlWithoutContextPath weight}}}}`;
module.exports["WebItemLocationQuery"] = $78914c14925ace72$export$abf96c374bfacb58;
module.exports["WebItemLocationWithSpaceKeyQuery"] = $78914c14925ace72$export$c4b66d2db87918fa;

});

parcelRegister("kxhju", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gTyTP = parcelRequire("gTyTP");


var $1gjU5 = parcelRequire("1gjU5");


var $fjiOd = parcelRequire("fjiOd");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch, isLiveDocsEnabled: isLiveDocsEnabled } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $fjiOd.WebItemLocationQuery),
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            if (isLiveDocsEnabled) webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    let t0;
    if ($[0] !== isLivePagesFeatureEnabled || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
            ...props,
            isLiveDocsEnabled: isLivePagesFeatureEnabled
        });
        $[0] = isLivePagesFeatureEnabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
        ...props,
        isLiveDocsEnabled: isLivePagesFeatureEnabled
    });
};
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("bavCP", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");

function $86f32d96feea2a1f$export$67f105fad14d18d({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
}
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("1gjU5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw140y _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw140y _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ])
    });
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("bHd1w", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("hXpXU"))).MovePageDialog
});
module.exports["MovePageDialog"] = $4f760397570928c6$export$28f6951b4656036e;

});

parcelRegister("hXpXU", function(module, exports) {

let $d12c16863fdd458b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d12c16863fdd458b$var$load("6wr18"),
    $d12c16863fdd458b$var$load("e4XZ1"),
    $d12c16863fdd458b$var$load("5ppK3"),
    $d12c16863fdd458b$var$load("7WcBh"),
    $d12c16863fdd458b$var$load("lVcuZ"),
    $d12c16863fdd458b$var$load("lnnYm"),
    $d12c16863fdd458b$var$load("19uFC"),
    $d12c16863fdd458b$var$load("a4yJG"),
    $d12c16863fdd458b$var$load("2t3HP"),
    $d12c16863fdd458b$var$load("fzHDF"),
    $d12c16863fdd458b$var$load("5zDuS"),
    $d12c16863fdd458b$var$load("lUQAm"),
    $d12c16863fdd458b$var$load("7u4WP"),
    $d12c16863fdd458b$var$load("Wowvf"),
    $d12c16863fdd458b$var$load("dS0Pr"),
    $d12c16863fdd458b$var$load("huYla"),
    $d12c16863fdd458b$var$load("amUNi"),
    $d12c16863fdd458b$var$load("2haIE"),
    $d12c16863fdd458b$var$load("9K4jq"),
    $d12c16863fdd458b$var$load("2bmVk"),
    $d12c16863fdd458b$var$load("ffEVr"),
    $d12c16863fdd458b$var$load("kUbUu"),
    $d12c16863fdd458b$var$load("7EorR"),
    $d12c16863fdd458b$var$load("hhss7"),
    $d12c16863fdd458b$var$load("7Omhy"),
    $d12c16863fdd458b$var$load("kC80R"),
    $d12c16863fdd458b$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});

parcelRegister("5FwhF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("j8HeZ"))).CopyPageTreeContainer
});
module.exports["CopyPageTreeDialog"] = $ee4e9cc4db58f73d$export$b3f442789ed34bf1;

});

parcelRegister("j8HeZ", function(module, exports) {

let $def04e611add7702$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $def04e611add7702$var$load("6wr18"),
    $def04e611add7702$var$load("5ppK3"),
    $def04e611add7702$var$load("7WcBh"),
    $def04e611add7702$var$load("lnnYm"),
    $def04e611add7702$var$load("lUQAm"),
    $def04e611add7702$var$load("kHOMt"),
    $def04e611add7702$var$load("hhss7"),
    $def04e611add7702$var$load("jXx9i"),
    $def04e611add7702$var$load("7u4WP"),
    $def04e611add7702$var$load("Wowvf"),
    $def04e611add7702$var$load("7EorR"),
    $def04e611add7702$var$load("ffEVr"),
    $def04e611add7702$var$load("kUbUu"),
    $def04e611add7702$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});

parcelRegister("3J7TU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $684d40bc929501f2$export$edb822e56299b4ef = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rCmOK",
    name: "CopyPageDialog",
    loader: async ()=>(await (parcelRequire("cq8vQ"))).CopyPageDialogContainer
});
module.exports["CopyPageDialog"] = $684d40bc929501f2$export$edb822e56299b4ef;

});

parcelRegister("cq8vQ", function(module, exports) {

let $90ae8429a2bb403d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90ae8429a2bb403d$var$load("6wr18"),
    $90ae8429a2bb403d$var$load("ffEVr"),
    $90ae8429a2bb403d$var$load("Wowvf"),
    $90ae8429a2bb403d$var$load("hhss7"),
    $90ae8429a2bb403d$var$load("aiU5r")
]).then(()=>parcelRequire('dVBJi'));

});

parcelRegister("1Zthr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $86e4d9c8583d266f$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CxVtX",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("byHyj"))).UnarchivePagesLoader
});
module.exports["UnarchivePagesDialogLoader"] = $86e4d9c8583d266f$export$9c05e92142f10f44;

});

parcelRegister("byHyj", function(module, exports) {

let $86a4a744c9cadb32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86a4a744c9cadb32$var$load("eHDb1"),
    $86a4a744c9cadb32$var$load("2zUEf"),
    $86a4a744c9cadb32$var$load("kHOMt"),
    $86a4a744c9cadb32$var$load("6EQss"),
    $86a4a744c9cadb32$var$load("6wr18"),
    $86a4a744c9cadb32$var$load("1u9sS"),
    $86a4a744c9cadb32$var$load("kH8lz"),
    $86a4a744c9cadb32$var$load("7WcBh"),
    $86a4a744c9cadb32$var$load("iQ0Jm"),
    $86a4a744c9cadb32$var$load("Wowvf"),
    $86a4a744c9cadb32$var$load("ffEVr"),
    $86a4a744c9cadb32$var$load("hhss7"),
    $86a4a744c9cadb32$var$load("jXx9i"),
    $86a4a744c9cadb32$var$load("iZU4p"),
    $86a4a744c9cadb32$var$load("7u4WP"),
    $86a4a744c9cadb32$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("k22lL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1988df8ccc55d194$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wym_j",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("lws4u"))).ArchiveUpsellDialog
});
module.exports["ArchiveUpsellDialog"] = $1988df8ccc55d194$export$8cf79fbd47bc14c3;

});

parcelRegister("lws4u", function(module, exports) {

let $fab25c81b1297ba9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fab25c81b1297ba9$var$load("hhss7"),
    $fab25c81b1297ba9$var$load("cPaXL")
]).then(()=>parcelRequire('v2hhG'));

});

parcelRegister("2WH1B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2099f9ed78e06b67$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ptN9P",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("dC1ue"))).ArchivePagesLoader
});
module.exports["ArchivePagesLoader"] = $2099f9ed78e06b67$export$baebba9f0bb9158;

});

parcelRegister("dC1ue", function(module, exports) {

let $9e8ffa340e2ab7f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e8ffa340e2ab7f6$var$load("eHDb1"),
    $9e8ffa340e2ab7f6$var$load("2zUEf"),
    $9e8ffa340e2ab7f6$var$load("6EQss"),
    $9e8ffa340e2ab7f6$var$load("6wr18"),
    $9e8ffa340e2ab7f6$var$load("1u9sS"),
    $9e8ffa340e2ab7f6$var$load("kH8lz"),
    $9e8ffa340e2ab7f6$var$load("iQ0Jm"),
    $9e8ffa340e2ab7f6$var$load("Wowvf"),
    $9e8ffa340e2ab7f6$var$load("kHOMt"),
    $9e8ffa340e2ab7f6$var$load("jXx9i"),
    $9e8ffa340e2ab7f6$var$load("iZU4p"),
    $9e8ffa340e2ab7f6$var$load("ffEVr"),
    $9e8ffa340e2ab7f6$var$load("9ftJe"),
    $9e8ffa340e2ab7f6$var$load("hhss7"),
    $9e8ffa340e2ab7f6$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("iLjL8"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("iLjL8"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("iLjL8", function(module, exports) {

let $da8bf18d9869c3f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da8bf18d9869c3f0$var$load("Wowvf"),
    $da8bf18d9869c3f0$var$load("6wr18"),
    $da8bf18d9869c3f0$var$load("ffEVr"),
    $da8bf18d9869c3f0$var$load("hhss7"),
    $da8bf18d9869c3f0$var$load("cyGuT"),
    $da8bf18d9869c3f0$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("aCrkK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");

const $91a763c2849bb3c4$var$experienceMap = {
    whiteboard: {
        restoreModal: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    database: {
        restoreModal: (0, $irVI7.DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    }
};
const $91a763c2849bb3c4$export$9560419a530f63b5 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const trackExperience = ({ contentType: contentType, experience: experience, task: task })=>{
        if (!contentType || !experience || !task) return;
        if (contentType === 'whiteboard' || contentType === 'database') {
            const experienceName = $91a763c2849bb3c4$var$experienceMap[contentType]?.[experience];
            if (experienceName) {
                if (task === 'start') experienceTracker.start({
                    name: experienceName
                });
                else experienceTracker.succeed({
                    name: experienceName
                });
            }
        }
    };
    return {
        trackExperience: trackExperience
    };
};
module.exports["useVersionHistoryExperienceTracking"] = $91a763c2849bb3c4$export$9560419a530f63b5;

});

parcelRegister("5thep", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $d81f7457a684c10d$export$c72df13ba879849e = (contentType)=>{
    return contentType === 'whiteboard' || contentType === 'database' && (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui');
};
module.exports["useIsVersionHistoryEnabled"] = $d81f7457a684c10d$export$c72df13ba879849e;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   */ onUpdateComment(threadKey) {
        this.onUpdateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("b805f"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("b805f", function(module, exports) {

let $81a081a8a5a44cc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81a081a8a5a44cc2$var$load("fwmQF"),
    $81a081a8a5a44cc2$var$load("9AHrA"),
    $81a081a8a5a44cc2$var$load("jwWp5"),
    $81a081a8a5a44cc2$var$load("4t77a"),
    $81a081a8a5a44cc2$var$load("eHDb1"),
    $81a081a8a5a44cc2$var$load("2zUEf"),
    $81a081a8a5a44cc2$var$load("cQKew"),
    $81a081a8a5a44cc2$var$load("f1NVy"),
    $81a081a8a5a44cc2$var$load("4Lgj0"),
    $81a081a8a5a44cc2$var$load("kSJiq"),
    $81a081a8a5a44cc2$var$load("89WyM"),
    $81a081a8a5a44cc2$var$load("aZinD"),
    $81a081a8a5a44cc2$var$load("1QdXB"),
    $81a081a8a5a44cc2$var$load("2t3HP"),
    $81a081a8a5a44cc2$var$load("1c1XO"),
    $81a081a8a5a44cc2$var$load("duPDN"),
    $81a081a8a5a44cc2$var$load("cPWI2"),
    $81a081a8a5a44cc2$var$load("h9Ed7"),
    $81a081a8a5a44cc2$var$load("lkOIY"),
    $81a081a8a5a44cc2$var$load("dh8Yu"),
    $81a081a8a5a44cc2$var$load("fxPKA"),
    $81a081a8a5a44cc2$var$load("1iUSs"),
    $81a081a8a5a44cc2$var$load("4eboO"),
    $81a081a8a5a44cc2$var$load("5U3YO"),
    $81a081a8a5a44cc2$var$load("8YSo7"),
    $81a081a8a5a44cc2$var$load("gLGsg"),
    $81a081a8a5a44cc2$var$load("5pvpJ"),
    $81a081a8a5a44cc2$var$load("36QeB"),
    $81a081a8a5a44cc2$var$load("hv4mn"),
    $81a081a8a5a44cc2$var$load("Wowvf"),
    $81a081a8a5a44cc2$var$load("6wr18"),
    $81a081a8a5a44cc2$var$load("cyGuT"),
    $81a081a8a5a44cc2$var$load("hhss7"),
    $81a081a8a5a44cc2$var$load("k5SAQ"),
    $81a081a8a5a44cc2$var$load("bfUix"),
    $81a081a8a5a44cc2$var$load("jXx9i"),
    $81a081a8a5a44cc2$var$load("azVjw"),
    $81a081a8a5a44cc2$var$load("3gquy"),
    $81a081a8a5a44cc2$var$load("iZU4p"),
    $81a081a8a5a44cc2$var$load("5tz7G"),
    $81a081a8a5a44cc2$var$load("7u4WP"),
    $81a081a8a5a44cc2$var$load("ffEVr"),
    $81a081a8a5a44cc2$var$load("8Gekp"),
    $81a081a8a5a44cc2$var$load("7e13v"),
    $81a081a8a5a44cc2$var$load("let0D"),
    $81a081a8a5a44cc2$var$load("6EQss"),
    $81a081a8a5a44cc2$var$load("6vyHt"),
    $81a081a8a5a44cc2$var$load("6M36W"),
    $81a081a8a5a44cc2$var$load("ioQAS"),
    $81a081a8a5a44cc2$var$load("89Sbl"),
    $81a081a8a5a44cc2$var$load("g7g2y"),
    $81a081a8a5a44cc2$var$load("e9JE4"),
    $81a081a8a5a44cc2$var$load("e4GNb"),
    $81a081a8a5a44cc2$var$load("5QKVr"),
    $81a081a8a5a44cc2$var$load("bxFZs"),
    $81a081a8a5a44cc2$var$load("7EorR"),
    $81a081a8a5a44cc2$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("bzwhi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cOrQJ = parcelRequire("cOrQJ");


var $67Foi = parcelRequire("67Foi");


var $9wGTI = parcelRequire("9wGTI");


var $lsxnT = parcelRequire("lsxnT");


var $5Mdl1 = parcelRequire("5Mdl1");


var $dm7Aa = parcelRequire("dm7Aa");


var $eufiU = parcelRequire("eufiU");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");


var $9iknb = parcelRequire("9iknb");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $cgtv4.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Mdl1.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const isMoreActionsHintDismissed = (0, $9iknb.useIsMoreActionsHintDismissed)();
    const isHintVisible = !isMoreActionsHintDismissed && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding');
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $42omo.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex,
        isHintVisible: isHintVisible
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cryCi = parcelRequire("cryCi");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("dm7Aa", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("eufiU", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $1P1Tu.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $9zUhf.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $9zUhf.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;
module.exports["useMoreActionsObjectSidebarTourActions"] = $2cb4928bb9fae204$export$66587c60bfe17f2b;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("9iknb", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $jxHjr = parcelRequire("jxHjr");

const { IS_MORE_ACTIONS_HINT_VISIBLE: $8af3353c14c2853a$var$IS_MORE_ACTIONS_HINT_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $8af3353c14c2853a$export$60f197fed8cf8ad6 = ()=>{
    const { data: isMoreActionsHintOnboardingStateData, error: isMoreActionsHintOnboardingStateError, loading: isMoreActionsHintOnboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)($8af3353c14c2853a$var$IS_MORE_ACTIONS_HINT_VISIBLE, !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding'));
    const isHintDismissed = isMoreActionsHintOnboardingStateData?.onboardingState?.some((0, $jxHjr.isOnboardingStateEqual)($8af3353c14c2853a$var$IS_MORE_ACTIONS_HINT_VISIBLE, (0, $jxHjr.IS_DISMISSED_FLAG)));
    return !isMoreActionsHintOnboardingStateError && !isMoreActionsHintOnboardingStateLoading && isHintDismissed;
};
module.exports["useIsMoreActionsHintDismissed"] = $8af3353c14c2853a$export$60f197fed8cf8ad6;

});

parcelRegister("jxHjr", function(module, exports) {
const $d2dc5c2cb3e5f13c$export$d20f6356992396b7 = 'false';
const $d2dc5c2cb3e5f13c$export$d994d555e09ad669 = (onboardingStateKey, onboardingStateValue)=>({ key: key, value: value })=>key === onboardingStateKey && value === onboardingStateValue;
module.exports["IS_DISMISSED_FLAG"] = $d2dc5c2cb3e5f13c$export$d20f6356992396b7;
module.exports["isOnboardingStateEqual"] = $d2dc5c2cb3e5f13c$export$d994d555e09ad669;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("lQ86k", function(module, exports) {

let $fe64bd06e98cdf08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe64bd06e98cdf08$var$load("8hbZ5"),
    $fe64bd06e98cdf08$var$load("3yFtm")
]).then(()=>parcelRequire('dQUV0'));

});

parcelRegister("fCjCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5543a1bcdfd8c47fe735784b0d385448>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5e9a073b74cb7a3$var$_react = $b5e9a073b74cb7a3$var$_interopRequireDefault((parcelRequire("42omo")));

var $b5e9a073b74cb7a3$var$_baseNew = $b5e9a073b74cb7a3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b5e9a073b74cb7a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5e9a073b74cb7a3$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $b5e9a073b74cb7a3$var$_react.default.createElement($b5e9a073b74cb7a3$var$_baseNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$b5e9a073b74cb7a3$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $b5e9a073b74cb7a3$var$_default = module.exports.default = $b5e9a073b74cb7a3$var$EyeOpenFilledIcon;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("f9HtC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0896bd7bf351fc8$export$73075fe16d77da88 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ckcO3",
    name: "ManageWatcherDialogLoader",
    loader: async ()=>(await (parcelRequire("i6HQi"))).ManageWatcherDialog
});
module.exports["ManageWatcherDialogLoader"] = $b0896bd7bf351fc8$export$73075fe16d77da88;

});

parcelRegister("i6HQi", function(module, exports) {

let $d2eacbc1926dd8ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2eacbc1926dd8ca$var$load("6FuHS"),
    $d2eacbc1926dd8ca$var$load("eyaRC"),
    $d2eacbc1926dd8ca$var$load("6wr18"),
    $d2eacbc1926dd8ca$var$load("2t3HP"),
    $d2eacbc1926dd8ca$var$load("h4Nf7"),
    $d2eacbc1926dd8ca$var$load("iXzmH"),
    $d2eacbc1926dd8ca$var$load("65c4i"),
    $d2eacbc1926dd8ca$var$load("Wowvf"),
    $d2eacbc1926dd8ca$var$load("hhss7"),
    $d2eacbc1926dd8ca$var$load("7EorR"),
    $d2eacbc1926dd8ca$var$load("ffEVr"),
    $d2eacbc1926dd8ca$var$load("kUbUu"),
    $d2eacbc1926dd8ca$var$load("iJwzY")
]).then(()=>parcelRequire('45gVm'));

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("3pU8m", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $3scmi = parcelRequire("3scmi");


var $56M4r = parcelRequire("56M4r");


var $iTh4n = parcelRequire("iTh4n");


var $jwNgW = parcelRequire("jwNgW");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $a61a6d10c0a933b0$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $jwNgW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3scmi.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $iTh4n.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $a61a6d10c0a933b0$export$2e2bcd8739ae039 = $a61a6d10c0a933b0$var$DropdownItemCheckbox;
module.exports["default"] = $a61a6d10c0a933b0$export$2e2bcd8739ae039;

});

parcelRegister("iTh4n", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $d6Fdl = parcelRequire("d6Fdl");


var $dh538 = parcelRequire("dh538");

const $ade312c7505f4d8d$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $ade312c7505f4d8d$var$CheckboxIcon = ({ checked: checked })=>{
    if ((0, $dh538.fg)('platform-custom-icon-migration')) return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("g", {
            fillRule: "evenodd",
            children: (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                        x: "5.5",
                        y: "5.5",
                        width: "13",
                        height: "13",
                        rx: "1.5",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        fill: "currentColor",
                        x: "6",
                        y: "6",
                        width: "12",
                        height: "12",
                        rx: "2",
                        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
                        fill: "inherit"
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d6Fdl.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
        secondaryColor: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent',
        children: /*#__PURE__*/ (0, $l998X.jsx)("g", {
            fillRule: "evenodd",
            children: (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                        x: "5.5",
                        y: "5.5",
                        width: "13",
                        height: "13",
                        rx: "1.5",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        fill: "currentColor",
                        x: "6",
                        y: "6",
                        width: "12",
                        height: "12",
                        rx: "2",
                        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
                        fill: "inherit"
                    })
                ]
            })
        })
    });
};
var $ade312c7505f4d8d$export$2e2bcd8739ae039 = $ade312c7505f4d8d$var$CheckboxIcon;
module.exports["default"] = $ade312c7505f4d8d$export$2e2bcd8739ae039;

});

parcelRegister("jwNgW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1FJYC = parcelRequire("1FJYC");


var $nVQ0B = parcelRequire("nVQ0B");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $05848c92b720c3b2$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $42omo.useContext)((0, $nVQ0B.SelectionStoreContext));
    const groupId = (0, $42omo.useContext)((0, $1FJYC.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $05848c92b720c3b2$export$2e2bcd8739ae039 = $05848c92b720c3b2$var$useCheckboxState;
module.exports["default"] = $05848c92b720c3b2$export$2e2bcd8739ae039;

});

parcelRegister("1FJYC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5d17552b6cb2fab4$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $42omo.createContext)('');
module.exports["CheckboxGroupContext"] = $5d17552b6cb2fab4$export$baf37c4be89255b8;

});

parcelRegister("fKL7x", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");


var $1FJYC = parcelRequire("1FJYC");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FJYC.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $b6be4855f2bf1ca8$export$2e2bcd8739ae039 = $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup;
module.exports["default"] = $b6be4855f2bf1ca8$export$2e2bcd8739ae039;

});

parcelRegister("jle6C", function(module, exports) {
var $b11a466056fa4426$export$f8bb0b205e1c369c = /*#__PURE__*/ function(UpdateContentType) {
    UpdateContentType["CONTENT"] = "content";
    UpdateContentType["CHILDREN"] = "children";
    UpdateContentType["BLOGS_IN_SPACE"] = "blogs";
    UpdateContentType["SPACE"] = "space";
    return UpdateContentType;
}({});
var $b11a466056fa4426$export$3b880fb327a46f45 = /*#__PURE__*/ function(UpdateType) {
    UpdateType["WATCH"] = "watch";
    UpdateType["UNWATCH"] = "unwatch";
    return UpdateType;
}({});
module.exports["UpdateContentType"] = $b11a466056fa4426$export$f8bb0b205e1c369c;
module.exports["UpdateType"] = $b11a466056fa4426$export$3b880fb327a46f45;

});

parcelRegister("gqsYd", function(module, exports) {
const $bf558bf49003e931$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["CONFLUENCE_EDITION"] = $bf558bf49003e931$export$4b915fb24c39b396;

});

parcelRegister("hpr9b", function(module, exports) {

var $6XxzN = parcelRequire("6XxzN");

const $0010f8f7298777ae$export$7db5b17cce09ecf7 = ()=>{
    return 0, $6XxzN.WatchDialogQueryWithWatchChildren;
};
module.exports["getWatchDialogQuery"] = $0010f8f7298777ae$export$7db5b17cce09ecf7;

});

parcelRegister("6XxzN", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $51124c5b395b8390$export$ff412db8b959e059 = (0, $eSUdr.default)`query WatchDialogQueryWithWatchChildren($contentId:ID!){singleContent(id:$contentId){id ...WatchDialogContentFragmentWithWatchChildren}}fragment WatchDialogContentFragmentWithWatchChildren on Content{id currentUserIsWatching currentUserIsWatchingChildren currentUserHasAncestorWatchingChildren type space{id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}`;
module.exports["WatchDialogQueryWithWatchChildren"] = $51124c5b395b8390$export$ff412db8b959e059;

});

parcelRegister("pskhd", function(module, exports) {
const $b218ab7927acda99$export$169d32883304392c = (data)=>{
    const isCurrentUserWatching = data?.singleContent?.currentUserIsWatching ?? false;
    const isWatchingSpace = data?.singleContent?.space?.currentUser?.isWatched ?? false;
    const isWatchingBlogs = data?.singleContent?.space?.currentUser?.isWatchingBlogs ?? false;
    // TODO remove type checks once watch with children gate cleaned up
    const isWatchingChildren = data?.singleContent && 'currentUserIsWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserIsWatchingChildren ?? false : false;
    const hasAncestorWatchingChildren = data?.singleContent && 'currentUserHasAncestorWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserHasAncestorWatchingChildren ?? false : false;
    return {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren
    };
};
module.exports["processWatchData"] = $b218ab7927acda99$export$169d32883304392c;

});

parcelRegister("77a1U", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $1KmJq = parcelRequire("1KmJq");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $cfidN = parcelRequire("cfidN");

const $280d5b858bf30a19$var$PageStarActionButtonPageStarMutation = (0, $eSUdr.default)`mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id metadata{currentuser{favourited{isFavourite favouritedDate}}}}}}`;
const $280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation = (0, $eSUdr.default)`mutation PageStarActionButtonPageUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id metadata{currentuser{favourited{isFavourite favouritedDate}}}}}}`;
const $280d5b858bf30a19$var$i18n = (0, $cgtv4.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.content.star.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble starring this"
    },
    unstarErrorTitle: {
        id: "action-buttons.content.unstar.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble unstarring this"
    },
    starSuccessFlagTitle: {
        id: "action-buttons.content.star.success.title",
        defaultMessage: "{contentTitle} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.content.unstar.success.title",
        defaultMessage: "{contentTitle} unstarred"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh the page and try again."
    }
});
const $280d5b858bf30a19$var$useStarAnalytics = (contentId, analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const stringAttrs = JSON.stringify(analytics?.attributes);
    return (0, $42omo.useCallback)((action)=>{
        if (!analytics) return;
        const { source: source, containerId: containerId, attributes: attributes } = analytics;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                source: source,
                attributes: attributes,
                objectId: contentId,
                ...containerId && {
                    containerId: containerId
                }
            }
        }).fire();
    }, // Using stringAttrs as dependency instead of analytics.attributes
    // https://github.com/facebook/react/issues/14476
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        analytics?.source,
        stringAttrs
    ]);
};
const $280d5b858bf30a19$var$PageStarComponent = ({ contentId: contentId, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, contentTitle: contentTitle = '', shouldShowFlags: shouldShowFlags = false })=>{
    const sendAnalyticsEvent = $280d5b858bf30a19$var$useStarAnalytics(contentId, analytics);
    const [star, { error: starError }] = (0, $1KmJq.useMutation)($280d5b858bf30a19$var$PageStarActionButtonPageStarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('created');
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                // @ts-ignore TS doesn't recognize __typename which is needed for mutation
                                __typename: 'FavouritedSummary',
                                isFavourite: true,
                                favouritedDate: new Date().toISOString()
                            }
                        }
                    }
                }
            }
        }
    });
    const [unstar, { error: unstarError }] = (0, $1KmJq.useMutation)($280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('deleted');
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            // @ts-ignore TS doesn't recognize __typename which is needed for mutation
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        }
    });
    const toggleStar = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) {
            onUnstar && onUnstar(e);
            unstar().then(()=>{
                if (shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        } else {
            onStar && onStar(e);
            star().then(()=>{
                if (shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.starSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        }
    }, [
        isStarred,
        onStar,
        star,
        onUnstar,
        unstar,
        contentTitle,
        flags,
        intl,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.starErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $280d5b858bf30a19$export$110ac8adb8c8c03 = (0, $7aRa9.withFlags)((0, $gmMgo.default)($280d5b858bf30a19$var$PageStarComponent));
module.exports["PageStar"] = $280d5b858bf30a19$export$110ac8adb8c8c03;

});

parcelRegister("cfidN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");

const $774441f3315c6f72$export$5b6a77363c518c1c = (0, $7aRa9.withFlags)(({ flags: flags, title: title, description: description, error: error })=>{
    (0, $42omo.useEffect)(()=>{
        flags.showErrorFlag({
            id: 'action-button-error',
            title: title,
            description: description
        });
    }, [
        title,
        description,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
});
module.exports["ActionErrorFlag"] = $774441f3315c6f72$export$5b6a77363c518c1c;

});

parcelRegister("cf6nm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gI8uy = parcelRequire("gI8uy");


var $kfYj7 = parcelRequire("kfYj7");


var $cOrQJ = parcelRequire("cOrQJ");

const $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e = ({ isStarred: isStarred, spacing: spacing = 'spacious' })=>{
    const theme = (0, $cOrQJ.default)();
    const starredColor = theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        label: "",
        color: starredColor,
        spacing: spacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
        label: "",
        color: "currentColor",
        spacing: spacing
    });
};
module.exports["StarIcon"] = $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e;

});

parcelRegister("kPqqM", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $xQxzY = parcelRequire("xQxzY");


var $56M4r = parcelRequire("56M4r");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $cf6nm = parcelRequire("cf6nm");


var $iCPvv = parcelRequire("iCPvv");

const $3dca15cc31736255$export$f4601f3807dd9177 = ({ isDisabled: isDisabled, className: className, shortcut: shortcut, ...props })=>{
    const TooltipI18n = props.isStarred ? $3dca15cc31736255$var$i18n.Unstar : $3dca15cc31736255$var$i18n.Star;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iCPvv.SpaceStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            testId: "star-menu-item",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: className,
            isDisabled: isDisabled,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            onClick: toggleStar,
            iconAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), TooltipI18n)));
};
const $3dca15cc31736255$export$e07e4133bf676bf6 = ({ spaceKey: spaceKey })=>{
    const { data: spaceFavouriteStatusData } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query SpaceStarMenuItemIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id alias name key currentUser{isFavourited}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first'
    });
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dca15cc31736255$export$f4601f3807dd9177, {
        isStarred: isStarred,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spacing: "none",
        spaceName: spaceName,
        shortcut: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
        shouldShowFlags: true,
        analytics: {
            attributes: {
                isContentWrapper: true,
                spaceId: // as of now, SpaceStarMenuItemWithQuery is only called from object header overflow menu
                spaceId
            },
            source: 'SpaceStarMenuItemOverflowMenu'
        }
    });
};
const $3dca15cc31736255$var$i18n = (0, $cgtv4.defineMessages)({
    Star: {
        id: "action-buttons.space.star.menu.item",
        defaultMessage: "Star space"
    },
    Unstar: {
        id: "action-buttons.space.unstar.menu.item",
        defaultMessage: "Unstar space"
    }
});
module.exports["SpaceStarMenuItem"] = $3dca15cc31736255$export$f4601f3807dd9177;
module.exports["SpaceStarMenuItemWithQuery"] = $3dca15cc31736255$export$e07e4133bf676bf6;

});

parcelRegister("iCPvv", function(module, exports) {

var $8DAzB = parcelRequire("8DAzB");


var $iWaZt = parcelRequire("iWaZt");


var $eUlFW = parcelRequire("eUlFW");


var $5j9jt = parcelRequire("5j9jt");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $inPa6 = parcelRequire("inPa6");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $cTJK3 = parcelRequire("cTJK3");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $cfidN = parcelRequire("cfidN");

const $ac59452c65a90798$var$i18n = (0, $cgtv4.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.space.star.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble starring this space"
    },
    unstarErrorTitle: {
        id: "action-buttons.space.unstar.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble unstarring this space"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh and try again."
    },
    starSuccessFlagTitle: {
        id: "action-buttons.space.star.success.title",
        defaultMessage: "{spaceName} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.space.unstar.success.title",
        defaultMessage: "{spaceName} unstarred"
    }
});
const $ac59452c65a90798$var$SpaceStarComponent = ({ spaceId: spaceId, spaceKey: spaceKey, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, spaceName: spaceName, shouldShowFlags: shouldShowFlags })=>{
    const readCurrentSpace = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5j9jt.default)
    });
    const readStarredSpaces = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $eUlFW.default)
    });
    const writeUpdateCurrentUserFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $iWaZt.default)
    });
    const writeStarredSpacesFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $8DAzB.default)
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const modifyStarCache = (0, $42omo.useCallback)((newStarredValue)=>{
        try {
            // The (Un)FavoriteSpaceMutations do not return the updated space, so we need to manually update the cache.
            // This is necessary to update the UI immediately after the user clicks the star button.
            writeUpdateCurrentUserFragment({
                fragmentId: `Space:${spaceId}`,
                data: {
                    currentUser: {
                        isFavourited: newStarredValue,
                        __typename: 'SpaceUserMetadata'
                    },
                    __typename: 'Space'
                }
            });
            // Update the starred spaces list in the Spaces dropdown (and any other consumers of useSpacesData)
            (0, $cTJK3.updateStarredSpacesList)(spaceId, newStarredValue, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment);
        } catch (e) {}
    }, [
        spaceId,
        readCurrentSpace,
        readStarredSpaces,
        writeStarredSpacesFragment,
        writeUpdateCurrentUserFragment
    ]);
    const [starSpace, { error: starError }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation SpaceStarFavoriteSpaceMutation($spaceKey:String!){favouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}`, {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(false);
        }
    });
    const [unstarSpace, { error: unstarError }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation SpaceStarUnfavoriteSpaceMutation($spaceKey:String!){unfavouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}`, {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(true);
        }
    });
    const toggleStar = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) onUnstar && onUnstar(e);
        else onStar && onStar(e);
        // Optimistically update the cache
        modifyStarCache(!isStarred);
        const mutation = isStarred ? unstarSpace : starSpace;
        mutation({
            variables: {
                spaceKey: spaceKey
            }
        }).then(()=>{
            if (isStarred && shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
            else if (!isStarred && shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.starSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
        }).catch((_)=>{});
        if (analytics) {
            const { source: source, containerId: containerId, attributes: attributes } = analytics;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: isStarred ? 'unstarred' : 'starred',
                    actionSubject: 'space',
                    source: source,
                    attributes: attributes,
                    ...containerId && {
                        containerId: containerId
                    }
                }
            }).fire();
        }
    }, [
        isStarred,
        spaceKey,
        analytics,
        starSpace,
        unstarSpace,
        modifyStarCache,
        onStar,
        onUnstar,
        createAnalyticsEvent,
        flags,
        intl,
        spaceName,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.starErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $ac59452c65a90798$export$4e2eb132a04ae560 = (0, $7aRa9.withFlags)((0, $gmMgo.default)($ac59452c65a90798$var$SpaceStarComponent));
module.exports["SpaceStar"] = $ac59452c65a90798$export$4e2eb132a04ae560;

});

parcelRegister("8DAzB", function(module, exports) {
/**
 * @generated SignedSource<<4a171dc3f24fa33365671bc293ee926d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edf1f89db5626c55$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarWriteStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$edf1f89db5626c55$var$node.hash = "72f0ab1980fee3d3ebcdbd9647ddc161";
var $edf1f89db5626c55$export$2e2bcd8739ae039 = $edf1f89db5626c55$var$node;
module.exports["default"] = $edf1f89db5626c55$export$2e2bcd8739ae039;

});

parcelRegister("iWaZt", function(module, exports) {
/**
 * @generated SignedSource<<4f3a66cae1b36513a5bd3deef2eab27d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3dd5c0573ac0253a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarActionButtonSpaceFragment",
    "selections": [
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                }
            ]
        }
    ],
    "type": "Space"
};
$3dd5c0573ac0253a$var$node.hash = "8952ed3b4f2eb093d58223c1da19fdac";
var $3dd5c0573ac0253a$export$2e2bcd8739ae039 = $3dd5c0573ac0253a$var$node;
module.exports["default"] = $3dd5c0573ac0253a$export$2e2bcd8739ae039;

});

parcelRegister("eUlFW", function(module, exports) {
/**
 * @generated SignedSource<<cf2e8f8aca39fd0339871e16ad8a5be7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae9f5e7e7a9dde99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarReadStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$ae9f5e7e7a9dde99$var$node.hash = "4a38c9f3868a7bbf44a9931e1d6903ac";
var $ae9f5e7e7a9dde99$export$2e2bcd8739ae039 = $ae9f5e7e7a9dde99$var$node;
module.exports["default"] = $ae9f5e7e7a9dde99$export$2e2bcd8739ae039;

});

parcelRegister("5j9jt", function(module, exports) {
/**
 * @generated SignedSource<<bdd1bb590fad23376c608a9931f01198>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b485608b483d3bf6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarCurrentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "alias"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ],
    "type": "Space"
};
$b485608b483d3bf6$var$node.hash = "0e7af2ea53ea33a3d76e321d036b891d";
var $b485608b483d3bf6$export$2e2bcd8739ae039 = $b485608b483d3bf6$var$node;
module.exports["default"] = $b485608b483d3bf6$export$2e2bcd8739ae039;

});

parcelRegister("cTJK3", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $fstZx = parcelRequire("fstZx");

const $a85b49bec4fd02db$export$1c070079c48d3bdd = (spaceId, isStarred, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment)=>{
    const apolloClient = (0, $hp2SH.getApolloClient)();
    const space = readCurrentSpace({
        id: `Space:${spaceId}`
    });
    try {
        let starredSpaces;
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) starredSpaces = readStarredSpaces({
            id: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`
        })?.nodes || [];
        else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        starredSpaces = apolloClient.readQuery({
            query: (0, $fstZx.StarredSpacesQuery),
            variables: {}
        })?.spaces?.nodes || [];
        let newStarredSpaces;
        if (isStarred) {
            newStarredSpaces = [
                ...starredSpaces,
                space
            ];
            newStarredSpaces.sort((a, b)=>!a?.name || !b?.name ? 0 : a.name.localeCompare(b.name));
        } else newStarredSpaces = starredSpaces.filter((s)=>s?.id !== spaceId);
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) writeStarredSpacesFragment({
            fragmentId: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`,
            data: {
                nodes: newStarredSpaces,
                __typename: 'PaginatedSpaceList'
            }
        });
        else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        apolloClient.writeQuery({
            query: (0, $fstZx.StarredSpacesQuery),
            variables: {},
            data: {
                spaces: {
                    nodes: newStarredSpaces,
                    __typename: 'PaginatedSpaceList'
                }
            }
        });
    } catch (e) {
    // If Apollo throws an error, the starred spaces data was not found in the cache.
    // Errors can be safely ignored as if there is no cache entry, there is no work to be done.
    }
};
module.exports["updateStarredSpacesList"] = $a85b49bec4fd02db$export$1c070079c48d3bdd;

});

parcelRegister("fstZx", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $bb42a67b08b88af0$export$f89460d6594658f1 = (0, $eSUdr.default)`query StarredSpacesQuery{spaces(favourite:true first:30 status:"current"){nodes{alias id name key status icon{path}}}}`;
const $bb42a67b08b88af0$export$73b0293722a8eb9f = (0, $eSUdr.default)`query MyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias id name key status icon{path}}}}}`;
const $bb42a67b08b88af0$export$9fdae40747d95364 = (0, $eSUdr.default)`query MyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias id name key status icon{path}currentUser{isFavourited}}myVisitedSpaces(limit:26){nodes{spaces{alias id name key status icon{path}}}}}`;
const $bb42a67b08b88af0$export$2e53cde7a8b8bbee = (0, $eSUdr.default)`query AnonymousSpacesQuery{spaces(first:10){nodes{alias id name key status icon{path}}}}`;
const $bb42a67b08b88af0$export$7c52f7af355ed457 = (0, $eSUdr.default)`query SearchSpacesQuery($spaceNamePattern:String!$isLicensed:Boolean!){spaces(first:30 status:"current" spaceNamePattern:$spaceNamePattern){nodes{alias id name key status icon{path}currentUser@include(if:$isLicensed){isFavourited}}}}`;
module.exports["StarredSpacesQuery"] = $bb42a67b08b88af0$export$f89460d6594658f1;
module.exports["MyVisitedSpacesQuery"] = $bb42a67b08b88af0$export$73b0293722a8eb9f;
module.exports["MyVisitedSpacesWithCurrentSpaceQuery"] = $bb42a67b08b88af0$export$9fdae40747d95364;
module.exports["AnonymousSpacesQuery"] = $bb42a67b08b88af0$export$2e53cde7a8b8bbee;
module.exports["SearchSpacesQuery"] = $bb42a67b08b88af0$export$7c52f7af355ed457;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("1PC5x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("kLaR3"))).LinkToThisPageDialog
});
module.exports["LinkToThisPageDialog"] = $297029061926b2dd$export$77691412571457f;

});

parcelRegister("kLaR3", function(module, exports) {

let $f1d09df73840bff1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1d09df73840bff1$var$load("6wr18"),
    $f1d09df73840bff1$var$load("ffEVr"),
    $f1d09df73840bff1$var$load("kHOMt"),
    $f1d09df73840bff1$var$load("hhss7"),
    $f1d09df73840bff1$var$load("Wowvf"),
    $f1d09df73840bff1$var$load("dXoLf")
]).then(()=>parcelRequire('gaLJH'));

});

parcelRegister("4vC63", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("kxAIf", function(module, exports) {

let $ef435e16a22b0379$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef435e16a22b0379$var$load("bzc8Q"),
    $ef435e16a22b0379$var$load("kyfJT")
]).then(()=>parcelRequire('dhbEh'));

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    entryPoint: 'confluenceUnknown'
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: (entryPoint, spaceKey, parentContent, stagingAreaActive, content)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("4WZ5N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8d83d1b43e737389f594b3c87e0e2ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39abf7eb3ad54dc7$var$_react = $39abf7eb3ad54dc7$var$_interopRequireDefault((parcelRequire("42omo")));

var $39abf7eb3ad54dc7$var$_baseNew = $39abf7eb3ad54dc7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $39abf7eb3ad54dc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $39abf7eb3ad54dc7$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $39abf7eb3ad54dc7$var$_react.default.createElement($39abf7eb3ad54dc7$var$_baseNew.default, Object.assign({
        name: "ArchiveBoxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$39abf7eb3ad54dc7$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $39abf7eb3ad54dc7$var$_default = module.exports.default = $39abf7eb3ad54dc7$var$ArchiveBoxIcon;

});

parcelRegister("1AbrA", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a94896b24fa6d771$export$833a1d1f1b7e4f0f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MiFff",
    name: "PageQuickActionAutomationMenu",
    loader: async ()=>(await (parcelRequire("7Abex"))).PageQuickActionAutomationMenu
});
module.exports["PageQuickActionAutomationMenu"] = $a94896b24fa6d771$export$833a1d1f1b7e4f0f;

});

parcelRegister("7Abex", function(module, exports) {

let $58549be900bacafd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58549be900bacafd$var$load("6wr18"),
    $58549be900bacafd$var$load("kSBog"),
    $58549be900bacafd$var$load("4xZ5N"),
    $58549be900bacafd$var$load("7f9Fz"),
    $58549be900bacafd$var$load("kHOMt"),
    $58549be900bacafd$var$load("Wowvf"),
    $58549be900bacafd$var$load("7EorR"),
    $58549be900bacafd$var$load("ffEVr"),
    $58549be900bacafd$var$load("kUbUu"),
    $58549be900bacafd$var$load("hhss7"),
    $58549be900bacafd$var$load("9QyoN")
]).then(()=>parcelRequire('bm1ob'));

});

parcelRegister("jcM8h", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $j1Ss3 = parcelRequire("j1Ss3");


var $6R5uz = parcelRequire("6R5uz");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dAYOx = parcelRequire("dAYOx");


var $lGgRw = parcelRequire("lGgRw");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $a6t12 = parcelRequire("a6t12");


var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");


var $3SLf9 = parcelRequire("3SLf9");

const $a26c936fb563039b$var$i18n = (0, $cgtv4.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ],
        fullName: fullName
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $8C5kA.default)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $42omo.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id history{createdBy{displayName ...on KnownUser{accountId}}ownedBy{displayName ...on KnownUser{accountId}}}}}`, {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel)),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepage-experie')
    });
};
module.exports["ContentOwnerPopupComponent"] = $a26c936fb563039b$export$62380b37452323f8;

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("g9Ghb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $91ba7504cfad305c$export$e82a504f7cb45e99 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PQ2oV",
    name: "ReverseTrialLozengeListItemExperiment",
    loader: async ()=>(await (parcelRequire("eQRId"))).ReverseTrialListItemWithErrorBoundary
});
module.exports["ReverseTrialLozengeListItemExperiment"] = $91ba7504cfad305c$export$e82a504f7cb45e99;

});

parcelRegister("eQRId", function(module, exports) {

let $acff9624b60e8031$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $acff9624b60e8031$var$load("hhss7"),
    $acff9624b60e8031$var$load("Wowvf"),
    $acff9624b60e8031$var$load("fqBFU"),
    $acff9624b60e8031$var$load("1HAEl")
]).then(()=>parcelRequire('f3FIN'));

});

parcelRegister("jhTeh", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf80d11b8f0d3f1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i0t_g",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("1GeOk"))).ReverseTrialLozengeWithErrorBoundary
});
module.exports["ReverseTrialLozengeExperiment"] = $acf80d11b8f0d3f1$export$b51195909514673e;

});

parcelRegister("1GeOk", function(module, exports) {

let $139533c72f429712$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $139533c72f429712$var$load("Wowvf"),
    $139533c72f429712$var$load("fqBFU")
]).then(()=>parcelRequire('gQsLh'));

});

parcelRegister("4tuiZ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $677e07da7eecc531$var$ContentHistoryStore = (0, $1P1Tu.createStore)({
    initialState: {
        shouldShowNewContentHistory: false,
        wasTransitionedFromEditor: false
    },
    actions: {
        showNewContentHistory: ()=>({ setState: setState })=>{
                setState({
                    shouldShowNewContentHistory: true
                });
            },
        hideNewContentHistory: ()=>({ setState: setState })=>{
                setState({
                    shouldShowNewContentHistory: false
                });
            },
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $677e07da7eecc531$export$90587b2a92cba8d5 = (0, $9zUhf.createStateHook)($677e07da7eecc531$var$ContentHistoryStore);
const $677e07da7eecc531$export$9b1a939bc5c5d3b = (0, $9zUhf.createActionsHook)($677e07da7eecc531$var$ContentHistoryStore);
const $677e07da7eecc531$export$1039ffcfa1dfeed2 = (0, $9zUhf.createHook)($677e07da7eecc531$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $677e07da7eecc531$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $677e07da7eecc531$export$9b1a939bc5c5d3b;
module.exports["useNewContentHistory"] = $677e07da7eecc531$export$1039ffcfa1dfeed2;

});

parcelRegister("dmDX7", function(module, exports) {
/** @graphql cc **/ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $eSUdr.default)`query usePendingRequestExistsQuery($accessRequestedAaid:String!$cloudId:ID!$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid cloudId:$cloudId contentId:$contentId){isPendingAccessRequestExists}}`;
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $42omo.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        }
    });
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("ewVsQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $6mKj3 = parcelRequire("6mKj3");


var $aXWbQ = parcelRequire("aXWbQ");

const $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation = (0, $eSUdr.default)`mutation useRequestToEditContentRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}`;
const $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID = 'request-to-edit-sent';
const $820cfbe605341dee$export$c3a30e09778accb4 = ({ contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent })=>{
    const [requestSent, setRequestSent] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const showRequestToEditFailedFlag = (0, $42omo.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.failed');
        if (!flags) return;
        flags.showWarningFlag({
            title: intl.formatMessage((0, $aXWbQ.messages).notSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).notSentFlagDescription),
            appearance: 'warning',
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const showRequestToEditSentFlag = (0, $42omo.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.success');
        if (!flags) return;
        if (!(0, $6mKj3.expValEquals)('confluence_ask_to_edit_across_content_type', 'cohort', 'test')) // Old flag
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription),
            actions: [
                {
                    content: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagAction),
                    onClick: ()=>flags.hideFlag($820cfbe605341dee$var$REQUEST_SENT_FLAG_ID)
                }
            ]
        });
        else // New flag
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagShortTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription),
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const handleRequestComplete = (result)=>{
        if (result?.requestPageAccess) {
            setRequestSent(true);
            showRequestToEditSentFlag();
        } else {
            showRequestToEditFailedFlag();
            setRequestSent(false);
        }
    };
    const handleRequestError = ()=>{
        showRequestToEditFailedFlag();
        setRequestSent(false);
    };
    const [requestToEditContent, { loading: loading }] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation, {
        variables: {
            requestPageAccessInput: {
                pageId: contentId || '',
                accessType: 'EDIT'
            }
        },
        onCompleted: handleRequestComplete,
        onError: handleRequestError
    });
    return {
        requestToEditContent: requestToEditContent,
        loading: loading,
        hasRequestedEditPermission: requestSent
    };
};
module.exports["useRequestToEditContent"] = $820cfbe605341dee$export$c3a30e09778accb4;

});

parcelRegister("aXWbQ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $b8ad22721a0e1a1a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    requestToEdit: {
        defaultMessage: "Request to edit",
        id: "no-permission.request.to.edit.button.label"
    },
    editRequestSent: {
        defaultMessage: "Request sent",
        id: "no-permission.edit.request.sent.button.label"
    },
    notSentFlagTitle: {
        defaultMessage: "Your request wasn\u2019t sent",
        id: "no-permission.request.to.edit.not.sent.flag.title"
    },
    notSentFlagDescription: {
        defaultMessage: "We ran into a problem submitting your edit request. Try again or contact your admin.",
        id: "no-permission.request.to.edit.not.sent.flag.description"
    },
    requestSentFlagTitle: {
        defaultMessage: "Request to edit sent",
        id: "no-permission.request.to.edit.request.sent.flag.title"
    },
    requestSentFlagShortTitle: {
        defaultMessage: "Request sent",
        id: "no-permission.request.to.edit.request.sent.flag.short.title"
    },
    requestSentFlagDescription: {
        defaultMessage: "We've asked the owner to give you edit access. You'll get an email once the request is approved.",
        id: "no-permission.request.to.edit.request.sent.flag.description"
    },
    requestSentFlagAction: {
        defaultMessage: "Got it",
        id: "no-permission.request.to.edit.request.sent.flag.action"
    }
});
module.exports["messages"] = $b8ad22721a0e1a1a$export$defe85febe8b728c;

});

parcelRegister("9xWyx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $8cjip = parcelRequire("8cjip");


var $fCjCI = parcelRequire("fCjCI");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $i7yn3 = parcelRequire("i7yn3");


var $bl4QJ = parcelRequire("bl4QJ");


var $cMvQV = parcelRequire("cMvQV");


var $9wGTI = parcelRequire("9wGTI");

const $28dd515dedf67dfe$var$i18n = (0, $cgtv4.defineMessages)({
    startWatch: {
        id: "content-types-header.start.watch",
        defaultMessage: "Watch"
    },
    stopWatch: {
        id: "content-types-header.stop.watch",
        defaultMessage: "Stop watching"
    }
});
const $28dd515dedf67dfe$export$57961f75e08513d1 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, triggerProps: triggerProps, contentType: contentType, hasRecentlyUnwatchedContent: hasRecentlyUnwatchedContent } = t0;
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentType || $[1] !== createAnalyticsEvent || $[2] !== onClick) {
        t1 = async ()=>{
            onClick();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "content-watch-button",
                    source: "viewedContentScreen",
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
        };
        $[0] = contentType;
        $[1] = createAnalyticsEvent;
        $[2] = onClick;
        $[3] = t1;
    } else t1 = $[3];
    const handleWatchButton = t1;
    let t2;
    if ($[4] !== intl || $[5] !== isWatching) {
        t2 = isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
            label: intl.formatMessage($28dd515dedf67dfe$var$i18n.stopWatch)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: intl.formatMessage($28dd515dedf67dfe$var$i18n.startWatch)
        });
        $[4] = intl;
        $[5] = isWatching;
        $[6] = t2;
    } else t2 = $[6];
    const icon = t2;
    let t3;
    if ($[7] !== intl || $[8] !== isWatching) {
        t3 = isWatching ? intl.formatMessage($28dd515dedf67dfe$var$i18n.stopWatch) : intl.formatMessage($28dd515dedf67dfe$var$i18n.startWatch);
        $[7] = intl;
        $[8] = isWatching;
        $[9] = t3;
    } else t3 = $[9];
    const tooltipText = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT)
        };
        $[10] = t4;
    } else t4 = $[10];
    const watchShortcutStrings = (0, $4tOXV.useShortcutStrings)(t4);
    let t5;
    if ($[11] !== createAnalyticsEvent) {
        t5 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "dismissed",
                    actionSubject: "button",
                    actionSubjectId: "WatchDialogWatchContentNudge",
                    source: "WatchButton"
                }
            }).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = t5;
    } else t5 = $[12];
    const onDismissNudgeButtonClick = t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== onClick) {
        t6 = ()=>{
            onClick();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "watched",
                    actionSubject: "button",
                    actionSubjectId: "WatchDialogWatchContentNudge",
                    source: "WatchButton"
                }
            }).fire();
        };
        $[13] = createAnalyticsEvent;
        $[14] = onClick;
        $[15] = t6;
    } else t6 = $[15];
    const onWatchFromNudgeButtonClick = t6;
    let t7;
    if ($[16] !== tooltipText) {
        t7 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? tooltipText : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: tooltipText,
            isTooltip: true
        });
        $[16] = tooltipText;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== watchShortcutStrings) {
        t8 = (0, $9wGTI.fg)("platform_tooltip_shortcuts_migration_1") ? watchShortcutStrings : undefined;
        $[18] = watchShortcutStrings;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== handleWatchButton || $[21] !== icon || $[22] !== isSelected || $[23] !== onMouseOver || $[24] !== triggerProps) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: handleWatchButton,
            onMouseOver: onMouseOver,
            appearance: "subtle",
            iconBefore: icon,
            isSelected: isSelected,
            ...triggerProps,
            "data-testId": "watch-content-button"
        });
        $[20] = handleWatchButton;
        $[21] = icon;
        $[22] = isSelected;
        $[23] = onMouseOver;
        $[24] = triggerProps;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "content-watch-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7,
            shortcut: t8,
            position: "top",
            hideTooltipOnClick: true
        }, t9));
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== hasRecentlyUnwatchedContent || $[31] !== isWatching || $[32] !== onDismissNudgeButtonClick || $[33] !== onWatchFromNudgeButtonClick) {
        t11 = !isWatching && !hasRecentlyUnwatchedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7yn3.WatchContentNudgeSpotlight), {
            onWatchFromNudgeButtonClick: onWatchFromNudgeButtonClick,
            onDismissNudgeButtonClick: onDismissNudgeButtonClick
        });
        $[30] = hasRecentlyUnwatchedContent;
        $[31] = isWatching;
        $[32] = onDismissNudgeButtonClick;
        $[33] = onWatchFromNudgeButtonClick;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== t10 || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
            blanketIsTinted: false
        }, t10, t11);
        $[35] = t10;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : ({ isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, triggerProps: triggerProps, contentType: contentType, hasRecentlyUnwatchedContent: hasRecentlyUnwatchedContent })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleWatchButton = (0, $42omo.useCallback)(async ()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'content-watch-button',
                source: 'viewedContentScreen',
                attributes: {
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        onClick,
        createAnalyticsEvent,
        contentType
    ]);
    const icon = isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
        label: intl.formatMessage($28dd515dedf67dfe$var$i18n.stopWatch)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
        label: intl.formatMessage($28dd515dedf67dfe$var$i18n.startWatch)
    });
    const tooltipText = isWatching ? intl.formatMessage($28dd515dedf67dfe$var$i18n.stopWatch) : intl.formatMessage($28dd515dedf67dfe$var$i18n.startWatch);
    const watchShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT)
    });
    const onDismissNudgeButtonClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'WatchDialogWatchContentNudge',
                source: 'WatchButton'
            }
        }).fire();
    };
    const onWatchFromNudgeButtonClick = ()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'watched',
                actionSubject: 'button',
                actionSubjectId: 'WatchDialogWatchContentNudge',
                source: 'WatchButton'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "content-watch-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? tooltipText : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: tooltipText,
            isTooltip: true
        }),
        shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? watchShortcutStrings : undefined,
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: handleWatchButton,
        onMouseOver: onMouseOver,
        appearance: "subtle",
        iconBefore: icon,
        isSelected: isSelected,
        ...triggerProps,
        "data-testId": "watch-content-button"
    }))), !isWatching && !hasRecentlyUnwatchedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7yn3.WatchContentNudgeSpotlight), {
        onWatchFromNudgeButtonClick: onWatchFromNudgeButtonClick,
        onDismissNudgeButtonClick: onDismissNudgeButtonClick
    }));
};

const $28dd515dedf67dfe$export$b4175d4e6b5294b9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-rBZR",
    name: "ContentTypesWatchDialogButtonLoader",
    loader: async ()=>(await Promise.resolve(module.exports)).ContentTypesWatchDialogButton,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
module.exports["ContentTypesWatchDialogButton"] = $28dd515dedf67dfe$export$57961f75e08513d1;
module.exports["ContentTypesWatchDialogButtonLoader"] = $28dd515dedf67dfe$export$b4175d4e6b5294b9;

});

parcelRegister("i7yn3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $5RBJ9 = parcelRequire("5RBJ9");

var $2Fndw = parcelRequire("2Fndw");


var $lwNi3 = parcelRequire("lwNi3");

const $d3138ac7876be805$var$i18n = (0, $cgtv4.defineMessages)({
    watchButtonNudgeTitle: {
        id: "watch-dialog.watch.nudge.title",
        defaultMessage: "Watch for updates"
    },
    watchButtonNudgeContent: {
        id: "watch-dialog.watch.nudge.content",
        defaultMessage: "When content you\u2019re watching is updated, you\u2019ll receive a notification."
    },
    watchButtonNudgeDismissText: {
        id: "watch-dialog.watch.nudge.dismiss.action",
        defaultMessage: "Dismiss"
    },
    watchButtonNudgeWatchText: {
        id: "watch-dialog.watch.nudge.watch.action",
        defaultMessage: "Watch"
    }
});
const $d3138ac7876be805$var$watchContentNudge = 'cc-watch-page-spotlight-nudge';
const $d3138ac7876be805$export$aa5e8a615927bea8 = ({ onWatchFromNudgeButtonClick: onWatchFromNudgeButtonClick, onDismissNudgeButtonClick: onDismissNudgeButtonClick })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isActive, setIsActive] = (0, $42omo.useState)(true);
    const [hasMessageStarted, setHasMessageStarted] = (0, $42omo.useState)(false);
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const onDismissNudge = ()=>{
        coordinationClient?.stop($d3138ac7876be805$var$watchContentNudge);
        setIsActive(false);
        onDismissNudgeButtonClick();
    };
    const onWatchFromNudgeClick = ()=>{
        coordinationClient?.stop($d3138ac7876be805$var$watchContentNudge);
        setIsActive(false);
        onWatchFromNudgeButtonClick();
    };
    (0, $42omo.useEffect)(()=>{
        const onShowNudge = ()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'WatchDialogWatchContentNudge'
                }
            }).fire();
        };
        const checkNudgeStatus = async ()=>{
            const messageStarted = await coordinationClient.start($d3138ac7876be805$var$watchContentNudge);
            if (messageStarted) {
                setHasMessageStarted(messageStarted);
                onShowNudge();
            }
        };
        checkNudgeStatus();
    }, [
        isActive,
        coordinationClient,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, isActive && hasMessageStarted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        testId: "watch-content-nudge-spotlight",
        actions: [
            {
                text: intl.formatMessage($d3138ac7876be805$var$i18n.watchButtonNudgeWatchText),
                onClick: onWatchFromNudgeClick
            },
            {
                text: intl.formatMessage($d3138ac7876be805$var$i18n.watchButtonNudgeDismissText),
                onClick: onDismissNudge
            }
        ],
        dialogPlacement: "bottom",
        heading: intl.formatMessage($d3138ac7876be805$var$i18n.watchButtonNudgeTitle),
        target: "content-watch-spotlight",
        key: "content-watch-spotlight",
        dialogWidth: 275,
        targetRadius: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d3138ac7876be805$var$i18n.watchButtonNudgeContent)));
};
$d3138ac7876be805$export$aa5e8a615927bea8.propTypes = {
    onWatchFromNudgeButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onDismissNudgeButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
module.exports["WatchContentNudgeSpotlight"] = $d3138ac7876be805$export$aa5e8a615927bea8;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("bl4QJ", function(module, exports) {
/* WatchButtonPlaceholder.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $8cjip = parcelRequire("8cjip");


var $eEA8O = parcelRequire("eEA8O");

const $84156adddab51810$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $84156adddab51810$export$2d7669ced06071f = ({ compact: compact })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($84156adddab51810$export$2d5d2ba3c7c8c40b, {
        testId: "watch-button-placeholder",
        "data-test-id": "watch-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: "WatchIcon",
            spacing: "spacious"
        }),
        isDisabled: true,
        spacing: compact ? 'compact' : 'default'
    });
$84156adddab51810$export$2d7669ced06071f.propTypes = {
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["WatchButtonPlaceholder"] = $84156adddab51810$export$2d7669ced06071f;

});

parcelRegister("5mJom", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fae6b037fdec4166$export$965fac7e99de5b4c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "asP3B",
    name: "ContentHeaderPresenceLoader",
    loader: async ()=>(await (parcelRequire("93RyD"))).ContentHeaderPresence
});
module.exports["ContentHeaderPresenceLoader"] = $fae6b037fdec4166$export$965fac7e99de5b4c;

});

parcelRegister("93RyD", function(module, exports) {

let $698df04eaab9a46a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $698df04eaab9a46a$var$load("dA13Y"),
    $698df04eaab9a46a$var$load("fjOTL"),
    $698df04eaab9a46a$var$load("h4Nf7"),
    $698df04eaab9a46a$var$load("cLdBj"),
    $698df04eaab9a46a$var$load("7rCOq"),
    $698df04eaab9a46a$var$load("6XCf4"),
    $698df04eaab9a46a$var$load("1qlDN"),
    $698df04eaab9a46a$var$load("1yVM6"),
    $698df04eaab9a46a$var$load("cyGuT"),
    $698df04eaab9a46a$var$load("jXx9i"),
    $698df04eaab9a46a$var$load("iZU4p"),
    $698df04eaab9a46a$var$load("bunf9"),
    $698df04eaab9a46a$var$load("kUbUu"),
    $698df04eaab9a46a$var$load("7Q5vz"),
    $698df04eaab9a46a$var$load("6FuHS"),
    $698df04eaab9a46a$var$load("eyaRC"),
    $698df04eaab9a46a$var$load("f1NVy"),
    $698df04eaab9a46a$var$load("6wr18"),
    $698df04eaab9a46a$var$load("kjZZD"),
    $698df04eaab9a46a$var$load("Wowvf"),
    $698df04eaab9a46a$var$load("hhss7"),
    $698df04eaab9a46a$var$load("ffEVr"),
    $698df04eaab9a46a$var$load("c4Kdp"),
    $698df04eaab9a46a$var$load("7EorR"),
    $698df04eaab9a46a$var$load("3YiKe")
]).then(()=>parcelRequire('bLtXM'));

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("5M5fB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $42omo.useRef)(null);
    const currentParticipants = (0, $42omo.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $42omo.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $42omo.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $42omo.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("1ch0f", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $inoU6 = parcelRequire("inoU6");


var $baNhC = parcelRequire("baNhC");

const $70727fac6b2369a2$export$20904b77028459e9 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const isBlank = isSingleUserSession && isUnpublishedDraft && !hasTitle && !hasBody && !hasEmoji && !hasEmoji && !hasCoverPicture && !hasContentState && !hasRestrictions && !hasLabels;
    return {
        isBlank: isBlank,
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    };
};
const $70727fac6b2369a2$export$96599dcc2d34575a = ({ contentId: contentId, deleteOnlyIfBlank: deleteOnlyIfBlank })=>(0, $hp2SH.getApolloClient)().mutate({
        mutation: (0, $inoU6.DeleteDraftMutation),
        variables: {
            contentId: contentId,
            action: deleteOnlyIfBlank ? (0, $baNhC.ContentDeleteActionType).DELETE_DRAFT_IF_BLANK : (0, $baNhC.ContentDeleteActionType).DELETE_DRAFT
        }
    });
module.exports["blankDraftInfo"] = $70727fac6b2369a2$export$20904b77028459e9;
module.exports["deleteDraft"] = $70727fac6b2369a2$export$96599dcc2d34575a;

});

parcelRegister("inoU6", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $71092054b022cd94$export$423f03de91e6fdb = (0, $eSUdr.default)`mutation DeleteDraftMutation($contentId:ID!$action:ContentDeleteActionType!){deleteContent(contentId:$contentId action:$action){contentId wasDeleted}}`;
module.exports["DeleteDraftMutation"] = $71092054b022cd94$export$423f03de91e6fdb;

});

parcelRegister("baNhC", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $358df202dbcafed8$export$e0db935847b66dda = /*#__PURE__*/ function(ContentDeleteActionType) {
    ContentDeleteActionType["DELETE_DRAFT"] = "DELETE_DRAFT";
    ContentDeleteActionType["DELETE_DRAFT_IF_BLANK"] = "DELETE_DRAFT_IF_BLANK";
    ContentDeleteActionType["MOVE_TO_TRASH"] = "MOVE_TO_TRASH";
    ContentDeleteActionType["PURGE_FROM_TRASH"] = "PURGE_FROM_TRASH";
    return ContentDeleteActionType;
}({});
module.exports["ContentDeleteActionType"] = $358df202dbcafed8$export$e0db935847b66dda;

});

parcelRegister("2unW6", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");

const $0c936a0ccc8709d1$export$d6875122194c7b44 = (contentId)=>{
    const [hasLabels, setHasLabels] = (0, $42omo.useState)(true);
    const { data: data } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useLabelsLabelCountQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count}}}}`, {
        variables: {
            contentId: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        setHasLabels((data?.content?.nodes?.[0]?.labels?.count ?? 0) > 0);
    }, [
        data
    ]);
    return hasLabels;
};
module.exports["useLabels"] = $0c936a0ccc8709d1$export$d6875122194c7b44;

});

parcelRegister("lu0E4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hXDOc = parcelRequire("hXDOc");


var $8G1o2 = parcelRequire("8G1o2");


var $dLX9a = parcelRequire("dLX9a");

const $d97c0945857481ee$export$8bc1bc0080a813ff = ({ isPublish: isPublish, contentId: contentId, spaceKey: spaceKey, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, children: children })=>{
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    const publishPreloadUrl = (0, $dLX9a.getPublishPreloadUrl)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    const closePreloadUrl = (0, $42omo.useMemo)(()=>{
        if (!breadcrumbs || breadcrumbs.length === 0) return '';
        return (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft,
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "preload-button-wrapper",
        preloadUrl: isPublish ? publishPreloadUrl : closePreloadUrl,
        preloadOptions: (0, $hXDOc.PreloadingPresets).everything
    }, children);
};
module.exports["PreloadButtonWrapper"] = $d97c0945857481ee$export$8bc1bc0080a813ff;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader",
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown
    }, children));
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("8G1o2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $6mKj3 = parcelRequire("6mKj3");


var $beez8 = parcelRequire("beez8");


var $8WndG = parcelRequire("8WndG");


var $eitcW = parcelRequire("eitcW");

function $4afe25e74c0897d4$export$af6ae8f81a672789(contentId) {
    const queryArgs = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const { data: data, error: error } = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_schema_exp_5', 'isEnabled', true) ? (0, $eitcW.useExperimentalEditorBreadcrumbsQuery)(queryArgs) : (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $beez8.EditorBreadcrumbsQuery), queryArgs);
    const breadcrumbs = (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    const memoizedBreadcrumbs = (0, $42omo.useMemo)(()=>{
        return (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    }, [
        data,
        error
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? memoizedBreadcrumbs : breadcrumbs;
}
module.exports["useEditorBreadcrumbs"] = $4afe25e74c0897d4$export$af6ae8f81a672789;

});

parcelRegister("beez8", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $46cdb07562615f76$export$b082362df704a046 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query EditorBreadcrumbsQuery($contentId:ID!)@experimental{experimentalEditorBreadcrumbs(contentId:$contentId){breadcrumbs{title url}}}`;
module.exports["EditorBreadcrumbsQuery"] = $46cdb07562615f76$export$b082362df704a046;

});

parcelRegister("8WndG", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");

function $808c5ea5e28dcdc3$export$ba755fc0ebb98c2(data, error) {
    if (error) {
        if ((0, $6fil2.containsNetworkError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }
    return data?.experimentalEditorBreadcrumbs?.breadcrumbs || [];
}
module.exports["handleEditorBreadcrumbsQueryResult"] = $808c5ea5e28dcdc3$export$ba755fc0ebb98c2;

});

parcelRegister("eitcW", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d = ({ variables: variables, skip: skip, onError: onError })=>{
    const { contentId: contentId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (json, _variables)=>{
            if (!contentId) throw new Error('contentId is missing.');
            return {
                experimentalEditorBreadcrumbs: {
                    breadcrumbs: json?.breadcrumbs || null
                }
            };
        },
        skip: skip,
        variables: variables,
        onError: onError
    });
};
module.exports["useExperimentalEditorBreadcrumbsQuery"] = $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if (Boolean((0, $1NBp8.FOLDER_VIEW).match(url))) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("5rEAe", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $ann9t = parcelRequire("ann9t");

const $15544693a6bca546$export$15562ab063498253 = async (contentId, readFragmentInterop)=>{
    const apolloClient = (0, $hp2SH.getApolloClient)();
    // Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
    // We want to gracefully handle this and return `undefined`, so we use the try/catch block to swallow errors.
    let parentId = undefined;
    try {
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) {
            const draftData = readFragmentInterop({
                id: `Content:${contentId}`
            });
            parentId = draftData?.ancestors?.slice(-1)?.[0]?.id;
        } else {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const draftParentQueryResult = await apolloClient.readQuery({
                query: (0, $ann9t.GetDraftParentQuery),
                variables: {
                    contentId: contentId
                }
            });
            parentId = draftParentQueryResult?.content?.nodes?.[0]?.ancestors?.slice(-1)?.[0]?.id;
        }
    } catch  {}
    return parentId;
};
module.exports["getParentOfDraft"] = $15544693a6bca546$export$15562ab063498253;

});

parcelRegister("ann9t", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $4aac1a034faa729a$export$450983e01fc665dd = (0, $eSUdr.default)`query GetDraftParentQuery($contentId:ID!){content(id:$contentId status:["draft"]){nodes{id ancestors{id}}}}`;
module.exports["GetDraftParentQuery"] = $4aac1a034faa729a$export$450983e01fc665dd;

});

parcelRegister("3mmDo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hYoU4 = parcelRequire("hYoU4");


var $1ch0f = parcelRequire("1ch0f");

const $f928d6004096ea67$export$a0b893b7ce6fdcb3 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const [willDeleteBlankDraftOnClose, setWillDeleteBlankDraftOnClose] = (0, $42omo.useState)(false);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    (0, $42omo.useEffect)(()=>{
        // necessary for showing correct tooltip on close button
        const { isBlank: isBlank } = (0, $1ch0f.blankDraftInfo)({
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        });
        setWillDeleteBlankDraftOnClose(collabEditConnected && isBlank);
    }, [
        isUnpublishedDraft,
        isSingleUserSession,
        hasTitle,
        hasBody,
        hasEmoji,
        hasCoverPicture,
        hasContentState,
        hasRestrictions,
        hasLabels,
        collabEditConnected
    ]);
    return willDeleteBlankDraftOnClose;
};
module.exports["useWillDeleteBlankDraftOnClose"] = $f928d6004096ea67$export$a0b893b7ce6fdcb3;

});

parcelRegister("atF9V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $5nr5P = parcelRequire("5nr5P");

const $5d4782fa577ebcb8$export$e6d5ad5483367d52 = ()=>{
    const [hasRestrictions, setHasRestrictions] = (0, $42omo.useState)(false);
    const hasRestrictionsSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $5nr5P.RestrictionsDataContainer)
        ]
    }, (restrictionsState)=>{
        setHasRestrictions(restrictionsState.state.hasRestrictions);
        return null;
    });
    return {
        hasRestrictionsSubscription: hasRestrictionsSubscription,
        hasRestrictions: hasRestrictions
    };
};
module.exports["useRestrictions"] = $5d4782fa577ebcb8$export$e6d5ad5483367d52;

});

parcelRegister("5nr5P", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");

class $22dbf97de39b4a94$export$8428b29fbe35d5c extends (0, $T1bCI.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                contentPermissions: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                contentStatus: undefined,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: //   currentUserInfo: PropTypes.shape({
            //     id: PropTypes.string.isRequired,
            //     displayName: PropTypes.string.isRequired,
            //     isSuperAdmin: PropTypes.bool,
            //     profilePicture: PropTypes.shape({
            //       path: PropTypes.string
            //     })
            //   }).isRequired,
            currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: // const restrictionsShape = {
            //   restrictions: PropTypes.shape({
            //     user: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           accountId: PropTypes.string,
            //           displayName: PropTypes.string,
            //           type: PropTypes.string
            //         })
            //       )
            //     }),
            //     group: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           name: PropTypes.string
            //         })
            //       )
            //     })
            //   })
            // };
            restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}
module.exports["RestrictionsDataContainer"] = $22dbf97de39b4a94$export$8428b29fbe35d5c;

});

parcelRegister("lHzSp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $ktUCG = parcelRequire("ktUCG");


var $i5zxs = parcelRequire("i5zxs");


var $bJX6u = parcelRequire("bJX6u");

const $fb2260515fd87e61$export$5ebd549b1d465b39 = ()=>{
    const [hasEmoji, setHasEmoji] = (0, $42omo.useState)(false);
    const [hasCoverPicture, setHasCoverPicture] = (0, $42omo.useState)(false);
    const [hasContentState, setHasContentState] = (0, $42omo.useState)(false);
    const emojiCoverPictureAndContentStateSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer)
        ]
    }, (emojiTitleState)=>{
        setHasEmoji(!!emojiTitleState.state.selectedEmoji);
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>{
        setHasCoverPicture(coverPictureState.state.hasCoverPicture);
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        setHasContentState(!!contentStateState.state.contentState);
        return null;
    }));
    return {
        emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        hasContentState: hasContentState
    };
};
module.exports["useEmojiTitleCoverPictureAndContentState"] = $fb2260515fd87e61$export$5ebd549b1d465b39;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $8rneB = parcelRequire("8rneB");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $T1bCI.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: property?.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    const nodes = (data?.content?.nodes?.[0] || data?.singleContent)?.[emojiFieldName]?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["getHasEmojiPublished"] = $61659933fe71a4ee$export$53519180ca077ff2;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
} : (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    // whiteboards and live pages are always published, so return EMOJI_TITLE_PUBLISHED_FIELD
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            isAIUnsplashImage: false,
            aiSuggestedUnsplashImages: undefined,
            shouldShowAIUnsplashHeaderToolbar: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setIsAIUnsplashImage = (isAIUnsplashImage)=>this.setState({
                isAIUnsplashImage: isAIUnsplashImage
            });
        this.setAISuggestedUnsplashImages = (aiSuggestedUnsplashImages)=>this.setState({
                aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
            });
        this.setShouldShowAIUnsplashHeaderToolbar = (shouldShowAIUnsplashHeaderToolbar)=>this.setState({
                shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar
            });
        this.resetToDefaults = ()=>{
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setIsAIUnsplashImage(false);
            this.setAISuggestedUnsplashImages(undefined);
            this.setShouldShowAIUnsplashHeaderToolbar(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("jacyh", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $1P1Tu.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $9zUhf.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $9zUhf.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("ecUYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("gabmL", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $cgtv4.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && edition === (0, $euL71.ConfluenceEdition).PREMIUM && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const canEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') pageData.refetch();
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $8C5kA.default)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId pageStatus publicLinkUrlPath}}`, {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $42omo.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $42omo.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;
module.exports["PublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b86a4cadf4c50ae1;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("1X7PR", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const isSpaceAdmin = Boolean(data?.space?.currentUser.isAdmin);
    const canEditPage = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
    return {
        contentType: contentType,
        canEditPublicLink: (isSpaceAdmin || canEditPage) && !isExternalCollaborator
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!$spaceKey:String!$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id type operations{operation targetType}}}space(key:$spaceKey)@include(if:$hasSpaceKey){id currentUser{isAdmin}}}`, {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator)
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("cLo2u", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

const $91bacb73ef37142f$export$12ed3d1363567203 = (0, $3u0dr.isReactCompilerActiveV1)() ? function useSpaceKey(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
} : function useSpaceKey(spaceKey) {
    // Space-level data is used to retrieve information about a space's external collaborators
    // in multiple places across the package. Attempt to get spaceKey from a range of sources.
    // If we are in a view-page context, spaceKey data may be available from PageState.
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // Otherwise, RoutesContext may contain the information we need
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    // Now that our context hooks have executed, we can return if we have a match.
    // Return statements are separated out for optimum readability.
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    // Legacy server-rendered UI pages do not have the "match" object in RoutesContext, but
    // they can contain space information in the <meta> data tag.
    const documentMetaSpaceKey = typeof document !== 'undefined' ? document.querySelector('meta#confluence-space-key')?.content : null;
    return documentMetaSpaceKey ?? null;
};
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("bgRei", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId objectType:$objectType){permissions}}`, {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("lEVfb", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");

const $8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery = (0, $eSUdr.default)`query useIsEditorToolbarDockedAtTopEditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}`;
const $8a729a72887c33f8$export$39186427447356b2 = ({ defaultDockedAtTop: defaultDockedAtTop = false } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery, {
        fetchPolicy: 'cache-only',
        skip: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')
    });
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')) return true;
    if (loading) // while loading use the default docking preference
    return defaultDockedAtTop;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        // couldn't query for user's docking preference, use the default docking preference
        return defaultDockedAtTop;
    }
    // get graphql user preference value
    const dockingPreference = data?.userPreferences?.confluenceEditorSettings?.toolbarDockingInitialPosition;
    if (dockingPreference === 'top') return true;
    if (dockingPreference === 'none') return false;
    return defaultDockedAtTop;
};
module.exports["useIsEditorToolbarDockedAtTop"] = $8a729a72887c33f8$export$39186427447356b2;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const twentyFourHoursAgoInSecondsFallbackReplayCap = Math.floor((Date.now() - 86400000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < twentyFourHoursAgoInSecondsFallbackReplayCap) sequenceNumber = twentyFourHoursAgoInSecondsFallbackReplayCap;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("iiPY2", function(module, exports) {
$parcel$export(module.exports, "ContentTypeClassification", () => (parcelRequire("2JKSZ")).ContentTypeClassification);
/* ContentTypeClassification.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $2JKSZ = parcelRequire("2JKSZ");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("2JKSZ")))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});
module.exports["ContentTypeClassificationLoader"] = $200528ba24c995ad$export$b3d0b57fae17761b;

});

parcelRegister("2JKSZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $arfOv = parcelRequire("arfOv");


var $9yVdT = parcelRequire("9yVdT");


var $fGQzQ = parcelRequire("fGQzQ");


var $1u6lx = parcelRequire("1u6lx");


var $in5LX = parcelRequire("in5LX");


var $79yie = parcelRequire("79yie");


const $d07cae14ea38bbbf$var$ClassificationTagButtonError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8ozBk",
    name: "ClassificationTagButtonError",
    loader: async ()=>(await (parcelRequire("1gG4q"))).ClassificationTagButtonError
});
const $d07cae14ea38bbbf$var$ContentTypeClassificationComponent = ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: readOnly = true, variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification;
    if (isAddNewClassificationMode) return null;
    if (!currentClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
        contentLevelError: contentLevelError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
        isLoading: isLoading,
        flagStatus: flagStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
        spaceKey: spaceKey,
        contentType: contentType,
        currentClassification: currentClassification,
        spaceDefaultIsOverridden: spaceDefaultIsOverridden,
        onEditSubmit: handleSubmit,
        menuBehavior: readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit,
        loading: isLoading,
        variant: variant,
        popupPlacementOverride: popupPlacementOverride,
        spacing: spacing,
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId
    }));
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationGetter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($d07cae14ea38bbbf$var$ContentTypeClassificationGetter);
const $d07cae14ea38bbbf$export$e97138dbbe0f9a02 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
module.exports["ContentTypeClassification"] = $d07cae14ea38bbbf$export$e97138dbbe0f9a02;

});

parcelRegister("arfOv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $i2BsV = parcelRequire("i2BsV");


var $jmjWc = parcelRequire("jmjWc");


var $earLp = parcelRequire("earLp");


var $7aj3N = parcelRequire("7aj3N");


var $1u6lx = parcelRequire("1u6lx");


const $e299f5faef060d8a$var$ClassificationReadViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zUIer",
    name: "ClassificationReadViewPopup",
    loader: async ()=>(await (parcelRequire("ddDB2"))).ClassificationReadViewPopup
});

const $e299f5faef060d8a$var$ClassificationEditViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mT5oW",
    name: "ClassificationEditViewPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("8KSlr")))).ClassificationEditViewPopup
});
var $e299f5faef060d8a$export$db79e28c55608769 = /*#__PURE__*/ function(TagButtonMenuBehavior) {
    TagButtonMenuBehavior["readOnly"] = "readOnly";
    TagButtonMenuBehavior["editOnly"] = "editOnly";
    TagButtonMenuBehavior["readAndEdit"] = "readAndEdit";
    return TagButtonMenuBehavior;
}({});
const $e299f5faef060d8a$var$DataClassificationLevelMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $i2BsV.default));
const $e299f5faef060d8a$var$messages = (0, $cgtv4.defineMessages)({
    tooltipMessage: {
        id: "data-classification.content-classification.tag-button.tooltip",
        defaultMessage: "This {contentType} is classified as {classification}"
    }
});
const $e299f5faef060d8a$export$e396cc9924b8f3a0 = ({ spaceKey: spaceKey, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: loading = false, isPopupDisabled: isPopupDisabled = false, menuBehavior: menuBehavior = "readOnly", variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId = 'data-classification-level' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || (0, $7aj3N.getPopupPlacementForTagVariant)(variant);
    (0, $42omo.useEffect)(()=>{
        if (menuBehavior === "editOnly") setIsReadView(false);
    }, [
        menuBehavior
    ]);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    const getOnChangeLevelClick = ()=>{
        if (menuBehavior === "readOnly") return undefined;
        return ()=>{
            setIsReadView(false);
            handlePopupShown({
                isOpen: true,
                shouldForce: true
            });
        };
    };
    const onEditCancel = (closePopup)=>{
        onEditCancelProp && onEditCancelProp();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const onEditSubmit = (classification, closePopup)=>{
        onEditSubmitProp && onEditSubmitProp(classification);
        onRestoreFocus && onRestoreFocus();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const handlePopupShown = ({ isOpen: isOpen, shouldForce: shouldForce = false })=>{
        if (isOpen) {
            const shouldTrackEvent = !isReadView || shouldForce;
            if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
        }
    };
    const renderPopupComponent = (closePopup)=>{
        return isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
            name: currentClassification.name,
            guideline: currentClassification.guideline,
            onChangeLevelClick: getOnChangeLevelClick()
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
            spaceKey: spaceKey,
            selectedOption: defaultSelectedEditOption,
            onEditCancel: ()=>onEditCancel(closePopup),
            onEditSubmit: (classification)=>onEditSubmit(classification, closePopup),
            loading: loading
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
        testId: buttonTestId,
        name: currentClassification.name,
        guideline: currentClassification.guideline,
        tooltip: formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        }),
        color: currentClassification.color,
        isPopupDisabled: isPopupDisabled,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        renderPopupComponent: renderPopupComponent,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        onPopupShown: ()=>handlePopupShown({
                isOpen: true
            }),
        isIconOnly: variant === (0, $1u6lx.TagButtonUIVariant).iconOnly,
        popupPlacement: popupPlacement,
        spacing: spacing
    }));
};
module.exports["TagButtonMenuBehavior"] = $e299f5faef060d8a$export$db79e28c55608769;
module.exports["GenericClassificationTagButton"] = $e299f5faef060d8a$export$e396cc9924b8f3a0;

});

parcelRegister("7aj3N", function(module, exports) {

var $1u6lx = parcelRequire("1u6lx");

const $8c761859b07fcf40$export$5eaa54a89a0ac = (variant)=>variant === (0, $1u6lx.TagButtonUIVariant).iconOnly ? 'auto' : 'bottom-start';
module.exports["getPopupPlacementForTagVariant"] = $8c761859b07fcf40$export$5eaa54a89a0ac;

});

parcelRegister("1u6lx", function(module, exports) {
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});
module.exports["TagButtonUIVariant"] = $a200b44450c31008$export$f72f271864b318ce;

});

parcelRegister("ddDB2", function(module, exports) {

let $027bcb2a62b71cce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $027bcb2a62b71cce$var$load("iJsKa").then(()=>parcelRequire('ePhVt'));

});

parcelRegister("9yVdT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9hlns = parcelRequire("9hlns");


var $u9agA = parcelRequire("u9agA");


var $gqqjz = parcelRequire("gqqjz");


var $in5LX = parcelRequire("in5LX");


var $gfkT8 = parcelRequire("gfkT8");


var $93WhG = parcelRequire("93WhG");

const $b9673e4989b5dd09$export$10b01f6c9dc571ea = ({ children: children, flagStatus: flagStatus, isLoading: isLoading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
            description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
            type: "warning",
            showRefresh: false
        })));
};
module.exports["TagLoadingAndFlagWrapper"] = $b9673e4989b5dd09$export$10b01f6c9dc571ea;

});

parcelRegister("gfkT8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1cYlh = parcelRequire("1cYlh");

const $4ebf6b4d55a3b532$var$actionMessage = (0, $cgtv4.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $42omo.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
module.exports["SaveFlag"] = $4ebf6b4d55a3b532$export$ac7557ff3627d244;

});

parcelRegister("1gG4q", function(module, exports) {

let $0ec7eb59ea45e0fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ec7eb59ea45e0fc$var$load("5odbj").then(()=>parcelRequire('2O7oS'));

});

parcelRegister("hl0fg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $42omo.useState)(getSize);
    (0, $42omo.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("iRMiv", function(module, exports) {

let $dbc2a4155f39e836$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbc2a4155f39e836$var$load("lnnYm"),
    $dbc2a4155f39e836$var$load("5odbj"),
    $dbc2a4155f39e836$var$load("2mt3f"),
    $dbc2a4155f39e836$var$load("frTOf")
]).then(()=>parcelRequire('8taxc'));

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 25000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("dYU3e", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");



var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $9wGTI = parcelRequire("9wGTI");


var $7Lnfv = parcelRequire("7Lnfv");


var $jQ6FG = parcelRequire("jQ6FG");


var $3joiD = parcelRequire("3joiD");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   * In component: query getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery or getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    const queryName = (0, $jQ6FG.getQueryName)(name, variables);
    let single = true;
    // If the query has already been preloaded with network only
    // Subsequent query with same name and variable should be done with cache-first to avoid duplicate network request
    (0, $3joiD.flagQueryPreloadedByNetworkOnly)(queryName, variables, fetchPolicy);
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // Save current boundary context
    const currentBoundary = window.__PRELOAD_BOUNDARY_NAME__;
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return client.query({
            query: query,
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            context: queryContext
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // Restore the previous boundary context as soon as the query resolves
            window.__PRELOAD_BOUNDARY_NAME__ = currentBoundary;
            const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
            return {
                ...result,
                hasErrors: hasErrors
            };
        });
    })();
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("lyWac", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return Promise.allSettled(values).then((results)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            const errors = [];
            for (const result of results){
                if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
                else if (result.status === 'fulfilled') {
                    const fulfilledValue = result.value;
                    if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                    else if (Array.isArray(fulfilledValue)) {
                        const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                        errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                    }
                }
            }
            if (errors.length > 0) {
                // Errors on preloader functions are not meant to break anything.
                // But we still want to know them...
                // eslint-disable-next-line no-console
                console.error('Errors caught by waitForAllReturnWhenError', {
                    errors: errors.map((error)=>error.message)
                });
                return errors;
            }
        });
    })();
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$ed215fd77db898ec(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToScriptTags"] = $372ebd682f0fb003$export$ed215fd77db898ec;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("kqIWy", function(module, exports) {

var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey)=>{
    /** @schema cc */ const useSpaceDetailQuery = (0, $4ZxLt.default);
    const options = {
        variables: {
            spaceKey: spaceKey
        }
    };
    const { loading: loading, data: data, error: error } = (0, $9wGTI.fg)('stop_watching_more_queries') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)(useSpaceDetailQuery, options) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(useSpaceDetailQuery, options);
    return {
        loading: loading,
        data: data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined,
        error: error
    };
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<2f52473be21986bee58c241e9bbdbeb7>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("e3X7L", function(module, exports) {
/**
 * @generated SignedSource<<018f680a41f998d85b2f3329e18a2d4f>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;
module.exports["default"] = $05607cbb6652fe1b$export$2e2bcd8739ae039;

});

parcelRegister("fyUox", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            query: (0, $zalpJ.PreloadHomepageIdQuery),
            variables: {
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c65934a9e331ff8701130392e383f058>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $jMyy4 = parcelRequire("jMyy4");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch (e) {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<edc256fe5c5e6d649d0fd080ebecc4d6>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lztxY = parcelRequire("lztxY");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $lztxY.getDraftContentAppearanceProperty),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<610ef5d59757084c5c735b88bfdb9d49>>
 * @relayHash c33a4203c746101786d53936f44b1619
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4ef10dac3898c01071d9db8da37b88a5e022cc46419c343458d7958799000fd4
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c33a4203c746101786d53936f44b1619",
            "id": "4ef10dac3898c01071d9db8da37b88a5e022cc46419c343458d7958799000fd4",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,description,color,name,status},featureEnabled,source,isReclassificationPermitted}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "677a732ef8b9ed562b6751493462953b";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("alaek", function(module, exports) {
$parcel$export(module.exports, "default", () => $21bae01687242d76$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $6fnsQ = parcelRequire("6fnsQ");


var $cmDjE = parcelRequire("cmDjE");

const $21bae01687242d76$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $21bae01687242d76$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
function $21bae01687242d76$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cmDjE.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}

});

parcelRegister("cmDjE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5P3yi = parcelRequire("5P3yi");


var $f2BEc = parcelRequire("f2BEc");

const $bdf91181004cdb95$var$boxShadowCssVar = '--avatar-box-shadow';
const $bdf91181004cdb95$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $bdf91181004cdb95$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $bdf91181004cdb95$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $bdf91181004cdb95$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $bdf91181004cdb95$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $bdf91181004cdb95$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $bdf91181004cdb95$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $bdf91181004cdb95$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const avatarSrc = (0, $f2BEc.getTeamAvatarSrc)(src, teamId); // If src changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5P3yi.FallbackAvatar), {
        "aria-label": alt,
        width: $bdf91181004cdb95$var$SIZES[size],
        height: $bdf91181004cdb95$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $gMc0m.default)([
            $bdf91181004cdb95$var$unboundStyles.root,
            $bdf91181004cdb95$var$containerStyles.root,
            $bdf91181004cdb95$var$borderRadiusMap[size],
            $bdf91181004cdb95$var$widthHeightMap[size],
            compact ? $bdf91181004cdb95$var$containerStyles.compactSpacing : $bdf91181004cdb95$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $gMc0m.default)([
                $bdf91181004cdb95$var$avatarImageStyles.image
            ])
        })
    });
};
module.exports["TeamAvatarImage"] = $bdf91181004cdb95$export$ac3673635a5387be;

});

parcelRegister("5P3yi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $2cfa1b514c8db58a$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $2cfa1b514c8db58a$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($2cfa1b514c8db58a$var$styles.wrapper, props.compact ? $2cfa1b514c8db58a$var$styles.compactWrapperSpacing : $2cfa1b514c8db58a$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}
module.exports["FallbackAvatar"] = $2cfa1b514c8db58a$export$eb63dcc490f6bbcd;

});

parcelRegister("f2BEc", function(module, exports) {
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $e75bf44959780d0d$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}
module.exports["getTeamAvatarSrc"] = $e75bf44959780d0d$export$59ff7d19feb890b6;

});

parcelRegister("1A9t2", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $6d2a4e7dc7af02b0$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $6d2a4e7dc7af02b0$export$533b26079ad0b4b;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("gfIPU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $5675860ef242c9e4$export$eed1d73ebdd8c7ab = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceFailure(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceFailure({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>experienceTracker.fail({
            name: name,
            error: error,
            attributes: attributes
        }), [
        experienceTracker,
        name,
        error,
        attributes
    ]);
    return null;
};
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("jv3O2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $8C5kA.default)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $42omo.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("jln20", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
} : ()=>(0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $42omo.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    const contextValue = (0, $42omo.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("hpTea"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("hpTea", function(module, exports) {

let $cadf9c7e3681c020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cadf9c7e3681c020$var$load("ioQAS"),
    $cadf9c7e3681c020$var$load("6wr18"),
    $cadf9c7e3681c020$var$load("kjZZD"),
    $cadf9c7e3681c020$var$load("ffEVr"),
    $cadf9c7e3681c020$var$load("2bmVk"),
    $cadf9c7e3681c020$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $cgtv4.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("4o1RV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

const $f3bd82ae210529c7$export$57395cb9dce31159 = (0, $3u0dr.isReactCompilerActiveV1)() ? function useNavigationPolicy() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useNavigationPolicy() {
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    return (0, $42omo.useMemo)(()=>({
            routePolicy: routePolicy,
            ...shimUrl
        }), [
        routePolicy,
        shimUrl
    ]);
};
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
const $734ea8da77496ad5$export$8ed0b067e5cd675d = (0, $3u0dr.isReactCompilerActiveV1)() ? function useShimUrl(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : function useShimUrl(navigationPolicy) {
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    const shimUrl = (0, $42omo.useCallback)((urlToShim)=>{
        return $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimAdfUrls = (0, $42omo.useCallback)((adf)=>{
        if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
        const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
        $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        return adfClone;
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimHtmlUrls = (0, $42omo.useCallback)((html)=>{
        if (!shimTemplate || !html) return html;
        // shimHtmlUrls is used on legacy macros, but some legacy macros return stringified ADFEntity
        // Check if the input is a JSON-stringified ADFEntity
        try {
            const parsedContent = JSON.parse(html);
            if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                // It's a valid ADF document - check if it needs nested table transformation
                if (html.includes('"extensionKey":"nested-table"')) {
                    const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                    return JSON.stringify(processedAdf);
                } else {
                    // ADF without nested tables - just delegate to shimAdfUrls and stringify the result
                    const shimmedAdf = shimAdfUrls(parsedContent);
                    return JSON.stringify(shimmedAdf);
                }
            }
        } catch  {
        // Not valid JSON, fall through to HTML processing
        }
        // Process as HTML string (for non-ADF content)
        try {
            return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, 'text/html'), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
        } catch  {
            return html;
        }
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter,
        shimAdfUrls
    ]);
    return (0, $42omo.useMemo)(()=>({
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        }), [
        shimUrl,
        shimAdfUrls,
        shimHtmlUrls
    ]);
};
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("bMPhU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(6);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`;
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !spaceKey;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data } = (0, $xQxzY.useQuery)(t0, t3);
    return data?.space?.homepage?.id || undefined;
} : (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("bCECL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $gTyTP = parcelRequire("gTyTP");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    const defaultedType = type === 'liveDoc' ? 'page' : type; // Prevent using 'liveDoc' type directly
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: defaultedType,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage && isLivePagesFeatureEnabled ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[defaultedType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("83Z6R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

function $b847dc1d37d68706$export$dcf9d4e77de27956(...[query, params]) {
    const resolversRef = (0, $42omo.useRef)();
    /**
	 * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
	 */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        params
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("iquRY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        variables: {
            cloudId: cloudId
        },
        onError: (error)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== 'PRE_ROLES' : false;
    return {
        spaceRoleMode: data?.confluence_spaceRoleMode,
        isRbacEnabled: isNotPreRoles,
        loading: loading
    };
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("i28ZW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $eSUdr.default)`query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}operations{operation targetType}}}`;
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $42omo.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: hasSpaceOperation($981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: hasSpaceOperation($981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: hasSpaceOperation($981a614bc39b93a3$export$50faaafd42078ad9),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("hpRYU", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $gtD4K = parcelRequire("gtD4K");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $6f0Oj = parcelRequire("6f0Oj");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $6mKj3 = parcelRequire("6mKj3");


var $jjoF2 = parcelRequire("jjoF2");


var $6RGMW = parcelRequire("6RGMW");


var $g3p2i = parcelRequire("g3p2i");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $6RGMW.UserAndGroupSearchQuery));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: components,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        enableEmailSearch: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        allowEmailSelectionWhenEmailMatched: !(0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false)
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $cgtv4.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/**
 * @generated SignedSource<<40e2b37836ef7625e634b9236789b118>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("6RGMW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $eSUdr.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;
module.exports["UserAndGroupSearchQuery"] = $88fbd0e78227b736$export$9eed0d08b5194ae7;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("1fJjv"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("1fJjv", function(module, exports) {

let $0e9a5783912299bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e9a5783912299bf$var$load("2haIE"),
    $0e9a5783912299bf$var$load("9K4jq"),
    $0e9a5783912299bf$var$load("6wr18"),
    $0e9a5783912299bf$var$load("dMOc8"),
    $0e9a5783912299bf$var$load("aX0L0"),
    $0e9a5783912299bf$var$load("QcHuP"),
    $0e9a5783912299bf$var$load("iQ0Jm"),
    $0e9a5783912299bf$var$load("coJiW"),
    $0e9a5783912299bf$var$load("ijPJo"),
    $0e9a5783912299bf$var$load("6FuHS"),
    $0e9a5783912299bf$var$load("eyaRC"),
    $0e9a5783912299bf$var$load("Wowvf"),
    $0e9a5783912299bf$var$load("dTsOE"),
    $0e9a5783912299bf$var$load("kHOMt"),
    $0e9a5783912299bf$var$load("hhss7"),
    $0e9a5783912299bf$var$load("ffEVr"),
    $0e9a5783912299bf$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("49Jc5"))).ReadTimeLoader
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("49Jc5", function(module, exports) {

let $306b0f4159abd72d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $306b0f4159abd72d$var$load("6wr18"),
    $306b0f4159abd72d$var$load("6mV9H"),
    $306b0f4159abd72d$var$load("ffEVr"),
    $306b0f4159abd72d$var$load("ioQAS"),
    $306b0f4159abd72d$var$load("irgIM")
]).then(()=>parcelRequire('cbZqw'));

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("48EJG"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("5rkBX"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("48EJG", function(module, exports) {

let $30378211f98b7f59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $30378211f98b7f59$var$load("f1NVy"),
    $30378211f98b7f59$var$load("5UCxV"),
    $30378211f98b7f59$var$load("grD80"),
    $30378211f98b7f59$var$load("4JQof"),
    $30378211f98b7f59$var$load("2F69B"),
    $30378211f98b7f59$var$load("ipiLs"),
    $30378211f98b7f59$var$load("laMwR"),
    $30378211f98b7f59$var$load("aZinD"),
    $30378211f98b7f59$var$load("1QdXB"),
    $30378211f98b7f59$var$load("goLL0"),
    $30378211f98b7f59$var$load("9Z7qK"),
    $30378211f98b7f59$var$load("duPDN"),
    $30378211f98b7f59$var$load("afXyT"),
    $30378211f98b7f59$var$load("1Jgsw"),
    $30378211f98b7f59$var$load("dclpt"),
    $30378211f98b7f59$var$load("tKhaz"),
    $30378211f98b7f59$var$load("cPWI2"),
    $30378211f98b7f59$var$load("lkOIY"),
    $30378211f98b7f59$var$load("dh8Yu"),
    $30378211f98b7f59$var$load("fxPKA"),
    $30378211f98b7f59$var$load("9jS5g"),
    $30378211f98b7f59$var$load("4eboO"),
    $30378211f98b7f59$var$load("8YSo7"),
    $30378211f98b7f59$var$load("9AHrA"),
    $30378211f98b7f59$var$load("jwWp5"),
    $30378211f98b7f59$var$load("gLGsg"),
    $30378211f98b7f59$var$load("6FuHS"),
    $30378211f98b7f59$var$load("eyaRC"),
    $30378211f98b7f59$var$load("eHDb1"),
    $30378211f98b7f59$var$load("2zUEf"),
    $30378211f98b7f59$var$load("6wr18"),
    $30378211f98b7f59$var$load("cyGuT"),
    $30378211f98b7f59$var$load("k5SAQ"),
    $30378211f98b7f59$var$load("bfUix"),
    $30378211f98b7f59$var$load("azVjw"),
    $30378211f98b7f59$var$load("3gquy"),
    $30378211f98b7f59$var$load("iZU4p"),
    $30378211f98b7f59$var$load("fZt2F"),
    $30378211f98b7f59$var$load("cQKew"),
    $30378211f98b7f59$var$load("5tz7G"),
    $30378211f98b7f59$var$load("7u4WP"),
    $30378211f98b7f59$var$load("Wowvf"),
    $30378211f98b7f59$var$load("let0D"),
    $30378211f98b7f59$var$load("6EQss"),
    $30378211f98b7f59$var$load("6vyHt"),
    $30378211f98b7f59$var$load("ioQAS"),
    $30378211f98b7f59$var$load("hX3A6"),
    $30378211f98b7f59$var$load("ffEVr"),
    $30378211f98b7f59$var$load("kUbUu"),
    $30378211f98b7f59$var$load("4Lgj0"),
    $30378211f98b7f59$var$load("kSJiq"),
    $30378211f98b7f59$var$load("e9JE4"),
    $30378211f98b7f59$var$load("e4GNb"),
    $30378211f98b7f59$var$load("hhss7"),
    $30378211f98b7f59$var$load("5QKVr"),
    $30378211f98b7f59$var$load("bxFZs"),
    $30378211f98b7f59$var$load("7EorR"),
    $30378211f98b7f59$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("5rkBX", function(module, exports) {

let $3f5f7659162ecace$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f5f7659162ecace$var$load("9AHrA"),
    $3f5f7659162ecace$var$load("4Lgj0"),
    $3f5f7659162ecace$var$load("kSJiq"),
    $3f5f7659162ecace$var$load("LXZNT"),
    $3f5f7659162ecace$var$load("coJiW"),
    $3f5f7659162ecace$var$load("h4Nf7"),
    $3f5f7659162ecace$var$load("6FuHS"),
    $3f5f7659162ecace$var$load("eyaRC"),
    $3f5f7659162ecace$var$load("Wowvf"),
    $3f5f7659162ecace$var$load("5tz7G"),
    $3f5f7659162ecace$var$load("89Sbl"),
    $3f5f7659162ecace$var$load("7EorR"),
    $3f5f7659162ecace$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("kmWRd", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    let t4;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop) {
        t4 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: "320px",
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ headerHeight: headerHeight = 0, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, isOpen: isOpen = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
        enterFrom: "right",
        fade: "inout"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            // `props` has className, so use inline styling to avoid conflicts
            style: {
                backgroundColor: 'elevation.surface',
                position: isFixed ? 'fixed' : 'absolute',
                right: '0',
                top: `${panelTop}px`,
                width: '320px',
                padding: 'space.300',
                borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                height: `calc(100vh - ${headerHeight}px)`,
                borderTop: displayTopBorder ? `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7a88b175622d580e$var$sidePanelContentStyling
        }, children))));
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, children);
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("iGyCW"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jVylI = parcelRequire("jVylI");


var $9wGTI = parcelRequire("9wGTI");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_bfhki8nm",
            __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhki8nm",
            __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.className
        ])
    });
});
const $be005db184746995$export$e9417b149b0db09d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride })=>{
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    return hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
        contentAppearance: appearance,
        isPagePreview: isPagePreview,
        isSpaceOverview: isSpaceOverview,
        hasEmoji: hasEmoji,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    })) : null;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("iGyCW", function(module, exports) {

let $d9a70272bb69e02b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d9a70272bb69e02b$var$load("f1NVy"),
    $d9a70272bb69e02b$var$load("6EQss"),
    $d9a70272bb69e02b$var$load("f35QR"),
    $d9a70272bb69e02b$var$load("eVYW1"),
    $d9a70272bb69e02b$var$load("ls0Um"),
    $d9a70272bb69e02b$var$load("020xd"),
    $d9a70272bb69e02b$var$load("eTBsW"),
    $d9a70272bb69e02b$var$load("bYxCZ"),
    $d9a70272bb69e02b$var$load("6HBYC"),
    $d9a70272bb69e02b$var$load("eDqo1"),
    $d9a70272bb69e02b$var$load("lxiFd"),
    $d9a70272bb69e02b$var$load("1oiJ6"),
    $d9a70272bb69e02b$var$load("huUvS"),
    $d9a70272bb69e02b$var$load("jp3gT"),
    $d9a70272bb69e02b$var$load("6vhrJ"),
    $d9a70272bb69e02b$var$load("jXx9i"),
    $d9a70272bb69e02b$var$load("ioQAS"),
    $d9a70272bb69e02b$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("gw4Bt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("clKWq", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c778e820ae925f4a$var$buttonStyle = null;
const $c778e820ae925f4a$export$51d63fc44de8b04c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _19lc1dpa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$d4589334c0881f2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _syaz173l _19lc1dpa _1fh11q3r",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$7099540c149f2cd6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1t4p14lu _ll8p1q3r",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$4fba02bb1c3a731d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bgrb1eg2 _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$5df393b96cc674b9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _bgrb1eg2 _yfoxkb7n _19lc1dpa",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$e74173003a1ed83f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dgtmw9": (0, $7sObp.default)(__cmplp.isHidden ? 'var(--show-action)' : '1')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bgrb1dxe _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$bba53dc78bc0e0ef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isSubtle && "_1s9r14lu _ewrd1q3r",
            __cmplp.className
        ])
    });
});
module.exports["FilledIconButton"] = $c778e820ae925f4a$export$51d63fc44de8b04c;
module.exports["UnfilledIconButton"] = $c778e820ae925f4a$export$d4589334c0881f2b;
module.exports["HoverButton"] = $c778e820ae925f4a$export$7099540c149f2cd6;
module.exports["HiddenAction"] = $c778e820ae925f4a$export$4fba02bb1c3a731d;
module.exports["ConditionalHiddenAction"] = $c778e820ae925f4a$export$e74173003a1ed83f;
module.exports["ConditionalSubtleHoverButton"] = $c778e820ae925f4a$export$bba53dc78bc0e0ef;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");

const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useGetCurrentStorageUsageGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed isStorageEnforcementGracePeriodComplete gracePeriodEndDate}}`, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("sD2Tz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $58PBI = parcelRequire("58PBI");

const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor })=>{
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (doPreload) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        doPreload,
        contentId
    ]);
    const onHover = (0, $42omo.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("58PBI", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("eix0u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac60b703236e33e11860080af1a47ce0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a68c599b1c939bc9$var$_react = $a68c599b1c939bc9$var$_interopRequireDefault((parcelRequire("42omo")));

var $a68c599b1c939bc9$var$_baseNew = $a68c599b1c939bc9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a68c599b1c939bc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a68c599b1c939bc9$var$WrenchIcon = (props)=>/*#__PURE__*/ $a68c599b1c939bc9$var$_react.default.createElement($a68c599b1c939bc9$var$_baseNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$a68c599b1c939bc9$var$WrenchIcon.displayName = 'WrenchIcon';
var $a68c599b1c939bc9$var$_default = module.exports.default = $a68c599b1c939bc9$var$WrenchIcon;

});


//# sourceMappingURL=ContentTypesHeader.963e9601.js.map
